import { Player } from "@lottiefiles/react-lottie-player";
import {
  Children,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import useClickOutside from "../../hooks/useClickOutside";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Tree, TreeNode } from "react-organizational-chart";
import { renderToStaticMarkup } from "react-dom/server";

import json_arrow_black from "../../assets/lottieJson/black_arrow.json";
import json_arrow_white from "../../assets/lottieJson/white_arrow.json";
import json_check_white from "../../assets/lottieJson/white_check.json";
import json_check_black from "../../assets/lottieJson/black_check.json";
import json_red_grape from "../../assets/lottieJson/red_grape.json";
import json_white_grape from "../../assets/lottieJson/white_grape.json";
import json_rose_grape from "../../assets/lottieJson/rose_grape.json";

import "react-toastify/dist/ReactToastify.css";
import "./styles/button/index.scss";
import "./styles/cta/index.scss";
import "./styles/card/index.scss";
import "./styles/modal/index.scss";
import "./styles/dropdown/index.scss";
import "./styles/tooltip/index.scss";
import "./styles/tankicon/index.scss";
import "./styles/filtericon/index.scss";
import "./styles/closeicon/index.scss";
import "./styles/bottleicon/index.scss";
import "./styles/operation_recap/index.scss";
import "./styles/optional_note/index.scss";
import "./styles/infocard/index.scss";
import "./styles/carousel/index.scss";
import "./styles/drug_batch_selector/index.scss";

import useLabels from "../../hooks/useLabels";
import { getItem, setItem } from "../../services/LocalStorage";
import {
  DatePicker,
  Input,
  Label,
  MultipleSelect,
  Select,
  Switch,
  Switch3,
  TextArea,
} from "../FormComponents";
import {
  ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
  ALPHA_SPACE_APEX_DOT_REGEX,
  INT_0_REGEX,
  INT_FLOAT_REGEX,
  INT_REGEX,
  NUM_ALPHA_SPACE_APEX_DOT_ALL_LEN_REGEX,
  NUM_ALPHA_SPACE_APEX_DOT_REGEX,
  PWD_REGEX,
  USER_REGEX,
} from "../../constants/regex";
import { format, formatDistanceToNow } from "date-fns";
import {
  DestLotDetail,
  DestTankDetail,
  formatPomaces,
  TankCompositionDetail,
} from "../OperationsDetail/Details";
import { color, motion } from "framer-motion";
import {
  selectActiveWinery,
  selectAllLotNames,
  selectBottleTypes,
  selectConfigs,
  selectMachineryTypes,
  selectUnits,
  selectWarehouseByType,
} from "../../context/selectors";
import { batch, useDispatch, useSelector } from "react-redux";
import {
  getBuyersList,
  getOIVSubstances,
  getStickyNote,
  updateStickyNote,
} from "../../services/utils";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { setWarehouse } from "../../context/warehouse/warehouseSlice";
import { id } from "date-fns/locale";
import { ROLES } from "../../constants/base";
import useAuth from "../../hooks/useAuth";
import { createColumnHelper } from "@tanstack/react-table";
import TableCell from "../Table/TableCell";
import EditCell from "../Table/EditCell";
import Table from "../Table";
import { axiosPrivate } from "../../api/axios";
import {
  assignDrugBatches,
  computeRequiredNumericQty,
  computeRequiredWarehouseQty,
  getWarehouseUnit,
  getWineColor,
  applySubtypeColorTransformation,
  groupBySubstanceId,
} from "../../services/common";
import { toastAxios } from "../../services/toastAxios";
import {
  getCurrencySymbol,
  getCurrencyCode,
  getCurrencyIcon,
} from "../../services/currency";
import { getLocaleObject } from "../../context/configs/configsSlice";
import { Icon } from "../../components/Icon";
import {
  formatTankUnit,
  formatArrowQuantity,
  tankOccupancy,
  getInputTankUnit,
  inputToLiters,
  litersToInput,
  getInputQtyRegex,
  getInputQtyMin,
} from "../../services/tankUnit";

const Button = ({
  label,
  isRed,
  isFull,
  customClassName,
  onClick,
  onMouseOver,
  onMouseLeave,
  arrowDirection = "right",
  disabled = false,
  customIcon = null,
  isLottie = true,
  isNavLink,
  isActive,
  disableIcon,
}) => {
  const lottieRef = useRef();

  const handleClick = (event) => {
    if (disabled) return;
    if (onClick) {
      event.preventDefault();
      onClick(event);
    }
  };

  const handleMouseOver = (event) => {
    if (disabled) return;
    lottieRef?.current?.play?.();
    if (onMouseOver) {
      event.preventDefault();
      onMouseOver();
    }
  };

  const handleMouseLeave = (event) => {
    if (disabled) return;
    lottieRef?.current?.stop?.();
    if (onMouseLeave) {
      event.preventDefault();
      onMouseLeave();
    }
  };

  const renderNavLinkIcon = () => {
    if (disableIcon) return;
    if (!isLottie)
      return (
        <div className="button_hole_icon_img">
          <img className="icon" src={customIcon} alt="" />
        </div>
      );

    return (
      <div className={`button_hole ${arrowDirection}`}>
        <div className="button_hole_icon_wrapper">
          {!customIcon && arrowDirection === "right" && (
            <Player
              autoplay={false}
              controls={false}
              hover={false}
              src={isRed ? json_check_white : json_check_black}
              style={{ width: "24px", height: "24px" }}
              ref={isActive ? lottieRef : null}
            />
          )}
          <div className="button_hole_icon_main">
            <Player
              autoplay={false}
              controls={false}
              hover={false}
              src={
                customIcon
                  ? customIcon
                  : isRed
                  ? json_arrow_white
                  : json_arrow_black
              }
              style={{
                width: "24px",
                height: "24px",
                transform: "rotateX(180deg)",
              }}
              ref={lottieRef}
              // ref2={(isNavLink && !isActive) || !isNavLink ? lottieRef : null}
            />
            {/* {!isActive && <Player
              autoplay={false}
              controls={false}
              hover={true}
              src={customIcon}
              style={{ width: "24px", height: "24px", transform: 'rotateX(180deg)' }}
              ref={(isNavLink && !isActive) || !isNavLink ? lottieRef : null}
            />} */}
          </div>
          {arrowDirection === "left" && (
            <Player
              autoplay={false}
              controls={false}
              hover={false}
              src={isRed ? json_check_white : json_check_black}
              style={{ width: "24px", height: "24px" }}
              ref={isActive ? lottieRef : null}
            />
          )}
        </div>
      </div>
    );
  };

  const renderArrowIcon = () => {
    return (
      <div className={`button_hole ${arrowDirection}`}>
        <div className="button_hole_icon_main">
          <Player
            autoplay={false}
            controls={false}
            hover={false}
            src={
              customIcon
                ? customIcon
                : isRed
                ? json_arrow_white
                : json_arrow_black
            }
            style={{ width: "24px", height: "24px" }}
            ref={(isNavLink && !isActive) || !isNavLink ? lottieRef : null}
          />
        </div>
      </div>
    );
  };

  const renderLeftIcon = () => {
    return (
      <span>
        <Player
          autoplay={false}
          controls={false}
          hover={false}
          loop={false}
          src={customIcon}
          style={{
            width: "24px",
            height: "24px",
            display: "inline-flex",
            alignItems: "center",
          }}
          ref={(isNavLink && !isActive) || !isNavLink ? lottieRef : null}
        />
      </span>
    );
  };

  return (
    <button
      className={`button${isRed ? "_red" : ""}${isFull ? "_full" : ""} ${
        customClassName || ""
      } ${isActive && customIcon ? " active" : ""}`}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}
    >
      {" "}
      {false &&
        isNavLink &&
        !customClassName.includes("burger_container_action") &&
        renderLeftIcon()}
      {isFull && label && (
        <label className={`button_label ${customClassName || ""}`}>
          {label}
        </label>
      )}
      {isNavLink ? renderNavLinkIcon() : renderArrowIcon()}
    </button>
  );
};

const CTA = ({
  children,
  customClassName,
  onClick,
  onMouseOver,
  onMouseLeave,
  isRed,
  isFull = false,
  isSubmit = false,
  onNavigate,
  openNewTab = false,
  disabled,
  navigate,
}) => {
  const handleClick = (event) => {
    if (disabled) return;
    if (onClick) {
      event.preventDefault();
      onClick(event);
    }
    if (onNavigate) {
      if (openNewTab) {
        window.open(onNavigate, "_blank", "noopener,noreferrer");
      } else {
        navigate(onNavigate);
      }
      return;
    }
  };

  const handleMouseOver = (event) => {
    if (disabled) return;
    if (onMouseOver) {
      event.preventDefault();
      onMouseOver();
    }
  };

  const handleMouseLeave = (event) => {
    if (disabled) return;
    if (onMouseLeave) {
      event.preventDefault();
      onMouseLeave();
    }
  };

  return (
    <button
      className={`cta${isRed ? "_red" : ""}${isFull ? "_full" : ""} ${
        customClassName || ""
      }`}
      type={isSubmit ? "submit" : "button"}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}
    >
      {children || ""}
      {customClassName === "complete"}
    </button>
  );
};

const Card = ({ children, customClassName }) => {
  return <div className={`base_card ${customClassName || ""}`}>{children}</div>;
};

const Modal = ({
  children,
  forwardRef,
  closeHandle,
  isOpen = false,
  customClassName,
  modalType = null,
}) => {
  if (!isOpen && modalType === null) return;

  return (
    <div className="modal_wrapper">
      {modalType === null && <div className="modal-overlay"></div>}
      <dialog
        ref={forwardRef}
        className={`base_modal ${customClassName || ""}`}
      >
        <div className="modal_container">{children}</div>
      </dialog>
    </div>
  );
};

const TankColumn = ({ rowData = [], tanks }) => {
  const getTankName = (id) => {
    return (
      tanks?.find?.((tank) => {
        return Number(tank.id) === Number(id);
      })?.name || ""
    );
  };
  return (
    <div>
      {rowData
        ?.filter(
          (
            item,
            index,
            self // filter duplicate tank_id (because of transfer_details)
          ) => index === self.findIndex((t) => t.tank_id === item.tank_id)
        )
        ?.map?.((row, index) => {
          return <div key={index}>{getTankName(row.tank_id)}</div>;
        })}
    </div>
  );
};

const BatchColumn = ({ rowData = {}, lots, type }) => {
  const getBatchName = (id) => {
    return (
      lots?.find?.((lot) => {
        return Number(lot.id) === Number(id);
      })?.name ||
      rowData?.src_tanks?.[0]?.batch_name ||
      rowData?.src_tanks?.[0]?.old_batch_name ||
      ""
    );
  };

  if (type === "DESTEMMING")
    return <div>{getBatchName(rowData?.batch_id_in)}</div>;
  else
    return (
      <div>
        {Array.isArray(rowData) &&
          rowData?.map?.((row) => {
            return <div>{getBatchName(row?.batch_id)}</div>;
          })}
        {!Array.isArray(rowData) && <div>{getBatchName()}</div>}
      </div>
    );
};
const CloseColumn = ({ rowData = [] }) => {
  // const [getLabel] = useLabels();

  const buyers = [
    ...new Set( // unique buyers
      rowData?.map((item) => item?.close_dest)?.filter(Boolean) // remove null/undefined
    ),
  ];

  const displayed = buyers.slice(0, 2);
  const remaining = buyers.length - displayed.length;

  // const displayText =
  //   displayed.join(", ") + (remaining > 0 ? ` +${remaining}` : "");
  const displayText = displayed.join(", ") + (remaining > 0 ? `, ...` : "");

  return (
    <div>
      <p>{displayText}</p>
    </div>
  );
};

const BottlingColumn = ({ rowData = {} }) => {
  const caps = rowData?.map((item) => item?.cap_lot).join(", ");
  const bottles = rowData?.map((item) => item?.bottle_lot).join(", ");

  return (
    <div>
      <p>
        <Icon           icon={"fa-bread-slice"}
          size={"xs"}
          style={{ color: "rgb(157, 126, 104)" }}
        />{" "}
        {caps || ""}
      </p>
      <p>
        <Icon icon={"fa-wine-bottle"} size={"xs"} /> {bottles || ""}
      </p>
    </div>
  );
};

const CellarmanColumn = ({ rowData = [], users }) => {
  const getCellarmanName = (id) => {
    return (
      users?.find?.((user) => Number(user.id) === Number(id))?.username || ""
    );
  };

  return (
    <div>
      {rowData?.map?.((id) => {
        return <div key={id}>{getCellarmanName(id)}</div>;
      })}
    </div>
  );
};

const Dropdown = ({ label, options, customClassName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef();
  useClickOutside(wrapperRef, () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  const handleClick = () => {
    if (!isOpen) {
      setIsOpen(true);
    }
  };

  return (
    <div
      className={`base_dropdown ${customClassName ? customClassName : ""}`}
      ref={wrapperRef}
      onClick={handleClick}
    >
      {label}
      {isOpen && (
        <div className="base_dropdown_list">
          {options?.map?.((option, idx) => {
            return (
              <div
                key={`option_dropdown_${idx}`}
                className="base_dropdown_list_option"
                onClick={option.handler}
              >
                {option.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const Tooltip = ({
  variant = "warning",
  place,
  events,
  content,
  html,
  children,
  customClassName,
}) => {
  const [randomID, setRandomID] = useState(String(Math.random()));

  return (
    <div
      className={`tooltip-container ${
        customClassName === "is_submit" ? customClassName : ""
      }`}
    >
      <a
        data-tooltip-id={randomID}
        data-tooltip-content={content}
        data-tooltip-html={html}
        data-tooltip-offset={10}
      >
        {children || ""}
      </a>
      <ReactTooltip
        key={randomID}
        place={place}
        id={randomID}
        // className={status}
        className={`tooltip-diff-arrow${
          variant?.length > 0 ? `__${variant}` : ""
        } ${customClassName}`}
        classNameArrow={`tooltip-arrow`}
        event={events}
      />
    </div>
  );
};

const InfoTooltip = ({ html }) => {
  return (
    html?.length > 0 && (
      <span className="info-tooltip">
        <Tooltip
          variant={"info"}
          html={html}
          place="right"
          events={["hover"]}
          customClassName="tooltip-text"
        >
          <span className="icon" style={{ opacity: 100 }}>
            <Icon icon="fa-circle-info" className="icon" />
          </span>
        </Tooltip>
      </span>
    )
  );
};

const CustomToastWithLink = ({ message, navigateTo }) => (
  <div>
    <Link to={navigateTo}>{message}</Link>
  </div>
);

const Toast = ({
  toastId,
  message,
  position = toast.POSITION.BOTTOM_RIGHT,
  type,
  autoClose = 4000,
  navigateTo = null,
  customClassName = "",
}) => {
  const getToastType = () => {
    switch (type) {
      case "info":
        return toast.TYPE.INFO;
      case "success":
        return toast.TYPE.SUCCESS;
      case "warning":
        return toast.TYPE.WARNING;
      case "error":
        return toast.TYPE.ERROR;
      default:
        return toast.TYPE.DEFAULT;
    }
  };

  const getToastPosition = () => {
    switch (position) {
      case "top-right":
        return toast.POSITION.TOP_RIGHT;
      case "top-left":
        return toast.POSITION.TOP_LEFT;
      case "top-center":
        return toast.POSITION.TOP_CENTER;
      case "bottom-right":
        return toast.POSITION.BOTTOM_RIGHT;
      case "bottom-left":
        return toast.POSITION.BOTTOM_LEFT;
      case "bottom-center":
        return toast.POSITION.BOTTOM_CENTER;
      default:
        return toast.POSITION.BOTTOM_RIGHT;
    }
  };

  const notify = () => {
    toast(
      navigateTo === null ? (
        message
      ) : (
        <CustomToastWithLink navigateTo={navigateTo} message={message} />
      ),
      {
        position: getToastPosition(),
        autoClose: autoClose,
        type: getToastType(),
        toastId: toastId,
        icon: true,
      }
    );
  };

  return (
    <div className={`base_toast ${customClassName || ""}`}>{notify()}</div>
  );
};

const StickyNotesModal = ({ isOpen, onClose, children }) => {
  const [getLabel] = useLabels();
  const modalRef = useRef(null);
  const [noteText, setNoteText] = useState("");
  const [noteModifiedDate, setNoteModifiedDate] = useState();
  const axiosPrivate = useAxiosPrivate();
  const activeWinery = useSelector(selectActiveWinery);
  const configs = useSelector(selectConfigs);

  const MAX_LEN = 1000;

  useEffect(() => {
    const modalElement = modalRef.current;

    const fetchStickyNote = async () => {
      if (!isOpen || !modalElement) return;

      try {
        const response = await getStickyNote(axiosPrivate);
        const note = response?.data?.[0];

        if (note) {
          setNoteText(note.content || "");
          setNoteModifiedDate(note.last_modified || null);
        }
      } catch (err) {
        console.error("Failed to fetch sticky note:", err);
      }
    };

    fetchStickyNote();
  }, []);

  const customIdStickyNoteError = "custom-id-sticky-note-error";

  useEffect(() => {
    const modalElement = modalRef.current;

    if (modalElement) {
      if (isOpen) {
        modalElement.close();
        modalElement.showModal();

        try {
          const loadedNotes = getItem(`stickyNotes.${activeWinery?.id}`);
          const noteModifiedDate = getItem(
            `stickyNotesLastModified.${activeWinery?.id}`
          );
          setNoteText(loadedNotes?.trim());
          setNoteModifiedDate(noteModifiedDate);
        } catch (err) {
          console.log("err", err);
        }
      } else {
        modalElement.close();
      }
    }
  }, [isOpen]);

  const storeStickyNote = async () => {
    const trimmedNote = noteText?.trim();

    if (trimmedNote?.length > MAX_LEN) {
      return;
    }

    const requestPayload = {
      content: trimmedNote,
    };

    if (noteText?.length > 0) {
      const response = await toastAxios(
        () => updateStickyNote(requestPayload, axiosPrivate),
        customIdStickyNoteError,
        null,
        getLabel,
      );

      setItem(`stickyNotes.${activeWinery?.id}`, noteText?.trim());
      setItem(`stickyNotesLastModified.${activeWinery?.id}`, new Date());
    }

    onClose();
  };

  return (
    isOpen && (
      <Modal
        forwardRef={modalRef}
        closeHandle={onClose}
        isOpen={isOpen}
        customClassName={"sticky-notes"}
      >
        <div className="sticky-note-container">
          <div className="sticky-note-header">
            <h3>{getLabel("personalNotes")}</h3>
            <p className="winery_name">{activeWinery?.name}</p>
          </div>

          <textarea
            maxlength={MAX_LEN}
            className="sticky-note"
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            placeholder={getLabel("personalNotesPlaceholder")}
          />

          <div className="sticky-note-footer">
            {noteText?.trim()?.length > MAX_LEN && (
              <span className="note-length">
                -{noteText?.trim()?.length - MAX_LEN}
              </span>
            )}

            <span className="modified-date">
              {getLabel("personalNotesModifiedDate")}{" "}
              {noteModifiedDate
                ? format(new Date(noteModifiedDate), configs.dateFormat)
                : "—"}
            </span>

            <button className="close-btn" onClick={storeStickyNote}>
              X
            </button>
          </div>
        </div>
      </Modal>
    )
  );
};

const ConfirmationModal = ({
  isOpen,
  hasCloseBtn = true,
  onConfirm,
  onClose,
  children,
  title,
  description,
  description2 = null,
  totalStep = 0,
  step,
  setStep,
  confirmMessage,
  closeMessage,
  isOperationRecap = false,
  errors,
  getValues,
  setNewBatchName,
  isAnalysis = false,
  setError,
  clearErrors,
  type,
}) => {
  const [getLabel] = useLabels();
  const modalRef = useRef(null);

  useEffect(() => {
    const modalElement = modalRef.current;

    if (modalElement) {
      if (isOpen) {
        modalElement.close();
        modalElement.showModal();
      } else {
        modalElement.close();
      }
    }
  }, [isOpen]);

  return (
    isOpen && (
      <Modal
        forwardRef={modalRef}
        closeHandle={onClose}
        isOpen={isOpen}
        children={children}
        customClassName={`confirmation winemaking ${
          isOperationRecap ? "recap" : ""
        }`}
      >
        <div className={"confirmation-modal-container"}>
          <h2 className="title">
            {title ? getLabel(title) : getLabel("modalNoTitle")}
          </h2>
          <br></br>
          {(isAnalysis || totalStep === 0 || step === totalStep) && (
            <>
              <p className="description">
                {description || getLabel("modalNoDescription")}
              </p>
              {description2 && <p className="description2">{description2}</p>}
            </>
          )}
          {!isAnalysis && totalStep > 0 && step < totalStep && (
            <p className="description">
              {description ||
                getLabel("modalNewBatchNameDescription") ||
                getLabel("modalNoDescription")}
            </p>
          )}
          {children}
          <div className="button-container">
            <CTA
              customClassName={"dialog confirm"}
              isRed={false}
              onClick={() => {
                if (!isAnalysis) {
                  if (totalStep === 0) {
                    onConfirm();
                  } else {
                    // if (errors?.new_batch_name) return;

                    // if (
                    //   !getValues("new_batch_name") &&
                    //   !getValues("batch_name_selector")?.label
                    // )
                    //   return;
                    // const new_batch_name = getValues("new_batch_name") ||
                    // getValues("batch_name_selector")?.label;

                    // setNewBatchName(new_batch_name);

                    if (totalStep > 0 && step < totalStep) {
                      setStep((prev) => prev + 1);
                    }
                    if (step === totalStep) {
                      onConfirm();
                    }
                  }
                } else {
                  // console.log('qui', errors, getValues('collection_date')?.filter((e) => e))
                  // return;
                  // if (step === totalStep) {

                  // }
                  // else {
                  if (
                    getValues("collection_date")?.filter((e) => e)?.length === 0
                  ) {
                    setError("collection_date", {
                      type: "manual",
                      message: getLabel("inputRequiredError"),
                    });
                    // return;
                    // } else if (errors?.collection_date) {
                    //   setError(errors?.collection_date);
                    // return;
                  } else clearErrors("collection_date");
                  // }

                  if (
                    !getValues("start_date") &&
                    !["ANALYST", "EXCEL_ANALYSIS"].includes(type)
                  ) {
                    setError("start_date", {
                      type: "manual",
                      message: getLabel("errorAnalysisExamDateFrom"),
                    });
                    // return;
                    // } else if (errors?.start_date) {
                    //   setError(errors?.start_date);
                    // return;
                  } else clearErrors("start_date");

                  if (!getValues("end_date")) {
                    setError("end_date", {
                      type: "manual",
                      message: getLabel("errorAnalysisExamDateTo"),
                    });
                    // return;
                    // } else if (errors?.end_date) {
                    // setError(errors?.end_date);
                    // return;
                  } else clearErrors("end_date");

                  if (
                    new Date(getValues("end_date")) <=
                    new Date(getValues("start_date"))
                  ) {
                    setError("end_date", {
                      type: "manual",
                      message: getLabel("errorAnalysisExamDateInvalidOrder"),
                    });
                    // return;
                  } else clearErrors("end_date");

                  if (errors?.temperature || errors?.collection_date) return;
                  // return;
                  if (totalStep > 0 && step < totalStep) {
                    setStep((prev) => prev + 1);
                  }

                  if (step === totalStep) {
                    // return;
                    onConfirm();
                  }
                }
              }}
            >
              {totalStep === 0 && <p>{getLabel("modalConfirmButton")}</p>}
              {totalStep > 0 && step < totalStep && (
                <p>{getLabel("modalNextStep")}</p>
              )}
              {totalStep > 0 && step === totalStep && (
                <p>{getLabel("modalConfirmButton")}</p>
              )}
            </CTA>
            <CTA
              customClassName={"dialog deny"}
              isRed={false}
              onClick={onClose}
            >
              {getLabel("modalDenyButton")}
            </CTA>
          </div>
        </div>
      </Modal>
    )
  );
};

const WineMakingProtocolModalChildren = ({
  type,
  operation,
  register,
  errors,
  control,
  drugs,
  getLabel,
  getValues,
  setValue,
  setCheckboxState,
}) => {
  const { product } = useWatch({ control });
  const { interval } = useWatch({ control });
  const { functional } = useWatch({ control });
  const { protocol_type } = useWatch({ control });
  const { operation: watchedOperation } = useWatch({ control });
  // const { oxigenation_type} = useWatch({ control });

  useEffect(() => {
    const opValue = watchedOperation?.value || operation?.value;
    if (["RINSE", "VAPORIZATION"].includes(opValue)) {
      const drug = drugs?.find((d) => d?.id === 45); // H2O
      if (drug) {
        const name = getLabel("protocolProduct_H2O");
        const product = {
          label: name,
          name: name,
          value: drug?.id,
          id: drug?.id,
          unit: drug?.unit,
          protocol_type: "ADD",
        };
        setValue("product", product);
      }
    }

    if (Number(getValues("day_to")) > 0) setCheckboxState(true);
  }, [watchedOperation, operation]);

  // NB: la logica "functional cambiato → invalida product/quantity" e
  // "product cambiato → azzera quantity" vive negli onChange dei rispettivi
  // Select (vedi onTableChange più sotto), NON in useEffect: deve reagire solo
  // all'azione utente. In edit mode i campi sono precaricati via setValue prima
  // del mount e NON vanno toccati (un effect su [functional]/[product] verrebbe
  // invece eseguito al mount — e due volte in React Strict Mode — azzerandoli).

  const getOperationsByType = () => {
    return type === "CIP"
      ? [
          {
            label: getLabel("protocolOperation_RINSE"),
            value: "RINSE",
          },
          {
            label: getLabel("protocolOperation_CLEANING"),
            value: "CLEANING",
          },
          {
            label: getLabel("protocolOperation_VAPORIZATION"),
            value: "VAPORIZATION",
          },
          // {
          //   label: getLabel("protocolOperation_HOMOGENIZATION_MASS"),
          //   value: "HOMOGENIZATION_MASS",
          // },
        ]
      : [
          {
            label: getLabel("protocolOperation_ADD"),
            value: "ADD",
          },
          // {
          //   label: getLabel("protocolOperation_TANNISSAGE"),
          //   value: "TANNISSAGE",
          // },
          // {
          //   label: getLabel("protocolOperation_BOIS"),
          //   value: "BOIS",
          // },
          // {
          //   label: getLabel("protocolOperation_ENZYME"),
          //   value: "ENZYME",
          // },
          // {
          //   label: getLabel("protocolOperation_SO2"),
          //   value: "SO2",
          // },
          {
            label: getLabel("protocolOperation_HOMOGENIZATION_MASS"),
            value: "HOMOGENIZATION_MASS",
          },
          {
            label: getLabel("protocolOperation_OXYGENATION"),
            value: "OXYGENATION",
          },
          // {
          //   label: getLabel("protocolOperation_NITROGEN"),
          //   value: "NITROGEN",
          // },
          // {
          //   label: getLabel("protocolOperation_INOCULATION"),
          //   value: "INOCULATION",
          // },
          // {
          //   label: getLabel("operationTypeRACKING"),
          //   value: "RACKING",
          // },
          // {
          //   label: getLabel("operationTypeDECANT"),
          //   value: "DECANT",
          // },
        ];
  };

  const getAddOperationsByType = () => {
    const functionalsSet = new Set();

    const ingredients = drugs?.flatMap((drug) => drug?.ingredients) || [];
    ingredients?.reduce(
      (_, item) => functionalsSet.add(item?.functional),
      null
    );
    const functionals = Array.from(functionalsSet);

    return (
      functionals
        ?.map((w) => ({
          value: w,
          label: getLabel(`drugLabelGroup_${w}`),
        }))
        ?.sort((a, b) => {
          if (a?.value === "Others") return 1;
          if (b?.value === "Others") return -1;
          return a?.label?.localeCompare(b?.label);
        }) || []
    );
  };

  const getPhasesByType = () => {
    const phases = [];
    if (type === "PRE")
      phases.push(
        ...[
          {
            label: getLabel("protocolPhase_PREFERM"),
            value: "PREFERM",
          },
          {
            label: getLabel("protocolPhase_INOCULATE"),
            value: "INOCULATE",
          },
          {
            label: getLabel("protocolPhase_START"),
            value: "START",
          },
          {
            label: getLabel("protocolPhase_FERMAL"),
            value: "FERMAL",
          },
        ]
      );
    else if (type === "POST")
      phases.push(
        ...[
          {
            label: getLabel("protocolPhase_FERMML"),
            value: "FERMML",
          },
          {
            label: getLabel("protocolPhase_ENDFERMML"),
            value: "ENDFERMML",
          },
          {
            label: getLabel("protocolPhase_POSTFERM"),
            value: "POSTFERM",
          },
          {
            label: getLabel("protocolPhase_AGING"),
            value: "AGING",
          },
          {
            label: getLabel("protocolPhase_REFINEMENT"),
            value: "REFINEMENT",
          },
          {
            label: getLabel("protocolPhase_STABILIZING"),
            value: "STABILIZING",
          },
          {
            label: getLabel("protocolPhase_PREBOTTLING"),
            value: "PREBOTTLING",
          },
          {
            label: getLabel("protocolPhase_BOTTLING"),
            value: "BOTTLING",
          },
        ]
      );
    else if (type === "SPARKLING")
      phases.push(
        ...[
          {
            label: getLabel("protocolPhase_PREFERM"),
            value: "PREFERM",
          },
          {
            label: getLabel("protocolPhase_INOCULATE"),
            value: "INOCULATE",
          },
          {
            label: getLabel("protocolPhase_FERMAL"),
            value: "FERMAL",
          },
          {
            label: getLabel("protocolPhase_AGING"),
            value: "AGING",
          },
          {
            label: getLabel("protocolPhase_REFINEMENT"),
            value: "REFINEMENT",
          },
          {
            label: getLabel("protocolPhase_PREBOTTLING"),
            value: "PREBOTTLING",
          },
          {
            label: getLabel("protocolPhase_BOTTLING"),
            value: "BOTTLING",
          },
        ]
      );
    else if (type === "CIP")
      // TO DO check
      phases.push(
        ...[
          {
            label: getLabel("protocolPhase_FERMML"),
            value: "FERMML",
          },
          {
            label: getLabel("protocolPhase_ENDFERMML"),
            value: "ENDFERMML",
          },
        ]
      );

    return phases;
  };

  const getFilteredDrugs = () => {
    const operationValue = watchedOperation?.value || operation?.value || null;
    if (type === "CIP")
      return (
        drugs
          ?.filter((drug) => drug?.type === "DETERGENT")
          ?.filter(
            (drug) =>
              operationValue === "RINSE" || operationValue === "VAPORIZATION"
                ? drug?.id === 45
                : drug?.id !== 45 // H2O only in case of RINSE, VAPORIZATION
          )
          ?.map((d) => ({
            ...d,
            label:
              d?.name +
              (d?.unit && d?.unit_id !== 5 ? " (" + d?.unit + ")" : ""),
          })) ?? []
      );

    if (!operationValue) return [];
    // const operationLabelGroupMap = {
    //   INOCULATION: "Fermentation agents",
    //   BACTERIA: "Fermentation agents",
    //   TANNISSAGE: "Tannins",
    //   BOIS: "Woods",
    //   ENZYME: "Enzymes",
    //   SO2: "Preservatives",
    //   NITROGEN: "Gases",
    //   OXYGENATION: "Gases",
    //   ADD: "Stabilising agents",
    // };

    // const labelGroup = operationLabelGroupMap[operationValue];
    // if (!labelGroup) return []; // no mapping

    return (
      drugs
        ?.filter((drug) =>
          drug?.ingredients?.some(
            (ingredient) => ingredient?.functional === functional?.value
          )
        )
        ?.map((d) => ({
          ...d,
          label: d?.name + (d?.unit ? " (" + d?.unit + ")" : ""),
        })) ?? []
    );
  };

  if (type === "PHYSICAL")
    return (
      <div className="panel_wrapper">
        <div className="left_panel">
          <div className="operation_info_container_row"></div>
        </div>
        <div className="right_panel">
          <div className="note_wrapper">
            <div className="operation_info_container_row notes">
              <TextArea
                name="goal"
                register={register}
                label={getLabel("protocolGoals")}
                placeholder={getLabel("protocolGoalsPlaceholder")}
                error={errors["goal"]}
                maxLength={{
                  value: 500,
                  message: getLabel("errorMaxLength", { value: 500 }),
                }}
              />
              <TextArea
                name="note"
                register={register}
                label={getLabel("protocolNotes")}
                placeholder={getLabel("protocolNotesPlaceholder")}
                error={errors["note"]}
                maxLength={{
                  value: 500,
                  message: getLabel("errorMaxLength", { value: 500 }),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );

  return (
    <div className="panel_wrapper">
      <div className="left_panel">
        <div className="operation_info_container_row">
          <Input
            name="day"
            register={register}
            // customClassName="quantity"
            type="number"
            label={
              type === "CIP"
                ? getLabel("protocolStep")
                : interval
                ? getLabel("protocolDayInterval")
                : getLabel("protocolDay")
            }
            placeholder={
              type === "CIP"
                ? getLabel("protocolStepPlaceholder")
                : getLabel("protocolDayPlaceholder")
            }
            error={errors["day"]}
            required={getLabel("inputRequiredError")}
            min={{
              value: type === "CIP" ? 1 : "0",
              message: getLabel("errorMinValue", {
                value: type === "CIP" ? 1 : "0",
              }),
            }}
            max={{
              value: 50,
              message: getLabel("errorMaxValue", { value: 50 }),
            }}
            regExpPattern={{
              value: INT_0_REGEX,
              message: getLabel("errorInt"),
            }}
            tooltip={type === "CIP" ? "" : getLabel("protocolDayTooltip")}
          />
          {type !== "CIP" &&
            watchedOperation?.value &&
            !["DECANT", "RACKING"].includes(watchedOperation?.value) && (
              <>
                {interval && (
                  <Input
                    name="day_to"
                    customClassName="quantity"
                    register={register}
                    type="number"
                    label={getLabel("protocolToDay")}
                    placeholder={getLabel("protocolToDayPlaceholder")}
                    tooltip={getLabel("protocolToDayTooltip")}
                    error={errors["day_to"]}
                    min={{
                      value: Number(getValues("day")) + 1,
                      message: getLabel("errorMinValue", {
                        value: Number(getValues("day")) + 1,
                      }),
                    }}
                    regExpPattern={{
                      value: INT_0_REGEX,
                      message: getLabel("errorInt"),
                    }}
                  />
                )}
                <Input
                  name={`interval`}
                  register={register}
                  label={getLabel(`protocolIntervalOp`)}
                  error={errors["interval"]}
                  type={"checkbox"}
                  checked={interval} // safe access
                  onChange={setCheckboxState}
                  // checked={getValues("interval")}
                  customClassName={"winemaking"}
                />
              </>
            )}
          {type !== "CIP" && (
            <Select
              name="phase"
              control={control}
              label={getLabel("protocolPhase")}
              placeholder={getLabel("protocolPhasePlaceholder")}
              error={errors}
              required={getLabel("inputRequiredError")}
              options={getPhasesByType()}
            />
          )}
        </div>
        <div className="operation_info_container_row">
          <Select
            name="operation"
            control={control}
            label={getLabel("protocolOperation")}
            placeholder={getLabel("protocolOperationPlaceholder")}
            error={errors}
            required={getLabel("inputRequiredError")}
            options={getOperationsByType()?.sort((a, b) => b?.label - a?.label)}
          />
          {type !== "CIP" &&
            watchedOperation?.value &&
            "HOMOGENIZATION_MASS" === watchedOperation?.value && (
              <>
                <Select
                  name="protocol_type"
                  control={control}
                  label={getLabel("protocolType")}
                  placeholder={getLabel("protocolTypePlaceholder")}
                  errors={errors["protocol_type"]}
                  required={getLabel("inputRequiredError")}
                  options={[
                    {
                      label: getLabel("protocolOperation_HOMOGENIZATION_TEMP"),
                      value: "HOMOGENIZATION_TEMP",
                    },
                    {
                      label: getLabel(
                        "protocolOperation_HOMOGENIZATION_REASSEMBLY"
                      ),
                      value: "HOMOGENIZATION_REASSEMBLY",
                    },
                  ]}
                  // defaultValue={type === 'CIP' ? {
                  //   label: getLabel(
                  //     "protocolOperation_HOMOGENIZATION_REASSEMBLY"
                  //   ),
                  //   value: "HOMOGENIZATION_REASSEMBLY",
                  // } : ""}
                  // defaultValue={{
                  //   label: getLabel(
                  //     "protocolOperation_HOMOGENIZATION_TEMP"
                  //   ),
                  //   value: "HOMOGENIZATION_TEMP",
                  // }}
                />
                {protocol_type?.value &&
                  "HOMOGENIZATION_TEMP" === protocol_type?.value &&
                  watchedOperation?.value === "HOMOGENIZATION_MASS" && (
                    // <>
                    <Input
                      name="quantity"
                      register={register}
                      type="number"
                      label={getLabel("protocolHomogenizationTemp")}
                      placeholder={getLabel(
                        "protocolHomogenizationTempPlaceholder"
                      )}
                      error={errors["quantity"]}
                      min={{
                        value: 1,
                        message: getLabel("errorMinValue", { value: 1 }),
                      }}
                      max={{
                        value: 40,
                        message: getLabel("errorMaxValue", { value: 40 }),
                      }}
                      regExpPattern={{
                        value: INT_FLOAT_REGEX,
                        message: getLabel("errorIntFloat"),
                      }}
                      tooltip={getLabel("protocolHomogenizationTempTooltip")}
                    />
                    // </>
                  )}
              </>
            )}
        </div>
        {type !== "CIP" && watchedOperation?.value && "ADD" === watchedOperation?.value && (
          <div className="operation_info_container_row">
            <Select
              name="functional"
              control={control}
              label={getLabel("drugLabelFunctional")}
              placeholder={getLabel("drugLabelFunctionalPlaceholder")}
              error={errors}
              required={getLabel("inputRequiredError")}
              options={getAddOperationsByType()?.sort(
                (a, b) => b?.label - a?.label
              )}
              // Solo su scelta utente (mai al mount/Strict Mode): se il prodotto
              // già selezionato non appartiene al nuovo functional, lo azzera.
              onTableChange={(value) => {
                if (!value?.value || !product?.value || type === "CIP") return;
                const isValid =
                  product?.ingredients?.some(
                    (ingredient) => ingredient?.functional === value?.value
                  ) ?? false;
                if (!isValid) {
                  setValue("product", { value: null, label: "" });
                  setValue("quantity", "");
                }
              }}
            />
            {watchedOperation?.value === "ADD" && (
              <>
                <Select
                  name="product"
                  control={control}
                  label={getLabel("protocolProduct")}
                  placeholder={getLabel("protocolProductPlaceholder")}
                  error={errors}
                  required={getLabel("inputRequiredError")}
                  options={getFilteredDrugs()}
                  isDisabled={
                    ["RINSE", "SO2", "VAPORIZATION"].includes(
                      watchedOperation?.value
                    ) || !functional?.value
                  }
                />
                {!["RINSE", "CLEANING", "VAPORIZATION"].includes(
                  watchedOperation?.value
                ) && (
                  <Input
                    name="quantity"
                    register={register}
                    isDisabled={!product?.value}
                    type="number"
                    label={getLabel("protocolQuantity")}
                    placeholder={getLabel("protocolQuantityPlaceholder")}
                    required={getLabel("inputRequiredError")}
                    error={errors["quantity"]}
                    regExpPattern={{
                      value: INT_FLOAT_REGEX,
                      message: getLabel("errorIntFloat"),
                    }}
                    validate={(value) => {
                      if (
                        product?.min_range !== undefined &&
                        product?.min_range !== null &&
                        Number(value) < Number(product?.min_range)
                      ) {
                        return getLabel("errorMinValueUnit", {
                          value: product?.min_range?.toString() || "0",
                          unit: product?.unit || "",
                        });
                      }
                      if (
                        product?.max_range !== undefined &&
                        product?.max_range !== null &&
                        Number(value) > Number(product?.max_range)
                      ) {
                        return getLabel("errorMaxValueUnit", {
                          value: product?.max_range?.toString(),
                          unit: product?.unit || "",
                        });
                      }
                      return true;
                    }}
                  />
                )}
              </>
            )}
          </div>
        )}
        {type === "CIP" && watchedOperation?.value && (
          <div className="operation_info_container_row">
            <Select
              name="product"
              control={control}
              label={getLabel("drugType_DETERGENT")}
              placeholder={getLabel("protocolProductPlaceholder")}
              error={errors}
              required={getLabel("inputRequiredError")}
              options={getFilteredDrugs()}
              isDisabled={["RINSE", "VAPORIZATION"].includes(watchedOperation?.value)}
            />
            {!["RINSE", "VAPORIZATION"].includes(watchedOperation?.value) && product?.id !== 45 && (
              <Input
                name="quantity"
                register={register}
                // customClassName={"quantity"}
                type="number"
                required={getLabel("inputRequiredError")}
                label={getLabel("drugConcentration")}
                placeholder={getLabel("protocolConcentrationPlaceholder")}
                error={errors["quantity"]}
                regExpPattern={{
                  value: INT_FLOAT_REGEX,
                  message: getLabel("errorIntFloat"),
                }}
                min={{
                  value: 0,
                  message: getLabel("errorMinValue", {
                    value: 0,
                  }),
                }}
                max={{
                  value: 100 || null,
                  message: getLabel("errorMaxValue", {
                    value: 100,
                  }),
                }}
              />
            )}
            <Input
              name="work_time"
              // customClassName="quantity"
              register={register}
              type="number"
              label={getLabel("protocolHomogenizationWorkContactTime")}
              placeholder={getLabel(
                "protocolHomogenizationWorkTimePlaceholder"
              )}
              required={getLabel("inputRequiredError")}
              error={errors["work_time"]}
              min={{
                value: 1,
                message: getLabel("errorMinValue", { value: 0 }),
              }}
              max={{
                value: 59,
                message: getLabel("errorMaxValue", { value: 59 }),
              }}
              regExpPattern={{
                value: INT_REGEX,
                message: getLabel("errorInt"),
              }}
            />
          </div>
        )}
        <div className="operation_info_container_row">
          {protocol_type?.value &&
            "HOMOGENIZATION_REASSEMBLY" === protocol_type?.value &&
            operation?.value === "HOMOGENIZATION_MASS" && (
              <>
                <Select
                  name="homogenization_type"
                  control={control}
                  label={getLabel("protocolHomogenizationType")}
                  placeholder={getLabel(
                    "protocolHomogenizationTypePlaceholder"
                  )}
                  errors={errors["homogenization_type"]}
                  required={getLabel("inputRequiredError")}
                  options={[
                    {
                      label: getLabel("protocolHomogenizationMass_CLOSED"),
                      value: "CLOSED",
                    },
                    {
                      label: getLabel("protocolHomogenizationMass_OPEN"),
                      value: "OPEN",
                    },
                  ]}
                />
                <Input
                  name="work_time"
                  customClassName="quantity"
                  register={register}
                  type="number"
                  label={getLabel("protocolHomogenizationWorkTime")}
                  placeholder={getLabel(
                    "protocolHomogenizationWorkTimePlaceholder"
                  )}
                  error={errors["work_time"]}
                  min={{
                    value: 1,
                    message: getLabel("errorMinValue", { value: 1 }),
                  }}
                  max={{
                    value: 24 * 60,
                    message: getLabel("errorMaxValue", {
                      value: 24 * 60,
                    }),
                  }}
                  regExpPattern={{
                    value: INT_REGEX,
                    message: getLabel("errorInt"),
                  }}
                />
                <Input
                  name="pause_time"
                  customClassName="quantity"
                  register={register}
                  type="number"
                  label={getLabel("protocolHomogenizationPauseTime")}
                  placeholder={getLabel(
                    "protocolHomogenizationPauseTimePlaceholder"
                  )}
                  error={errors["pause_time"]}
                  min={{
                    value: 1,
                    message: getLabel("errorMinValue", { value: 1 }),
                  }}
                  max={{
                    value: 24,
                    message: getLabel("errorMaxValue", { value: 24 }),
                  }}
                  regExpPattern={{
                    value: INT_REGEX,
                    message: getLabel("errorInt"),
                  }}
                />
                <Input
                  name="motor_speed"
                  customClassName="quantity"
                  register={register}
                  type="number"
                  label={getLabel("protocolHomogenizationMotorSpeed")}
                  placeholder={getLabel(
                    "protocolHomogenizationMotorSpeedPlaceholder"
                  )}
                  error={errors["motor_speed"]}
                  min={{
                    value: 1,
                    message: getLabel("errorMinValue", { value: 1 }),
                  }}
                  max={{
                    value: 100,
                    message: getLabel("errorMaxValue", { value: 100 }),
                  }}
                  regExpPattern={{
                    value: INT_REGEX,
                    message: getLabel("errorInt"),
                  }}
                />
                <Input
                  name="iter_per_day"
                  customClassName="quantity"
                  register={register}
                  type="number"
                  label={getLabel("protocolHomogenizationIterPerDay")}
                  placeholder={getLabel(
                    "protocolHomogenizationIterPerDayPlaceholder"
                  )}
                  error={errors["iter_per_day"]}
                  min={{
                    value: 1,
                    message: getLabel("errorMinValue", { value: 1 }),
                  }}
                  max={{
                    value: 20,
                    message: getLabel("errorMaxValue", { value: 20 }),
                  }}
                  regExpPattern={{
                    value: INT_REGEX,
                    message: getLabel("errorInt"),
                  }}
                />
              </>
            )}
          {operation?.value && "OXYGENATION" === operation?.value && (
            <>
              <Select
                name="protocol_type"
                control={control}
                label={getLabel("protocolOxigenationTypology")}
                placeholder={getLabel("protocolOxigenationTypologyPlaceholder")}
                errors={errors["protocol_type"]}
                required={getLabel("inputRequiredError")}
                options={[
                  {
                    label: getLabel("protocolOXYGENATION_MICRO"),
                    value: "MICRO",
                  },
                  {
                    label: getLabel("protocolOXYGENATION_MACRO"),
                    value: "MACRO",
                  },
                  {
                    label: getLabel("protocolOXYGENATION_CUSTOM"),
                    value: "CUSTOM",
                  },
                ]}
              />
              {["MICRO", "MACRO"].includes(protocol_type?.value) && (
                <Input
                  name="quantity"
                  // customClassName="quantity"
                  register={register}
                  type="number"
                  label={
                    "MICRO" === protocol_type?.value
                      ? getLabel("protocolOxygenationDose_MICRO")
                      : getLabel("protocolOxygenationDose_MACRO")
                  }
                  placeholder={getLabel("protocolOxygenationDosePlaceholder")}
                  error={errors["quantity"]}
                  min={{
                    value: 1,
                    message: getLabel("errorMinValue", { value: 1 }),
                  }}
                  max={{
                    value: 1000,
                    message: getLabel("errorMaxValue", { value: 1000 }),
                  }}
                  regExpPattern={{
                    value: INT_REGEX,
                    message: getLabel("errorInt"),
                  }}
                />
              )}
              {"CUSTOM" === protocol_type?.value && (
                <>
                  <Input
                    name="quantity"
                    // customClassName="quantity"
                    register={register}
                    type="number"
                    label={getLabel("protocolOxygenationDose_CUSTOM")}
                    placeholder={getLabel("protocolOxygenationDosePlaceholder")}
                    error={errors["quantity"]}
                    min={{
                      value: 1,
                      message: getLabel("errorMinValue", { value: 1 }),
                    }}
                    max={{
                      value: 1000,
                      message: getLabel("errorMaxValue", { value: 1000 }),
                    }}
                    regExpPattern={{
                      value: INT_REGEX,
                      message: getLabel("errorInt"),
                    }}
                  />
                  <Input
                    name="oxygenation_dose_hours"
                    customClassName="quantity"
                    register={register}
                    type="number"
                    label={getLabel("protocolOxygenationDoseHours")}
                    placeholder={getLabel(
                      "protocolOxygenationDoseHoursPlaceholder"
                    )}
                    error={errors["oxygenation_dose_hours"]}
                    min={{
                      value: 1,
                      message: getLabel("errorMinValue", { value: 0 }),
                    }}
                    max={{
                      value: 1000,
                      message: getLabel("errorMaxValue", { value: 23 }),
                    }}
                    regExpPattern={{
                      value: INT_REGEX,
                      message: getLabel("errorInt"),
                    }}
                  />
                  <Input
                    name="oxygenation_dose_minutes"
                    customClassName="quantity"
                    register={register}
                    type="number"
                    label={getLabel("protocolOxygenationDoseMinutes")}
                    placeholder={getLabel(
                      "protocolOxygenationDoseMinutesPlaceholder"
                    )}
                    error={errors["oxygenation_dose_minutes"]}
                    min={{
                      value: 1,
                      message: getLabel("errorMinValue", { value: 0 }),
                    }}
                    max={{
                      value: 1000,
                      message: getLabel("errorMaxValue", { value: 59 }),
                    }}
                    regExpPattern={{
                      value: INT_REGEX,
                      message: getLabel("errorInt"),
                    }}
                  />
                </>
              )}
              {/* <Input
                  name="oxygenationIterPerDay"
                  register={register}
                  type="number"
                  label={getLabel("protocolOxygenationIterPerDay")}
                  placeholder={getLabel(
                    "protocolOxygenationIterPerDayPlaceholder"
                  )}
                  error={errors["oxygenationIterPerDay"]}
                  min={{
                    value: 1,
                    message: getLabel("errorMinValue", { value: 1 }),
                  }}
                  max={{
                    value: 20,
                    message: getLabel("errorMaxValue", { value: 20 }),
                  }}
                  regExpPattern={{
                    value: INT_REGEX,
                    message: getLabel("errorInt"),
                  }}
                /> */}
            </>
          )}
        </div>
      </div>
      <div className="right_panel">
        <div className="note_wrapper">
          <div className="operation_info_container_row notes">
            <TextArea
              name="goal"
              register={register}
              label={getLabel("protocolGoals")}
              placeholder={getLabel("protocolGoalsPlaceholder")}
              error={errors["goal"]}
              maxLength={{
                value: 500,
                message: getLabel("errorMaxLength", { value: 500 }),
              }}
            />
            <TextArea
              name="note"
              register={register}
              label={getLabel("protocolNotes")}
              placeholder={getLabel("protocolNotesPlaceholder")}
              error={errors["note"]}
              maxLength={{
                value: 500,
                message: getLabel("errorMaxLength", { value: 500 }),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const WineMakingProtocolRowModal = ({
  isOpen = false,
  hasCloseBtn = true,
  handleSubmit,
  onConfirm,
  onClose,
  children,
  title,
  confirmMessage,
  closeMessage,
  errors,
  getValues,
  setError,
  clearErrors,
}) => {
  const [getLabel] = useLabels();
  const modalRef = useRef(null);

  useEffect(() => {
    const modalElement = modalRef.current;

    if (modalElement) {
      if (isOpen) {
        modalElement.close();
        modalElement.showModal();
      } else {
        modalElement.close();
      }
    }
  }, [isOpen]);

  return (
    <form onSubmit={handleSubmit(onConfirm)} autoComplete="off" noValidate>
      {isOpen && (
        <Modal
          forwardRef={modalRef}
          closeHandle={onClose}
          isOpen={isOpen}
          children={children}
          customClassName={"winemaking"}
        >
          <div className={"confirmation-modal-container"}>
            <h2 className="title">
              {title ? getLabel(title) : getLabel("modalNoTitle")}
            </h2>
            {/* <br></br> */}
            {children}
            <div className="button-container">
              <CTA
                customClassName={"dialog confirm"}
                isRed={false}
                isSubmit={true}
                onClick={() => onConfirm()}
              >
                <p>{getLabel("modalConfirmButton")}</p>
              </CTA>
              <CTA
                customClassName={"dialog deny"}
                isRed={false}
                onClick={onClose}
              >
                {getLabel("modalDenyButton")}
              </CTA>
            </div>
          </div>
        </Modal>
      )}
    </form>
  );
};

const FilterCandleStock = ({
  control,
  errors,
  fieldsBatches,
  getValues,
  candlesOptions,
}) => {
  const [getLabel] = useLabels();
  
  const isButtonDisabled = () => {
    // all possible candle IDs
    const allCandleIds =
      candlesOptions
        // ?.filter((c) => c?.status !== "ACTIVE" || Boolean(c?.filter_id))
        ?.filter(c =>
          // escludi SOLO le candle realmente selezionate
          !selectedSerials.includes(c.serial_number) &&

          // candle disponibile
          c.filter_id === null
        )
        ?.map((c) => Number(c.id)) || [];
    if (allCandleIds.length === 0) return true;

    // currently selected candle IDs in fieldsBatches
    const selectedIds =
      fieldsBatches?.fields
        ?.filter((f) => !f?.is_disabled)
        ?.map((f) => f?.value)
        // ?.map((_, idx) => getValues(`candles.${idx}.id`))
        ?.filter(Boolean) || [];

    // remaining options = those not yet selected
    const remaining = allCandleIds.filter(
      (id) => !selectedIds.includes(Number(id))
    );

    return remaining.length === 0;
  };

  const selectedSerials =
    fieldsBatches.fields
      ?.filter(f => f?.value !== null && f?.serial_number)
      .map(f => f.serial_number) ?? []

  return (
    <div className="drug_stock">
      <div className="substance_form_wrapper vertical">
        <h5>{getLabel("filterCandles")}</h5>
        {fieldsBatches?.fields?.map?.((field, idx) => {
          return (
            <div key={field.id} className="substance_form_wrapper_row card">
              <Select
                control={control}
                defaultValue={
                  getValues(`candle_porosity`) || { label: null, value: null }
                }
                name={`candles.${idx}`}
                label={getLabel("filterCandleSerial")}
                placeholder={getLabel("filterSerialNumberPlaceholder")}
                error={errors}
                required={getLabel("inputRequiredError")}
                options={candlesOptions
                  ?.filter(c =>
                    // escludi SOLO le candle realmente selezionate
                    !selectedSerials.includes(c.serial_number) &&

                    // candle disponibile
                    c.filter_id === null
                  )
                  ?.map((c) => {
                    return {
                      ...c,
                      is_disabled:
                        c?.status !== "ACTIVE" || Boolean(c?.filter_id),
                      value: c?.id,
                      label: `${c?.serial_number} ${c?.porosity || "—"} µm [${
                        c?.porosity
                          ? getLabel(
                              `filterCandleType_${c?.type}_Short`
                            )?.toLowerCase?.()
                          : ""
                      }]`,
                    };
                })}
              />
              {fieldsBatches?.fields?.length > 1 && (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    fieldsBatches.remove(idx);
                  }}
                >
                  -
                </button>
              )}
            </div>
          );
        })}
        <div className="substance_form_wrapper_row">
          <button
            id="batchesD"
            disabled={isButtonDisabled()}
            onClick={(e) => {
              e.preventDefault();
              fieldsBatches.append({
                batchesData: {},
              });
            }}
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
};

const FilterCandle = ({
  register,
  control,
  errors,
  getFilterPorosityOptions,
  getFilterMaxCapacityOptions,
  getValues,
}) => {
  const [getLabel] = useLabels();
  const { auth } = useAuth();
  const currencySymbol = getCurrencySymbol(getCurrencyCode(auth?.user));

  return (
    <div className="drug_stock">
      <div className="substance_form_wrapper vertical">
        <h5>{getLabel("filterCandle")}</h5>
        <div className="substance_form_wrapper_row card">
          <Input
            name={"serial_number"}
            register={register}
            label={getLabel(`filterCandleSerial`)}
            placeholder={getLabel("filterSerialNumberPlaceholder")}
            error={errors["serial_number"]}
            required={getLabel("inputRequiredError")}
            minLength={{
              value: 3,
              message: getLabel("errorMinLength", { value: 3 }),
            }}
            maxLength={{
              value: 24,
              message: getLabel("errorMaxLength", {
                value: 24,
              }),
            }}
            regExpPattern={{
              value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
              message: getLabel("errorAlphaNumSpace_-"),
            }}
          />
          <Select
            control={control}
            defaultValue={
              getValues(`candle_porosity`) || { label: null, value: null }
            }
            name={"porosity"}
            label={getLabel("filterPorosity")}
            placeholder={getLabel("filterPorosityPlaceholder")}
            error={errors}
            required={getLabel("inputRequiredError")}
            options={getFilterPorosityOptions()}
          />
          <Select
            control={control}
            // defaultValue={}
            name={"type"}
            label={getLabel("filterCandleType")}
            placeholder={getLabel("filterCandleTypePlaceholder")}
            error={errors}
            required={getLabel("inputRequiredError")}
            options={[
              { label: getLabel("filterCandleType_NOMINAL"), value: "NOMINAL" },
              {
                label: getLabel("filterCandleType_ABSOLUTE"),
                value: "ABSOLUTE",
              },
            ]}
          />
        </div>
        <div className="substance_form_wrapper_row card">
          <Input
            name={"max_filter_capacity"}
            error={errors["max_filter_capacity"]}
            register={register}
            type="number"
            label={getLabel("filterMaxCapacityUnit")}
            placeholder={getLabel("filterMaxCapacityPlaceholder")}
            // min={{
            //   value: getFilterMaxCapacityOptions()?.min || 1,
            //   message: getLabel("errorMinValue", {
            //     value: getFilterMaxCapacityOptions()?.min || "1",
            //   }),
            // }}
            max={{
              value: getFilterMaxCapacityOptions()?.max || 100000,
              message: getLabel("errorMaxValue", {
                value: getFilterMaxCapacityOptions()?.max || "100000",
              }),
            }}
            // required={getLabel("inputRequiredError")}
          />
          <Input
            name={"cost"}
            customClassName="quantity"
            error={errors["cost"]}
            register={register}
            type="number"
            label={getLabel("drugBatchUnitCost")}
            placeholder={getLabel("drugBatchUnitCostPlaceholder", {
              currency: currencySymbol,
              unit: getValues("unit")?.label,
            })}
            // error={errors["new_batch_name"]}
            required={getLabel("inputRequiredError")}
            min={{
              value: 1,
              message: getLabel("errorMinValue", { value: 1 }),
            }}
            regExpPattern={{
              value: INT_FLOAT_REGEX,
              message: getLabel("errorIntFloat"),
            }}
            tooltip={getLabel("drugBatchUnitCostTooltip", {
              batch: getValues(`serial_number`),
              unit: "", //getValues("unit")?.label,
            })}
          />
        </div>
      </div>
    </div>
  );
};

const DrugBatchSelector = (props) => {
  const {
    configs,
    register,
    control,
    errors,
    fieldsBatches,
    substance = null,
    totalVolume = 0,
    getValues,
    getError,
    autoPreselect = true,
    isAutomaticCTA = false,
  } = props;

  const [getLabel] = useLabels();

  /* --------------------------------------------------
   * SAFE DEFAULTS (important)
   * -------------------------------------------------- */
  const safeSubstance = substance ?? {};
  const batches = safeSubstance.batches ?? [];

  const warehouseUnit = useMemo(() => {
    switch (safeSubstance.unit_id) {
      case 1: // mg/L
      case 2: // g/hL
      case 4: // Kg
      case 6: // g/L
      case 7: // g/100Kg
        return { value: "kg", label: getLabel("drugBatchUnit_Kg") };

      case 3: // L
        return { value: "l", label: getLabel("drugBatchUnit_L") };

      case 5: // Unit
        return { value: "unit", label: getLabel("drugBatchUnit_Unit") };

      default:
        return null;
    }
  }, [safeSubstance.unit_id]);

  // BASE AMOUNT:
  // - grams for weight
  // - liters for liquids
  // - units for unit-based products
  const requiredNumericQty = useMemo(() => {
    return computeRequiredNumericQty(safeSubstance, totalVolume) || 0;
  }, [safeSubstance, totalVolume]);

  // FINAL WAREHOUSE QUANTITY
  const requiredWarehouseQty = useMemo(() => {
    return computeRequiredWarehouseQty(warehouseUnit, requiredNumericQty) || 0;
  }, [requiredNumericQty, warehouseUnit]);

  const availableWarehouseQty = useMemo(
    () => batches.reduce((sum, b) => sum + (Number(b?.stock) || 0), 0) || 0,
    [batches]
  );

  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

  const sortedBatches = useMemo(() => {
    return [...batches]
      .map((b) => ({
        ...b,
        is_disabled: b.expire_date < today,
      }))
      .sort((a, b) => a.expire_date.localeCompare(b.expire_date));
  }, [batches]);

  // const sortedBatches = useMemo(() => {
  //   return [...batches]?.map(b => { return { ...b, is_disabled: today > new Date(b.expire_date) }}).sort(
  //     (a, b) => new Date(a.expire_date) - new Date(b.expire_date)
  //   );
  // }, [batches]);

  // const autoAssignBatches = (isExcludeBatchNumber = null) => {
  //   let remaining = requiredWarehouseQty;
  //   const filteredBatches = sortedBatches?.filter(b => isExcludeBatchNumber ? b?.batch_number !== isExcludeBatchNumber : true) || [];
  //   const allocation = filteredBatches
  //     .map(batch => {
  //       if (remaining <= 0) return null;

  //       const used = Math.min(batch.stock, remaining);
  //       remaining -= used;

  //       return buildBatchField(batch, used);
  //     })
  //     .filter(Boolean);

  //   if (allocation.length) {
  //     fieldsBatches.replace(allocation);
  //   }
  // }

  useEffect(() => {
    if (!autoPreselect) return;
    if (!sortedBatches.length) return;
    if (fieldsBatches.fields.length > 0) return;
    if (!requiredWarehouseQty) return;
    
    assignDrugBatches(
      [substance],
      totalVolume,
      fieldsBatches,
      getLabel,
      null,
      false
    );
  }, [autoPreselect, sortedBatches, requiredWarehouseQty]);

  const isButtonDisabled = () => {
    // No substance → no selection
    if (!substance) return true;

    // Required quantity already covered
    if (remainingQty <= 0) return true;

    // No more batches to add
    if (fieldsBatches.fields.length >= sortedBatches.length) return true;

    return false;
  };

  const buildBatchField = (batch, quantity) => ({
    value: batch.batch_number,
    label: batch.batch_number,
    batch_number: batch.batch_number,
    drug_batch_id: batch.drug_batch_id,
    quantity,
    expire_date: batch.expire_date,
    substance_id: substance?.substance_id || substance?.id,
    warehouse_unit: warehouseUnit?.label,
  });

  const getAllocatableQty = (batchStock, remainingQty) =>
    Math.max(Math.min(batchStock, remainingQty), 0);

  const addNextBatch = () => {
    const selected = new Set(fieldsBatches.fields.map((b) => b.batch_number));

    const nextBatch = sortedBatches.find((b) => !selected.has(b.batch_number));

    if (!nextBatch) return;

    const remaining = Math.max(
      requiredWarehouseQty -
        fieldsBatches.fields.reduce(
          (sum, b) => sum + (Number(b.quantity) || 0),
          0
        ),
      0
    );

    if (remaining <= 0) return;

    const qty = getAllocatableQty(nextBatch.stock, remaining);

    fieldsBatches.append(buildBatchField(nextBatch, qty));
  };

  const getSelectedBatchNumbersExceptIdx = (currentIdx) =>
    new Set(
      fieldsBatches.fields
        .filter((_, i) => i !== currentIdx)
        .map((f) => f?.batch_number)
        .filter(Boolean)
    );

  const getBatchOptionsForIdx = (idx) => {
    const selectedElsewhere = getSelectedBatchNumbersExceptIdx(idx);
    const currentValue = fieldsBatches.fields[idx]?.batch_number;
    const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

    const filteredBatches = sortedBatches
      ?.map((b) => ({
        ...b,
        is_disabled: b.expire_date < today,
      }))
      .sort((a, b) => a.expire_date.localeCompare(b.expire_date));

    return filteredBatches
      .filter((b) => {
        // skip current value if "used"
        if (b.batch_number === currentValue) return false;

        // exclude batches used in other rows
        return !selectedElsewhere.has(b.batch_number);
      })
      .map((b) => ({
        value: b.batch_number,
        label: `${b.batch_number} · exp ${format(
          new Date(b.expire_date),
          configs.shortDateFormat
        )}`,
        drug_batch_id: b.drug_batch_id,
        batch: b,
        is_disabled: b?.is_disabled ?? false,
      }));
  };

  /* --------------------------------------------------
   * Render
   * -------------------------------------------------- */

  const usedTotal = useMemo(
    () =>
      fieldsBatches.fields.reduce(
        (sum, b) => sum + (Number(b.quantity) || 0),
        0
      ),
    [fieldsBatches.fields]
  );

  const remainingQty = Math.max(requiredWarehouseQty - usedTotal, 0);

  const isEnoughStock = usedTotal >= requiredWarehouseQty;

  /* --------------------------------------------------
   * EARLY RETURN *AFTER* HOOKS (safe)
   * -------------------------------------------------- */
  if (!substance) {
    return null;
  }

  return (
    <div className="drug_batch_selector_wrapper">
      <h4>{substance?.name || substance?.substance_name || "—"}</h4>
      <div className="summary_wrapper">
        {/* ---- Summary ---- */}
        <div className="warehouse-summary">
          <p>
            <strong>{getLabel("treatmentRequiredQuantity")}:</strong>{" "}
            {requiredWarehouseQty.toFixed(3)} {warehouseUnit?.label}
          </p>

          <div className="warehouse-summary-status">
            <p>
              <strong>{getLabel("treatmentRemainingQuantity")}:</strong>{" "}
              {availableWarehouseQty?.toFixed(3)} {warehouseUnit?.label}
            </p>
            {!isEnoughStock && (
              <p className="error">
                ❌ {getLabel("treatmentQuantityNotSatisfied")}
              </p>
            )}
            {isEnoughStock && remainingQty <= 0 && (
              <p className="ok">✅ {getLabel("treatmentQuantitySatisfied")}</p>
            )}
          </div>
        </div>
        {isAutomaticCTA && (
          <div className="warehouse-cta">
            <Tooltip
              variant={"info"}
              html={getLabel("treatmentAssignDrugBatchesTooltip")}
              place="right"
              events={["hover"]}
            >
              <CTA
                // customClassName={"dialog confirm"}
                disabled={isEnoughStock}
                isRed={false}
                onClick={() =>
                  assignDrugBatches(
                    [substance],
                    totalVolume,
                    fieldsBatches,
                    getLabel,
                    null,
                    false
                  )
                }
              >
                {getLabel("treatmentAssignDrugBatches")}
              </CTA>
            </Tooltip>
          </div>
        )}
      </div>
      {batches?.length > 0 && (
        <div className="drug_batch_selector">
          {/* ---- Batch selection ---- */}
          <div className="substance_form_wrapper vertical">
            <h5>{getLabel("drugBatchNumbers")}</h5>
            {fieldsBatches.fields.map((field, idx) => (
              <div
                key={`drug_batch_${field.id}`}
                className="substance_form_wrapper_row card"
              >
                <div className="batch-wrapper">
                  <Select
                    name={`drug_batches_tmp.${idx}`}
                    control={control}
                    label={getLabel("drugBatch")}
                    placeholder={getLabel("drugBatchPlaceholder")}
                    options={getBatchOptionsForIdx(idx)}
                    disabled
                    onTableChange={(option) => {
                      if (!option?.batch) return;

                      const batch = option.batch;

                      const usedElsewhere = fieldsBatches.fields.reduce(
                        (sum, b, i) =>
                          i === idx ? sum : sum + (Number(b.quantity) || 0),
                        0
                      );

                      const remaining = Math.max(
                        requiredWarehouseQty - usedElsewhere,
                        0
                      );

                      const qty = getAllocatableQty(batch.stock, remaining);
                      //  console.log(batch, 'option', getAllocatableQty(batch.stock, remaining), batch.stock, remaining)

                      fieldsBatches.update(idx, buildBatchField(batch, qty));
                    }}
                  />

                  {field.batch_number && (
                    <p className="batch-stock">
                      {getLabel("treatmentUsedQuantity")}:{" "}
                      <strong>
                        {field?.quantity || "—"} {warehouseUnit?.label}
                      </strong>
                    </p>
                  )}
                  {field.batch_number && (
                    <p className="batch-date">
                      {getLabel("drugExpireDate")}:{" "}
                      <strong>
                        {field?.expire_date
                          ? format(
                              new Date(field.expire_date),
                              configs.shortDateFormat
                            )
                          : "-"}
                      </strong>
                    </p>
                  )}
                </div>
                {fieldsBatches.fields?.length > 1 && (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      fieldsBatches.remove(idx);

                      // if removed, recompute the quantities (do not readd the one just removed)
                      // autoAssignBatches(field?.batch_number);
                      assignDrugBatches(
                        [substance],
                        totalVolume,
                        fieldsBatches,
                        getLabel,
                        field?.batch_number,
                        false
                      );
                    }}
                  >
                    −
                  </button>
                )}
              </div>
            ))}

            <button
              type="button"
              className="add-batch-btn"
              disabled={isButtonDisabled()}
              onClick={addNextBatch}
            >
              +
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const DrugStock = ({
  type,
  register,
  control,
  errors,
  getUnitOptions,
  fieldsBatches,
  getValues,
  getError,
}) => {
  const [getLabel] = useLabels();
  const configs = useSelector(selectConfigs);
  const { auth } = useAuth();
  const currencySymbol = getCurrencySymbol(getCurrencyCode(auth?.user));

  return (
    <div className="drug_stock">
      <div className="substance_form_wrapper">
        {type === "treatment" && (
          <div>
            <div className="substance_form_wrapper_row">
              <div className="unit-selector">
                <Select
                  name="unit"
                  control={control}
                  label={getLabel("drugBatchUnit")}
                  placeholder={getLabel("drugBatchUnitPlaceholder")}
                  error={errors["unit"]}
                  required={getLabel("inputRequiredError")}
                  options={getUnitOptions()}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {type === "treatment" && (
        <div className="substance_form_wrapper vertical">
          <h5>{getLabel("drugBatchNumbers")}</h5>
          {getValues("unit") &&
            fieldsBatches?.fields?.map?.((field, idx) => {
              return (
                <div key={field.id} className="substance_form_wrapper_row card">
                  <Input
                    name={`batches.${idx}.batch_number`}
                    register={register}
                    label={getLabel(`drugBatchNumber`)}
                    placeholder={getLabel("drugBatchNumberPlaceholder")}
                    error={getError(idx, errors?.batches, "batch_number")}
                    required={getLabel("inputRequiredError")}
                    minLength={{
                      value: 3,
                      message: getLabel("errorMinLength", { value: 3 }),
                    }}
                    maxLength={{
                      value: 24,
                      message: getLabel("errorMaxLength", {
                        value: 24,
                      }),
                    }}
                    regExpPattern={{
                      value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
                      message: getLabel("errorAlphaNumSpace_-"),
                    }}
                  />
                  <Input
                    name={`batches.${idx}.supplier`}
                    error={getError(idx, errors?.batches, "supplier")}
                    register={register}
                    label={getLabel("drugBatchSupplier")}
                    placeholder={getLabel("drugBatchSupplierPlaceholder")}
                    minLength={{
                      value: 3,
                      message: getLabel("errorMinLength", { value: 3 }),
                    }}
                    maxLength={{
                      value: 32,
                      message: getLabel("errorMaxLength", { value: 32 }),
                    }}
                    regExpPattern={{
                      value: NUM_ALPHA_SPACE_APEX_DOT_REGEX,
                      message: getLabel("errorAlphaSpaceApexNum"),
                    }}
                    tooltip={
                      idx === 0
                        ? getLabel("drugBatchQuantityTooltip", {
                            unit: getValues("unit")?.label,
                          })
                        : ""
                    }
                  />
                  <DatePicker
                    name={`batches.${idx}.expire_date`}
                    control={control}
                    label={getLabel("drugExpireDate")}
                    error={errors["expire_date"]}
                    required={getLabel("inputRequiredError")}
                    dateFormat={configs.shortDateFormat}
                    placeholder={getLabel("expiringDatePlaceholder")}
                  />
                  <Input
                    name={`batches.${idx}.stock`}
                    customClassName="quantity"
                    error={getError(idx, errors?.batches, "stock")}
                    register={register}
                    type="number"
                    label={getLabel("drugBatchQuantity")}
                    placeholder={getLabel("drugBatchQuantityPlaceholder", {
                      unit: getValues("unit")?.label,
                    })}
                    // error={errors["new_batch_name"]}
                    required={getLabel("inputRequiredError")}
                    min={{
                      value: 0.1,
                      message: getLabel("errorMinValue", { value: 0.1 }),
                    }}
                    max={{
                      value: 100000,
                      message: getLabel("errorMaxValue", {
                        value: 100000,
                      }),
                    }}
                    regExpPattern={{
                      value:
                        getValues("unit")?.value === 5
                          ? INT_REGEX
                          : INT_FLOAT_REGEX,
                      message: getLabel("errorIntFloat"),
                    }}
                    tooltip={
                      idx === 0
                        ? getLabel("drugBatchQuantityTooltip", {
                            unit: getValues("unit")?.label,
                          })
                        : ""
                    }
                  />
                  <Input
                    name={`batches.${idx}.cost`}
                    customClassName="quantity"
                    error={getError(idx, errors?.batches, "cost")}
                    register={register}
                    type="number"
                    label={getLabel("drugBatchUnitCost")}
                    placeholder={getLabel("drugBatchUnitCostPlaceholder", {
                      currency: currencySymbol,
                      unit: getValues("unit")?.label,
                    })}
                    // error={errors["new_batch_name"]}
                    required={getLabel("inputRequiredError")}
                    min={{
                      value: 1,
                      message: getLabel("errorMinValue", { value: 1 }),
                    }}
                    regExpPattern={{
                      value: INT_FLOAT_REGEX,
                      message: getLabel("errorIntFloat"),
                    }}
                    tooltip={
                      idx === 0
                        ? getLabel("drugBatchUnitCostTooltip", {
                            batch: getValues(`batches.${idx}.batch_number`),
                            unit: getValues("unit")?.label,
                          })
                        : ""
                    }
                  />
                  {fieldsBatches?.fields?.length > 0 && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        fieldsBatches.remove(idx);
                      }}
                    >
                      -
                    </button>
                  )}
                </div>
              );
            })}
          <div className="substance_form_wrapper_row">
            <button
              id="batchesD"
              onClick={(e) => {
                e.preventDefault();
                fieldsBatches.append({
                  batchesData: {},
                });
              }}
            >
              +
            </button>
          </div>
        </div>
      )}
      {getValues("unit")?.value && (
        <h5>{getLabel("drugStockAlertConfiguration")}</h5>
      )}
      {getValues("unit")?.value && (
        <div className="substance_form_wrapper_row">
          <div className="unit-selector">
            <Input
              name={`min_stock`}
              register={register}
              type="number"
              label={getLabel(`drugStockMin`)}
              placeholder={getLabel("drugStockMinPlaceholder", {
                unit: `(${getValues("unit")?.label})` || "",
              })}
              error={errors["min_stock"]}
              min={{
                value: 1,
                message: getLabel("errorMinValue", { value: 1 }),
              }}
              max={{
                value: 1000,
                message: getLabel("errorMaxValue", {
                  value: 1000,
                }),
              }}
              regExpPattern={{
                value: INT_REGEX,
                message: getLabel("errorInt"),
              }}
              tooltip={getLabel("drugStockMinTooltip")}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const DrugForm = ({ register, control, errors, setValue, getValues }) => {
  const [getLabel] = useLabels();
  const axiosPrivate = useAxiosPrivate();
  const dispatch = useDispatch();
  const warehouseData = useSelector(selectWarehouseByType("oiv"));
  const [showWood, setShowWood] = useState(false);
  const [substancesByIndex, setSubstancesByIndex] = useState({});
  const [physicalOptionsByIndex, setPhysicalOptionsByIndex] = useState({});

  const { type, unit_id, compositions } = useWatch({ control });
  // const [coFormulated, setCoFormulated] = useState(is_co_formulated);

  const coFormulated = useWatch({ control, name: "is_co_formulated" });

  const fieldsCompositions = useFieldArray({
    control,
    name: "compositions",
  });

  const loadOIVSubstances = async () => {
    const oivSubstances = await getOIVSubstances(axiosPrivate);
    dispatch(setWarehouse({ type: "oiv", data: oivSubstances }));
  };

  useEffect(() => {
    if (!warehouseData || warehouseData?.length === 0) loadOIVSubstances();
  }, []);

  // useEffect(() => {
  //   const typeValue = type?.value;

  //   const updated = {};

  //   compositions?.forEach((comp, idx) => {
  //     const currentType = coFormulated ? comp?.type?.value : typeValue;
  //     const functionalValue = comp?.functional?.value;

  //     if (!functionalValue) return;

  //     const group = warehouseData?.find((w) => w?.group === functionalValue);
  //     console.log('g', group, 'cc', comp)
  //     setShowWood(group?.group === "Woods");

  //     const tmp =
  //       group?.substances
  //         ?.filter(
  //           (s) =>
  //             (currentType === "ADDITIVE" && s?.additive) ||
  //             (currentType === "ADJUVANT" && s?.processing_aid)
  //         )
  //         ?.map((s) => ({
  //           ...s,
  //           name: null,
  //           value: s?.name,
  //           label: getLabel(`drugLabel_${s?.name}`),
  //         })) ?? [];

  //     if (!coFormulated && tmp?.length === 0) {
  //       if (compositions.length > 1) {
  //         fieldsCompositions.remove(idx); // safe to remove
  //       } else {
  //         // reset instead of removing if only 1 left
  //         fieldsCompositions.update(idx, {
  //           type: { value: null, label: "" },
  //           functional: { value: null, label: "" },
  //           substance: { value: null, label: "" },
  //           physical: { value: null, label: "" },
  //           origins: [],
  //           quantity: 0,
  //         });
  //       }
  //       return;
  //     } else if (!coFormulated && tmp?.length > 0) {

  //     }

  //     updated[idx] = tmp.sort((a, b) => a?.label?.localeCompare(b?.label));
  //   });

  //   setSubstancesByIndex(updated);
  // }, [warehouseData, compositions, type]);

  // useEffect(() => {
  //   const typeValue = type?.value;
  //   const updated = {};

  //   compositions?.forEach((comp, idx) => {
  //     const currentType = coFormulated ? comp?.type?.value : typeValue;
  //     let functionalValue = comp?.functional?.value;
  //     let substanceValue = comp?.substance?.value;

  //     if (!functionalValue) return;

  //     const group = warehouseData?.find((w) => w?.group === functionalValue);
  //     if (group?.group === "Woods" && showWood !== true) {
  //       setShowWood(true);
  //     } else if (group?.group !== "Woods" && showWood !== false) {
  //       setShowWood(false);
  //     }

  //     // Filtro sostanze compatibili
  //     const filteredSubstances =
  //       group?.substances
  //         ?.filter(
  //           (s) =>
  //             (currentType === "ADDITIVE" && s?.additive) ||
  //             (currentType === "ADJUVANT" && s?.processing_aid)
  //         ) ?? [];

  //     // 🔁 VALIDAZIONI A CASCATA

  //     // Se non ci sono sostanze compatibili con il type selezionato → reset functional & substance
  //     if (filteredSubstances.length === 0) {
  //       if (compositions.length > 1) {
  //         fieldsCompositions.remove(idx); // remove row if more than 1
  //       } else {
  //         // reset composition to empty
  //         fieldsCompositions.update(idx, {
  //           type: { value: null, label: "" },
  //           functional: { value: null, label: "" },
  //           substance: { value: null, label: "" },
  //           physical: { value: null, label: "" },
  //           origins: [],
  //           quantity: 0,
  //         });
  //       }
  //       return;
  //     }

  //     // Se la substance selezionata non è più valida → reset
  //     const isSubstanceValid = filteredSubstances.some(
  //       (s) => s.name === substanceValue
  //     );

  //     if (!isSubstanceValid) {
  //       fieldsCompositions.update(idx, {
  //         ...comp,
  //         substance: { value: null, label: "" },
  //       });
  //     }

  //     updated[idx] = filteredSubstances
  //       .map((s) => ({
  //         ...s,
  //         name: null,
  //         value: s?.name,
  //         label: getLabel(`drugLabel_${s?.name}`),
  //       }))
  //       .sort((a, b) => a.label?.localeCompare(b.label));
  //   });
  //   console.log('updated', updated)
  //   setSubstancesByIndex(updated);
  // }, [warehouseData, compositions, type]);

  const getSubstanceGroups = (idx) => {
    const composition = compositions?.[idx];
    const typeValue = coFormulated ? composition?.type?.value : type?.value;
    if (!composition || !warehouseData || !Array.isArray(warehouseData))
      return [];

    // Filtra i gruppi in base al tipo (ADDITIVE o ADJUVANT)
    const filtered = warehouseData?.filter((oiv) =>
      oiv?.substances?.some(
        (s) =>
          (typeValue === "ADDITIVE" && s?.additive) ||
          (typeValue === "ADJUVANT" && s?.processing_aid)
      )
    );

    // Mappa ai gruppi
    return filtered
      .map((w) => ({
        value: w?.group,
        label: getLabel(`drugLabelGroup_${w?.group}`),
      }))
      ?.sort((a, b) => {
        if (a?.value === "Others") return 1;
        if (b?.value === "Others") return -1;
        return a?.label?.localeCompare(b?.label);
      });
  };

  const validateCompositionRows = () => {
    for (let i = 0; i < getValues("compositions")?.length; i++)
      validateCompositionRow(i);
  };

  const validateCompositionRow = (idx) => {
    const comps = getValues("compositions"); // to get updated values, compositions is not upto date yet

    const comp = comps?.[idx];
    const currentType = coFormulated
      ? comp?.type?.value
      : getValues("type")?.value;
    const functionalValue = comp?.functional?.value;
    const substanceValue = comp?.substance?.value;

    if (!functionalValue || !currentType) return;

    const group = warehouseData?.find((w) => w?.group === functionalValue);
    const compatibleSubstances =
      group?.substances?.filter(
        (s) =>
          (currentType === "ADDITIVE" && s.additive) ||
          (currentType === "ADJUVANT" && s.processing_aid)
      ) ?? [];

    // se nessuna sostanza è compatibile con quel type, resetto tutto
    if (compatibleSubstances.length === 0) {
      if (compositions.length > 1) {
        fieldsCompositions.remove(idx);
      } else {
        fieldsCompositions.update(idx, {
          type: { value: null, label: "" },
          functional: { value: null, label: "" },
          substance: { value: null, label: "" },
          physical: { value: null, label: "" },
          origins: [],
          quantity: 0,
        });
      }
      return;
    }

    // se la substance attuale non è valida, la resetto
    if (substanceValue !== null && substanceValue !== undefined) {
      const isValidSubstance = compatibleSubstances.some(
        (s) => s.name === substanceValue
      );

      if (!isValidSubstance) {
        fieldsCompositions.update(idx, {
          ...comp,
          substance: { value: null, label: "" },
        });
      }
    }

    // aggiorno le substances compatibili (es. per il select)
    setSubstancesByIndex((prev) => ({
      ...prev,
      [idx]: compatibleSubstances
        .map((s) => ({
          ...s,
          name: null,
          value: s.name,
          label: getLabel(`drugLabel_${s.name}`),
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    }));
  };

  useEffect(() => {
    const unitId = unit_id?.value || null;
    if (!unitId || !Array.isArray(compositions)) return;

    const unitToAllowedPhysicals = {
      1: ["POWDER", "GEL", "MICROGRANULE", "PASTE"],
      2: ["POWDER", "GEL", "MICROGRANULE", "PASTE"],
      4: ["POWDER", "GEL", "MICROGRANULE", "PASTE"],
      6: ["POWDER", "GEL", "MICROGRANULE", "PASTE"],
      7: ["POWDER", "GEL", "MICROGRANULE", "PASTE"],
      3: ["LIQUID"],
      5: ["TABLET"],
    };

    const allowed = unitToAllowedPhysicals[unitId] || [];
    const updated = {};

    compositions?.forEach((comp, idx) => {
      const physical = comp?.physical?.value || comp?.physical || null;

      // Confronta prima di fare setValue
      if (physical && !allowed.includes(physical)) {
        // Evita di chiamare setValue se è già null
        const current = comp?.physical;
        if (current?.value !== null && current?.label !== "") {
          setValue(`compositions.${idx}.physical`, { label: "", value: null });
        }
      }
      // Prepara le opzioni per questa riga
      updated[idx] = allowed
        .map((val) => ({
          label: getLabel(`drugLabel_${val}`),
          value: val,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    });

    setPhysicalOptionsByIndex(updated);
  }, [unit_id, compositions]);

  const getError = (idx, data, key) => {
    if (
      !errors ||
      Object.keys(errors)?.length === 0 ||
      !data ||
      data?.length <= idx
    )
      return;

    return data?.[idx]?.[key] || null;
  };

  return (
    <div className="row_wrapper">
      <div className="row">
        {!coFormulated && (
          <Select
            name="type"
            control={control}
            label={getLabel("drugType")}
            placeholder={getLabel("drugTypePlaceholder")}
            error={errors["type"]}
            required={getLabel("inputRequiredError")}
            options={[
              {
                value: "ADDITIVE",
                label: getLabel("drugType_ADDITIVE"),
              },
              {
                value: "ADJUVANT",
                label: getLabel("drugType_ADJUVANT"),
              },
              {
                value: "DETERGENT",
                label: getLabel("drugType_DETERGENT"),
              },
            ]}
            onTableChange={() => validateCompositionRows()}
          />
        )}
        {type?.value !== "DETERGENT" && (
          <Input
            name={"is_co_formulated"}
            register={register}
            error={errors["is_co_formulated"]}
            // isLabel={false}
            type={"checkbox"}
            label={getLabel("drugSubType_isCoFormulated")}
            checked={coFormulated}
            // onChange={() => setCoFormulated((prev) => !prev)}
            onChange={() => setValue("is_co_formulated", !coFormulated)}
            customClassName={"confirm no_margin_top"}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // Prevent default Enter behavior (e.g., form submission)
                // setCoFormulated((prev) => !prev);
                setValue("is_co_formulated", !coFormulated);
              }
            }}
          />
        )}
      </div>
      {type?.value !== "DETERGENT" && (
        <div className="substance_form_wrapper_row wrap">
          {/* <h4>{getLabel("drugIngredients")}</h4> */}
          {fieldsCompositions?.fields
            ?.filter((_, index) => coFormulated || index === 0)
            ?.map?.((field, idx) => {
              return (
                <div key={field.id} className="row_wrapper row_container">
                  {/* <MultipleSelect */}
                  {coFormulated && (
                    <Select
                      name={`compositions.${idx}.type`}
                      control={control}
                      label={getLabel("drugType")}
                      placeholder={getLabel("drugTypePlaceholder")}
                      error={getError(idx, errors?.compositions, "type")}
                      required={getLabel("inputRequiredError")}
                      options={[
                        {
                          value: "ADDITIVE",
                          label: getLabel("drugType_ADDITIVE"),
                        },
                        {
                          value: "ADJUVANT",
                          label: getLabel("drugType_ADJUVANT"),
                        },
                      ]}
                      onTableChange={() => validateCompositionRow(idx)}
                    />
                  )}
                  <Select
                    name={`compositions.${idx}.functional`}
                    control={control}
                    isDisabled={
                      coFormulated ? !compositions?.[idx]?.type?.value : !type
                    }
                    label={getLabel("drugLabelFunctional")}
                    error={getError(idx, errors?.compositions, "functional")}
                    placeholder={getLabel("drugLabelFunctionalPlaceholder")}
                    options={getSubstanceGroups(idx)}
                    isSearchable={true}
                    onTableChange={() => validateCompositionRow(idx)}
                  />
                  <Select
                    name={`compositions.${idx}.substance`}
                    control={control}
                    isDisabled={
                      (coFormulated
                        ? !compositions?.[idx]?.type?.value
                        : !type) || !compositions?.[idx]?.functional
                    }
                    label={getLabel("drugLabelSubstance")}
                    placeholder={getLabel("drugLabelSubstancePlaceholder")}
                    error={getError(idx, errors?.compositions, "substance")}
                    options={substancesByIndex?.[idx] || []}
                    isSearchable={true}
                    onTableChange={() => validateCompositionRow(idx)}
                  />
                  {!showWood && (
                    <Select
                      name={`compositions.${idx}.physical`}
                      control={control}
                      isDisabled={
                        coFormulated ? !compositions?.[idx]?.type?.value : !type
                      }
                      label={getLabel("drugLabelPhysical")}
                      placeholder={getLabel("drugLabelPhysicalPlaceholder")}
                      error={getError(idx, errors?.compositions, "physical")}
                      options={physicalOptionsByIndex?.[idx] || []}
                    />
                  )}
                  <MultipleSelect
                    name={`compositions.${idx}.origins`}
                    control={control}
                    label={getLabel("drugLabelOrigins")}
                    error={getError(idx, errors?.compositions, "origins")}
                    placeholder={getLabel("drugLabelOriginsPlaceholder")}
                    isDisabled={
                      coFormulated ? !compositions?.[idx]?.type?.value : !type
                    }
                    options={[
                      {
                        label: getLabel("drugLabel_ORGANIC"),
                        value: "ORGANIC",
                      },
                      {
                        label: getLabel("drugLabel_SYNTHETIC"),
                        value: "SYNTHETIC",
                      },
                      {
                        label: getLabel("drugLabel_MINERAL"),
                        value: "MINERAL",
                      },
                      { label: getLabel("drugLabel_PLANT"), value: "PLANT" },
                      { label: getLabel("drugLabel_ANIMAL"), value: "ANIMAL" },
                      {
                        label: getLabel("drugLabel_MICROBIOLOGIC"),
                        value: "MICROBIOLOGIC",
                      },
                      ...(showWood
                        ? [
                            { label: getLabel("drugLabel_OAK"), value: "OAK" },
                            {
                              label: getLabel("drugLabel_CHESTNUT"),
                              value: "CHESTNUT",
                            },
                            {
                              label: getLabel("drugLabel_GRAPE_DERIVED"),
                              value: "GRAPE_DERIVED",
                            },
                          ]
                        : []),
                    ]?.sort((a, b) => a?.label?.localeCompare(b?.label))}
                  />

                  {coFormulated && compositions?.[idx]?.substance?.value && (
                    <Input
                      name={`compositions.${idx}.quantity`}
                      error={getError(idx, errors?.compositions, "quantity")}
                      register={register}
                      type="number"
                      customClassName={"small"}
                      label={getLabel("drugIngredientQuantity")}
                      placeholder={getLabel(
                        "drugIngredientQuantityPlaceholder"
                      )}
                      required={getLabel("inputRequiredError")}
                      min={{
                        value: 1,
                        message: getLabel("errorMinValue", { value: 1 }),
                      }}
                      max={{
                        value: 100,
                        message: getLabel("errorMaxValue", {
                          value: 100,
                        }),
                      }}
                      regExpPattern={{
                        value: INT_REGEX,
                        message: getLabel("errorInt"),
                      }}
                      tooltip={
                        idx === 0
                          ? getLabel("drugIngredientQuantityTooltip")
                          : ""
                      }
                    />
                  )}
                  {fieldsCompositions?.fields?.length > 1 && coFormulated && (
                    <div key={"minus_button"} className="minus_button">
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          fieldsCompositions.remove(idx);
                        }}
                      >
                        -
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          {coFormulated && (
            <div key={"plus_button"} className="row_wrapper">
              <button
                id="batchesD"
                onClick={(e) => {
                  e.preventDefault();
                  fieldsCompositions.append({
                    ingredientData: {},
                  });
                }}
              >
                +
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const RecurrentDatesSelector = ({
  control,
  errors,
  getLabel,
  configs,
  isTime = false,
}) => {
  const { fields, append, remove, update } = useFieldArray({
    control,
    name: "recursive_dates",
  });

  const updateDate = (id, newDate) => {
    const new_date = isTime ? newDate : new Date(newDate?.setHours(23, 59, 59));
    const index = fields.findIndex((item) => item.id === id);
    if (index !== -1) {
      update(index, { ...fields[index], date: new_date });
    }
  };

  const deleteDate = (id) => {
    const index = fields.findIndex((item) => item.id === id);
    if (index !== -1) {
      remove(index);
    }
  };

  const addDate = () => {
    append({
      id: `${Date.now()}-${Math.random()}`,
      date: null,
      format: isTime ? configs.dateFormat : configs.mediumDateFormat,
      checked: true,
    });
  };

  const sortedFields = [...fields].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  return (
    <div className="recursive_date_wrapper">
      <ul className="recursive_date">
        {sortedFields.map((item) => {
          const index = fields.findIndex((f) => f.id === item.id);
          return (
            <li key={item.id} className="recursive_date_li">
              <DatePicker
                name={`recursive_dates.${index}.date`}
                control={control}
                error={errors?.recursive_dates?.[index]?.date}
                isLabel={false}
                required={getLabel("inputRequiredError")}
                dateFormat={item.format}
                isTime={isTime}
                defaultValue={item.date}
                onChange={(newDate) => updateDate(item.id, newDate)}
              />
              <div className="button_wrapper">
                <CTA
                  customClassName="delete"
                  onClick={() => deleteDate(item.id)}
                >
                  X
                </CTA>
              </div>
            </li>
          );
        })}
      </ul>
      <div className="add_date_button_wrapper">
        <button className="add-button" onClick={addDate}>
          {getLabel("addNewRow")}
        </button>
      </div>
    </div>
  );
};

const OperationRecap = ({
  id = null,
  control,
  errors,
  register,
  getValues,
  setValue,
  setError,
  clearErrors,
  availableLotNames = [],
  lotNames = [],
  src_tanks = [],
  dest_tanks = [],
  step,
  totalStep = 0,
  setStep = () => null,
  setFocus,
  type,
  operationType = null,
  configs,
  lots,
  tanks,
  units,
  drugs,
  setFile,
  isScale = true,
  setPointBoundaries = {},
  isCredential = false,
  additionalType = null,
  additionalSubtype = null,
  additionalData = [],
  arrayFields = [],
  isAutomaticCTA = false,
  rectifyResetStatus = null,
  rectifyResetTotalFilteredLiters = null,
}) => {
  const [getLabel] = useLabels();
  const bottleTypes = useSelector(selectBottleTypes);
  const machineryTypes = useSelector(selectMachineryTypes);
  const { auth } = useAuth();
  const currencySymbol = getCurrencySymbol(getCurrencyCode(auth?.user));

  const customId = "custom-id-reuse-name";

  const filterUnits = () => {
    const allowedTreatmentTypes = [1, 2, 6]; // mg/L, g/hL, g/L needed for concentrations
    return [
      ...units?.filter((u) =>
        type === "treatment" ? allowedTreatmentTypes.includes(u?.id) : true
      ),
    ]?.sort(function (a, b) {
      var textA = a.label.toUpperCase();
      var textB = b.label.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  };

  const getUnitOptions = (substance) => {
    const unit_id = substance?.unit_id || null;
    if (!unit_id) return [];

    const options = [
      {
        value: "3",
        label: getLabel("drugBatchUnit_L"),
      },
      {
        value: "4",
        label: getLabel("drugBatchUnit_Kg"),
      },
      {
        value: "5",
        label: getLabel("drugBatchUnit_Unit"),
      },
    ];

    switch (unit_id) {
      case 1:
      case 2:
      case 4:
      case 6:
      case 7:
        // Kg
        return [options[1]];
      case 3:
        // L
        return [options[0]];
      case 5:
        // unit
        return [options[2]];
    }

    return [];
  };

  const getBottleCapacityOptions = () => {
    const options = [];
    for (const type of bottleTypes) {
      const value = type?.value;
      if (!value) continue;
      const translated = getLabel(`bottleVolume_${value}`);
      const translatedVol = getLabel(`bottleVolume_${value}_Vol`);

      options.push({
        value,
        label: translated,
        name: `${translated} (${translatedVol})`,
      });
    }
    return options;
  };

  const getMachineryOptions = () => {
    const options = [];
    for (const type of machineryTypes) {
      const value = type?.value;
      if (!value) continue;

      options.push({
        value,
        label: getLabel(`machineryType_${value}`),
      });
    }
    return options;
  };

  const getFilterPorosityOptions = () => {
    switch (additionalSubtype?.toUpperCase?.()) {
      case "CARTON":
        return [
          { label: getLabel("filterPorosity_FINE"), value: 0.45 },
          { label: getLabel("filterPorosity_MEDIUM"), value: 0.8 },
          { label: getLabel("filterPorosity_COARSE"), value: 1.2 },
        ];

      case "TANGENTIAL":
      case "CANDLE":
        return [
          { label: getLabel("filterPorosity_ULTRA"), value: 0.1 },
          { label: getLabel("filterPorosity_STERILE"), value: 0.2 },
          { label: getLabel("filterPorosity_FINE"), value: 0.45 },
          { label: getLabel("filterPorosity_MEDIUM"), value: 0.65 },
          { label: getLabel("filterPorosity_COARSE"), value: 0.8 },
          { label: getLabel("filterPorosity_VERY_COARSE"), value: 1.2 },
        ];

      case "HOUSING":
        return [
          { label: getLabel("filterPorosity_ULTRA"), value: 0.1 },
          { label: getLabel("filterPorosity_STERILE"), value: 0.2 },
          { label: getLabel("filterPorosity_FINE"), value: 0.45 },
          { label: getLabel("filterPorosity_MEDIUM"), value: 0.65 },
          { label: getLabel("filterPorosity_COARSE"), value: 0.8 },
          { label: getLabel("filterPorosity_VERY_COARSE"), value: 1.2 },
          { label: getLabel("filterPorosity_ULTRA_COARSE"), value: 3 },
          { label: getLabel("filterPorosity_SUPER_COARSE"), value: 5 },
          { label: getLabel("filterPorosity_GROSS_COARSE"), value: 8 },
          { label: getLabel("filterPorosity_MEGA_COARSE"), value: 10 },
        ];

      default:
        return [];
    }
  };

  const getFilterMaxCapacityOptions = () => {
    const capacityRange = {
      CARTON: { min: 500, max: 20000 },
      TANGENTIAL: { min: 2000, max: 100000 },
      HOUSING: { min: 1000, max: 10000 },
    };
    return capacityRange?.[additionalSubtype?.toUpperCase?.()];
  };

  const getError = (idx, data, key) => {
    if (
      !errors ||
      Object.keys(errors)?.length === 0 ||
      !data ||
      data?.length <= idx
    )
      return;

    return data?.[idx]?.[key] || null;
  };

  useEffect(() => {
    if (step < src_tanks?.length && type === "ANALYSIS") {
      const t = src_tanks[step];
      if (t) {
        const name = `temperature.${t?.tank_id || t?.batch_id}`;
        setFocus(name);
      }
    }
  }, [step, src_tanks, setFocus]);

  const renderByType = () => {
    if (type === "NEW_DRUG_BATCH")
      return (
        <DrugBatchSelector
          type={"treatment"}
          configs={configs}
          register={register}
          control={control}
          errors={errors}
          substance={additionalData}
          totalVolume={additionalSubtype}
          fieldsBatches={arrayFields}
          getValues={getValues}
          getError={getError}
          autoPreselect={id === null}
          isAutomaticCTA={isAutomaticCTA}
        />
      );
    else if (type === "WINEMAKING_OPERATIONS")
      return (
        <WineMakingProtocolModalChildren
          type={operationType === "CLEANING" ? "CIP" : (operationType || type)}
          operation={additionalData}
          // operation={!id ? modalOperation : watchedOperation}
          register={register}
          errors={errors}
          control={control}
          drugs={drugs}
          getLabel={getLabel}
          getValues={getValues}
          setValue={setValue}
          // setCheckboxState={setCheckbox(!checkbox)}
        />
      );
    else if (type === "NEW_STOCK")
      return (
        <DrugStock
          type={"treatment"}
          register={register}
          control={control}
          errors={errors}
          getUnitOptions={getUnitOptions}
          fieldsBatches={arrayFields}
          getValues={getValues}
          getError={getError}
        />
      );
    else if (type === "NEW_TREATMENT")
      return (
        <div className="rows">
          <h5>{getLabel("drugTitle")}</h5>
          <div className="row_wrapper">
            <Input
              name="name"
              register={register}
              type="text"
              label={getLabel("drugName")}
              placeholder={getLabel("drugNamePlaceholder")}
              error={errors["name"]}
              required={getLabel("inputRequiredError")}
              minLength={{
                value: 3,
                message: getLabel("errorMinLength", { value: 3 }),
              }}
              maxLength={{
                value: 24,
                message: getLabel("errorMaxLength", { value: 24 }),
              }}
              regExpPattern={{
                value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
                message: getLabel("errorAlphaNumSpace_-"),
              }}
            />
            <Select
              name="unit_id"
              control={control}
              label={getLabel("unit")}
              placeholder={getLabel("unitPlaceholder")}
              error={errors["unit"]}
              required={getLabel("inputRequiredError")}
              options={filterUnits()}
              tooltip={getLabel("unitDrugTooltip")}
              defaultValue={{
                value: 0,
                label: "",
              }}
            />
          </div>
          <h5>{getLabel("substanceLabels")}</h5>
          <DrugForm
            register={register}
            errors={errors}
            control={control}
            setValue={setValue}
            getValues={getValues}
            // remove={remove}
            is_co_formulated={getValues("is_co_formulated") || false}
          />
          <h5>{getLabel("substanceApplicationRang")}</h5>
          <div className="row_wrapper">
            <Input
              name="min_range"
              register={register}
              type="number"
              label={getLabel("drugMinRange")}
              placeholder={getLabel("drugMinRangePlaceholder")}
              error={errors["min_range"]}
              minLength={{
                value: 1,
                message: getLabel("errorMinLength", { value: 1 }),
              }}
              maxLength={{
                value: 7,
                message: getLabel("errorMaxLength", { value: 7 }),
              }}
              regExpPattern={{
                value: INT_FLOAT_REGEX,
                message: getLabel("errorIntFloat"),
              }}
              max={{
                value: getValues("max_range")?.toString() || null,
                message: getLabel("errorDrugQuantityOverMax"),
              }}
            />
            <Input
              name="max_range"
              register={register}
              type="number"
              label={getLabel("drugMaxRange")}
              placeholder={getLabel("drugMaxRangePlaceholder")}
              error={errors["max_range"]}
              minLength={{
                value: 1,
                message: getLabel("errorMinLength", { value: 1 }),
              }}
              maxLength={{
                value: 7,
                message: getLabel("errorMaxLength", { value: 7 }),
              }}
              regExpPattern={{
                value: INT_FLOAT_REGEX,
                message: getLabel("errorIntFloat"),
              }}
              min={{
                value: getValues("min_range")?.toString() || -1,
                message: getLabel("errorDrugQuantityUnderMin"),
              }}
            />
            <Input
              name="quantity"
              register={register}
              type="number"
              required={getLabel("inputRequiredError")}
              label={getLabel("drugIdealQuantity")}
              placeholder={getLabel("drugIdealQuantityPlaceholder")}
              error={errors["quantity"]}
              minLength={{
                value: 1,
                message: getLabel("errorMinLength", { value: 1 }),
              }}
              maxLength={{
                value: 7,
                message: getLabel("errorMaxLength", { value: 7 }),
              }}
              regExpPattern={{
                value: INT_FLOAT_REGEX,
                message: getLabel("errorIntFloat"),
              }}
              min={{
                value: getValues("min_range")?.toString() || -1,
                message: getLabel("errorDrugQuantityUnderMin"),
              }}
              max={{
                value: getValues("max_range")?.toString() || null,
                message: getLabel("errorDrugQuantityOverMax"),
              }}
            />
          </div>
          <h5>{getLabel("substanceTemperature")}</h5>
          <div className="row_wrapper">
            <Input
              name="min_temperature"
              register={register}
              type="number"
              label={getLabel("drugMinTemperature")}
              placeholder={getLabel("drugMaxTempPlaceholder")}
              error={errors["min_temperature"]}
              minLength={{
                value: 1,
                message: getLabel("errorMinLength", { value: 1 }),
              }}
              maxLength={{
                value: 7,
                message: getLabel("errorMaxLength", { value: 7 }),
              }}
              regExpPattern={{
                value: INT_FLOAT_REGEX,
                message: getLabel("errorIntFloat"),
              }}
              max={{
                value: getValues("max_temperature")?.toString() || null,
                message: getLabel("errorDrugTemperatureOverMax"),
              }}
            />
            <Input
              name="max_temperature"
              register={register}
              type="number"
              label={getLabel("drugMaxTemperature")}
              placeholder={getLabel("drugMaxTempPlaceholder")}
              error={errors["max_temperature"]}
              minLength={{
                value: 1,
                message: getLabel("errorMinLength", { value: 1 }),
              }}
              maxLength={{
                value: 7,
                message: getLabel("errorMaxLength", { value: 7 }),
              }}
              regExpPattern={{
                value: INT_FLOAT_REGEX,
                message: getLabel("errorIntFloat"),
              }}
              min={{
                value: getValues("min_temperature")?.toString() || -1,
                message: getLabel("errorDrugTemperatureUnderMin"),
              }}
            />
          </div>
          <h5>{getLabel("drugAdditionalNotes")}</h5>
          <div className="row_wrapper">
            <TextArea
              name="notes"
              register={register}
              label={getLabel("drugNotes")}
              placeholder={getLabel("drugNotesPlaceholder")}
              error={errors["notes"]}
              maxLength={{
                value: 100,
                message: getLabel("errorMaxLength", { value: 100 }),
              }}
            />
          </div>
        </div>
      );
    else if (type === "REMOVE_TREATMENT")
      return (
        <div className="remove_item">
          <Label label={getLabel("drugName")}>
            {additionalData?.[0]?.name}
          </Label>
          <Label label={getLabel("drugQuantity")}>
            {`${additionalData?.[0]?.quantity} ${
              additionalData?.[0]?.unit || ""
            }`}
          </Label>
          <Label label={getLabel("drugType")}>
            {getLabel(`drugType_${additionalData?.[0]?.type}`)}
          </Label>
        </div>
      );
    else if (type === "REMOVE_WAREHOUSE")
      return (
        <div className="remove_item">
          <Label
            label={getLabel(
              additionalType === "bottles" ? "bottleName" : 
              additionalType === "filters" ? "filterName" : "capName"
            )}
          >
            {additionalData?.[0]?.name || additionalData?.[0]?.filter_name || additionalData?.[0]?.serial_number}
          </Label>
          {["bottles", "caps"].includes(additionalType) && <Label
            label={getLabel(
              additionalType === "bottles" ? "bottleOrigin" : "capOrigin"
            )}
          >
            {additionalData?.[0]?.origin}
          </Label>}
          {["bottles", "caps"].includes(additionalType) && <Label
            label={getLabel(
              additionalType === "bottles" ? "bottleQuantity" : "capQuantity"
            )}
          >
            {additionalData?.[0]?.quantity}
          </Label>}

          {["filters"].includes(additionalType) && additionalData?.[0]?.filter_name && <Label
            label={getLabel("filterSerialNumber")}
          >
            {additionalData?.[0]?.serial_number}
          </Label>}
        </div>
      );
    else if (type === "NEW_WAREHOUSE")
      return (
        <div className="new_item">
          {["bottles", "caps"].includes(additionalType) && (
            <div className="row_wrapper">
              <Input
                name={"new_warehouse_name"}
                // error={"new_warehouse_name"}
                error={errors["new_warehouse_name"]}
                register={register}
                type="text"
                label={getLabel(
                  additionalType === "bottles" ? "bottleName" : "capName"
                )}
                placeholder={getLabel("operationNewBatchNamePlaceholder")}
                required={getLabel("inputRequiredError")}
                minLength={{
                  value: 3,
                  message: getLabel("errorMinLength", { value: 3 }),
                }}
                maxLength={{
                  value: 24,
                  message: getLabel("errorMaxLength", {
                    value: 24,
                  }),
                }}
                regExpPattern={{
                  value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
                  message: getLabel("errorAlphaNumSpace_-"),
                }}
                validate={(value) => {
                  if (
                    additionalData?.some(
                      (c) =>
                        c?.name?.toLowerCase() === value?.toLowerCase()?.trim()
                    )
                  ) {
                    return getLabel("errorNewCapNameAlreadyTaken", {
                      name: value,
                    });
                  }

                  return true; // Validation passed
                }}
              />
              <Input
                name={"new_warehouse_origin"}
                error={"new_warehouse_origin"}
                register={register}
                type="text"
                label={getLabel(
                  additionalType === "bottles" ? "bottleOrigin" : "capOrigin"
                )}
                placeholder={getLabel("capOriginPlaceholder")}
                minLength={{
                  value: 3,
                  message: getLabel("errorMinLength", { value: 3 }),
                }}
                maxLength={{
                  value: 24,
                  message: getLabel("errorMaxLength", {
                    value: 24,
                  }),
                }}
                regExpPattern={{
                  value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
                  message: getLabel("errorAlphaNumSpace_-"),
                }}
              />
              {additionalType === "bottles" && (
                <Select
                  control={control}
                  defaultValue={{
                    value: "",
                    label: "",
                  }}
                  name={"new_warehouse_bottles_capacity"}
                  label={getLabel("bottleCapacity")}
                  placeholder={getLabel("bottleCapacityPlaceholder")}
                  error={errors}
                  required={getLabel("inputRequiredError")}
                  options={getBottleCapacityOptions()}
                />
              )}
              <Input
                name={"new_warehouse_quantity"}
                label={getLabel(
                  additionalType === "bottles"
                    ? "bottleQuantity"
                    : "capQuantity"
                )}
                placeholder={getLabel("capQuantityPlaceholder")}
                // tooltip={getLabel("bulkStartTooltip")}
                register={register}
                error={errors["new_warehouse_quantity"]}
                required={getLabel("inputRequiredError")}
                type="number"
                min={{
                  value: 1,
                  message: getLabel("errorMinValue", { value: 1 }),
                }}
                max={{
                  value: 1000000,
                  message: getLabel("errorMaxValue", { value: 1000000 }),
                }}
                regExpPattern={{
                  value: INT_REGEX,
                  message: getLabel("errorInt"),
                }}
              />
            </div>
          )}
          {additionalType === "machineries" && (
            <div className="row_wrapper">
              <Input
                name={"new_warehouse_name"}
                // error={"new_warehouse_name"}
                error={errors["new_warehouse_name"]}
                register={register}
                type="text"
                label={getLabel("machineryName")}
                placeholder={getLabel("machineryNamePlaceholder")}
                required={getLabel("inputRequiredError")}
                minLength={{
                  value: 3,
                  message: getLabel("errorMinLength", { value: 3 }),
                }}
                maxLength={{
                  value: 24,
                  message: getLabel("errorMaxLength", {
                    value: 24,
                  }),
                }}
                regExpPattern={{
                  value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
                  message: getLabel("errorAlphaNumSpace_-"),
                }}
                validate={(value) => {
                  if (
                    additionalData?.some(
                      (c) =>
                        c?.name?.toLowerCase() === value?.toLowerCase()?.trim()
                    )
                  ) {
                    return getLabel("errorNewCapNameAlreadyTaken", {
                      name: value,
                    });
                  }

                  return true; // Validation passed
                }}
              />
              <Select
                control={control}
                defaultValue={{
                  value: "",
                  label: "",
                }}
                name={"new_warehouse_machinery_type"}
                label={getLabel("machineryType")}
                placeholder={getLabel("machineryTypePlaceholder")}
                error={errors}
                required={getLabel("inputRequiredError")}
                options={getMachineryOptions()}
              />
            </div>
          )}
          {additionalType === "filters" && additionalSubtype === "candle" && (
            <div className="row_wrapper">
              <FilterCandle
                register={register}
                control={control}
                errors={errors}
                getFilterPorosityOptions={getFilterPorosityOptions}
                getFilterMaxCapacityOptions={getFilterMaxCapacityOptions}
                getValues={getValues}
              />
            </div>
          )}

          {additionalType === "filters" && additionalSubtype !== "candle" && (
            <>
              <div className="row_wrapper">
                <Input
                  name={"new_filter_name"}
                  // error={"new_warehouse_name"}
                  error={errors["new_filter_name"]}
                  register={register}
                  type="text"
                  label={getLabel(
                    additionalSubtype === "housing"
                      ? "filterHousingName"
                      : "filterName"
                  )}
                  placeholder={getLabel("filterNamePlaceholder")}
                  required={getLabel("inputRequiredError")}
                  minLength={{
                    value: 3,
                    message: getLabel("errorMinLength", { value: 3 }),
                  }}
                  maxLength={{
                    value: 24,
                    message: getLabel("errorMaxLength", {
                      value: 24,
                    }),
                  }}
                  regExpPattern={{
                    value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
                    message: getLabel("errorAlphaNumSpace_-"),
                  }}
                  validate={(value) => {
                    if (
                      additionalData?.some(
                        (c) =>
                          c?.name?.toLowerCase() ===
                          value?.toLowerCase()?.trim()
                      )
                    ) {
                      return getLabel("errorNewCapNameAlreadyTaken", {
                        name: value,
                      });
                    }

                    return true; // Validation passed
                  }}
                />
                <Input
                  name={"serial_number"}
                  // error={"new_warehouse_name"}
                  error={errors["serial_number"]}
                  register={register}
                  type="text"
                  label={getLabel(
                    additionalSubtype === "housing"
                      ? "filterHousingSerialNumber"
                      : "filterSerialNumber"
                  )}
                  placeholder={getLabel("filterSerialNumberPlaceholder")}
                  // required={getLabel("inputRequiredError")}
                  minLength={{
                    value: 3,
                    message: getLabel("errorMinLength", { value: 3 }),
                  }}
                  maxLength={{
                    value: 24,
                    message: getLabel("errorMaxLength", {
                      value: 24,
                    }),
                  }}
                  regExpPattern={{
                    value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
                    message: getLabel("errorAlphaNumSpace_-"),
                  }}
                />
              </div>
              <div className="row_wrapper">
                {additionalSubtype !== "housing" && (
                  <Select
                    control={control}
                    // defaultValue={}
                    name={"porosity"}
                    label={getLabel("filterPorosity")}
                    placeholder={getLabel("filterPorosityPlaceholder")}
                    error={errors}
                    required={getLabel("inputRequiredError")}
                    options={getFilterPorosityOptions()}
                  />
                )}
                {additionalSubtype !== "housing" && (
                  <Input
                    name={"max_filter_capacity"}
                    register={register}
                    customClassName="quantity"
                    error={errors["max_filter_capacity"]}
                    type="number"
                    label={getLabel("filterMaxCapacityUnit")}
                    placeholder={getLabel("filterMaxCapacityPlaceholder")}
                    // min={{
                    //   value: getFilterMaxCapacityOptions()?.min || 1,
                    //   message: getLabel("errorMinValue", {
                    //     value: getFilterMaxCapacityOptions()?.min || "1",
                    //   }),
                    // }}
                    max={{
                      value: getFilterMaxCapacityOptions()?.max || 100000,
                      message: getLabel("errorMaxValue", {
                        value: getFilterMaxCapacityOptions()?.max || "100000",
                      }),
                    }}
                    // required={getLabel("inputRequiredError")}
                  />
                )}
                {additionalSubtype === "carton" && (
                  <Input
                    name={"cost"}
                    customClassName="quantity"
                    error={errors["cost"]}
                    register={register}
                    type="number"
                    label={getLabel("drugBatchUnitCost")}
                    placeholder={getLabel("drugBatchUnitCostPlaceholder", {
                      currency: currencySymbol,
                      unit: getValues("unit")?.label,
                    })}
                    required={getLabel("inputRequiredError")}
                    min={{
                      value: 1,
                      message: getLabel("errorMinValue", { value: 1 }),
                    }}
                    regExpPattern={{
                      value: INT_FLOAT_REGEX,
                      message: getLabel("errorIntFloat"),
                    }}
                    tooltip={getLabel("drugBatchUnitCostTooltip", {
                      batch: getValues("new_filter_name"),
                      unit: "", //getValues("unit")?.label,
                    })}
                  />
                )}
              </div>
            </>
          )}
          {additionalType === "filters" && additionalSubtype === "housing" && (
            <FilterCandleStock
              control={control}
              errors={errors}
              candlesOptions={additionalData}
              fieldsBatches={arrayFields}
              getValues={getValues}
            />
          )}
          {/* {additionalType === "filters" && additionalSubtype === "tangential" && (
            <Input
              name={"membrane_count"}
              register={register}
              error={errors["membrane_count"]}
              type="number"
              label={getLabel("filterMembraneCount")}
              placeholder={getLabel("filterMembraneCountPlaceholder")}
              min={{
                value: 1,
                message: getLabel("errorMinValue", {
                  value: "1",
                }),
              }}
              max={{
                value: 24,
                message: getLabel("errorMaxValue", {
                  value: "24",
                }),
              }}
              required={getLabel("inputRequiredError")}
            />)} */}
          <TextArea
            name="new_filter_notes"
            register={register}
            label={getLabel(
              additionalType === "bottles" ? "bottleNote" : "capNote"
            )}
            placeholder={getLabel("clientNotesPlaceholder")}
            // error={errors["new_warehouse_notes"]}
          />
        </div>
      );
    else if (type === "RECTIFY_WAREHOUSE")
      return (
        <div className="new_item rectify_item">
          {["caps", "bottles"].includes(additionalType) && (
            <>
              <div className="rectify_info_banner">
                <p>{getLabel("rectifyInfoDeactivated")}</p>
              </div>
              <div className="row_wrapper">
                <Input
                  name={"rectify_quantity"}
                  error={errors["rectify_quantity"]}
                  register={register}
                  type="number"
                  label={getLabel("rectifyQuantity")}
                  placeholder={getLabel("rectifyQuantityPlaceholder")}
                  required={getLabel("inputRequiredError")}
                  min={{
                    value: 0,
                    message: getLabel("errorMinValue", { value: 0 }),
                  }}
                  max={{
                    value: 1000000,
                    message: getLabel("errorMaxValue", { value: 1000000 }),
                  }}
                  regExpPattern={{
                    value: INT_REGEX,
                    message: getLabel("errorInt"),
                  }}
                />
              </div>
            </>
          )}
          {additionalType === "filters" &&
            !["housing", "candle"].includes(additionalSubtype) && (
              <>
                <div className="rectify_info_banner">
                  <p>{getLabel("rectifyInfoExhausted")}</p>
                </div>
                <div className="row_wrapper">
                  <Input
                    name={"rectify_max_capacity"}
                    error={errors["rectify_max_capacity"]}
                    register={register}
                    type="number"
                    label={getLabel("rectifyMaxCapacity")}
                    placeholder={getLabel("rectifyMaxCapacityPlaceholder")}
                    required={getLabel("inputRequiredError")}
                    min={{
                      value: 1,
                      message: getLabel("errorMinValue", { value: 1 }),
                    }}
                  />
                  <Input
                    name={"rectify_reset_status"}
                    register={register}
                    type={"checkbox"}
                    label={getLabel("rectifyResetStatus")}
                    checked={rectifyResetStatus ?? false}
                    onChange={() =>
                      setValue("rectify_reset_status", !rectifyResetStatus)
                    }
                    customClassName={"confirm no_margin_top"}
                  />
                </div>
              </>
            )}
          {(additionalType === "candles" ||
            additionalSubtype === "candle") && (
            <>
              <div className="rectify_info_banner">
                <p>{getLabel("rectifyInfoExhausted")}</p>
              </div>
              <div className="row_wrapper">
                <Input
                  name={"rectify_max_capacity"}
                  error={errors["rectify_max_capacity"]}
                  register={register}
                  type="number"
                  label={getLabel("rectifyMaxCapacity")}
                  placeholder={getLabel("rectifyMaxCapacityPlaceholder")}
                  required={getLabel("inputRequiredError")}
                  min={{
                    value: 1,
                    message: getLabel("errorMinValue", { value: 1 }),
                  }}
                />
                <Input
                  name={"rectify_reset_status"}
                  register={register}
                  type={"checkbox"}
                  label={getLabel("rectifyResetStatus")}
                  checked={rectifyResetStatus ?? false}
                  onChange={() =>
                    setValue("rectify_reset_status", !rectifyResetStatus)
                  }
                  customClassName={"confirm no_margin_top"}
                />
                <Input
                  name={"rectify_reset_total_filtered_liters"}
                  register={register}
                  type={"checkbox"}
                  label={getLabel("rectifyResetTotalFilteredLiters")}
                  checked={rectifyResetTotalFilteredLiters ?? false}
                  onChange={() =>
                    setValue(
                      "rectify_reset_total_filtered_liters",
                      !rectifyResetTotalFilteredLiters
                    )
                  }
                  customClassName={"confirm no_margin_top"}
                />
              </div>
            </>
          )}
        </div>
      );
    else if (type === "SENSOR_SETPOINT") {
      return (
        <Input
          name="new_set_point"
          register={register}
          type="number"
          label={getLabel("sensorNewSetPoint")}
          placeholder={getLabel("sensorNewSetPointPlaceholder")}
          error={errors["new_set_point"]}
          required={getLabel("inputRequiredError")}
          defaultValue={setPointBoundaries?.default || ""}
          min={{
            value: setPointBoundaries?.min || "0",
            message: getLabel("errorMinValue", {
              value: setPointBoundaries?.min || "0",
            }),
          }}
          max={{
            value: setPointBoundaries?.max,
            message: getLabel("errorMaxValue", {
              value: setPointBoundaries?.max,
            }),
          }}
          regExpPattern={{
            value: INT_FLOAT_REGEX,
            message: getLabel("errorIntFloat"),
          }}
        />
      );
    } else if (type === "ANALYST") {
      return (
        <Input
          name="analyst"
          register={register}
          type="text"
          label={getLabel("analysisAnalyst")}
          placeholder={getLabel("analysisAnalystPlaceholder")}
          error={errors["analyst"]}
          required={getLabel("inputRequiredError")}
          isReverse={true}
          minLength={{
            value: 3,
            message: getLabel("errorMinLength", { value: 3 }),
          }}
          maxLength={{
            value: 32,
            message: getLabel("errorMaxLength", { value: 32 }),
          }}
          regExpPattern={{
            value: ALPHA_SPACE_APEX_DOT_REGEX,
            message: getLabel("errorAlphaSpaceApex"),
          }}
        />
      );
    } else if (type === "EXCEL_ANALYSIS") {
      return (
        <Input
          name="file"
          register={register}
          type="file"
          label={getLabel("operationExcelFileImport")}
          placeholder={getLabel("operationExcelFileImportPlaceholder")}
          error={errors["file"]}
          tooltip={getLabel("operationExcelFileImportTooltip")}
          accept=".xls,.xlsx"
          onChange={(e) => {
            setFile(e.target?.files?.[0]);
            e?.stopPropagation?.();
          }}
        />
      );
    } else if (type === "RECURRENT_ANALYSIS") {
      return (
        <RecurrentDatesSelector
          getLabel={getLabel}
          control={control}
          errors={errors}
          configs={configs}
          isTime={["HOUR", "DAILY"].includes(getValues("repeatSize")?.value)}
        />
      );
    } else
      return (
        <div className={`operation_recap`}>
          {type !== "ANALYSIS" && (
            <>
              {totalStep > 0 && step < totalStep && (
                <div className="batch_name">
                  <Select
                    control={control}
                    defaultValue={{
                      value: "",
                      label: "",
                    }}
                    name="batch_name_selector"
                    label={""}
                    placeholder={getLabel("operationNewLotNamePlaceholder")}
                    error={errors["batch_id_in"]}
                    required={getLabel("inputRequiredError")}
                    options={[
                      {
                        value: true,
                        label: getLabel("lotNewName"),
                      },
                      ...availableLotNames,
                    ]}
                  />
                  {getValues("batch_name_selector")?.value && (
                    <Input
                      name="new_batch_name"
                      register={register}
                      type="text"
                      label={getLabel("operationNewBatchName")}
                      placeholder={getLabel("operationNewBatchNamePlaceholder")}
                      error={errors["new_batch_name"]}
                      required={getLabel("inputRequiredError")}
                      isReverse={true}
                      minLength={{
                        value: 3,
                        message: getLabel("errorMinLength", { value: 3 }),
                      }}
                      maxLength={{
                        value: 24,
                        message: getLabel("errorMaxLength", { value: 24 }),
                      }}
                      regExpPattern={{
                        value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
                        message: getLabel("errorAlphaNumSpace_-"),
                      }}
                      validate={(value) => {
                        if (lotNames?.includes(value?.trim()))
                          setError("new_batch_name", {
                            type: "manual",
                            message: getLabel("errorNewBatchNameAlreadyTaken", {
                              name: value,
                            }),
                          });
                        else if (
                          getValues("batch_name_selector")?.value &&
                          lotNames?.includes(value?.trim())
                        ) {
                          toast.warning(
                            getLabel("toast_lotNameAlreadyPresent"),
                            {
                              toastId: customId,
                              position: toast.POSITION.BOTTOM_RIGHT,
                              exclude: true,
                              autoClose: 5000,
                            }
                          );
                        } else {
                          clearErrors("new_batch_name");
                          toast.dismiss(customId);
                        }
                      }}
                    />
                  )}
                </div>
              )}
              {(totalStep === 0 || step === totalStep) && (
                <div
                  className={`graph ${
                    ["CUT"].includes(type) ? "reverse" : ""
                  } ${!isScale ? "no-scale" : ""}`}
                >
                  {type === "CUT" && dest_tanks?.length > 0 && (
                    <Tree
                      lineWidth={"2px"}
                      lineColor={"#64242E"}
                      lineBorderRadius={"20px"}
                      label={
                        <TankIcon
                          tank={dest_tanks?.[0]}
                          isReverse={true}
                          isArrowQuantity={true}
                        />
                        // <TankIcon // dest_tank
                        //   tank={{
                        //     ...dest_tanks[0],
                        //   }}
                        //   isReverse={true}
                        //   isSrc={false}
                        //   isRecap={true}
                        //   isText={true}
                        //   isArrowQuantity={true}
                        //   noDestError={errors?.dest_tanks}
                        // />
                      }
                    >
                      {src_tanks?.map((tank) => (
                        <TreeNode
                          label={
                            <TankIcon
                              tank={tank}
                              // tank={{
                              //   ...tank,
                              //   planned_quantity: tank?.is_planned ? 0 :,
                              //   // toRemove: -Number(tank.quantity),
                              //   // quantity: Number(tank.quantity),
                              // }}
                              isText={true}
                              isReverse={true}
                              isRecap={true}
                              noDestError={errors?.dest_tanks}
                              isArrowQuantity={true}
                              isSrc={true}
                            />
                          }
                        ></TreeNode>
                      ))}
                    </Tree>
                  )}
                  {type === "DESTEMMING" && src_tanks?.length > 0 && (
                    <Tree
                      lineWidth={"2px"}
                      lineColor={"#64242E"}
                      lineBorderRadius={"20px"}
                      label={
                        <TreeNode
                          label={
                            <DestLotDetail
                              lot={src_tanks[0]}
                              isDestemming={true}
                              isRecap={true}
                              toRemove={
                                dest_tanks?.reduce((acc, curr) => {
                                  return (
                                    acc + (Number(curr?.add_quantity) || 0)
                                  );
                                }, 0) || 0
                              }
                            />
                          }
                        ></TreeNode>
                      }
                    >
                      {dest_tanks
                        // ?.filter((d) => d?.tankData?.value && d?.quantity)
                        ?.map((tank) => (
                          <TreeNode
                            label={
                              tank?.type === "pomaces" ? (
                                <PomacesIcon data={tank} />
                              ) : (
                                <TankIcon tank={tank} isArrowQuantity={true} operationType={type} subtype={additionalSubtype} />
                              )
                            }
                          ></TreeNode>
                        ))}
                    </Tree>
                  )}
                  {type === "NEW_LOT" && src_tanks?.length > 0 && (
                    <Tree
                      lineWidth={"2px"}
                      lineColor={"#64242E"}
                      lineBorderRadius={"20px"}
                      label={
                        <TreeNode
                          label={
                            <DestLotDetail
                              lot={src_tanks?.[0]}
                              isDestemming={true}
                              isRecap={true}
                              isNewLot={true}
                              toRemove={Number(src_tanks?.[0]?.quantity) || 0}
                            />
                          }
                        ></TreeNode>
                      }
                    >
                      {dest_tanks
                        // ?.filter((d) => d?.tankData?.value && d?.quantity)
                        ?.map((tank) => (
                          <TreeNode
                            label={
                              <TankIcon
                                tank={tank}
                                isText={true}
                                isDestemming={true}
                                isReverse={false}
                                isArrowQuantity={true}
                                isRecap={true}
                                isSrc={false}
                                noDestError={errors?.dest_tanks?.tankData}
                              />
                            }
                          ></TreeNode>
                        ))}
                    </Tree>
                  )}
                  {["RACKING", "DECANT", "CLOSING", "FILTERING"].includes(
                    type
                  ) &&
                    src_tanks?.length > 0 && (
                      <Tree
                        lineWidth={"2px"}
                        lineColor={"#64242E"}
                        lineBorderRadius={"20px"}
                        label={
                          <TreeNode
                            label={
                              <TankIcon
                                tank={{
                                  ...src_tanks[0],
                                  remove_quantity: src_tanks[0]?.arrow_quantity,
                                }}
                                isArrowQuantity={true}
                                isText={true}
                                isReverse={false}
                                isRecap={true}
                                noDestError={errors?.dest_tanks?.tankData}
                              />
                            }
                          ></TreeNode>
                        }
                      >
                        {type === "FILTERING" ? (
                          <>
                            {additionalData?.length > 0 ? (
                              // Renderizza una catena di TreeNode per ogni filtro
                              (() => {
                                let filterNodes = dest_tanks?.map((tank) => (
                                  <TreeNode
                                    key={`dest-tank-${tank.id}`}
                                    label={
                                      <TankIcon
                                        tank={{
                                          ...tank,
                                          // planned_quantity: 0,
                                        }}
                                        isArrowQuantity={true}
                                      />
                                    }
                                  ></TreeNode>
                                ));
                                
                                // Avvolgi i dest_tanks in una catena di FilterIcon per ogni filtro
                                for (let i = additionalData?.length - 1; i >= 0; i--) {
                                  const filter = additionalData[i];
                                  filterNodes = (
                                    <TreeNode
                                      key={`filter-${i}`}
                                      label={<FilterIcon filter={filter} isRecap={true} />}
                                    >
                                      {filterNodes}
                                    </TreeNode>
                                  );
                                }

                                return filterNodes;
                              })()
                            ) : (
                              // Se non ci sono filtri, mostra semplicemente i dest_tanks
                              dest_tanks?.map((tank) => (
                                <TreeNode
                                  key={`dest-tank-${tank.id}`}
                                  label={
                                    <TankIcon
                                      tank={{
                                        ...tank,
                                      }}
                                      isArrowQuantity={true}
                                    />
                                  }
                                ></TreeNode>
                              ))
                            )}
                          </>
                        ) : (
                          dest_tanks
                            // ?.filter((d) => d?.tankData?.value && d?.quantity)
                            ?.map((tank) => (
                              <TreeNode
                                label={
                                  type === "CLOSING" && tank?.type === "close" ? (
                                    <CloseIcon data={tank} />
                                  ) : type === "RACKING" &&
                                    ["pomaces", "pomacesW"].includes(tank?.type) ? (
                                    <PomacesIcon data={tank} />
                                  ) : (
                                    <TankIcon
                                      tank={{
                                        ...tank,
                                        // planned_quantity: 0,
                                      }}
                                      isArrowQuantity={true}
                                    />
                                  )
                                }
                              ></TreeNode>
                            ))
                        )}
                      </Tree>
                    )}
                  {type === "BOTTLING" && src_tanks?.length > 0 && (
                    <Tree
                      lineWidth={"2px"}
                      lineColor={"#64242E"}
                      lineBorderRadius={"20px"}
                      label={
                        <TreeNode
                          label={
                            <TankIcon
                              tank={{
                                ...src_tanks?.[0],
                                is_src: true,
                                // Recap must show the post-operation remaining
                                // (before - removed), matching the detail view.
                                quantity: Math.max(
                                  0,
                                  (Number(src_tanks?.[0]?.old_quantity) || 0) -
                                    (Number(src_tanks?.[0]?.arrow_quantity) || 0)
                                ),
                                remove_quantity: src_tanks?.[0]?.arrow_quantity,
                              }}
                              isArrowQuantity={true}
                              isText={true}
                              isReverse={false}
                              isRecap={true}
                              // noDestError={errors?.dest_tanks?.tankData}
                            />
                          }
                        ></TreeNode>
                      }
                    >
                      {dest_tanks?.map((tank) => (
                        <TreeNode
                          label={
                            <BottleIcon
                              // {...tank}
                              batch_type={tank?.batch_type}
                              batch_name={tank?.batch_name}
                              color={tank?.color}
                              cap_lot={tank?.cap_lot?.label || tank?.cap_lot}
                              // capacity={tank?.cap_lot?.label}
                              bottle_lot={
                                tank?.bottle_lot?.label || tank?.bottle_lot
                              }
                              toAdd={tank?.add_quantity ?? tank?.arrow_quantity}
                              isRecap={true}
                            />
                          }
                        ></TreeNode>
                      ))}
                    </Tree>
                  )}
                </div>
              )}
            </>
          )}
          {type === "ANALYSIS" && (
            <div className="analysis_wrapper_row">
              {src_tanks?.map((tank, index) => (
                <>
                  {index === step && (
                    <div key={`analysis_recap_${index}`}>
                      <h6 className="analysis_tank_name">
                        {
                          (tank?.tank_id
                            ? tanks?.find((t) => t.id === Number(tank?.tank_id))
                            : lots?.find((l) => l.id === Number(tank.batch_id))
                          )?.name
                        }
                      </h6>
                      {(tank?.tank_id || tank?.batch_id) && (
                        <Input
                          name={`temperature.${
                            tank?.tank_id || tank?.batch_id
                          }`}
                          register={register}
                          type="number"
                          error={
                            errors[`temperature`]?.[
                              tank?.tank_id || tank?.batch_id
                            ]
                          }
                          label={getLabel("analysisExamTemperature")}
                          placeholder={
                            getLabel("analysisExamTemperaturePlaceholder") +
                            " (\u00b0C)"
                          }
                          required={getLabel("inputRequiredError")}
                          min={{
                            value: 15,
                            message: getLabel("errorMinValue", { value: 15 }),
                          }}
                          max={{
                            value: 35,
                            message: getLabel("errorMaxValue", { value: 35 }),
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault(); // Prevent default Enter behavior (e.g., form submission)
                              if (step < totalStep) {
                                setStep((prev) => prev + 1);
                                // const t = src_tanks?.[index + 1];
                                // setFocus(`temperature.${t?.tank_id || t?.batch_id}`);
                              }
                            }
                          }}
                        />
                      )}
                      {/* <div className={`interval_value exam`}>
                <DatePicker
                  name={`collection_date.${tank?.batch_id || tank?.tank_id}`}
                  control={control}
                  label={getLabel("dateExamFrom")}
                  error={errors[`collection_date`]}
                  required={getLabel("inputRequiredError")}
                  dateFormat={configs.dateFormat}
                  isTime={true}
                />
              </div>
              <Input
                name={`analyst.${tank?.batch_id || tank?.tank_id}`}
                register={register}
                type="text"
                error={errors[`analyst`]?.[tank?.batch_id || tank?.tank_id]}
                label={getLabel("analysisAnalyst")}
                placeholder={getLabel("analysisAnalystPlaceholder")}
                required={getLabel("inputRequiredError")}
                minLength={{
                  value: 3,
                  message: getLabel("errorMinLength", { value: 3 }),
                }}
                maxLength={{
                  value: 30,
                  message: getLabel("errorMaxLength", { value: 30 }),
                }}
                regExpPattern={{
                  value: ALPHA_SPACE_APEX_DOT_REGEX,
                  message: getLabel("errorAlphaSpaceApex"),
                }}
              />
              <div className={`interval_value exam`}>
                <DatePicker
                  name={`start_date.${tank?.batch_id || tank?.tank_id}`}
                  control={control}
                  label={getLabel("dateExamFrom")}
                  error={errors["start_date"]}
                  required={getLabel("inputRequiredError")}
                  dateFormat={configs.dateFormat}
                  isTime={true}
                />
                <DatePicker
                  name={`end_date.${tank?.batch_id || tank?.tank_id}`}
                  control={control}
                  label={getLabel("dateExamTo")}
                  error={errors["end_date"]}
                  required={getLabel("inputRequiredError")}
                  dateFormat={configs.dateFormat}
                  isTime={true}
                />
              </div>
               */}
                    </div>
                  )}
                </>
              ))}
              {/* </> */}
              {/* )} */}
              {/* {step === totalStep && (
            <>
              <Input
                name="analyst"
                register={register}
                type="text"
                error={errors["analyst"]}
                label={getLabel("analysisAnalyst")}
                placeholder={getLabel("analysisAnalystPlaceholder")}
                required={getLabel("inputRequiredError")}
                minLength={{
                  value: 3,
                  message: getLabel("errorMinLength", { value: 3 }),
                }}
                maxLength={{
                  value: 30,
                  message: getLabel("errorMaxLength", { value: 30 }),
                }}
                regExpPattern={{
                  value: ALPHA_SPACE_APEX_DOT_REGEX,
                  message: getLabel("errorAlphaSpaceApex"),
                }}
              />
              <div className={`interval_value exam`}>
                <DatePicker
                  name="start_date"
                  control={control}
                  label={getLabel("dateExamFrom")}
                  error={errors["start_date"]}
                  required={getLabel("inputRequiredError")}
                  dateFormat={configs.dateFormat}
                  isAnalysis={true}
                />
                <DatePicker
                  name="end_date"
                  control={control}
                  label={getLabel("dateExamTo")}
                  error={errors["end_date"]}
                  required={getLabel("inputRequiredError")}
                  dateFormat={configs.dateFormat}
                  isAnalysis={true}
                />
              </div>
            </>
          )} */}
            </div>
          )}
        </div>
      );
  };

  const renderCrendentials = () => {
    return (
      <>
        <h5 className="login_title">{getLabel("modalCredentials")}</h5>
        <div className="login_wrapper">
          <Input
            name="username"
            register={register}
            regExpPattern={{
              value: USER_REGEX,
              message: getLabel("inputPatternError"),
            }}
            type="text"
            label={getLabel("username")}
            placeholder={getLabel("usernamePlaceholder")}
            error={errors["username"]}
            required={getLabel("inputRequiredError")}
            isRequiredTooltip={false}
            // onChange={resetError}
          />
          <Input
            name="password"
            register={register}
            regExpPattern={{
              value: PWD_REGEX,
              message: getLabel("inputPatternError"),
            }}
            type="password"
            label={getLabel("password")}
            placeholder={getLabel("passwordPlaceholder")}
            error={errors["password"]}
            required={getLabel("inputRequiredError")}
            isRequiredTooltip={false}
            // onChange={resetError}
          />
        </div>
      </>
    );
  };

  return (
    <div>
      {renderByType()}
      {isCredential && renderCrendentials()}
    </div>
  );
};

const RecapTankIcon = ({ tank, wineColor }) => {
  const [getLabel] = useLabels();

  return (
    <div className="init_status">
      <div>
        <p className="tank_name">{tank?.name}</p>
        {tank?.state === "WINE" && [0, 1, 2].includes(tank?.batch_type) && (
          <span className="batch_name">
            {getLabel(`lotType${tank?.batch_type}`)}
          </span>
        )}
      </div>
      <div className="tank_representation">
        <div
          className={"tank_tile_progress_" + wineColor}
          style={{
            height: `${
              (Number(tank?.quantity) / Number(tank?.capacity)) * 100
            }%`,
          }}
        ></div>
      </div>
      <div>
        <p className="tank_quantity">{`${tank?.quantity || 0} L (${Math.round(
          (tank?.quantity * 100) / (Number(tank?.capacity) || 1)
        )}%)`}</p>
      </div>
    </div>
  );
};

const CloseIcon = ({
  data = {},
  isTank = true,
  isDetail = false,
  isTracking = false,
}) => {
  const [getLabel] = useLabels();
  const color = getWineColor(data?.color, "hex");
  const { auth } = useAuth();
  const currencyIcon = getCurrencyIcon(getCurrencyCode(auth?.user));

  return (
    <div
      className={`close_icon ${isDetail ? "detail" : ""} ${
        isTracking ? "tracking" : ""
      }`}
    >
      <div className="close_icons_wrapper">
        <span>
          <Icon             icon={"fa-tag"}
            size={"2x"}
            style={{ color: getWineColor(data?.color, "hex") }}
          />
        </span>
        <span>
          <Icon icon={currencyIcon} size={"lg"} />
        </span>
      </div>
      <div className="data_wrapper">
        <h6
          className={`bold tank_name description_ellipsis ${
            isDetail ? "fix_margin_bottom" : ""
          }`}
        >
          {data?.close_dest || ""}
        </h6>
        <p className="description_ellipsis">
          {data?.close_reason
            ? getLabel(`buyReason_${data?.close_reason}`) || ""
            : "\u00A0"}
        </p>
      </div>
      {data?.quantity ? (
        isDetail ? (
          <div className="close_quantity_detail">+{data?.quantity || ""}L</div>
        ) : (
          <h6 className="bold tank_name">+{data?.quantity || ""} L</h6>
        )
      ) : (
        <h6>{"\u00A0"}</h6>
      )}
      {isDetail &&
        !!data?.close_notes &&
        data.close_notes.trim().length > 0 && (
          <OptionalNoteRow
            isDetail={isDetail}
            notes={data?.close_notes || ""}
          />
        )}
    </div>
  );
};

const PomacesIcon = ({ data = {} }) => {
  const [getLabel] = useLabels();
  const totalPomaces = Number(data?.quantity); // * 0.4;
  const { value, unit } = formatPomaces(totalPomaces, getLabel);

  return (
    <div className="tank_icon">
      <div className="tank_name">
        <h6 className="bold tank_name unset-width">{data?.name || ""}</h6>
        <span className="batch_name">
          {getLabel(`pomaceReason_${data?.waste_type}`)}
        </span>
      </div>
      <div className="recycle_icon">
        <Icon icon="fa-recycle" size="xl" />
      </div>
      <h6 className="bold tank_name unset-width">
        +{value || ""} {unit}
      </h6>
    </div>
  );
};

const FilterIcon = ({ filter, isRecap = false }) => {
  const [getLabel] = useLabels();
  const [isCandlesOpen, setIsCandleOpen] = useState(false);
  const { auth } = useAuth();
  const currencySymbol = getCurrencySymbol(getCurrencyCode(auth?.user));

  const iconByType = {
    HOUSING: <Icon icon="fa-bars" />,
    CARTON: <Icon icon="fa-layer-group" />,
    TANGENTIAL: <Icon icon="fa-sliders" />,
  };

  const candleIcon = (
    <Icon icon="fa-minus" style={{ rotate: "-45deg" }} />
  );

  if (!isRecap && (!filter || !filter?.id)) return null;

  const {
    name,
    type,
    serial_number,
    status,
    porosity,
    total_filtered_liters,
    max_capacity_liters,
    element_count,
    deactivated,
    candles = [],
  } = filter;

  return (
    <div
      className={`filter_card ${deactivated ? "is_deactivated" : ""}  ${
        type === "HOUSING" ? "is_hover" : ""
      } ${isRecap ? "is_recap" : ""}`}
      onClick={() => setIsCandleOpen((prev) => !prev)}
    >
      <div className="card_header">
        {iconByType[type]}
        <div className="header_content">
          <h3>{name}</h3>
          <p className="serial">{serial_number}</p>
        </div>
        <span className={`status status_${status?.toLowerCase()}`}>
          {getLabel(`filterStatus_${status}`)}
        </span>
      </div>

      <div className="card_body">
        <div className="row">
          <label>{getLabel("filterPorosity")}</label>
          <span>{porosity ? `${porosity} µm` : "-"}</span>
        </div>

        <div className="row">
          <label>{getLabel("filterTotalFiltered")}</label>
          <span>{parseInt(total_filtered_liters) || 0} L</span>
        </div>

        {max_capacity_liters && (
          <div className="row">
            <label>{getLabel("filterMaxCapacity")}</label>
            <span>{parseInt(max_capacity_liters) || "—"} L</span>
          </div>
        )}

        {Number(element_count) > 0 &&
          ["TANGENTIAL", "HOUSING"].includes(type) && (
            <div className="row">
              <label>
                {getLabel(
                  type === "TANGENTIAL"
                    ? "filterMembraneCount"
                    : "filterCandleCount"
                )}
              </label>
              <span>{element_count}</span>
            </div>
          )}
        {type === "HOUSING" && !isCandlesOpen && candles?.length > 0 && (
          <div className="row">
            <div className="arrow_icon">
              <Icon icon="fa-angle-down" />
            </div>
          </div>
        )}
      </div>
      {type === "HOUSING" && isCandlesOpen && (
        <div className="candles_section">
          <h4>{getLabel("filterCandles")}</h4>
          {candles?.map((c) => (
            <div
              key={`candle_${c.id}`}
              className={`candle_row ${c?.deactivated ? "is_deactivated" : ""}`}
            >
              {candleIcon}
              <div className="candle_info">
                <div className="line">
                  <strong>{c?.serial_number || ""}</strong>
                  <span
                    className={`candle_status status_${c.status?.toLowerCase()}`}
                  >
                    {getLabel(`filterStatus_${c.status}`)}
                  </span>
                </div>

                <div className="line">
                  {getLabel(`filterCandleType_${c.type}`)?.toLowerCase?.()} —{" "}
                  {c.porosity} µm
                </div>

                <div className="line small">
                  {c?.max_capacity_liters
                    ? `${getLabel("filterMaxCapacityShort")} ${
                        c.max_capacity_liters
                      } L — `
                    : ""}
                  {c?.cost ? (c.cost || 0) + " " + currencySymbol : ""}
                </div>
              </div>
            </div>
          ))}
          {type === "HOUSING" && isCandlesOpen && candles?.length > 0 && (
            <div className="candle_row arrow_section">
              <div className="arrow_icon">
                <Icon icon="fa-angle-up" />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

// Decide whether the FLOWER/PRESSED/MIXED batch_type (fiore/pressato/misto) is
// relevant for a given product. The quality split happens for anything that is
// already WINE (travaso, imbottigliamento, ...) and, for special vinifications,
// already at DESTEMMING when the must is white/rosé/orange.
export const isBatchTypeNeeded = ({ operationType, outputColor, outputState, subtype = null, substate = null }) => {
  // Macerating batches still have skins on — FLOWER/PRESSED/MIXED distinction doesn't apply yet.
  if (substate === "MACERATING") return false;

  // For DESTEMMING, the fiore/pressato/misto split only happens when pressing occurs immediately.
  // All other subtypes (maceration techniques, carbonic, etc.) leave skins in the tank —
  // the quality split will only be determined later at racking time.
  if (operationType === "DESTEMMING")
    return subtype === "WITH_PRESSING" || subtype === "DIRECT_PRESSING";

  // tutto ciò che lavora il vino (stato WINE): travaso, imbottigliamento
  if (outputState === "WINE") return true;

  return false;
};

// Row-level variant for lot/tank lists: the destemming output is a MUST, so a
// must that is white/rosé carries the batch_type just like wine does.
// LotList rows have substate as a direct string field; TankList rows carry it
// inside the tank_substate JSON object from batch_substate_history.
export const showsBatchTypeForRow = (row) =>
  [0, 1, 2].includes(row?.batch_type) &&
  isBatchTypeNeeded({
    operationType: row?.state === "MUST" ? "DESTEMMING" : undefined,
    outputColor: row?.color,
    outputState: row?.state,
    subtype: row?.vinification_technique,
    substate: row?.substate || row?.tank_substate?.substate,
  });

// Reusable badge for the FLOWER/PRESSED/MIXED batch_type (lotType0/1/2).
// Renders a styled pill when `show` and a valid batchType (0,1,2) are provided,
// otherwise keeps a non-breaking space to preserve layout spacing.
export const LotTypeBadge = ({ batchType, getLabel, show = true }) => {
  const valid = show && [0, 1, 2].includes(batchType);

  return (
    <span
      className={`batch_name lot_type_badge ${
        valid ? `lot_type_badge--${batchType}` : "lot_type_badge--placeholder"
      }`}
    >
      {valid ? getLabel(`lotType${batchType}`) : " "}
    </span>
  );
};

const TankIcon = ({ tank, isArrowQuantity = false, isReverse = false, operationType = null, subtype = null }) => {
  const [getLabel] = useLabels();

  return (
    <div className={`tank_icon ${isReverse ? "reverse" : ""}`}>
      <div className="tank_name">
        <h6 className="bold tank_name unset-width">{tank?.name}</h6>
        {Number(tank?.quantity) > 0 &&
          tank?.batch_name &&
          [0, 1, 2].includes(tank?.batch_type) &&
          isBatchTypeNeeded({ operationType, outputColor: tank?.color, outputState: tank?.state, subtype }) && (
            <LotTypeBadge batchType={tank?.batch_type} getLabel={getLabel} />
          )}
        {/* {(Number(tank?.quantity) === 0 || !tank?.batch_name) &&
          tank?.state === "WINE" && <span className="batch_name">&nbsp;</span>} */}
      </div>
      <div className="init_wrapper">
        <div
          className={`init_status ${
            ["TONNEAU", "BARRIQUE"].includes(tank?.type) ? "barrel" : ""
          } ${tank?.type === "TONNEAU" ? "tonneau" : ""}`}
        >
          {tank?.batch_name && (
            <p className={`batch_name 'bold' : ''}`}>
              {Number(tank?.quantity) > 0
                ? tank?.batch_name || getLabel("tankState_EMPTY")
                : getLabel("tankState_EMPTY")}
            </p>
          )}
          <div
            className={`tank_representation 
            ${
              tank?.is_focused === true
                ? "focused " + tank?.color?.toLowerCase() || "red"
                : ""
            }
            ${
              tank?.not_focused === true
                ? "not_focused " + tank?.color?.toLowerCase() || "red"
                : ""
            } ${
              ["TONNEAU", "BARRIQUE"].includes(tank?.type)
                ? tank?.type?.toLowerCase?.()
                : ""
            } ${tank?.type === "TONNEAU" ? "tonneau" : ""}`}
          >
            {tank?.is_planned && Number(tank?.planned_quantity) > 0 && (
              <div
                className={`tank_tile_estimated_progress ${tank?.color?.toLowerCase()}`}
                style={{
                  height: `${
                    ((Number(tank?.planned_quantity) + Number(tank?.quantity)) /
                      Number(tank?.capacity)) *
                    100
                  }%`,
                }}
              ></div>
            )}
            <div
              className={`tank_tile_progress_${tank?.color?.toLowerCase()}`}
              style={{
                height: `${
                  (Number(tank?.quantity) / Number(tank?.capacity)) * 100
                }%`,
              }}
            ></div>
          </div>
          <div className="tank_info">
            {(() => {
              const totalQty =
                (Number(tank?.quantity) || 0) +
                (!tank?.is_src && tank?.is_planned
                  ? Number(tank?.planned_quantity) || 0
                  : 0);
              const { displayedQuantity, displayedCapacity, unit } =
                formatTankUnit(totalQty, tank?.capacity);
              return (
                <>
                  {displayedQuantity} / {displayedCapacity}
                  {unit}{" "}
                  <span className="tank_percentage">
                    {"(" + tankOccupancy(totalQty, tank?.capacity) + "%)"}
                  </span>
                </>
              );
            })()}
          </div>

          {isArrowQuantity &&
            (() => {
              const { value, unit } = formatArrowQuantity(
                Number(tank?.add_quantity || tank?.remove_quantity) || 0
              );
              return (
                <h6>{`${tank?.remove_quantity ? "-" : "+"}${value} ${unit}`}</h6>
              );
            })()}
          {/* {isArrowQuantity && <div>
            {tank?.is_src && <h6>{`-${Number(tank?.toRemove) || 0}L`}</h6>}
            {!tank?.is_src && <h6>{`+${tank?.arrow_quantity || 0}L`}</h6>}
          </div>} */}
          {/* {true && <div>
            {" (" + Math.round(
              ((Number(tank?.old_quantity) || 0) * 100) /
                Number(tank?.capacity)
            ) +
            "%)"}
          </div>} */}
        </div>
      </div>
    </div>
  );
};

const BottleIcon = ({
  batch_type,
  bottle_lot,
  cap_lot,
  isName = false,
  isRecap = false,
  isDetail = false,
  isTracking = false,
  batch_name = null,
  quantity = null,
  drop = null,
  toAdd = null,
  color,
  volume = "0.75 L",
  bottleCount = null,
  composition = [],
  isMobile = false,
}) => {
  const { auth } = useAuth();
  const role = auth?.role || ROLES.GUEST;
  const [getLabel] = useLabels();
  const [data, setData] = useState({});
  const [lotInfo, setLotInfo] = useState([]);
  const [hoverSection, setHoverSection] = useState(null); // 'end', or null

  useEffect(() => {
    const tmp = { is_src: false, name: batch_name || "", composition: [] };

    if (Array.isArray(composition) && composition?.length > 0) {
      setLotInfo(composition?.sort((a, b) => b?.percentage - a?.percentage));
    }
    setData(tmp);
  }, []);

  return (
    <div className="tanks_wrapper">
      {isName && <div className="tank_name">{batch_name}</div>}
      <div className={`bottle_recap  ${isRecap ? "recap" : ""}`}>
        {!isName && (
          <p className="bold">
            {batch_name || ""}
            {/* {isDetail && Number(quantity) > 0 ? ` (${quantity} L)` : ""} */}
          </p>
        )}
        {[0, 1, 2].includes(batch_type) && (
          <LotTypeBadge batchType={batch_type} getLabel={getLabel} />
        )}
        {isDetail && Number(quantity) > 0 && (
          <p className="normal">{quantity} L</p>
        )}
        <div
          className="bottle_data"
          onMouseEnter={() =>
            role === ROLES.CLIENT && !isMobile && setHoverSection("end")
          }
          onMouseLeave={() =>
            role === ROLES.CLIENT && !isMobile && setHoverSection(null)
          }
        >
          {/* Cap (Icon + Text on the same line) */}
          <div className="cap_icon">
            <div className="icon">
              <Icon                 icon={"fa-bread-slice"}
                size={"sm"}
                style={{ color: "rgb(157, 126, 104)" }}
              />
            </div>
          </div>

          {/* Bottle */}
          <div className="bottle_icon">
            <div className="icon">
              <Icon                 icon="fa-wine-bottle"
                style={{ color: getWineColor(color) }}
                size={"4x"}
              />
            </div>
          </div>
          {/* <div className="lots">
            {lotNames?.length > 0 && (
              <p className="bold tank_name fixed-width">
                {getLabel("lots")}:{" "}
                <p className="normal">{lotNames?.toString()}</p>
              </p>
            )}
          </div> */}
        </div>

        {(isDetail || isTracking) && bottle_lot && (
          <div>
            {volume && (
              <div className="bottle_capacity">
                <span>{volume}</span>
                {bottleCount > 0 && (
                  <span className="bottle_count">{`x ${bottleCount}`}</span>
                )}
              </div>
            )}
          </div>
        )}

        {!isDetail && <p className="normal">{bottle_lot || ""}</p>}
        {!isDetail && <p className="normal">{cap_lot || ""}</p>}
        {isDetail && (
          <div>
            {bottle_lot && (
              <p>
                {getLabel("bottleLot")}:{" "}
                <span className="bold">{bottle_lot || ""}</span>
              </p>
            )}
            {cap_lot && (
              <p>
                {getLabel("capLot")}:{" "}
                <span className="bold">{cap_lot || ""}</span>
              </p>
            )}
            {/* {drop > 0 && (
              <p className="drop">
                {getLabel("operationDrop")}:{" "}
                <span className="bold">{drop} L</span>
              </p>
            )} */}
          </div>
        )}
        {isRecap && toAdd && (
          <h6 className="add_quantity">{`+${toAdd || 0}L`}</h6>
        )}
      </div>
      {!isRecap && drop > 0 && (
        <p className="tank_name">
          {getLabel("operationDrop")}{" "}
          <span className="batch_name">{drop} L</span>
        </p>
      )}
      <TankCompositionDetail
        hoverSection={hoverSection}
        lotInfo={lotInfo}
        tank={data}
        role={role}
        isMobile={isMobile}
      />
    </div>
  );
};

const BatchIcon = ({
  lot,
  isText = false,
  isReverse = false,
  isRecap = false,
  isName = false,
  size,
}) => {
  const getGrapeColor = () => {
    switch (lot?.color) {
      case "WHITE":
        return json_white_grape;
      case "ROSE":
        return json_rose_grape;
      // case "ORANGE":
      //   return json_orange_grape;
      default:
        return json_red_grape;
    }
  };

  return (
    <div className={`recap ${isReverse ? "reverse" : ""}`}>
      {!isName && <h6 className="bold centered">{lot?.label}</h6>}
      <Player
        autoplay={false}
        controls={false}
        hover={false}
        src={getGrapeColor()}
        style={{
          width: isName ? "64px" : size ? size : "84px",
          height: isName ? "64px" : size ? size : "84px",
          marginTop: isName ? "12px" : "",
        }}
      />
      {isName && <p className="batch_name">{lot?.name}</p>}

      {isText && (
        <>
          <div>
            <span>
              {`${
                (Number(lot?.quantity) || 0) + (Number(lot?.toRemove) || 0) || 0
              }/${Number(lot?.initial_quantity) || 1} Kg`}{" "}
              <span className="tank_percentage">{`(${Math.round(
                ((Number(lot?.quantity) + Number(lot?.toRemove || 0) || 0) /
                  (Number(lot?.initial_quantity) || 1)) *
                  100
              )}%)`}</span>
            </span>
            {isRecap && (
              <h6 className="bold">{`-${Number(lot?.toRemove) || 0} Kg`}</h6>
            )}
          </div>
          <div className="arrow">
            {`${Number(lot?.arrow_quantity)} L`}
            <Player
              autoplay={false}
              controls={false}
              hover={false}
              src={json_arrow_black}
              style={{
                width: "24px",
                height: "24px",
                transform: "rotate(180deg)",
              }}
            />
          </div>
          <span>
            {`${
              (Number(lot?.quantity) || 0) + (Number(lot?.toRemove) || 0) || 0
            }/${Number(lot?.initial_quantity) || 1} Kg`}{" "}
            <span className="tank_percentage">{`(${Math.round(
              ((Number(lot?.quantity) + Number(lot?.toRemove || 0) || 0) /
                (Number(lot?.initial_quantity) || 1)) *
                100
            )}%)`}</span>
          </span>
        </>
      )}
    </div>
  );
};

const BatchDetail = ({
  tank: lot,
  color,
  operation,
  isName = true,
  isDrop = true,
  isArrow = false,
}) => {
  const [getLabel] = useLabels();

  const getWineColor = (color) => {
    switch (color) {
      case "WHITE":
        return "white";
      case "ORANGE":
        return "orange";
      case "ROSE":
        return "rose";
      case "ORANGE":
        return "roorangee";
      default:
        return "red";
    }
  };

  return (
    <>
      {isName && (
        <div className="tank_name">
          {lot?.name}
          {/* {operation?.batch_name_out && <p className="batch_name">{operation?.batch_name_out}</p>} */}
          {/* {tank?.new_batch_name && (
            <p className="batch_name">{tank?.new_batch_name}</p>
          )} */}
        </div>
      )}
      <div className="init_status">
        {lot?.old_batch_name && (
          <p className="batch_name">{lot?.old_batch_name}</p>
        )}
        <div className="tank_representation">
          <div
            className={
              "tank_tile_progress_" + getWineColor(color || lot?.color)
            }
            style={{
              height: `${
                (Number(lot?.old_quantity) / Number(lot?.capacity)) * 100
              }%`,
            }}
          ></div>
        </div>
        <div>
          {lot?.old_quantity || 0} / {lot?.capacity}L (
          {Math.round(
            ((Number(lot?.old_quantity) || 0) * 100) / Number(lot?.capacity)
          )}
          %)
        </div>
      </div>
      <div className="arrow">
        {`${Number(lot?.arrow_quantity) > 0 ? "+" : "-"}${Number(
          lot?.arrow_quantity
        )} L`}
        <Player
          autoplay={false}
          controls={false}
          hover={false}
          src={json_arrow_black}
          style={{ width: "24px", height: "24px", transform: "rotate(180deg)" }}
        />
      </div>
      <div className="end_status">
        {lot?.batch_name && (
          <p className="batch_name bold">{lot?.batch_name}</p>
        )}
        <div className="tank_representation">
          <div
            className={
              "tank_tile_progress_" + getWineColor(color || lot?.color)
            }
            style={{
              height: `${
                (Number(lot?.quantity) / Number(lot?.capacity)) * 100
              }%`,
            }}
          ></div>
        </div>
        <div>
          {Number(lot?.quantity) || 0} / {lot?.capacity}
          {"L"} (
          {Math.round(
            ((Number(lot?.quantity) || 0) * 100) / Number(lot?.capacity)
          )}
          %)
        </div>
      </div>
      {isDrop && operation?.completion_date !== null && (
        <div className="operation_info_container_row">
          <p className="tank_name">
            {getLabel("operationDrop")}
            <span className="batch_name">
              {" "}
              {`${lot?.drop || 0}`}{" "}
              {operation?.type === "DESTEMMING" ? "Kg" : "L"}
            </span>
          </p>
        </div>
      )}
    </>
  );
};

const ExternalLotIcon = ({ lot }) => {
  const getWineColor = (color) => {
    switch (color) {
      case "WHITE":
        return "white";
      case "ORANGE":
        return "orange";
      case "ROSE":
        return "rose";
      default:
        return "red";
    }
  };

  return (
    <div className={"recap"}>
      <div>
        <h6 className="bold">{`${lot?.name}`}</h6>
        <p className="bold">{`${lot?.quantity || 0} L`}</p>
        <div
          className={`tank_representation recap ${"isName" ? "icon_name" : ""}`}
        >
          <div
            className={"tank_tile_progress_" + getWineColor(lot?.color)}
            style={{
              height: `${
                (((Number(lot?.quantity) || 0) + Number(lot?.toAdd || 0)) /
                  (Number(lot?.capacity) || 1)) *
                100
              }%`,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

const NotificationWithLink = ({ content }) => {
  const navigate = useNavigate();

  const notify = () => {
    toast(content?.message, {
      icon: true,
      ...content?.props,
      autoClose: false,
    });
  };

  return (
    // <CustomToastWithLink navigateTo={content?.link || '/lots'} message={content?.message} />
    <div onClick={() => navigate(content?.link || "lots")}>
      New Message{notify()}
    </div>
  );
};

const InfoCard = ({
  label,
  number,
  icon = null,
  img = null,
  isOnlyIcon = false,
  isGrey = false,
  size = "xs",
  content = <></>,
  img_name = "",
}) => {
  const html = renderToStaticMarkup(content);

  return (
    <div className="info_card_container">
      <Tooltip variant={"info"} html={html} place="bottom" events={["hover"]}>
        <div className="info_card">
          <div className="info_card_label">
            {isOnlyIcon ? "" : label || ""}
            {icon && <Icon icon={icon} size={size} />}
          </div>
          <div className="info_card_number">
            {img && (
              <img
                className={`icon ${isGrey ? "grey" : ""}`}
                src={img}
                alt={img_name}
              />
            )}
            {number || "0"}
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

const Carousel = ({
  children,
  direction = "horizontal",
  autoscroll = false,
  speed = 3000,
  redirect = null,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showButtons, setShowButtons] = useState(false);
  const carouselRef = useRef(null);

  useEffect(() => {
    if (carouselRef.current) {
      const totalWidth = carouselRef.current.scrollWidth;
      const containerWidth = carouselRef.current.clientWidth;

      setShowButtons(totalWidth > containerWidth);
    }
  }, [children]);

  const handleCarouselClick = (event) => {
    if (event.target !== carouselRef.current) {
      if (redirect) redirect();
    }
  };

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.addEventListener("click", handleCarouselClick);
    }

    return () => {
      if (carouselRef.current) {
        carouselRef.current.removeEventListener("click", handleCarouselClick);
      }
    };
  }, [carouselRef]);

  const nextSlide = (event) => {
    if (event) event.stopPropagation();
    const totalWidth = carouselRef.current.scrollWidth;
    const containerWidth = carouselRef.current.clientWidth;
    const currentIndexWidth = currentIndex * itemWidth;

    if (currentIndexWidth + containerWidth < totalWidth) {
      setCurrentIndex((prevIndex) =>
        Math.min(prevIndex + 1, children.length - 1)
      );
    }
  };

  const prevSlide = (event) => {
    if (event) event.stopPropagation();
    const currentIndexWidth = currentIndex * itemWidth;
    if (currentIndexWidth > 0) {
      setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    }
  };

  // const itemWidth = useMemo(() => {
  //   if (direction === "horizontal") {
  //     return carouselRef.current
  //       ? carouselRef.current.clientWidth / children.length
  //       : 0;
  //   } else {
  //     return carouselRef.current
  //       ? carouselRef.current.clientHeight / children.length
  //       : 0;
  //   }

  // }, [children, direction, carouselRef]);

  const [itemWidth, setItemWidth] = useState(0);

  useEffect(() => {
    if (!carouselRef.current || !children?.length) return;

    const size =
      direction === "horizontal"
        ? carouselRef.current.clientWidth
        : carouselRef.current.clientHeight;

    setItemWidth(size / children.length);
  }, [children?.length, direction]);

  useEffect(() => {
    if (autoscroll) {
      const intervalId = setInterval(() => {
        if (direction === "horizontal") {
          nextSlide();
        } else {
          nextSlide();
        }
      }, speed);

      return () => clearInterval(intervalId);
    }
  }, [autoscroll, speed, nextSlide]);

  return (
    <div className="carousel">
      {showButtons && (
        <button onClick={prevSlide} className="carousel-button left">
          ❮
        </button>
      )}
      <motion.div
        ref={carouselRef}
        className={`carousel-container ${direction}`}
        animate={{
          x: direction === "horizontal" ? -currentIndex * 100 : 0,
          y: direction === "vertical" ? -currentIndex * 100 : 0,
        }}
        transition={
          autoscroll
            ? {
                duration: 5,
                repeat: Infinity,
                repeatType: "mirror",
                delay: 1, // aggiungi un ritardo di 2 secondi tra le ripetizioni
                ease: "linear", // utilizza la funzione di easing lineare per renderizzare l'animazione più fluida
              }
            : {}
        }
      >
        {Children.map(children, (child) => (
          <div
            className="carousel-item"
            style={
              {
                // width: direction === "horizontal" ? `${itemWidth}px` : "auto",
                // minHeight: direction === "vertical" ? `${itemWidth}px` : "auto",
                // flexBasis: `${itemWidth}px`, // Add this to set the flex basis
              }
            }
          >
            {child}
          </div>
        ))}
      </motion.div>

      {showButtons && (
        <button onClick={nextSlide} className="carousel-button right">
          ❯
        </button>
      )}
    </div>
  );
};

const sortByTankName = (a, b) => {
  // last: disabled
  if (a.is_disabled && !b.is_disabled) return 1;
  if (!a.is_disabled && b.is_disabled) return -1;

  // top: fa-calendar icon
  if (a.icon === "fa-calendar" && b.icon !== "fa-calendar") return -1;
  if (a.icon !== "fa-calendar" && b.icon === "fa-calendar") return 1;

  // case insensitive
  return (a.name || "")?.localeCompare(b.name || "", undefined, {
    numeric: true,
    sensitivity: "base", // ignore upper/lowercase and accents
  });
};

const getTotalQuantity = (
  tank_id_in,
  operation,
  dest_tanks,
  isOperation = false,
  unit = getInputTankUnit()
) => {
  // const batch_id_in = getValues("batch_id_in") || {};
  if (
    !id &&
    !isOperation &&
    tank_id_in?.is_planned &&
    Number(tank_id_in?.planned_quantity) <= 0
  )
    return 0; // i.e. if the in batch is all planned in other dests

  // Da operation i valori sono già in litri (BE); dal form sono in unità input.
  return (
    (isOperation ? operation?.dest_tanks : dest_tanks)?.reduce((acc, curr) => {
      const q = isOperation
        ? Number(curr?.quantity) || 0
        : inputToLiters(curr?.quantity, unit);
      return acc + (Number(q) || 0);
    }, 0) || 0
  );
};

const mapLotToSelectOption = (
  lot,
  operation,
  dest_tanks,
  pomaces_quantity = 0,
  pomaces_w_quantity = 0,
  unit = getInputTankUnit()
) => {
  const id = operation?.id || null;
  const allocatedInitialQuantity = id
    ? getTotalQuantity(lot, operation, dest_tanks, id > 0, unit)
    : 0;
  // Calculate the quantity available for consumption in the current operation:
  // This is the difference between the real (current) quantity and what remains planned after scheduled operations.

  const pomacesQuantityOtherOps =
    lot?.planned_pomaces
      ?.filter((t) => (id ? t?.operation_id !== Number(id) : true))
      ?.reduce((acc, curr) => acc + (Number(curr?.quantity) || 0), 0) || 0;

  // Get the total allocated quantity across destination tanks (dynamic value)
  const allocated = getTotalQuantity(lot, operation, dest_tanks, false, unit);
  const availableForCurrentOp =
    allocatedInitialQuantity + (Number(lot?.planned_quantity) || 0);

  // The current operation can only remove as much as is available
  const checkedQuantity = allocated > availableForCurrentOp ? 0 : allocated; // avoid value over the available quantity
  const tmpArrowQuantity = id
    ? checkedQuantity
    : Math.min(availableForCurrentOp, allocated);
  const arrowQuantity = tmpArrowQuantity >= 0 ? tmpArrowQuantity : 0;
  // Build the lotData object
  const lotData = {};
  lotData.name = lot?.name || lot?.label || "";
  lotData.color = lot?.color;
  lotData.initial_quantity = lot?.initial_quantity; // Fixed initial capacity (e.g., 100 Kg)

  // Set arrow_quantity: the amount to be removed by the current operation
  lotData.arrow_quantity = arrowQuantity;

  const isPlannedByOtherOps =
    lot?.is_planned && lot?.shared_operation_ids?.length > 0
      ? id
        ? lot.shared_operation_ids.some((opId) => Number(opId) !== Number(id))
        : true
      : false;

  lotData.is_planned = isPlannedByOtherOps; //lot?.is_planned;
  // Set the planned quantity for the current operation:
  // This represents how much will be consumed (arrowQuantity) and thus how much is 'planned' for removal.
  // (If no operation is executed, lot.quantity remains unchanged.)
  // In an editing context (when 'id' exists), we update values based on current distribution.
  if (id) {
    if (availableForCurrentOp > 0) {
      // For display when editing:
      // - The new "quantity" (i.e. what is scheduled to remain) is the planned_quantity from the lot.
      // - The amount consumed by the current operation is arrowQuantity.
      lotData.quantity = Number(lot?.planned_quantity) || 0; // What is expected to remain after scheduled ops
      lotData.planned_quantity = arrowQuantity; // Amount to be removed by the current op

      // For additional display details:
      // "real_initial_quantity" shows the total available for consumption (availableForCurrentOp)
      // "estimated_initial_quantity" shows what remains if we subtract the arrowQuantity from the current quantity.
      lotData.real_initial_quantity = !isPlannedByOtherOps
        ? Number(lot?.quantity)
        : availableForCurrentOp - pomacesQuantityOtherOps;
      lotData.estimated_initial_quantity = !isPlannedByOtherOps
        ? 0
        : Number(lot?.quantity) - availableForCurrentOp;

      // Final quantity calculations after the current operation:
      // The real final quantity would be the current lot.quantity minus the amount removed
      lotData.real_final_quantity =
        (!isPlannedByOtherOps ? Number(lot?.quantity) : availableForCurrentOp) -
        arrowQuantity -
        pomacesQuantityOtherOps -
        Number(pomaces_quantity) -
        Number(pomaces_w_quantity);
      lotData.estimated_final_quantity = !isPlannedByOtherOps
        ? 0
        : Number(lot?.quantity) - availableForCurrentOp;
      lotData.arrow_quantity +=
        Number(pomaces_quantity) + Number(pomaces_w_quantity);
    } else {
      // If nothing is available, all values become zero.
      lotData.quantity = 0;
      lotData.planned_quantity = 0;
      lotData.real_initial_quantity = 0;
      lotData.estimated_initial_quantity = 0;
      lotData.real_final_quantity = 0;
      lotData.estimated_final_quantity = 0;
    }
  } else {
    // For non-editing contexts, simply use the lot values.
    lotData.quantity = Number(lot?.quantity) || 0;
    lotData.planned_quantity = Number(lot?.planned_quantity) || 0;
    lotData.real_initial_quantity = isPlannedByOtherOps
      ? Number(lot?.planned_quantity) - pomacesQuantityOtherOps
      : Number(lot?.quantity) || 0;
    lotData.estimated_initial_quantity =
      (Number(lot?.quantity) || 0) - arrowQuantity;
    lotData.real_final_quantity =
      (isPlannedByOtherOps //lot?.is_planned
        ? (Number(lot?.planned_quantity) || 0) -
          arrowQuantity -
          pomacesQuantityOtherOps
        : !id
        ? Number(lot?.quantity) - arrowQuantity
        : Number(lot?.quantity)) -
      pomaces_quantity -
      pomaces_w_quantity;
    // lotData.batch_name = lot?.name || lot?.label || "";
    lotData.estimated_final_quantity = Number(lot?.planned_quantity) || 0;
    lotData.arrow_quantity +=
      Number(pomaces_quantity) + Number(pomaces_w_quantity);
  }

  if (lotData?.arrow_quantity > lotData?.real_initial_quantity) {
    lotData.arrow_quantity = 0;
    lotData.real_final_quantity = lotData?.real_initial_quantity;
  }
  lotData.composition = lot?.composition;

  return lotData;
};

const buildPomace = (pomaceData) => ({
  quantity: Number(pomaceData?.quantity) || 0,
  cost: Number(pomaceData?.cost) || 0,
  recipient_id: pomaceData?.dest?.value || null,
  recipient: pomaceData?.dest?.label || null,
  is_new: pomaceData?.dest?.is_new || false,
  is_field: pomaceData?.dest?.is_field,
  waste_type: pomaceData?.reason?.value || null,
  notes: pomaceData?.close_notes,
});

// Funzione base che estrae e calcola i campi comuni del tank
const getTankBaseData = (tank, operation = null) => {
  const id = operation?.id || null;

  const planned_pomaces =
    (tank?.planned_pomaces || []) 
      ?.filter((t) => (id ? t?.operation_id !== id : true))
      ?.reduce((acc, curr) => acc + (Number(curr?.quantity) || 0), 0) || 0;

  const availability =
    Number(tank?.capacity) - (Number(tank?.planned_quantity) || 0);

  return {
    value: tank?.id,
    label: tank?.name,
    type: tank?.type,
    barrels_num: tank?.barrels_num,
    capacity: Number(tank?.capacity),
    quantity: Number(tank?.quantity),
    vinification_technique: tank?.vinification_technique,
    is_planned: tank?.is_planned === true,
    is_planned_src: tank?.is_planned_src === true,
    is_planned_state: tank?.is_planned_state,
    planned_pomaces,
    planned_quantity: tank?.planned_quantity,
    planned_subtype: tank?.planned_subtype,
    planned_batch_name: tank?.planned_batch_name,
    planned_batch_type: tank?.planned_batch_type,
    planned_batch_color: tank?.planned_batch_color,
    planned_batch_state: tank?.planned_batch_state,
    availability,
    color: tank?.color,
    state: tank?.state,
    lot: tank?.lot || tank?.batch_name,
    lot_id: tank?.batch_id || "",
    batch_type: tank?.batch_type,
    composition: tank?.composition,
    programmed_as_src: tank?.programmed_as_src,
    programmed_as_dest: tank?.programmed_as_dest,
    pomaces_content: tank?.pomaces_content,
  };
};

const mapTankToSelectOption = (
  tank,
  type, // "src" or "dest"
  lots = [],
  operation = null,
  getLabel = () => null
) => {
  const isSrc = type === "src";
  const isDest = type === "dest";
  const id = operation?.id || null;

  // Usa la funzione base per ottenere i campi comuni
  const common = getTankBaseData(tank, operation);

  // if (isSrc) {
  //   const lot = lots?.find(l => l?.id === tank?.batch_id);
  //   if (lot) common.shared_operation_ids = lot?.shared_operation_ids;
  // }

  if (tank?.quantity === 0 && !tank?.batch_id && operation === null) {
    common.batch_type = 0; // default to PRESSED
    // common.state = "WINE";
  }

  if (isDest) {
    return {
      ...common,
      is_disabled:
        tank?.is_planned_src === true ||
        Number(tank?.planned_quantity) === Number(tank?.capacity),

      icon:
        (tank?.is_planned && Number(tank?.planned_quantity) >= 0) ||
        tank?.is_planned_src > 0
          ? "fa-calendar"
          : null,

      is_sanitized: Number(tank?.quantity) === 0 && tank?.is_sanitized,

      name:
        tank?.name +
        ` (${
          tank?.is_planned && Number(tank?.planned_quantity) > 0
            ? tank?.planned_batch_name || ""
            : Number(tank?.quantity) <= 0
            ? getLabel("tankState_EMPTY")
            : lots?.find((lot) => lot?.id === tank?.batch_id)?.name ||
              getLabel("tankState_EMPTY")
        })`,

      is_planned_by_other_ops:
        tank?.is_planned &&
        tank?.programmed_as_dest?.filter(
          (p_id) => id === null || p_id !== Number(id)
        )?.length > 0,
    };
  }

  if (isSrc) {
    const isSelectedAsSrc = operation?.src_tanks?.find(
      (s) => s?.id == tank?.tank_id
    );
    return {
      ...common,
      is_disabled:
        tank?.is_planned_src === true &&
        ((id && !isSelectedAsSrc) ||
          Number(tank?.planned_quantity) === Number(tank?.quantity)),

      icon:
        tank?.is_planned_src &&
        Number(tank?.quantity) > 0 &&
        Number(tank?.quantity) !== Number(tank?.planned_quantity)
          ? "fa-calendar"
          : null,

      name:
        tank?.name + ` (${tank?.batch_name || getLabel("tankState_EMPTY")})`,

      is_planned_by_other_ops:
        tank?.is_planned_src &&
        tank?.programmed_as_src?.filter(
          (p_id) => id === null || p_id !== Number(id)
        )?.length > 0,
    };
  }

  return common; // fallback, should never hit this unless type is wrong
};

const getUnifiedTankData = (
  t,
  {
    type, // 'DECANT', 'RACKING', 'NEW_LOT', 'CUT', 'DESTEMMING', 'BOTTLING', 'FILTERING
    subtype,
    carbonic_output_state,
    isSrc = false,
    id = null,
    lots = [],
    operation = {},
    src_tanks = [],
    dest_tanks = [],
    lotNames = [],
    lotTypeMap = {},
    tank_id_in = {},
    color,
    pomaces_quantity = 0,
    pomaces_w_quantity = 0,
    expectedDestinationState = null,
    unit = getInputTankUnit(),
    // operations = [],
  }
) => {
  const tank = isSrc ? t?.tankData || t : type === "CUT" ? t : t?.tankData;

  if (!tank) return null;

  // I valori dal form (t.quantity / dest_tanks[].quantity) sono in unità input
  // (L o hL); tutta la matematica qui sotto è in litri (come i tank dal BE).
  // Normalizziamo a litri PRIMA di qualsiasi confronto/somma.
  dest_tanks = dest_tanks?.map?.((d) => ({
    ...d,
    quantity: inputToLiters(d?.quantity, unit),
  }));

  const tmpQuantity = (() => {
    const q = inputToLiters(Number(t?.quantity) || 0, unit);
    if (isSrc) {
      if (type === "CUT") {
        return q;
      } else {
        return (
          dest_tanks?.reduce(
            (acc, curr) => acc + (Number(curr?.quantity) || 0),
            0
          ) || 0
        );
      }
    } else {
      const available = tank?.availability ?? 0;
      const alreadyUsed =
        dest_tanks
          ?.filter((tt) => tt?.id !== t?.tankData?.value)
          ?.reduce((acc, curr) => acc + (Number(curr?.quantity) || 0), 0) || 0;
      const availableAtSrc = Number(tank_id_in?.quantity) - alreadyUsed; // check there are enough liters in the src

      return availableAtSrc < 0 ? 0 : available >= q && q >= 0 ? q : 0;
    }
  })();
  const quantity = Number(tmpQuantity) >= 0 ? tmpQuantity : 0;

  const new_batch_name = !isSrc
    ? t?.batch_name_selector?.value === true && t?.new_batch_name
      ? t.new_batch_name
      : t?.batch_name_selector?.value === false
      ? t?.batch_name_selector?.label
      : ""
    : tank?.lot;

  // Usa la funzione base per ottenere i campi comuni del tank
  const baseData = getTankBaseData(tank, operation);

  // Trova il lot e le compositions per questo tank
  const lot = lots?.find(l => l?.id == tank?.lot_id);
  const tankCompositions = lot?.composition?.filter(c =>
    c?.tank_id == tank?.value
  );

  const tankData = {
    is_src: isSrc,
    name: t?.label || baseData.label || "",
    type: baseData.type,
    state: baseData.state,
    batch_type: baseData.batch_type,
    barrels_num: baseData.barrels_num,
    arrow_quantity: quantity,
    capacity: baseData.capacity,
    old_quantity: baseData.quantity,
    planned_quantity: baseData.planned_quantity,
    vinification_technique: baseData.vinification_technique,
    // old_quantity2:
    //   isSrc && tank?.is_planned_src
    //     ? Number(tank?.planned_quantity)
    //     : tank?.quantity,
    old_batch_name: baseData.lot || "",
    old_batch_type: baseData.quantity > 0 && [0, 1, 2].includes(baseData.batch_type) ? baseData.batch_type : undefined,
    batch_name: baseData.lot || "",
    composition: tankCompositions,
    quantity: baseData.quantity + (isSrc ? -1 : 1) * quantity,
    is_planned: (isSrc ? baseData.is_planned_src : baseData.is_planned) === true,
    is_planned_state: baseData.is_planned_state,
    // planned_quantity:
    //   (isSrc ? tank?.is_planned_src : tank?.is_planned)
    //     ? (isSrc ? -1 : 1) * (Number(tank?.planned_quantity) - (!id ? Number(t?.quantity) : 0))
    //     : 0,
    // planned_quantity2: (isSrc ? tank?.is_planned_src : tank?.is_planned)
    //   ? (isSrc ? -1 : 1) *
    //     (Number(tank?.planned_quantity) -
    //       (!id ? Number(!isSrc ? tank?.quantity : t?.quantity) : 0))
    //   : 0,
    planned_subtype: baseData.planned_subtype,
    planned_batch_name: baseData.planned_batch_name,
    planned_batch_color: baseData.planned_batch_color,
    planned_batch_state: baseData.planned_batch_state,
    planned_batch_type: baseData.planned_batch_type,
    color: baseData.quantity > 0 ? baseData.color : tank_id_in?.color || color?.value || (!isSrc && type === "CUT" ? dest_tanks?.[0]?.tankData?.color : null),
  };

  if (!isSrc) {
    tankData.color = applySubtypeColorTransformation(tankData.color, subtype);
    if (subtype === "CARBONIC_MACERATION") {
      tankData.state = carbonic_output_state || "WINE";
    } else if (subtype === "ORANGE_WINE") {
      tankData.state = carbonic_output_state || "MUST";
    }

    if (tank_id_in?.state && !tankData?.state) {
      tankData.state = tank_id_in.state;
    }
  }
  
  if (t?.quantity > 0 && t?.lot_id && ["WINE", "BOTTLED"].includes(t?.state)) {
    tankData.old_batch_type = t?.batch_type;
    if (isSrc) tankData.batch_type = t?.batch_type;
  }

  if (!isSrc) {
    if (id === null) {
      // Cerca prima un lotto con nome E stato corretto
      let l = expectedDestinationState
        ? lotNames?.find((ll) =>
            ll?.name === new_batch_name &&
            ll?.state === expectedDestinationState
          )
        : null;

      // Fallback: cerca solo per nome se non trovato con stato
      if (!l) {
        l = lotNames?.find((ll) => ll?.name === new_batch_name);
      }

      if (l) {
        // Non sovrascrivere lo stato se già settato da logiche speciali (CARBONIC_MACERATION, etc.)
        if (!tankData.state || tankData.state === baseData.state) {
          tankData.state = l?.state;
        }
        tankData.batch_type = l?.batch_type;
      } else {
        // first occurrence of new batch name, get switch status
        tankData.batch_type = lotTypeMap?.[new_batch_name];
      }
    } else {
      // const isPressed = ["WINE", "BOTTLED"].includes(tankData?.state)
      //   ? lotTypeMap?.[new_batch_name] ?? false
      //   : null;
      // console.log('lotst', lotTypeMap?.[new_batch_name])
      tankData.batch_type = lotTypeMap?.[new_batch_name];
    }
  }

  if (type === "FILTERING" && !isSrc) {
    // For FILTERING destination tank, batch_type must match source tank
    tankData.batch_type = tank_id_in?.batch_type;
  }

  const programmedIds = isSrc
    ? tank?.programmed_as_src
    : tank?.programmed_as_dest;

  const isPlannedByOtherOps =
    tankData?.is_planned &&
    ((id === null && programmedIds?.length > 0) ||
      (id !== null && programmedIds?.some((p_id) => p_id !== Number(id))));
  tankData.is_planned = isPlannedByOtherOps;

  // Quota riservata dalle SOLE altre operazioni pianificate: il campo raw di
  // backend (tank?.planned_quantity) è proiettato considerando TUTTE le op
  // pianificate, inclusa quella in editing, quindi va scorporata la quota
  // già propria dell'operazione corrente (thisOpQuantity) per non contarla
  // come "altrui". Vale sia per src (quantità in uscita) che per dest
  // (quantità in ingresso), con verso opposto.
  const thisOpQuantity = !id
    ? 0
    : Number(
        isSrc
          ? operation?.src_tanks?.find((s) => s?.tank_id === tank?.value)
              ?.arrow_quantity
          : operation?.dest_tanks?.find((d) => d?.tank_id === tank?.value)
              ?.arrow_quantity
      ) || 0;

  const otherOpsReserved = isPlannedByOtherOps
    ? (isSrc
        ? Number(tank?.quantity) - Number(tank?.planned_quantity || 0)
        : Number(tank?.planned_quantity || 0) - Number(tank?.quantity)) -
      thisOpQuantity
    : 0;

  if (isSrc) {
    // old_quantity = quanto è realmente disponibile per QUESTA operazione
    // (contenuto reale meno la sola quota riservata da altre operazioni).
    // planned_quantity resta il "tetto" fisso (contenuto reale totale): la
    // differenza fra i due (usata da Details.js per la barra/etichetta
    // "stimata" e per il testo in end_status) è quindi sempre pari a
    // otherOpsReserved, indipendentemente da quanto si digita in questa op.
    tankData.old_quantity = isPlannedByOtherOps
      ? Number(tank?.quantity) - otherOpsReserved
      : Number(tank?.quantity) || 0;
    tankData.planned_quantity = isPlannedByOtherOps
      ? Number(tank?.quantity) || 0
      : 0;
  } else {
    // dest: old_quantity resta il contenuto reale attuale (baseData.quantity,
    // già impostato sopra); planned_quantity è la sola quota fissa riservata
    // dalle altre operazioni (stack aggiuntivo, indipendente dall'input
    // corrente di questa operazione).
    tankData.planned_quantity = isPlannedByOtherOps ? otherOpsReserved : 0;
  }

  // Gestione batch_name per planned by other ops
  if (!isSrc) {
    const batch_name_value = t?.batch_name_selector?.value;
    const batch_name_label = t?.batch_name_selector?.label;

    if (tank?.planned_batch_name && isPlannedByOtherOps && !batch_name_value) {
      tankData.batch_name = tank?.planned_batch_name || new_batch_name;
      if (id) {
        tankData.batch_name = new_batch_name;
      }
    } else if (
      tank?.planned_batch_name &&
      !isPlannedByOtherOps &&
      batch_name_value
    ) {
      tankData.planned_quantity = 0;
    } else {
      tankData.batch_name = new_batch_name;
      if (!isPlannedByOtherOps) {
        tankData.planned_quantity = 0;
      }
    }
    tankData.is_planned_by_other_ops = isPlannedByOtherOps;
  } else {
    // sorgente: il nome lotto resta quello presente
    tankData.batch_name = tankData?.old_batch_name;
    if (
      // !id &&
      type === "RACKING" ||
      type === "DESTEMMING"
    ) {
      const pomacesQuantity = Number(pomaces_quantity) || 0;
      const pomacesWQuantity = Number(pomaces_w_quantity) || 0;
      const pomacesTotal = pomacesQuantity + pomacesWQuantity;
      tankData.arrow_quantity = tankData?.arrow_quantity + pomacesTotal;

      let availability = tank?.quantity;
      if (isPlannedByOtherOps) {
        const plannedPomacesOtherOps =
          tankData?.planned_pomaces
            ?.filter((t) => (id ? t?.operation_id !== Number(id) : true))
            ?.reduce((acc, curr) => acc + (Number(curr?.quantity) || 0), 0) ||
          0;
        const thisOpQuantity = id
          ? tankData?.arrow_quantity - plannedPomacesOtherOps
          : 0; // in case of update, do not count current data
        availability = tankData?.planned_quantity + thisOpQuantity; // - (Number(operation?.treatments?.[0]?.quantity) || 0) + thisOpQuantity;
        // TO DO controlla
      }
      if (tankData?.arrow_quantity > availability) {
        tankData.quantity = -1; // trick to reuse set to quantity = 0, arrow_quantity = 0
      }
    }
  }
  if (
    isSrc &&
    (tankData?.quantity < 0 ||
      (tankData?.is_planned &&
        tankData?.arrow_quantity > tankData?.old_quantity))
  ) {
    tankData.quantity = 0;
    tankData.arrow_quantity = 0;
  } else if (!isSrc && type === "DESTEMMING") {
    let srcBatchAvailableQuantity = tank_id_in?.quantity;
    const isPlannedByOtherOps = tank_id_in?.shared_operation_ids?.some(
      (p_id) => p_id !== Number(id)
    );
    if (tank_id_in?.is_planned && isPlannedByOtherOps) {
      const plannedPomacesOtherOps =
        tank_id_in?.planned_pomaces
          ?.filter((t) => (id ? t?.operation_id !== Number(id) : true))
          ?.reduce((acc, curr) => acc + (Number(curr?.quantity) || 0), 0) || 0;
      const thisOpQuantity = id
        ? tank_id_in?.arrow_quantity - plannedPomacesOtherOps
        : 0; // in case of update, do not count current data
      srcBatchAvailableQuantity = tank_id_in?.planned_quantity + thisOpQuantity; // - (Number(operation?.treatments?.[0]?.quantity) || 0) + thisOpQuantity;
    }
    if (tankData?.arrow_quantity > srcBatchAvailableQuantity) {
      tankData.quantity = 0;
      tankData.arrow_quantity = 0;
    }

    if (tank_id_in?.color === "WHITE") {
      tankData.state = "MUST";
    }
  }

  // CUT specific
  if (type === "CUT") {
    if (isSrc) {
      const programmedQuantity = !id
        ? Number(tank?.quantity)
        : Number(
            operation?.src_tanks?.find((s) => s?.tank_id === tank?.value)
              ?.arrow_quantity
          );

      const availableQuantity = isPlannedByOtherOps
        ? Number(tank?.quantity) - otherOpsReserved
        : Number(tank?.quantity) || 0;
      const availableFreeSpace = tank?.capacity - availableQuantity;
      const isInvalidArrowQuantity =
        Math.abs(quantity) > availableQuantity || quantity < 0;

      tankData.arrow_quantity = isInvalidArrowQuantity ? 0 : Math.abs(quantity);
      tankData.remove_quantity = quantity;
      tankData.quantity =
        tank?.quantity - (isInvalidArrowQuantity ? 0 : quantity);
    } else {
      const programmedQuantity = id
        ? operation?.src_tanks?.reduce(
            (acc, curr) => acc + (Number(curr?.arrow_quantity) || 0),
            0
          ) || 0
        : dest_tanks?.reduce(
            (acc, curr) => acc + (Number(curr?.quantity) || 0),
            0
          ) || 0;

      const availableFreeSpace =
        tank?.capacity -
        (isPlannedByOtherOps
          ? Number(tank?.quantity) + otherOpsReserved
          : Number(tank?.quantity));
      const isInvalidArrowQuantity = programmedQuantity > availableFreeSpace;

      tankData.arrow_quantity = isInvalidArrowQuantity ? 0 : programmedQuantity;

      tankData.batch_name = new_batch_name;
      tankData.quantity =
        tank?.quantity + (isInvalidArrowQuantity ? 0 : programmedQuantity);

      if (tankData.is_planned_by_other_ops) {
        tankData.old_batch_name = null;
        tankData.planned_batch_name = tankData.batch_name || "";
      }
    }
  }

  // default PRESSED only when the FLOWER/PRESSED/MIXED distinction is relevant
  const _needsBatchType = isBatchTypeNeeded({
    operationType: type,
    outputColor: tankData?.color,
    outputState: tankData?.state,
    subtype,
  });
  if (
    !isSrc &&
    _needsBatchType &&
    (![0, 1, 2].includes(tankData.batch_type) ||
      tankData.batch_type === undefined)
  ) {
    tankData.batch_type = 0;
    if (!tankData.state) {
      const newState =
        type === "RACKING" ||
        (type === "DESTEMMING" && tankData?.color === "WHITE")
          ? "MUST"
          : type === "DESTEMMING"
          ? "MUST"
          : type === "BOTTLING"
          ? "BOTTLED"
          : null;
      tankData.state = newState;
    }
  }

  return tankData;
};

const quantitiesCustomId = "custom-id-invalid-quantities";

const checkCutAvailableQuantity = (
  id,
  operation,
  tank_id_in,
  tankData,
  quantity,
  getLabel,
  dest_tanks = [],
  unit = getInputTankUnit()
) => {
  // L'availability proviene dai tank data (litri); i valori dal form sono in unità input.
  quantity = inputToLiters(quantity, unit);
  dest_tanks = dest_tanks?.map?.((d) => ({
    ...d,
    quantity: inputToLiters(d?.quantity, unit),
  }));
  const isPlannedState = tankData?.is_planned_src === true;

  const isPlannedByOtherOps =
    isPlannedState &&
    ((id === null && tankData?.programmed_as_src?.length > 0) ||
      (id !== null &&
        tankData?.programmed_as_src?.some((p_id) => p_id !== Number(id))));

  const isPlanned = tankData?.value && isPlannedState && isPlannedByOtherOps;
  const previousQuantity = id
    ? operation?.src_tanks?.find((s) => s?.tank_id === tankData?.value)
        ?.arrow_quantity
    : 0;

  const availableQuantity =
    (isPlanned
      ? Number(tankData?.planned_quantity || 0)
      : tankData?.quantity || 0) + previousQuantity;

  if (quantity > availableQuantity) {
    return getLabel("errorMaxValue", {
      value: availableQuantity,
    });
  }
  // const totalQuantity = getTotalQuantity(
  //   tank_id_in,
  //   operation,
  //   dest_tanks,
  // );
  const totalQuantity =
    dest_tanks?.reduce((acc, curr) => {
      return acc + (Number(curr?.quantity) || 0);
    }, 0) || 0;

  const dest_tank = dest_tanks?.tankData || {};
  const previousTotalQuantity = id
    ? operation?.src_tanks?.reduce((acc, curr) => {
        return acc + (Number(curr?.arrow_quantity) || 0);
      }, 0) || 0
    : 0;

  const totalAvailability =
    (Number(dest_tank?.capacity) -
      (dest_tank?.is_planned
        ? Number(dest_tank?.planned_quantity)
        : Number(dest_tank?.quantity)) || 0) - previousTotalQuantity;
  // console.log('totalQuantity', totalQuantity, 'totalAvailability', totalAvailability)
  if (totalQuantity <= totalAvailability) toast.dismiss(quantitiesCustomId);

  return true;
};

// const checkTransferAvailableQuantity = (
//   id,
//   idx,
//   type,
//   tank_id_in,
//   watchedArray,
//   value,
//   baseName,
//   getValues,
//   getLabel,
//   clearErrors,
//   trigger,
//   isPomaces = false,
// ) => {
//   const isClose = type === "CLOSING";
//   const isRacking = type === "RACKING";
//   const isBottling = type === "BOTTLING";
//   const isDestemming = type === "DESTEMMING";
//   const pomaces_quantity = !(isRacking || isDestemming)
//     ? 0
//     : Number(getValues("pomaces.quantity") || 0);
//   const pomaces_w_quantity = !(isRacking || isDestemming)
//     ? 0
//     : Number(getValues("pomacesW.quantity") || 0);

//   const src_batch = getUnifiedTankData(tank_id_in, {
//     type: type,
//     isSrc: true,
//     id,
//     // getValues,
//     dest_tanks: watchedArray,
//     pomaces_quantity,
//     pomaces_w_quantity,
//   });

//   let availability = Number(src_batch?.old_quantity) || 0;
//   const pomacesTotal = pomaces_quantity + (type === "DESTEMMING" && tank_id_in?.color === "WHITE" ? pomaces_w_quantity : 0);
//   const totalRequestedQuantity = watchedArray?.reduce((acc, curr, i) => {
//     if (i === idx) return acc + Number(value || 0); // use the current input
//     return acc + (Number(curr?.quantity) || 0);
//   }, 0) + pomacesTotal;

//   let lotAvailability = tank_id_in?.quantity;
//   if (type === "DESTEMMING" || type === "RACKING") {
//     const isPlannedByOtherOps = tank_id_in?.shared_operation_ids?.some((p_id) => p_id !== Number(id));
//     if (tank_id_in?.is_planned && isPlannedByOtherOps) {
//       const plannedPomacesOtherOps = tank_id_in?.planned_pomaces
//         ?.filter(t => id ? t?.operation_id !== Number(id) : true)?.reduce(
//           (acc, curr) => acc + (Number(curr?.quantity) || 0),
//           0
//         ) || 0;
//       const thisOpQuantity = id ? (tank_id_in?.arrow_quantity - plannedPomacesOtherOps) : 0;   // in case of update, do not count current data

//       // lotAvailability = tank_id_in?.planned_quantity - plannedPomacesOtherOps;// - (Number(operation?.treatments?.[0]?.quantity) || 0) + thisOpQuantity;
//       lotAvailability = tank_id_in?.planned_quantity + thisOpQuantity;// - (Number(operation?.treatments?.[0]?.quantity) || 0) + thisOpQuantity;
//       availability = lotAvailability;
//     } else {
//       lotAvailability -= ((pomaces_quantity || 0) + (pomaces_w_quantity || 0))
//     }
//   }

//   const tankAvailability = type === "DESTEMMING" ? lotAvailability : Number(watchedArray?.[idx]?.tankData?.availability);
//   if (isPomaces) {
//     const difference = availability - totalRequestedQuantity;

//     // ❌ ERRORE BLOCCANTE → supero volume sorgente
//     if (difference < 0) {
//       return getLabel("errorMaxValue", {
//         value: getLabel("errorMaxValueReached"),
//       });
//     }

//     // ⚠️ WARNING → fuori range stimato
//     const movedQuantity = watchedArray?.reduce(
//       (acc, curr) => acc + (Number(curr?.quantity) || 0),
//       0
//     );

//     const isWhitePomaces =
//       isDestemming &&
//       tank_id_in?.color === "WHITE" &&
//       getValues("pomacesW.quantity") !== undefined;

//     const pomacesRange = isDestemming
//       ? isWhitePomaces
//         ? [2, 5]   // bucce bianche
//         : [15, 20] // raspi / vinacce
//       : [15, 20];

//     const minPomaces = Math.floor(
//       (movedQuantity * pomacesRange[0]) / 100
//     );
//     const maxPomaces = Math.floor(
//       (movedQuantity * pomacesRange[1]) / 100
//     );

//     if (Number(value) < minPomaces || Number(value) > maxPomaces) {
//       // ⚠️ warning NON bloccante, solo sul campo corrente
//       setTimeout(() => trigger(), 0);
//       return getLabel("errorMaxValueWarning", {
//         min: minPomaces,
//         max: maxPomaces,
//       });
//     }

//     return true;
//   }
// // if (isPomaces) {
// //     const difference = lotAvailability + pomacesTotal - totalRequestedQuantity;
// //     if (difference < 0) return getLabel("errorMaxValue", {
// //         value: difference < 0 ? getLabel("errorMaxValueReached") : difference,
// //       });
// //   }
//   else if (
//     (!isBottling && !isClose ? Number(value) <= tankAvailability : true) &&
//     Number(value) <= Number(availability) &&
//     Number(totalRequestedQuantity) <= Number(availability)
//   ) {
//     watchedArray?.forEach(
//       (r, index) =>
//         Number(r?.quantity) > 0 && clearErrors(`${baseName}.${index}.quantity`)
//     );
//     // if (isRacking || isDestemming) //trigger("pomaces.quantity");
//     // clearErrors("pomaces.quantity");
//     // console.log('Number(value)', Number(value), 'tankAvailability', tankAvailability, 'availability', availability, 'totalRequestedQuantity', totalRequestedQuantity)
//     return true; // is valid
//   } else {
//     const difference =
//       (isClose || isBottling)
//         ? availability - totalRequestedQuantity
//         : Number(value) > tankAvailability
//         ? tankAvailability
//         : 0;
//     if (difference < 0)
//       return getLabel("errorMaxValue", {
//         value: difference < 0 ? getLabel("errorMaxValueReached") : difference,
//       });
//   }
// };

const computePomacesStatus = ({
  type,
  tank_id_in,
  dest_tanks = [],
  pomaces = 0,
  pomacesW = 0,
  value = 0,
  pomacesKey = "pomaces",
  isPomaces = false,
}) => {
  const pomacesTotal =
    pomaces + (type === "DESTEMMING" || type === "RACKING" ? pomacesW : 0);

  const totalRequested =
    dest_tanks.reduce((acc, d) => acc + Number(d.quantity || 0), 0) +
    pomacesTotal;

  const availability = Number(tank_id_in?.quantity || 0);

  const difference = availability - totalRequested;
  if (difference < 0) {
    return { isError: true, isWarning: false, reason: "OVER_MAX" };
  }

  // ⚠️ warning range
  const range =
    type === "DESTEMMING"
      ? pomacesKey === "pomacesW"
        ? [5, 10] // bucce bianche
        : [2, 5] // raspi
      : [15, 20];

  const min = Math.floor((totalRequested * range[0]) / 100);
  const max = Math.floor((totalRequested * range[1]) / 100);

  let isWarning = false;
  let reason = null;

  if (value < min) {
    isWarning = true;
    reason = "UNDER_MIN";
  } else if (value > max) {
    isWarning = true;
    reason = "OVER_MAX";
  }

  return { isError: false, isWarning, min, max, reason };
};

export const computePlannedLotAvailability = ({ tank, operationId }) => {
  if (!tank) {
    return {
      availability: 0,
      lotAvailability: 0,
      isPlannedByOtherOps: false,
    };
  }

  const programmedIds = tank.programmed_as_dest || [];
  const isPlannedByOtherOps = programmedIds.some(
    (p_id) => p_id !== Number(operationId)
  );

  let availability = 0;
  let lotAvailability = tank.quantity;

  if (tank.is_planned && isPlannedByOtherOps) {
    const plannedPomacesOtherOps =
      tank.planned_pomaces
        ?.filter((t) =>
          operationId ? t.operation_id !== Number(operationId) : true
        )
        ?.reduce((acc, curr) => acc + Number(curr?.quantity || 0), 0) || 0;

    const thisOpQuantity =
      (operationId ? Number(tank.arrow_quantity || 0) : 0) -
      plannedPomacesOtherOps;

    lotAvailability = Number(tank.planned_quantity || 0) + thisOpQuantity;

    availability = lotAvailability;
  }

  return {
    lotAvailability,
    isPlannedByOtherOps,
    availability,
  };
};

const checkTransferAvailableQuantity = (
  id,
  idx,
  type,
  subtype,
  tank_id_in,
  watchedArray,
  value,
  baseName,
  getValues,
  getLabel,
  clearErrors,
  trigger,
  isPomaces = false,
  pomacesKey = "pomaces",
  unit = getInputTankUnit()
) => {
  const isClose = type === "CLOSING";
  const isRacking = type === "RACKING";
  const isBottling = type === "BOTTLING";
  const isDestemming = type === "DESTEMMING";

  // L'availability dei tank è in litri; i valori dal form sono in unità input:
  // normalizziamo tutto a litri prima dei confronti.
  value = inputToLiters(value, unit);
  watchedArray = watchedArray?.map?.((d) => ({
    ...d,
    quantity: inputToLiters(d?.quantity, unit),
  }));

  const pomaces_quantity = !(isRacking || isDestemming)
    ? 0
    : inputToLiters(getValues("pomaces.quantity") || 0, unit);

  const pomaces_w_quantity = !(isRacking || isDestemming)
    ? 0
    : inputToLiters(getValues("pomacesW.quantity") || 0, unit);

  const src_batch = getUnifiedTankData(tank_id_in, {
    type,
    subtype,
    carbonic_output_state: getValues("carbonic_output_state")?.value,
    isSrc: true,
    id,
    dest_tanks: watchedArray,
    pomaces_quantity,
    pomaces_w_quantity,
    unit: "L", // watchedArray è già stato convertito in litri qui sopra
  });

  let availability = Number(src_batch?.old_quantity) || 0;

  const pomacesTotal =
    pomaces_quantity +
    ((type === "DESTEMMING" && tank_id_in?.color === "WHITE") || isRacking
      ? pomaces_w_quantity
      : 0);

  const totalRequestedQuantity =
    watchedArray?.reduce((acc, curr, i) => {
      if (i === idx) return acc + Number(value || 0);
      return acc + (Number(curr?.quantity) || 0);
    }, 0) + pomacesTotal;

  let lotAvailability = tank_id_in?.quantity;

  if (type === "DESTEMMING" || type === "RACKING") {
    const { lotAvailability: tmpLotAvailability, availability } =
      computePlannedLotAvailability({
        tank: tank_id_in,
        operationId: id,
      });
    lotAvailability = tmpLotAvailability;
  }

  const tankAvailability =
    type === "DESTEMMING" || type === "RACKING"
      ? lotAvailability
      : Number(watchedArray?.[idx]?.tankData?.availability);

  if (isPomaces) {
    const input_tank = { ...tank_id_in, quantity: tankAvailability };
    const status = computePomacesStatus({
      type,
      tank_id_in: input_tank,
      dest_tanks: watchedArray,
      pomaces: inputToLiters(getValues("pomaces.quantity") || 0, unit),
      pomacesW: inputToLiters(getValues("pomacesW.quantity") || 0, unit),
      value: Number(value),
      isWhite: pomacesKey === "pomacesW",
      isPomaces: true,
    });

    const val = status.reason === "UNDER_MIN" ? status.min : status.max;

    if (status.isError) {
      return getLabel("errorMaxValue", {
        value: getLabel("errorMaxValueReached", { value: val }),
      });
    }

    // if (status.isWarning) {
    //   return getLabel(
    //     status.reason === "UNDER_MIN"
    //       ? "errorMinValueWarning"
    //       : "errorMaxValueWarning",
    //     { value: status.reason === "UNDER_MIN" ? status.min : status.max }
    //   );
    // }
    // if (!status.isError && !status.isWarning) {
    // if (!status.isError) {
    watchedArray?.forEach(
      (r, index) =>
        Number(r?.quantity) > 0 && clearErrors(`${baseName}.${index}.quantity`)
    );
    clearErrors(pomacesKey === "pomacesW" ? "pomaces" : "pomacesW");
    // }

    return true;
  } else if (
    (!isBottling && !isClose ? Number(value) <= tankAvailability : true) &&
    Number(value) <= Number(availability) &&
    Number(totalRequestedQuantity) <= Number(availability)
  ) {
    watchedArray?.forEach(
      (r, index) =>
        Number(r?.quantity) > 0 && clearErrors(`${baseName}.${index}.quantity`)
    );
    clearErrors("pomaces.quantity"); // TO DO fix clear error and change errorMessage
    if (type === "DESTEMMING" || type === "RACKING") clearErrors("pomacesW.quantity");

    return true;
  } else {
    const difference =
      isClose || isBottling
        ? availability - totalRequestedQuantity
        : Number(value) + pomacesTotal > tankAvailability
        ? tankAvailability - Number(value) - pomacesTotal
        : 0;
    // if (isPomaces) console.log('Number(value)', Number(value), 'pomacesTotal', pomacesTotal, 'tankAvailability', tankAvailability, 'totalRequestedQuantity', totalRequestedQuantity, 'availability', availability, 'difference', difference)

    if (difference < 0) {
      if (type === "DESTEMMING" || type === "RACKING") {
        clearErrors("pomaces.quantity");
      }
      if (type === "DESTEMMING" || type === "RACKING") {
        clearErrors("pomacesW.quantity");
      }
      return getLabel("errorMaxValue", {
        value:
          difference < 0 ? getLabel("errorMaxValueReached") : tankAvailability,
      });
    }
  }
};

const getBottlesCount = (idx, watchedArray, bottleTypes) => {
  const d = watchedArray?.[idx] || {};
  const totalQtyUsedIncludingCurrent = Number(d?.quantity) || 0;
  const volume = parseFloat(
    bottleTypes?.find((t) => t?.value === d?.bottle_lot?.bottle_type)?.volume ||
      0.75
  ); // e.g., 0.75

  return Math.ceil(totalQtyUsedIncludingCurrent / volume);
};

const filterBottleCapData = (
  data,
  idx,
  watchedArray,
  bottleTypes,
  getLabel,
  is_bottle = true
) => {
  if (!data?.length) return [];

  const key = is_bottle ? "bottle_lot" : "cap_lot";
  const selectedValue = watchedArray?.[idx]?.[key]?.value;

  return [
    // { label: "", value: "" }, // Dummy empty option
    ...data
      .map((item, i) => {
        const itemId = item?.id;
        const currentQuantity = Number(watchedArray?.[idx]?.quantity);
        // Calculate how much of this item is used across all dests (excluding current idx)
        const totalUsedQty =
          watchedArray?.reduce((acc, dest, i) => {
            const destVal = dest?.[key]?.value;
            // Include all uses of this item except at current index
            if (destVal === itemId && i !== idx) {
              return acc + getBottlesCount(i, watchedArray, bottleTypes);
            }
            return acc;
          }, 0) || 0;

        // Filter out the currently selected item at idx
        if (itemId === selectedValue) return null;

        const selectedBottleType = item?.bottle_type;
        const selectedVolume =
          is_bottle && selectedBottleType
            ? getLabel(`bottleVolume_${selectedBottleType}_Vol`)
            : 0.75;

        const volume = parseFloat(selectedVolume); // e.g., 0.75

        const totalQtyUsedIncludingCurrent =
          totalUsedQty + (Number(currentQuantity) || 0);
        const requiredItems = Math.ceil(totalQtyUsedIncludingCurrent / volume);
        const availableItems = Number(item?.quantity) || 0;

        // Disable the item if the required bottles exceed the remaining stock
        const isDisabled = requiredItems > availableItems;
        const quantity = (Number(item?.quantity) || 0) - totalUsedQty || 0;

        // if ((is_bottle && i !== idx)) console.log('i', i, 'idx', idx, 'item?.quantity', item?.quantity, 'count', count, 'ceil', Math.ceil(totalUsedQty * volume))

        return {
          value: itemId,
          label: item?.name,
          // quantity: Number(item?.quantity),
          quantity: quantity, // quantità residua reale
          ...(is_bottle && {
            bottle_type: item?.bottle_type || "Standard",
            bottle_volume:
              bottleTypes?.find((t) => t?.value === item?.bottle_type)
                ?.volume || 0.75,
          }),
          name: `${item?.name} (${is_bottle ? volume + "L " : ""}x${quantity})`,
          is_disabled: isDisabled,
        };
      })
      .filter((item) => item !== null), // Remove nulls from the list
  ];
};

const renderBottlingCapBottleSelector = (
  subtype,
  operation,
  watchedArray,
  capsData,
  bottlesData,
  tank_id_in,
  baseName,
  bottleTypes,
  idx,
  control,
  register,
  errors,
  getValues,
  getLabel,
  getError,
  clearErrors
) => {
  const item = watchedArray?.[idx];
  const isNew = item?.batch_name_selector?.value === true;
  const batchName = isNew
    ? item?.new_batch_name
    : item?.batch_name_selector?.label;
  const bottleLot = item?.bottle_lot?.value;
  const quantity = item?.quantity;
  const inputUnit = getInputTankUnit();

  return (
    <div className="bottling_wrapper">
      {batchName && (
        <BottleIcon
          batch_type={tank_id_in?.batch_type || item?.batch_type}
          color={tank_id_in?.color}
          batch_name={batchName || item?.batch_name || ""}
          cap_lot={item?.cap_lot?.label || ""}
          volume={getLabel(`bottleVolume_${item?.bottle_lot?.bottle_type}_Vol`)}
          bottle_lot={item?.bottle_lot?.label || ""}
          isDetail={true}
          bottleCount={getBottlesCount(idx, watchedArray, bottleTypes)}
        />
      )}
      {batchName && (
        <div className="bottling_input">
          <Input
            name={`${baseName}.${idx}.quantity`}
            register={register}
            type="number"
            customClassName="quantity"
            label={`${getLabel(`quantity`)} (${inputUnit})`}
            placeholder={getLabel("operationDestTanksQuantityPlaceholder")}
            required={getLabel("inputRequiredError")}
            // max={{
            //   value: Number(tank_id_in?.quantity || 0),
            //   message: getLabel("errorMaxValue", {
            //     value: Number(tank_id_in?.quantity || 0)
            //   }),
            // }}
            min={{
              value: getInputQtyMin(inputUnit),
              message: getLabel("errorMinValue", { value: getInputQtyMin(inputUnit) }),
            }}
            regExpPattern={{
              value: getInputQtyRegex(inputUnit),
              message: getLabel(inputUnit === "hL" ? "errorIntFloat" : "errorInt"),
            }}
            error={getError(idx, baseName, "quantity")}
            validate={(value) => {
              return checkTransferAvailableQuantity(
                id,
                idx,
                "BOTTLING",
                subtype,
                tank_id_in,
                watchedArray,
                value,
                baseName,
                getValues,
                getLabel,
                clearErrors
              );
            }}
            // tooltip={getLabel("bottleQuantityTooltip")}
          />
        </div>
      )}
      {batchName && quantity > 0 && !getError(idx, baseName, "quantity") && (
        <div className="cap_bottle_main_wrapper">
          <div className="cap_bottle_wrapper">
            <Select
              control={control}
              // defaultValue={{
              //   value: "",
              //   label: "",
              // }}
              name={`${baseName}.${idx}.bottle_lot`}
              label={getLabel("bottleLot")}
              placeholder={getLabel("bottleLotPlaceholder")}
              error={errors}
              required={getLabel("inputRequiredError")}
              options={filterBottleCapData(
                bottlesData,
                idx,
                watchedArray,
                bottleTypes,
                getLabel
              )}
              // tooltip={getLabel("bottleLotTooltip")}
            />
            <Select
              control={control}
              // defaultValue={{
              //   value: "",
              //   label: "",
              // }}
              name={`${baseName}.${idx}.cap_lot`}
              label={getLabel("capLot")}
              placeholder={getLabel("capLotPlaceholder")}
              error={errors}
              required={getLabel("inputRequiredError")}
              options={filterBottleCapData(
                capsData,
                idx,
                watchedArray,
                bottleTypes,
                getLabel,
                false
              )}
              validate={(selectedOption) => {
                // TO DO why trigger() is not working?
                // trigger();
                return true;
                const key = "cap_lot";
                const selectedId = selectedOption?.value;

                if (!selectedId) return true;

                const selectedItem = capsData?.find((c) => c.id === selectedId);
                const availableQty = Number(selectedItem?.quantity) || 0;

                // Totale di litri che usano questo cap_lot (incluso l’attuale idx)
                const totalLiters = watchedArray?.reduce((sum, dest) => {
                  const destCapId = dest?.[key]?.value;
                  const qty = Number(dest?.quantity) || 0;
                  return destCapId === selectedId ? sum + qty : sum;
                }, 0);

                const requiredCaps = Math.ceil(totalLiters / 0.75);

                if (requiredCaps > availableQty) {
                  const remaining =
                    availableQty -
                    Math.ceil(
                      (totalLiters -
                        (Number(watchedArray?.[idx]?.quantity) || 0)) /
                        0.75
                    );

                  const label =
                    availableQty === 0
                      ? "errorBottlingNoCaps"
                      : availableQty === 1
                      ? "errorBottlingNotEnoughCap"
                      : "errorBottlingNotEnoughCaps";

                  return getLabel(label, {
                    val1: requiredCaps,
                    val2: availableQty,
                    name: selectedItem?.name,
                  });
                }

                return true;
              }}
              // tooltip={getLabel("bottleLotTooltip")}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const checkBatchNameValidity = (
  id,
  idx,
  watchedArray,
  lotNames,
  expectedDestinationState,
  selectedName
) => {
  const usedNames = new Set(
    watchedArray
      .filter((_, i) => i !== idx)
      .map((tank) =>
        tank?.batch_name_selector?.value
          ? tank?.new_batch_name?.trim?.()
          : tank?.batch_name_selector?.label?.trim?.()
      )
      .filter(Boolean)
  );

  for (let i = 0; i < watchedArray?.length; i++) {
    const tank = watchedArray?.[i];
    if (i === idx) continue;
    const selector = tank?.batch_name_selector;

    if (selector?.value === false) {
      // old lot
      // Solo se usa un nome "inherited"
      const foundLot = lotNames?.find(
        (l) => l?.name === selectedName && l?.state === expectedDestinationState
      );

      const isInvalid =
        foundLot === undefined ||
        (foundLot?.status === "PLANNED" &&
          !foundLot?.shared_operation_ids?.some(
            (op_id) => op_id !== Number(id)
          ));
      if (isInvalid) return true;
    } else {
      const isSameNameOfANewBatch = usedNames.has(selectedName);
      if (isSameNameOfANewBatch) return true;
    }

    // if (isInvalid || isSameNameOfANewBatch) {
    //   return true;
    //   // Reset selettore se non è più valido
    //   setValue(`${baseName}.${i}.batch_name_selector`, {
    //     value: "",
    //     label: "",
    //   });
    // }
  }
  return false;
};

const renderBatchNameSelector = (
  id,
  type,
  isSrc = false,
  watchedArray,
  baseName,
  idx,
  control,
  register,
  errors,
  lots,
  lotNames,
  expectedDestinationState,
  setValue,
  getValues = () => null,
  getLabel,
  getError,
  setLotTypeMap = () => null,
  batch_id_in_name = null,
  batch_id_in_color = null,
  subtype = null,
  tank_id_in = null,
  lotTypeMap,
  src_tanks_extra = null
) => {
  const entry = watchedArray?.[idx];
  const tankData = isSrc ? entry : entry?.tankData;
  const batch_name_selector = entry?.batch_name_selector;

  if (
    type === "BOTTLING" ||
    (tankData?.value && !tankData?.is_planned_by_other_ops)
  )
    return (
      <div className="new_batch_name">
        <Select
          control={control}
          // defaultValue={{
          //   value: false,
          //   label: "",
          // }}
          name={
            isSrc
              ? `${baseName}.batch_name_selector`
              : `${baseName}.${idx}.batch_name_selector`
          }
          // name={`batch_name_selector.${idx}`}
          // name="batch_name_selector"
          label={getLabel("operationNewLotName")}
          placeholder={getLabel("operationNewLotNamePlaceholder")}
          error={errors}
          required={getLabel("inputRequiredError")}
          options={[
            {
              value: true,
              label: getLabel("lotNewName"),
              className: "bold",
            },
            ...computeLotNames(
              id,
              type,
              idx,
              expectedDestinationState,
              lotNames,
              watchedArray,
              getLabel,
              baseName,
              setValue,
              batch_id_in_name,
              batch_id_in_color,
              tank_id_in,
              lotTypeMap,
              subtype,
              getValues("carbonic_output_state")?.value,
              src_tanks_extra
            ),
          ]}
          isDisabled={
            (type === "BOTTLING" && !tank_id_in?.value) ||
            tankData?.is_planned_by_other_ops === true
          }
          tooltip={
            idx === 0
              ? getLabel("destemmingTankDestBatchNameSelectorTooltip")
              : ""
          }
        />
        {batch_name_selector?.value && (
          <Input
            name={
              isSrc
                ? `${baseName}.new_batch_name`
                : `${baseName}.${idx}.new_batch_name`
            }
            error={
              isSrc
                ? errors?.[baseName]?.new_batch_name
                : getError(idx, baseName, "new_batch_name")
            }
            // name="new_batch_name"
            register={register}
            type="text"
            label={getLabel("operationNewBatchName")}
            placeholder={getLabel("operationNewBatchNamePlaceholder")}
            // error={errors["new_batch_name"]}
            required={getLabel("inputRequiredError")}
            isReverse={true}
            minLength={{
              value: 3,
              message: getLabel("errorMinLength", { value: 3 }),
            }}
            maxLength={{
              value: 24,
              message: getLabel("errorMaxLength", {
                value: 24,
              }),
            }}
            regExpPattern={{
              value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
              message: getLabel("errorAlphaNumSpace_-"),
            }}
            validate={(value) => {
              if (
                batch_name_selector?.value &&
                ((type === "RACKING" &&
                  checkBatchNameValidity(
                    id,
                    idx,
                    watchedArray,
                    lotNames,
                    expectedDestinationState,
                    value?.trim()
                  )) ||
                  lots
                    ?.map(
                      (l) =>
                        l?.status !== "PLANNED" &&
                        l?.state === expectedDestinationState &&
                        l?.name?.toLowerCase?.()
                    )
                    ?.includes(value?.toLowerCase?.()?.trim()))
              ) {
                return getLabel("errorNewBatchNameAlreadyTaken", {
                  name: value,
                });
              } else {
                if (
                  type === "RACKING" ||
                  (type === "DESTEMMING" && batch_id_in_color === "WHITE" && subtype === "WITH_PRESSING")
                ) {
                  const cleanedValue = value.trim();
                  if (!cleanedValue) return;

                  const tank = watchedArray?.[idx];
                  // Determine old name (before editing)
                  const oldName = tank?.batch_name_selector?.value
                    ? tank?.new_batch_name
                    : tank?.batch_name_selector?.label;

                  // If unchanged → nothing to do
                  if (oldName === cleanedValue) return;

                  setLotTypeMap((prev) => {
                    // Copy previous values
                    const newMap = { ...prev };

                    // If old exists → move value
                    if (oldName && oldName in newMap) {
                      newMap[cleanedValue] = newMap[oldName];
                      delete newMap[oldName];
                    } else {
                      // Otherwise new entry with default PRESSED
                      newMap[cleanedValue] = 0;
                    }

                    return newMap;
                  });
                }
              }
            }}
            // onBlur3={(e) => {
            //   // checkBatchNameValidity(
            //   //   id,
            //   //   idx,
            //   //   watchedArray,
            //   //   lotNames,
            //   //   expectedDestinationState,
            //   //   baseName,
            //   //   setValue
            //   // );

            //   // if (type === "RACKING" && false) {
            //   //   const value = e.target.value;
            //   //   const cleanedValue = value?.trim();

            //   //   // Skip if cleanedValue is empty or already exists in lotTypeMap
            //   //   if (!cleanedValue) return;

            //   //   // remove old values to reset the lotTypeMap to a clear state (no previous lot names stored)
            //   //   let oldName;
            //   //   const allUsedLotNames = new Set();
            //   //   for (let i = 0; i < watchedArray?.length; i++) {
            //   //     const batch_name = watchedArray?.[i]?.batch_name_selector
            //   //       ?.value
            //   //       ? watchedArray?.[i]?.new_batch_name
            //   //       : watchedArray?.[i]?.batch_name_selector?.label;
            //   //     if (i === idx) {
            //   //       oldName = batch_name;
            //   //       continue;
            //   //     } else if (batch_name) allUsedLotNames.add(batch_name);
            //   //   }
            //   //   for (const l of lotNames?.filter((l) =>
            //   //     ["WINE", "BOTTLED"].includes(l?.state)
            //   //   ) ?? []) {
            //   //     allUsedLotNames.add(l?.name);
            //   //   }

            //   //   console.log('oldName', oldName, 'cleanedValue', cleanedValue)
            //   //   // Initialize lotTypeMap if not already set
            //   //   setLotTypeMap(prev => {
            //   //     console.log('lotTypeMap 0', prev, 'oldValue', prev[oldName])
            //   //     // Se il nuovo nome è vuoto → non fare nulla
            //   //     if (!cleanedValue) return prev;

            //   //     // Se il nuovo nome già esiste → non cambiare nulla
            //   //     if (Object.hasOwn(prev, cleanedValue)) return prev;

            //   //     const newMap = { ...prev };

            //   //     // Se esisteva un vecchio nome, trasferisco il valore
            //   //     if (oldName && Object.hasOwn(prev, oldName)) {
            //   //       newMap[cleanedValue] = prev[oldName]; // copy value
            //   //       delete newMap[oldName];               // remove old key
            //   //       return newMap;
            //   //     }

            //   //     // Caso nuovo lotto: crea entry con default false
            //   //     newMap[cleanedValue] = false;
            //   //     return newMap;
            //   //   });
            //   //   // setLotTypeMap((prev) => {

            //   //   //   if (!cleanedValue) return prev;
            //   //   //   const isWineLot = lotNames?.some(
            //   //   //     (l) => l?.state === "WINE" && l?.name === cleanedValue
            //   //   //   );
            //   //   //   if (isWineLot || Object.hasOwn(prev, cleanedValue)) {
            //   //   //     // Clean up unused keys even if we don't add anything new
            //   //   //     const filtered = Object.fromEntries(
            //   //   //       Object.entries(prev).filter(([key]) =>
            //   //   //         allUsedLotNames.has(key)
            //   //   //       )
            //   //   //     );

            //   //   //   console.log('filtered 1', filtered)
            //   //   //     return filtered;
            //   //   //   }

            //   //   //   // Normal case: add new key, but also filter out unused ones
            //   //   //   const filtered = Object.fromEntries(
            //   //   //     Object.entries(prev).filter(([key]) =>
            //   //   //       allUsedLotNames.has(key)
            //   //   //     )
            //   //   //   );

            //   //   //   console.log('filtered 2', filtered)
            //   //   //   return {
            //   //   //     ...filtered,
            //   //   //     [cleanedValue]: false,
            //   //   //   };
            //   //   // });
            //   // }
            // }}
          />
        )}
      </div>
    );
  else if (tankData?.value && tankData?.is_planned_by_other_ops)
    return (
      <div className="new_batch_name">
        <Label
          tooltip={getLabel("operationNewPlannedBatchNameTooltip")}
          label={getLabel("operationNewPlannedBatchName")}
        >
          {tankData?.planned_batch_name || tankData?.batch_name}
        </Label>
      </div>
    );
  return null;
};

const computeLotNames = (
  id,
  type,
  idx,
  expectedDestinationState,
  lotNames,
  watchedArray,
  getLabel,
  baseName,
  setValue,
  batch_id_in_name = null,
  batch_id_in_color = null,
  tank_id_in = null,
  lotTypeMap = null,
  subtype = null,
  carbonic_output_state = null,
  src_tanks_extra = null
) => {
  const nameMap = new Map();

  const tank = watchedArray?.[idx];
  const tankData = type === "BOTTLING" ? tank_id_in : tank?.tankData; // TO DO double check for BOTTLING

  lotNames
    ?.filter((l) => l?.state === expectedDestinationState)
    ?.filter((l) => {
      if (
        (type === "RACKING" || type === "BOTTLING") &&
        Number(tankData?.quantity) > 0
      ) {
        return l?.batch_type === tankData?.batch_type;
      } else {
        return true;
      }
    })
    ?.forEach((l) => {
      if (l?.name)
        nameMap.set(l.name, {
          label: l.name,
          batch_type: l?.batch_type,
          color: l?.color,
        });
    });

  if (["DESTEMMING", "NEW_LOT"].includes(type) && batch_id_in_name) {
    nameMap.set(batch_id_in_name, {
      label: batch_id_in_name?.trim(),
      color: batch_id_in_color,
    }); // TO DO check if missing batch_type cretes problems
  }

  // If single destination tank not selected, skip lot assignment
  if (
    !(watchedArray?.length === 1) // && watchedArray?.[0]?.tankData?.value === null)
  ) {
    watchedArray
      ?.filter(
        (tank) =>
          Number(tank?.tankData?.quantity) > 0 || Number(tank?.quantity) > 0
      )
      ?.forEach((item, i) => {
        const lotName = item?.tankData?.lot || item?.new_batch_name;

        if (lotName) {
          // In wizard mode: use lotTypeMap value directly for created batches
          const batchType = lotTypeMap?.[lotName] !== undefined
            ? lotTypeMap?.[lotName]
            : item?.tankData?.batch_type;

          nameMap.set(lotName, {
            label: lotName,
            color: item?.tankData?.color,
            batch_type: batchType,
          });
        }
      });
  }

  // RACKING / FILTERING: include src batch name even when state transitions (e.g. MUST→WINE)
  if (["RACKING", "FILTERING"].includes(type) && tank_id_in?.lot) {
    if (!nameMap.has(tank_id_in.lot)) {
      nameMap.set(tank_id_in.lot, {
        label: tank_id_in.lot,
        batch_type: tank_id_in?.batch_type,
        color: tank_id_in?.color,
      });
    }
  }

  // CUT: include all source tank batch names for the destination name selector
  if (type === "CUT" && Array.isArray(src_tanks_extra)) {
    src_tanks_extra.forEach((st) => {
      const lot = st?.tankData?.lot || st?.lot;
      if (lot && !nameMap.has(lot)) {
        nameMap.set(lot, {
          label: lot,
          batch_type: st?.tankData?.batch_type,
          color: st?.tankData?.color,
        });
      }
    });
  }

  // Add new batch names during input
  // if (!isValidate) {
  // for (const tank of watchedArray) {
  //   if (tank?.new_batch_name?.length > 0)
  //     nameMap.set(tank?.new_batch_name, {
  //       label: tank?.new_batch_name,
  //     });
  // }

  watchedArray?.forEach((tank, i) => {
    const originalName = (
      tank?.batch_name ||
      (tank?.is_planned && !tank?.is_planned_by_other_ops
        ? tank?.planned_batch_name || tank?.lot
        : null)
    )?.trim();
    const newName = tank?.new_batch_name?.trim();

    // Se è la riga corrente, rimuovi entrambi
    if (i === idx) {
      if (id && originalName && nameMap.has(originalName)) {
        nameMap.delete(originalName);
      }
      if (newName && nameMap.has(newName)) {
        nameMap.delete(newName);
      }
    } else {
      // Altrimenti, rimuovi solo il originalName
      if (
        id &&
        originalName &&
        nameMap.has(originalName) &&
        originalName !== newName
      ) {
        nameMap.delete(originalName);
      }
    }
  });

  const dest_name = tank?.batch_name_selector?.value
    ? tank?.new_batch_name
    : tank?.batch_name_selector?.label;

  // Determina se mostrare il batch_type tra parentesi
  const shouldShowBatchType = (entry) => {
    // Sempre per RACKING e BOTTLING
    if (type === "RACKING" || type === "BOTTLING") return true;

    // Per DESTEMMING con WITH_PRESSING o DIRECT_PRESSING (bianchi o rossi → rosé)
    if (type === "DESTEMMING" && (subtype === "WITH_PRESSING" || subtype === "DIRECT_PRESSING")) return true;

    // Per DESTEMMING con CARBONIC_MACERATION o ORANGE_WINE solo se output è WINE
    if (type === "DESTEMMING" && ["CARBONIC_MACERATION", "ORANGE_WINE"].includes(subtype) && carbonic_output_state === "WINE") return true;

    return false;
  };

  // Return sorted array with `value: false`
  return Array.from(nameMap.values())
    .map((entry) => ({
      ...entry,
      value: false,
      ...(entry?.color && {
        icon: "fa-circle",
        icon_color: getWineColor(entry?.color, "rgb"),
        icon_border_color: "#060b0f",
      }),
      is_disabled:
        (type === "RACKING" || type === "BOTTLING") &&
        tankData?.batch_type !== entry?.batch_type &&
        dest_name &&
        Number(tankData?.quantity) > 0,
      name:
        shouldShowBatchType(entry) && [0, 1, 2].includes(entry?.batch_type)
          ? `${entry?.label} (${getLabel(
              `lotType${entry?.batch_type}`
            )?.toLowerCase?.()})`
          : entry?.label,
    }))
    ?.sort((a, b) => a?.label?.localeCompare(b?.label));
};

const SourceSelector = ({
  id,
  type,
  subtype,
  operation,
  configs,
  register,
  control,
  errors,
  tanks,
  lots,
  tank_id_in,
  dest_tanks,
  // getTankData,
  lotNames,
  pomaces_quantity,
  pomaces_w_quantity,
  lotTypeMap,
  setValue,
  getValues = () => null,
  isMobile = false,
  lockedSubtype = null,
  isWizardMode = false,
  isBatchMode = false,
  bottlesOperation = null,
}) => {
  const [getLabel] = useLabels();
  const bottleTypes = selectBottleTypes();
  // Unità degli input (litri da spostare): L o hL secondo la preferenza utente.
  // La sorgente lavora sempre con masse di vino/mosto (volumi), mai forceLiters.
  const inputUnit = getInputTankUnit();

  // Set locked subtype when it's provided
  useEffect(() => {
    if (lockedSubtype) {
      const subtypeOptions = getAvailableSubtypes(type, tank_id_in?.color);
      const foundOption = subtypeOptions?.find(opt => opt.value === lockedSubtype);
      if (foundOption) {
        setValue('subtype', { value: lockedSubtype, label: foundOption.label });
      }
    }
  }, [lockedSubtype]);

  useEffect(() => {
    const subtype = getValues('subtype')?.value;
    const color = tank_id_in?.color;

    // Reset se tank vuoto
    if (!tank_id_in?.value) {
      if (!lockedSubtype) {
        setValue('subtype', null);
      }
      return;
    }
    
    // Reset se subtype incompatibile
    if (subtype) {
      const whiteOnly = ['FILM_MACERATION', 'ORANGE_WINE', 'CRYO_MACERATION'];
      const redOnly = ['ROSE_MACERATION', 'DIRECT_PRESSING', 'CARBONIC_MACERATION'];
      
      if ((whiteOnly.includes(subtype) && color !== 'WHITE') ||
          (redOnly.includes(subtype) && color !== 'RED') ||
          (subtype === 'SALASSO' && (color !== 'RED' || tank_id_in?.state !== 'MUST'))) {
        setValue('subtype', null);
      }
    }
  }, [tank_id_in]);

  const isValidRackingTank = (tank, lots) => {
    const specialMacerationTechniques = [
      'FILM_MACERATION',
      'CRYO_MACERATION',
      'ROSE_MACERATION',
      'DIRECT_PRESSING',
      'ORANGE_WINE',
      'CARBONIC_MACERATION'
    ];

    const isMust = tank?.state === "MUST";
    const isWineWithSpecialMaceration =
      tank?.state === "WINE" &&
      tank?.vinification_technique &&
      specialMacerationTechniques.includes(tank.vinification_technique);

    return (
      tank?.batch_name &&
      (isMust || isWineWithSpecialMaceration) &&
      Number(tank?.quantity) > 0
    );
  };

  const isValidFilteringTank = (tank) => {
    return (
      tank?.batch_name && tank?.state === "WINE" && Number(tank?.quantity) > 0
    );
  };

  const isTankAlreadyInDestTanks = (tank) => {
    return !dest_tanks?.some?.((field) => field?.tankData?.value == tank.id);
  };

  const isTankValidForCut = (tank) => {
    const tankData = dest_tanks?.[0]?.tankData || {};
    const srcState = tankData?.state || null;
    const srcColor = tankData?.color || null;
    const isPlanned = tank?.is_planned === true;
    const tankCurrentState =
      Number(tank.quantity) > 0 ? tank?.state || null : null;
    const tankCurrentQuantity = Number(tank.quantity) || null;
    const tankPlannedState = tank?.planned_batch_state || null;
    const tankPlannedQuantity = Number(tank.planned_quantity) || null;

    // empty and unplanned always returned
    if (tankCurrentQuantity <= 0 && !isPlanned) return true;
    // if not empty, check current state and color
    else if (!isPlanned && tankCurrentQuantity > 0)
      return tankCurrentState === srcState && (!srcColor || tank.color === srcColor);
    // if planned, check future state against the CUT's source state/color
    else if (isPlanned && tankPlannedQuantity > 0)
      return tankPlannedState === srcState;

    return false;
  };

  const getDestemmingSourceOptions = () => {
    return lots
      ?.filter((lot) => lot?.state === "GRAPE" && lot?.id !== tank_id_in?.value)
      ?.sort(sortByTankName)
      ?.map((lot) => buildDestemmingLotData(lot, tank_id_in, id));
  };

  const buildDestemmingLotData = (lot, tank_id_in, id) => {

    const total_pomaces = lot?.planned_pomaces?.filter(p => Number(p?.operation_id) !== Number(id))?.reduce((acc, curr) => {
      return acc + (Number(curr?.quantity) || 0);
    }, 0) || 0;
    
    const isDisabled =
      (!id ||
        lot?.shared_operation_ids?.filter((op_id) => op_id !== Number(id))
          ?.length > 0) &&
      lot?.is_planned &&
      (Number(lot?.planned_quantity) - Number(total_pomaces)) <= 0;

    const isPlannedByOtherOps =
      lot?.is_planned &&
      lot?.shared_operation_ids?.some((p_id) => Number(p_id) !== Number(id));
      
    // const icon =
    //   (lot?.is_planned && Number(lot?.planned_quantity) >= 0) ||
    //   lot?.is_planned_src > 0
    //     ? "fa-calendar"
    //     : null;
    
    const icon = isPlannedByOtherOps ? "fa-calendar" : null;
    return {
      value: lot.id,
      batch_id: lot.id,
      label: lot.name,
      color: lot.color,
      planned_pomaces: lot?.planned_pomaces || [],
      composition: lot?.composition,
      initial_quantity: lot?.quantity,
      quantity: lot?.actual_quantity,
      planned_quantity: lot?.planned_quantity,
      shared_operation_ids: lot?.shared_operation_ids,
      is_planned: isPlannedByOtherOps,
      is_disabled: isDisabled,
      icon,
    };
  };

  const getSourceOptions = () => {
    if (isBatchMode && type === "CLOSING") {
      return (
        lots
          ?.filter((l) => l?.state === "BOTTLED" && Number(l?.actual_quantity) > 0)
          ?.sort(sortByTankName)
          ?.map((lot) => ({
            value: lot.id,
            label: lot.name,
            color: lot.color,
            quantity: lot.actual_quantity,
            planned_quantity: lot.actual_quantity,
            is_planned: false,
            lot: lot.name,
            lot_id: lot.id,
            state: "BOTTLED",
          })) || []
      );
    }

    if (type === "DESTEMMING") {
      const specialMacerationTechniques = [
        'FILM_MACERATION',
        'CRYO_MACERATION',
        'ROSE_MACERATION',
        'DIRECT_PRESSING',
        'ORANGE_WINE',
        'CARBONIC_MACERATION'
      ];

      return lots
        ?.filter((lot) => {
          const isGrape = lot?.state === "GRAPE";
          const isWineWithSpecialMaceration =
            lot?.state === "WINE" &&
            lot?.vinification_technique &&
            specialMacerationTechniques.includes(lot.vinification_technique);

          return (isGrape || isWineWithSpecialMaceration) && lot?.id !== tank_id_in?.value;
        })
        ?.sort(sortByTankName)
        ?.map?.((lot) => {
          return {
            value: lot.id,
            batch_id: lot.id,
            label: lot.name,
            color: lot.color,
            composition: lot?.composition,
            initial_quantity: lot?.quantity,
            vinification_technique: lot?.vinification_technique,
            quantity: lot?.actual_quantity,
            planned_quantity: lot?.planned_quantity,
            shared_operation_ids: lot?.shared_operation_ids,
            is_planned: lot?.is_planned,
            is_disabled:
              !id && lot?.is_planned && Number(lot?.planned_quantity) <= 0, // i.e. if the in batch is all planned in other dests
            icon:
              (lot?.is_planned && Number(lot?.planned_quantity) >= 0) ||
              lot?.is_planned_src > 0
                ? "fa-calendar"
                : null,
          };
        });
    }

    if (type === "CUT") {
      return (
        tanks
          ?.filter((tank) => isTankValidForCut(tank))
          ?.filter((tank) => isTankAlreadyInDestTanks(tank))
          ?.sort(sortByTankName)
          ?.map((tank) =>
            mapTankToSelectOption(
              tank,
              type === "CUT" ? "dest" : "src",
              lots,
              operation || (id ? { id: Number(id) } : null),
              getLabel
            )
          ) || []
      );
    }
    return (
      (type === "RACKING"
        ? tanks?.filter((t) => isValidRackingTank(t, lots))
        : type === "FILTERING"
        ? tanks?.filter((t) => isValidFilteringTank(t))
        : type === "BOTTLING"
        ? tanks?.filter((t) => t?.batch_name && t?.state === "WINE" && Number(t?.quantity) > 0)
        : ["TREATMENT", "DECANT", "ADD", "HOMOGENIZATION_MASS", "OXYGENATION"].includes(type)
        ? tanks?.filter((t) => t?.batch_name && ["MUST", "WINE"].includes(t?.state) && Number(t?.quantity) > 0)
        : type === "CLOSING"
        ? tanks?.filter((t) => t?.batch_name && ["MUST", "WINE", "BOTTLED"].includes(t?.state) && Number(t?.quantity) > 0)
        : ["STABILIZATION_STATIC", "STABILIZATION_DYNAMIC", "STABILIZATION_RESIN"].includes(type)
        ? tanks?.filter((t) => t?.batch_name && t?.state === "WINE" && Number(t?.quantity) > 0)
        : tanks?.filter((t) => Number(t.quantity) > 0)
      )
        ?.filter((tank) => isTankAlreadyInDestTanks(tank))
        ?.sort(sortByTankName)
        ?.map((tank) =>
          mapTankToSelectOption(
            tank,
            type === "CUT" ? "dest" : "src",
            lots,
            operation || (id ? { id: Number(id) } : null),
            getLabel
          )
        ) || []
    );
    // .map(mapTankToSelectOption);
  };

  const getError = (idx, data, key) => {
    if (idx === null) return data?.[key] || null;

    if (
      !errors ||
      Object.keys(errors)?.length === 0 ||
      !data ||
      data?.length <= idx
    )
      return;

    return data?.[idx]?.[key] || null;
  };

  const computeEstimationQuantity = (tank) => {
    if (!tank) return 0;

    // GRAPE lots (DESTEMMING source): quantity is in Kg.
    // Use lot quantity, reduced to planned_quantity when other DESTEMMINGs are already scheduled.
    if (type === "DESTEMMING") {
      const isPlannedByOtherOps =
        tank?.is_planned &&
        (tank?.shared_operation_ids || []).some(opId => opId !== Number(id));
      return isPlannedByOtherOps
        ? Number(tank.planned_quantity) || 0
        : Number(tank.quantity) || 0;
    }

    // MUST/WINE tanks (RACKING source):
    // Other rackings already scheduled from this same tank reduce the available quantity.
    if (tank?.is_planned_src && tank?.is_planned_by_other_ops) {
      const pomacesOtherOps =
        (tank?.planned_pomaces || [])
          .filter(t => id ? t.operation_id !== Number(id) : true)
          .reduce((acc, curr) => acc + Number(curr.quantity || 0), 0);
      const destSum =
        dest_tanks?.reduce((acc, curr) => acc + inputToLiters(curr?.quantity, inputUnit), 0) || 0;
      const thisOpQty = id ? destSum + pomacesOtherOps : 0;
      return Number(tank.planned_quantity || 0) + thisOpQty;
    }

    // Tank filled by a planned op (e.g. future destemming not yet executed):
    // planned_quantity holds the future content.
    if (tank?.is_planned && (tank?.programmed_as_dest || []).length > 0) {
      const { lotAvailability } = computePlannedLotAvailability({ tank, operationId: id });
      if (lotAvailability > 0) return lotAvailability;
    }

    // Default: current content of the tank.
    return Number(tank.quantity) || 0;
  };

  // helper: convert a range value to ratio in [0,1]
  const toRatio = (v) => {
    const n = Number(v ?? 0);
    if (Number.isNaN(n)) return 0;
    return n > 1
      ? Math.max(0, Math.min(1, n / 100))
      : Math.max(0, Math.min(1, n));
  };

  // helper: compute distribution (min/max numeric values and formatted string)
  const computeDistribution = (ranges, quantity, isPomaces = false) => {
    return Object.entries(ranges).reduce((acc, [key, range]) => {
      const [rawMin, rawMax] = Array.isArray(range) ? range : [0, 0];
      const minRatio = toRatio(rawMin);
      const maxRatio = toRatio(rawMax);

      const minVal = Math.floor(minRatio * quantity);
      const maxVal = Math.floor(maxRatio * quantity);

      const unit = isPomaces ? "Kg" : "L";
      acc[key] = `${minVal} - ${maxVal} ${unit}`;
      return acc;
    }, {});
  };

  const renderDistributionElement = (data, isPomaces = false, labelPrefix = "lotType") => {
    return (
      <div className={`${isPomaces ? "pomaces_margin_top" : ""}`}>
        {Object.keys(data).map((key) => (
          <li
            key={`must_distribution_li_${key}`}
            className={`must_distribution_li ${
              Object.keys(data)?.length === 1 ? "one_pomace" : ""
            }`}
          >
            <div className="must_distribution_row">
              <span className="must_distribution_label bold">
                {getLabel(`${labelPrefix}_${key}`)}
              </span>
              <span className="must_distribution_value">{data[key]}</span>
            </div>
          </li>
        ))}
      </div>
    );
  };

  /**
   * Render distribution estimation for DESTEMMING.
   * - Uses ranges based on typical destemming yields
   * - Accepts ratio or percent values (0.5 or 50)
   * - Returns null if tank_quantity is zero/invalid
   */
  const renderDestemmingDistribution = () => {
    if (!tank_id_in) return null;

    const lotQuantity = computeEstimationQuantity(tank_id_in);

    if (!lotQuantity || Number.isNaN(lotQuantity) || lotQuantity <= 0)
      return null;

    // CARBONIC_MACERATION: whole-cluster fermentation — stems and skins both remain
    // in the tank, nothing comes out at destemming time.
    const isCarbonicMaceration = subtype === "CARBONIC_MACERATION";
    // The output state (MUST or WINE) is user-selected for CARBONIC_MACERATION/ORANGE_WINE
    const carbonicOutputState = getValues("carbonic_output_state")?.value || "MUST";

    const distributionRanges = isCarbonicMaceration
      ? { [carbonicOutputState]: [99, 100] }  // key = MUST or WINE per scelta utente
      : { MUST: [95, 98] };

    // Pomaces at destemming time:
    // - CARBONIC_MACERATION: nothing (whole clusters, no immediate separation)
    // - All other techniques: only STEM (raspi) come out; skins remain until racking
    const pomacesRanges = isCarbonicMaceration ? {} : { STEM: [2, 5] };

    const distributionData = computeDistribution(distributionRanges, lotQuantity, false);
    const pomacesData = computeDistribution(pomacesRanges, lotQuantity, true);
    const hasPomaces = Object.keys(pomacesRanges).length > 0;

    return (
      <div className="must_distribution">
        <div className="must_distribution_row">
          <span className="must_distribution_label bold">{lotQuantity} Kg</span>
          <span className="must_distribution_value">
            {getLabel("operationDestemmingExtimation")}
          </span>
        </div>

        <ul className="must_distribution_ul one_el_fix">
          {renderDistributionElement(distributionData, false, isCarbonicMaceration ? "lotState" : "lotType")}
          {hasPomaces && renderDistributionElement(pomacesData, true)}
        </ul>
      </div>
    );
  };

  /**
   * Render distribution ranges (min-max) for a given tank.
   * - accepts ranges expressed as ratios (0.5) or percentages (50)
   * - returns null if tank_quantity is zero/invalid
   */
  const renderMustDistribution = (tank) => {
    if (!tank) return null;

    // Skip se l'input ha già un batch_type definito
    // batch_type = 0 potrebbe essere default, quindi controlla:
    const specialMacerationTechniques = [
      'FILM_MACERATION',
      'CRYO_MACERATION',
      'ROSE_MACERATION',
        'DIRECT_PRESSING',
      'ORANGE_WINE',
      'CARBONIC_MACERATION'
    ];

    const hasBatchType = [0, 1, 2].includes(tank?.batch_type);
    const isRackingOp = type === "RACKING";

    // Skip se ha batch_type E:
    // - È già WINE (batch_type sicuramente reale)
    // - È MUST ma la tecnica NON permette divisione fiore/misto/pressato
    // Eccezione: RACKING mostra sempre le stime (fiore/pressato si separano anche da MUST RED)
    const hasRealBatchType = !isRackingOp && hasBatchType && (
      tank?.state === "WINE" ||
      (tank?.state === "MUST" && !specialMacerationTechniques.includes(tank?.vinification_technique) && tank?.vinification_technique !== "WITH_PRESSING")
    );

    if (hasRealBatchType) {
      return null;
    }
    // quantity deve essere calcolata con la somma delle quantity nell'array, rawQuantity come fallback
    // choose quantity: planned (if source is planned) otherwise current quantity
    const tankQuantity = computeEstimationQuantity(tank);

    if (!tankQuantity || Number.isNaN(tankQuantity) || tankQuantity <= 0)
      return null;

    const isPressing = (tank_id_in?.color === "WHITE" && subtype === "WITH_PRESSING") ||
                       (tank_id_in?.color === "RED" && subtype === "DIRECT_PRESSING");
    const pomacesContent = tank_id_in?.pomaces_content || null;

    // ranges can be ratios (0.5) or percent (50)
    const distributionRanges = {
      FLOWER: isPressing ? [50, 60] : [60, 70],
      PRESSED: isPressing ? [20, 25] : [15, 20],
      ...(isPressing ? { MIXED: [15, 20] } : {}),
    };

    // Pomaces at pressing time: STEM (raspi) + SKIN (bucce) both come out.
    // At racking: depends on what stayed in the must (pomaces_content of the source batch).
    //   SKINS_AND_STEMS → both STEM and SKIN come out (e.g. after CARBONIC_MACERATION)
    //   SKINS           → only SKIN (bucce) come out (standard RED maceration)
    //   NONE / unknown  → no pomaces (e.g. after pressing or filtering)
    const pomacesRanges = isPressing
      ? { STEM: [15, 20], SKIN: [5, 10] }
      : isRackingOp
        ? pomacesContent === "SKINS_AND_STEMS"
          ? { STEM: [10, 15], SKIN: [10, 15] }
          : pomacesContent === "SKINS"
            ? { SKIN: [15, 25] }
            : pomacesContent === "NONE"
              ? {}
              : { POMACES: [15, 20] }
        : { POMACES: [15, 20] };

    const distributionData = computeDistribution(
      distributionRanges,
      tankQuantity,
      false
    );
    const pomacesData = computeDistribution(pomacesRanges, tankQuantity, true);

    // render
    return (
      <div className="must_distribution">
        <div className="must_distribution_row">
          <span className="must_distribution_label bold">{tankQuantity} {type === "DESTEMMING" ? "Kg" : "L"}</span>
          <span className="must_distribution_value">
            {getLabel(
              type === "DESTEMMING" //  && isWhitePressing
                ? "operationWhiteDestemmingExtimation"
                : "operationRackingExtimation"
            )}
          </span>
        </div>
        <ul className="must_distribution_ul">
          {renderDistributionElement(distributionData)}
          {Object.keys(pomacesRanges).length > 0 && renderDistributionElement(pomacesData, true)}
        </ul>
      </div>
    );
  };

  // Helper per filtrare i subtypes in base al tipo di operazione e al colore dell'uva
  const getAvailableSubtypes = (operationType, grapeColor, grapeState) => {
    // Definizione dei subtypes per ogni tipo di operazione
    const OPERATION_SUBTYPES = {
      DESTEMMING: [
        {
          value: 'WITH_PRESSING',
          label: getLabel('operationSubtypeWITH_PRESSING'),
          allowedColors: ['WHITE']
        },
        {
          value: 'RED_VINIFICATION',
          label: getLabel('operationSubtypeRED_VINIFICATION'),
          allowedColors: ['RED']
        },
        {
          value: 'FILM_MACERATION',
          label: getLabel('operationSubtypeFILM_MACERATION'),
          allowedColors: ['WHITE']
        },
        {
          value: 'CRYO_MACERATION',
          label: getLabel('operationSubtypeCRYO_MACERATION'),
          allowedColors: ['WHITE']
        },
        {
          value: 'ROSE_MACERATION',
          label: getLabel('operationSubtypeROSE_MACERATION'),
          allowedColors: ['RED']
        },
        {
          value: 'DIRECT_PRESSING',
          label: getLabel('operationSubtypeDIRECT_PRESSING'),
          allowedColors: ['RED']
        },
        {
          value: 'CARBONIC_MACERATION',
          label: getLabel('operationSubtypeCARBONIC_MACERATION'),
          allowedColors: ['RED']
        },
        {
          value: 'ORANGE_WINE',
          label: getLabel('operationSubtypeORANGE_WINE'),
          allowedColors: ['WHITE']
        }
      ],
      DECANT: [
        // {
        //   value: 'SALASSO',
        //   label: getLabel('operationSubtypeSALASSO'),
        //   allowedColors: ['RED', 'WHITE', "ROSE", 'ORANGE']
        // },
        {
          value: 'STANDARD',
          label: getLabel('operationSubtypeSTANDARD')
        },
        {
          value: 'SALASSO',
          label: getLabel('operationSubtypeSALASSO'),
          allowedColors: ['RED'],
          requiredState: 'MUST'
        }
      ],
      BOTTLING: [
        {
          value: 'SPARKLING',
          label: getLabel('operationSubtypeSPARKLING')
        },
        {
          value: 'STANDARD',
          label: getLabel('operationSubtypeSTANDARD')
        }
      ]
    };

    // Se non c'è un tipo di operazione, restituisci array vuoto
    if (!operationType) {
      return [];
    }

    // Ottieni i subtypes per il tipo di operazione
    const subtypesForOperation = OPERATION_SUBTYPES[operationType] || [];

    // Per DESTEMMING e DECANT, filtra in base al colore dell'uva
    if ((operationType === 'DESTEMMING' || operationType === 'DECANT') && subtypesForOperation.length > 0) {
      // Se non c'è un colore selezionato, mostra tutte le opzioni
      if (!grapeColor) {
        return subtypesForOperation;
      }

      // Filtra in base al colore dell'uva (e stato opzionale)
      return subtypesForOperation.filter(subtype => {
        if (subtype.allowedColors && !subtype.allowedColors.includes(grapeColor)) return false;
        if (subtype.requiredState && grapeState !== subtype.requiredState) return false;
        return true;
      });
    }

    // Per altri tipi di operazione (es. BOTTLING), restituisci tutti i subtypes
    return subtypesForOperation;
  };

  const customIdInvalidPlannedState = "custom-id-invalid-planned-batch-state";
  const checkAllDestTanksStates = () => {
    const carbonic_output_state = getValues("carbonic_output_state")?.value;
    
    for (const d of dest_tanks) {
      if (d?.tankData?.planned_batch_state && d?.tankData?.planned_batch_state !== carbonic_output_state) {
        toast.error(
          getLabel("toast_invalidPlannedState", { 
            name: d?.tankData?.label,
            state: getLabel(`lotState_${carbonic_output_state}`)?.toLowerCase?.(),
            old_state: getLabel(`lotState_${d?.tankData?.planned_batch_state}`)?.toLowerCase?.(),
          }), {
          toastId: customIdInvalidPlannedState,
          isLoading: false,
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 4000,
      });
        setValue("carbonic_output_state", {
          value: d?.tankData?.planned_batch_state,
          label: getLabel(`lotState_${d?.tankData?.planned_batch_state}`),
        })
      }
    }
  }

  const renderOperationSubtypeSelector = () => {
    return (
      <div className="operation_form_wrapper_row">
        <Select
          control={control}
          name="subtype"
          label={getLabel(type === "BOTTLING" ? "operationBottlingSubtype" : "operationSubtype")}
          placeholder={getLabel("operationSubtypePlaceholder")}
          error={errors}
          required={type !== "DECANT" ? getLabel("inputRequiredError") : false}
          isDisabled={!tank_id_in?.value || !!lockedSubtype || isWizardMode}
          options={getAvailableSubtypes(type, tank_id_in?.color, tank_id_in?.state)}
          tooltip={getLabel(type === "BOTTLING" ? "operationBottlingSubtypeTooltip" : "operationSubtypeTooltip")}
        />
        
        {["CARBONIC_MACERATION", "ORANGE_WINE"].includes(subtype) && <Select
          control={control}
          name="carbonic_output_state"
          onTableChange={checkAllDestTanksStates}
          label={getLabel("operationCarbonicMacerationState")}
          placeholder={getLabel("operationCarbonicMacerationStatePlaceholder")}
          error={errors}
          required={getLabel("inputRequiredError")}
          isDisabled={!subtype}
          options={[
            {
              value: "MUST",
              label: getLabel("lotState_MUST"),
            },
            {
              value: "WINE",
              label: getLabel("lotState_WINE"),
            },]}
          tooltip={getLabel("operationCarbonicMacerationStateTooltip")}
        />}
        {subtype === "CRYO_MACERATION" && (
          <>
            <Input
              name="cryo_temperature"
              register={register}
              type="number"
              label={getLabel("operationCryoMacerationTemperature")}
              placeholder={getLabel("operationCryoMacerationTemperaturePlaceholder")}
              tooltip={getLabel("operationCryoMacerationTemperatureTooltip")}
              error={errors["cryo_temperature"]}
              required={getLabel("inputRequiredError")}
              min={{ value: 3, message: getLabel("errorMinValue", { value: 3 }) }}
              max={{ value: 13, message: getLabel("errorMaxValue", { value: 13 }) }}
              regExpPattern={{ value: INT_REGEX, message: getLabel("errorInt") }}
            />
            <Input
              name="cryo_hours"
              register={register}
              type="number"
              label={getLabel("operationCryoMacerationHours")}
              placeholder={getLabel("operationCryoMacerationHoursPlaceholder")}
              tooltip={getLabel("operationCryoMacerationHoursTooltip")}
              error={errors["cryo_hours"]}
              required={getLabel("inputRequiredError")}
              min={{ value: 1, message: getLabel("errorMinValue", { value: 1 }) }}
              max={{ value: 72, message: getLabel("errorMaxValue", { value: 72 }) }}
              regExpPattern={{ value: INT_REGEX, message: getLabel("errorInt") }}
            />
          </>
        )}
      </div>
    )
  }

  if (type === "DESTEMMING" || type === "NEW_LOT")
    return (
      <div>
        <h5>{getLabel("fromLot")}</h5>
        <div className="operation_form_wrapper_row">
          <Select
            // onTableChange={(value) => resetDestTanks(value)}
            control={control}
            defaultValue={operation?.batch_id_in}
            name="batch_id_in"
            label={getLabel("operationDestemmingLot")}
            placeholder={getLabel("operationDestemmingLotPlaceholder")}
            error={errors}
            required={getLabel("inputRequiredError")}
            options={getDestemmingSourceOptions()}
            tooltip={getLabel("destemmingBatchInTooltip")}
            isDisabled={isWizardMode}
          />
          {tank_id_in && !isWizardMode && (
            <DestLotDetail
              lot={mapLotToSelectOption(
                tank_id_in,
                operation,
                dest_tanks,
                pomaces_quantity,
                pomaces_w_quantity,
                inputUnit
              )}
              isRecap={false}
              isMobile={isMobile}
              isName={false}
              isAdditional={true}
              isWizardMode={isWizardMode}
            />
          )}
          {!isWizardMode && (type === "DESTEMMING" && !((tank_id_in?.color === "WHITE" && subtype === "WITH_PRESSING") || (tank_id_in?.color === "RED" && subtype === "DIRECT_PRESSING"))) && renderDestemmingDistribution()}
          {!isWizardMode && (type === "DESTEMMING" && ((tank_id_in?.color === "WHITE" && subtype === "WITH_PRESSING") || (tank_id_in?.color === "RED" && subtype === "DIRECT_PRESSING"))) && renderMustDistribution(tank_id_in)}
        </div>
        {tank_id_in && isWizardMode && (
          <div className="wizard_lot_detail_card">
            <DestLotDetail
              lot={mapLotToSelectOption(
                tank_id_in,
                operation,
                dest_tanks,
                pomaces_quantity,
                pomaces_w_quantity,
                inputUnit
              )}
              isRecap={false}
              isMobile={isMobile}
              isName={false}
              isAdditional={true}
              isWizardMode={isWizardMode}
            />
          </div>
        )}
        <div className="operation_form_wrapper_row">
          {type === "DESTEMMING" && renderOperationSubtypeSelector()}
        </div>
      </div>
    );

  const renderTechnique = () => {
    if (!tank_id_in?.vinification_technique) return;
    const lot = lots?.find(l => l?.id == tank_id_in?.lot_id);
    const tankSubstate = lot?.tank_substates?.find(ts => Number(ts?.tank_id) === Number(tank_id_in?.value));
    
    return <div className="technique_wrapper">
      <div className="technique">
        <p className="technique_state">{getLabel(`lotState_${tank_id_in?.state}`)}</p>
        <p className="technique_type">{getLabel(`operationSubtype${tank_id_in?.vinification_technique}`)}</p>
      </div>

      <div className="badge">
        {tankSubstate?.substate && !tankSubstate?.substate_ended_at && (
          <span className="substate_badge_active">
            <span className="icon">
              <Icon icon="fa-circle" className="pulse_icon" />
            </span>
            <span className="substate_label">{getLabel(`lotSubstate_${tankSubstate.substate}`)}</span>
          </span>
        )}
        {tankSubstate?.substate_started_at && (
          <p className="technique_time">
            {formatDistanceToNow(new Date(tankSubstate.substate_started_at), {
              addSuffix: !tankSubstate?.substate_ended_at,
              locale: getLocaleObject(configs.locale)
            })}
          </p>
        )}
      </div>
    </div>
  }

  return (
    <>
      <h5>{getLabel(isBatchMode && type === "CLOSING" ? "fromLot" : type === "CUT" ? "toTank" : "fromTank")}</h5>
      <div className="operation_form_wrapper_row card">
        <div className="operation_form_wrapper_row vertical">
          <Select
            control={control}
            name={type === "DESTEMMING" ? "batch_id_in" : "tank_id_in"}
            isDisabled={isWizardMode}
            isSearchable={true}
            label={getLabel(
              type === "DESTEMMING"
                ? "operationDestemmingLot"
                : (isBatchMode && type === "CLOSING")
                ? "operationDestemmingLot"
                : type === "CUT"
                ? "operationSrcTankName"
                : "operationTransferTank"
            )}
            placeholder={getLabel(
              type === "DESTEMMING"
                ? "operationDestemmingLotPlaceholder"
                : (isBatchMode && type === "CLOSING")
                ? "operationDestemmingLotPlaceholder"
                : type === "CUT"
                ? "operationSrcTanksPlaceholder"
                : "operationTransferTankPlaceholder"
            )}
            error={errors}
            required={getLabel("inputRequiredError")}
            options={getSourceOptions()}
          />

          {renderTechnique()}
        </div>

        {Object.keys(tank_id_in || {})?.length > 0 && (
          <>
            {type === "DESTEMMING" && (
              <DestLotDetail
                lot={getUnifiedTankData(tank_id_in, {
                  type: type,
                  subtype,
                  isSrc: true,
                  id,
                  lotNames,
                  lots,
                  pomaces_quantity: pomaces_quantity,
                  pomaces_w_quantity: pomaces_w_quantity,
                  dest_tanks,
                  unit: inputUnit,
                })}
                isRecap={false}
                isMobile={isMobile}
                isName={false}
                isAdditional={true}
              />
            )}
            {type !== "DESTEMMING" && !isWizardMode && !(isBatchMode && type === "CLOSING") && (
              <DestTankDetail
                tank={getUnifiedTankData(tank_id_in, {
                  type: type,
                  subtype,
                  carbonic_output_state: getValues("carbonic_output_state")?.value,
                  isSrc: type !== "CUT",
                  id,
                  operation,
                  lots,
                  dest_tanks,
                  pomaces_quantity: pomaces_quantity,
                  pomaces_w_quantity: pomaces_w_quantity,
                  unit: inputUnit,
                })}
                isDrop={false}
                isName={false}
                isFirst={true}
                isMobile={isMobile}
              />
            )}
            {isBatchMode && type === "CLOSING" && tank_id_in?.value && (() => {
              const bottleVolume = bottleTypes?.find((t) => t.value === bottlesOperation?.bottle_type)?.volume || 0.75;
              const liters = bottlesOperation
                ? Number(bottlesOperation.quantity) || 0
                : Number(tank_id_in?.quantity) || 0;
              const total = Math.floor(liters / bottleVolume);
              const used = dest_tanks?.reduce((acc, d) => acc + (Number(d?.quantity) || 0), 0) || 0;
              const remaining = Math.max(0, total - used);
              return (
                <>
                  <BottleIcon
                    color={tank_id_in?.color}
                    batch_name={tank_id_in?.label}
                    isDetail={false}
                    isRecap={false}
                  />
                  <div className="batch_bottles_counter">
                    <Icon icon="fa-wine-bottle" size="sm" />
                    <span className={remaining === 0 ? "exhausted" : ""}>
                      {remaining}/{total}
                    </span>
                  </div>
                  {bottlesOperation?.bottle_lot && (
                    <p className="batch_lot_label">
                      <Icon icon="fa-wine-bottle" size="xs" />{" "}
                      {bottlesOperation.bottle_lot}
                    </p>
                  )}
                  {bottlesOperation?.cap_lot && (
                    <p className="batch_lot_label">
                      <Icon icon="fa-bread-slice" size="xs" />{" "}
                      {bottlesOperation.cap_lot}
                    </p>
                  )}
                </>
              );
            })()}

            {type === "RACKING" && renderMustDistribution(tank_id_in)}

            {type === "CUT" &&
              renderBatchNameSelector(
                id,
                type,
                true,
                [tank_id_in],
                "tank_id_in",
                0,
                control,
                register,
                errors,
                lots,
                lotNames,
                dest_tanks?.[0]?.tankData?.state,
                setValue,
                getValues,
                getLabel,
                getError,
                null,
                null,
                null,
                null,
                null,
                lotTypeMap,
                dest_tanks
              )}

            {(type === "BOTTLING" || (type === "DECANT" && tank_id_in?.color === 'RED' && tank_id_in?.state === 'MUST')) && renderOperationSubtypeSelector()}
          </>
        )}
      </div>

      {type !== "DESTEMMING" && isWizardMode && Object.keys(tank_id_in || {})?.length > 0 && (
        <div className="wizard_dest_tank_detail_card">
          <DestTankDetail
            tank={getUnifiedTankData(tank_id_in, {
              type: type,
              subtype,
              carbonic_output_state: getValues("carbonic_output_state")?.value,
              isSrc: type !== "CUT",
              id,
              operation,
              lots,
              lotNames,
              dest_tanks,
              pomaces_quantity: pomaces_quantity,
              pomaces_w_quantity: pomaces_w_quantity,
              expectedDestinationState: tank_id_in?.state,
              unit: inputUnit,
            })}
            isDrop={false}
            isName={false}
            isFirst={true}
            isMobile={isMobile}
          />
        </div>
      )}
    </>
  );
};

const DestinationSelector = ({
  id,
  type,
  subtype,
  operation,
  register,
  control,
  errors,
  clearErrors,
  trigger,
  setValue,
  tanks,
  lots,
  tank_id_in,
  fields,
  append,
  update,
  remove,
  getValues,
  lotTypeMap,
  setLotTypeMap,
  isMobile = false,
  baseName = "dest_tanks",
  watchedArray,
  lotNames,
  capsData,
  bottlesData,
  axiosPrivate,
  isWizardMode = false,
  forceLiters = false,
  isBatchMode = false,
}) => {

  const [getLabel] = useLabels();
  // forceLiters: per i flussi che NON sono "litri da spostare" (es. nuovo lotto
  // uva in Kg) l'input resta in litri/Kg, senza conversione hL.
  const inputUnit = forceLiters ? "L" : getInputTankUnit();
  // Layout a card verticale (viz a sinistra, controlli a destra) con icone
  // tank rimpicciolite (zoom 0.5): pensato SOLO per il wizard, dove lo spazio
  // orizzontale è ridotto. Fuori dal wizard (es. RACKING in TransferForm) si usa
  // il layout normale a piena dimensione — l'overflow lì si risolve con il wrap
  // della riga (vedi .operation_form_wrapper_row in OperationsForm/styles).
  const useCardLayout = isWizardMode;
  const bottleTypes = useSelector(selectBottleTypes);
  const [expectedDestinationState, setExpectedDestinationState] = useState(() => {
    if (type === "DESTEMMING") return "MUST";
    if (type === "RACKING") return tank_id_in?.color === "ORANGE" ? "MUST" : "WINE";
    if (type === "FILTERING") return "WINE";
    if (type === "BOTTLING") return "BOTTLED";
    return tank_id_in?.state || null;
  });
  const [expectedDestinationColor, setExpectedDestinationColor] = useState(
    tank_id_in?.color || null
  );
  const [closingRecipients, setClosingRecipients] = useState([]);

  useEffect(() => {
    const fetchBuyers = async () => {
      const buyers = await getBuyersList(axiosPrivate);
      setClosingRecipients(buyers);
    };
    if (type === "CLOSING") fetchBuyers();
  }, []);

  useEffect(() => {
    // when the user changes input tank, remmove the invalid states dest_tanks
    if (
      [
        "TREATMENT",
        "ANALYSIS",
        "TANNISSAGE",
        "BOIS",
        "ENZYME",
        "SO2",
        "HOMOGENIZATION_MASS",
        "OXYGENATION",
        "NITROGEN",
        "INOCULATION",
      ].includes(type)
    )
      return;

    if (typeof getValues !== "function") return;

    const subtype = getValues("subtype")?.value;
    const carbonic_output_state = getValues("carbonic_output_state")?.value;

    const expectedDestState =
      type === "DESTEMMING"
        ? subtype === "CARBONIC_MACERATION"
          ? carbonic_output_state || "WINE"
          : "MUST"
        : type === "RACKING"
        ? tank_id_in?.color === "ORANGE"
          ? "MUST"
          : "WINE"
        : type === "FILTERING"
        ? "WINE"
        : type === "BOTTLING"
        ? "BOTTLED"
        : type === "NEW_LOT"
        ? tank_id_in?.state
        : type === "CUT"
        ? watchedArray?.[0]?.tankData?.state
        : ["DECANT", "NEW_LOT"].includes(type)
        ? tank_id_in?.state
        : null;

    if (!expectedDestState) return;
    setExpectedDestinationState(expectedDestState);

    const expectedDestColor = ["RACKING", "FILTERING", "DECANT", "NEW_LOT", "DESTEMMING"].includes(type)
      ? tank_id_in?.color || null
      : null; // CUT handled inside isValidTankState via watchedArray
    setExpectedDestinationColor(expectedDestColor);

    if (watchedArray?.length > 0) {
      // check if is the default empty tank
      if (watchedArray?.length === 1) {
        const tank_data = watchedArray?.[0]?.tankData;
        if (
          tank_data?.value === null &&
          tank_data?.label === null &&
          watchedArray?.[0]?.quantity == 0
        )
          return;
      }

      return; // TO DO remove

      // Find indices to remove
      const prevLen = watchedArray?.length || 0;
      const indicesToRemove = watchedArray
        ?.map((item, index) =>
          (id ? item?.tankData?.state : item?.state) !== expectedDestState
            ? index
            : null
        )
        .filter((i) => i !== null)
        .sort((a, b) => b - a); // remove from highest to lowest

      // Remove unwanted items
      indicesToRemove.forEach((index) => remove(index));

      // If all were removed or the array was empty/null, add a default item
      if (prevLen === 0 || indicesToRemove.length === prevLen) {
        append({
          tankData: {},
          quantity: 0,
        });
      }
    }
  }, [tank_id_in, type]);

  const handleDestTankChange = (idx, selectedOption) => {
    
    // First, we find the corresponding dest_tank
    const tmp = { ...watchedArray[idx] };
    // Update the selected tank value and label
    tmp.tankData = { ...selectedOption };

    // Check if the tank has a planned_batch_name, and if so, handle batch name logic
    const tmpLabel = tmp?.tankData?.planned_batch_name
      ? tmp.tankData.planned_batch_name // If planned_batch_name exists, use it as the label
      : false; // If planned_batch_name doesn't exist, reset the batch name selector

    // Call update once to update the specific tank
    tmp.batch_name_selector = {
      value: false,
      label: tmpLabel,
    };
    tmp.new_batch_name = "";

    update(idx, tmp);

    checkColors(idx, tmp); // call with current data
  };

  const checkSwitchDisabled = (idx) => {
    // if is update and the dest lot already exists, it must be disabled
    const dest_t = watchedArray?.[idx];

    const dest_name = dest_t?.batch_name_selector?.value
      ? dest_t?.new_batch_name
      : dest_t?.batch_name_selector?.label;
    const foundBatch = lots?.find(
      (l) =>
        l?.name === dest_name &&
        // && l?.status === 'CONFIRMED'
        (l?.state === "WINE" || l?.state === expectedDestinationState)
    );
    const isBatchPlannedOnlyByThisOp =
      id &&
      foundBatch?.shared_operation_ids?.length === 1 &&
      foundBatch?.shared_operation_ids?.[0] === Number(id);
    const existingBatch = dest_name
      ? (foundBatch !== undefined && !isBatchPlannedOnlyByThisOp) || false
      : false; //l?.tanks?.some(ll => ll?.tank_id == watchedArray?.[idx]?.tankData?.value));

    const newLotIndex = watchedArray?.findIndex(
      (d) => d?.new_batch_name === dest_t?.batch_name_selector?.label
    );

    if (
      dest_t?.tankData?.lot &&
      dest_t?.tankData?.quantity > 0 &&
      (dest_t?.tankData?.state === "WINE" ||
        dest_t?.tankData?.state === expectedDestinationState)
    ) {
      return true;
    }

    if (
      !existingBatch &&
      dest_t?.batch_name_selector &&
      dest_t?.batch_name_selector?.value === false &&
      newLotIndex > -1
    ) {
      return true;
    }

    if (!dest_t?.tankData?.lot && !existingBatch && !dest_name) {
      // not batch_name configured yet and tank is empty
      return true;
    }
    const isExisting = id && existingBatch;
    if (
      dest_t?.tankData?.quantity === 0 &&
      !dest_t?.tankData?.is_planned &&
      !existingBatch
    )
      return false;

    return (
      Number(dest_t?.tankData?.old_quantity) > 0 ||
      Number(dest_t?.tankData?.planned_quantity) > 0 ||
      isExisting
    );
  };

  const isBatchExistingAndShared = (idx) => {
    const tank = watchedArray?.[idx];
    const dest_name = tank?.batch_name_selector?.value
      ? tank?.new_batch_name
      : tank?.batch_name_selector?.label;

    const foundBatch = lots?.find(
      (l) =>
        l?.name === dest_name &&
        (l?.state === "WINE" || l?.state === expectedDestinationState)
    );

    const isBatchPlannedOnlyByThisOp =
      id &&
      foundBatch?.shared_operation_ids?.length === 1 &&
      foundBatch?.shared_operation_ids?.[0] === Number(id);

    const existingBatch =
      dest_name && foundBatch !== undefined && !isBatchPlannedOnlyByThisOp;

    return existingBatch || false;
  };

  const customId = "custom-id-different-color";
  const checkColors = (updatedIdx, updatedTank) => {
    const colors = new Set();

    watchedArray?.forEach((item, i) => {
      const tank = i === updatedIdx ? updatedTank : item;
      if (tank?.tankData?.quantity > 0 && tank?.tankData?.color) colors.add(tank.tankData.color);
    });

    if (tank_id_in?.color) colors.add(tank_id_in.color);

    if (colors.size > 1) {
      toast(getLabel("toast_WarningDiffentWineColor"), {
        toastId: customId,
        type: toast.TYPE.ERROR,
        isLoading: false,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: false,
      });
      return false;
    } else {
      toast.dismiss(customId);
      return true;
    }
  };

  const getLotSwitchState = (idx, optionsCount = 2) => {
    const tank = watchedArray?.[idx];
    if (!tank) {
      return { status: 0, fixed: false, disabled: true };
    }

    const destName =
      (tank?.batch_name_selector?.value
        ? tank?.new_batch_name
        : tank?.batch_name_selector?.label) || null;

    const tankData = tank?.tankData || {};

    /* ---------------- PLANNED TANK ---------------- */
    if (!destName) {
      if (
        tankData?.is_planned &&
        Number(tankData?.quantity) === 0 &&
        [0, 1, 2].includes(tankData?.planned_batch_type)
      ) {
        return {
          status: tankData.planned_batch_type,
          fixed: false,
          disabled: false,
        };
      }

      return { status: 0, fixed: false, disabled: true };
    }

    /* ---------------- EXISTING BATCH ---------------- */
    const foundBatch = lots?.find(
      (l) =>
        l?.name === destName &&
        (["WINE", "BOTTLED"].includes(l?.state) ||
          l?.state === expectedDestinationState)
    );

    const isBatchPlannedOnlyByThisOp =
      id &&
      foundBatch?.shared_operation_ids?.length === 1 &&
      foundBatch?.shared_operation_ids?.[0] === Number(id);

    const existingBatch =
      destName && foundBatch !== undefined && !isBatchPlannedOnlyByThisOp;

    /* ---------------- FIXED ---------------- */
    const fixed =
      existingBatch &&
      tank?.batch_name_selector?.value === false &&
      [0, 1, 2].includes(foundBatch?.batch_type);

    /* ---------------- DISABLED ---------------- */
    const disabled =
      fixed || checkSwitchDisabled(idx) || isBatchExistingAndShared(idx);

    /* ---------------- STATUS ---------------- */
    let status;

    if (!id && foundBatch) {
      status = foundBatch.batch_type ?? 0;
    } else if (existingBatch) {
      status = foundBatch.batch_type ?? 0;
    } else {
      status = lotTypeMap?.[destName] ?? 0;
    }

    // clamp safety
    if (status >= optionsCount) status = 0;

    return { status, fixed, disabled };
  };

  // const getSwitchStatus = (idx) => {
  //   const tank = watchedArray?.[idx];
  //   const dest_name =
  //     (tank?.batch_name_selector?.value
  //       ? tank?.new_batch_name
  //       : tank?.batch_name_selector?.label) || null;
  //   if (dest_name === null) {
  //     const tankData = tank?.tankData || {}; // check if planned
  //     if (
  //       tankData?.is_planned &&
  //       Number(tankData?.quantity) === 0 &&
  //       [0, 1, 2].includes(tankData?.planned_batch_type)
  //     ) {
  //       return tankData?.planned_batch_type === 0;
  //     }
  //   }
  //   const foundBatch = lots?.find(
  //     (l) => l?.name === dest_name && l?.state === "WINE"
  //   );
  //   const isBatchPlannedOnlyByThisOp =
  //     id &&
  //     foundBatch?.shared_operation_ids?.length === 1 &&
  //     foundBatch?.shared_operation_ids?.[0] === Number(id);
  //   const existingBatch =
  //     dest_name && foundBatch !== undefined && !isBatchPlannedOnlyByThisOp;

  //   if (!id && isBatchPlannedOnlyByThisOp === undefined && foundBatch)
  //     return foundBatch?.batch_type === 0; // if not id, return batch_type 0 (FLOWER) or false

  //   // If batch is shared, disable switch (don't return status here)
  //   if (existingBatch) return false;

  //   // Use status from lotTypeMap, fallback to fals
  //   return lotTypeMap?.[dest_name] ?? false;
  // };

  const getError = (idx, baseName, key) => {
    if (type === "CUT" && !key) {
      return null;
    }
    const fieldErrors = errors?.[baseName];
    if (
      !fieldErrors ||
      !Array.isArray(fieldErrors) ||
      fieldErrors.length <= idx
    ) {
      return null;
    }

    return fieldErrors[idx]?.[key] || null;
  };

  const isValidTankState = (t) => {
    if (type === "CUT") {
      const firstState = watchedArray?.[0]?.tankData?.state || null;
      const firstColor = watchedArray?.[0]?.tankData?.color || null;
      if (["MUST", "WINE"].includes(firstState))
        return t.state === firstState && (!firstColor || t.color === firstColor) && Number(t?.quantity) > 0;
      else if (firstState === null && watchedArray?.length === 1)
        return Number(t?.quantity) > 0; // if first, return true if not empty
      return false;
    } else if (["RACKING", "FILTERING"].includes(type) && t.state === "WINE" && t.quantity > 0)
      return !expectedDestinationColor || t.color === expectedDestinationColor;

    if (Number(t?.quantity) === 0) return true;

    if (t.state !== expectedDestinationState) return false;
    if (expectedDestinationColor && t.color !== expectedDestinationColor) return false;
    return true;
  };

  const isValidTankSubtype = (t) => {
    if (type === "DESTEMMING") {
      if (t?.is_planned && t?.planned_subtype) {
        const planned_subtype = t?.planned_subtype;

        // Check if the color of the tank after the planned operation is compatible
        // with the color of wine produced by this DESTEMMING operation
        const myOutputColor = subtype === "ORANGE_WINE" && tank_id_in?.color === "WHITE"
          ? "ORANGE"
          : subtype === "ROSE_MACERATION" && tank_id_in?.color === "RED"
            ? "ROSE"
            : tank_id_in?.color;

        // Calculate the color of the tank AFTER the planned operation on it
        const plannedOutputColor = planned_subtype === "CARBONIC_MACERATION" && t?.color === "RED"
          ? "ROSE" // CARBONIC_MACERATION on RED grapes → output is ROSE wine
          : planned_subtype === "ROSE_MACERATION" && t?.color === "RED"
            ? "ROSE"
            : planned_subtype === "ORANGE_WINE" && t?.color === "WHITE"
              ? "ORANGE"
              : t?.color;

        // Colors must be compatible: my output can't mix with different tank color
        if (plannedOutputColor && myOutputColor && plannedOutputColor !== myOutputColor) {
          return false;
        }

        // Also check if subtypes are compatible when both exist
        return subtype === planned_subtype || !planned_subtype;
      }
    }
    return true;
  };

  const isPlusButtonDisabled = () => {
    const len = watchedArray?.length;
    const lastElement = watchedArray?.[len - 1];

    if (type === "CLOSING" || type === "NEW_LOT") {
      const isBuyerName =
        String(lastElement?.close_dest?.value)?.trim()?.length > 0;

      const src_quantity = tank_id_in?.is_planned
        ? Number(tank_id_in?.planned_quantity)
        : Number(tank_id_in?.quantity);

      const totalRequestedQuantity = watchedArray?.reduce(
        (acc, curr) => acc + (Number(curr?.quantity) || 0),
        0
      );

      return (
        (type !== "CLOSING" ? false : !isBuyerName) ||
        totalRequestedQuantity >= src_quantity ||
        Number(lastElement?.quantity) === 0
      );
    }

    if (type !== "BOTTLING") {
      return !lastElement?.tankData?.value;
    }

    // BOTTLING
    const batch_name_selector = lastElement?.batch_name_selector;

    const hasValidName =
      batch_name_selector?.value === true
        ? String(lastElement?.new_batch_name)?.trim().length > 0
        : String(batch_name_selector?.label)?.trim().length > 0;

    const hasValidQuantity = Number(lastElement?.quantity) > 0;

    return !(hasValidQuantity && hasValidName);
  };

  // const isPlusButtonDisabled = () => {
  //   const len = watchedArray?.length;
  //   const lastElement = watchedArray?.[len - 1];

  //   console.log('batch', tank_id_in, type, 'watchedArray', watchedArray)
  //   if (type === "CLOSING") {
  //     const isBuyerName =
  //       String(lastElement?.close_dest?.value)?.trim()?.length > 0;
  //     const src_quantity = tank_id_in?.is_planned
  //       ? Number(tank_id_in?.planned_quantity)
  //       : Number(tank_id_in?.quantity);
  //     const totalRequestedQuantity = watchedArray?.reduce((acc, curr, i) => {
  //       return acc + (Number(curr?.quantity) || 0);
  //     }, 0);
  //     // console.log('watchedArray', watchedArray, 'totalRequestedQuantity', totalRequestedQuantity)
  //     return (
  //       !isBuyerName ||
  //       totalRequestedQuantity >= src_quantity ||
  //       Number(lastElement?.quantity) === 0
  //     );
  //   } else if (type !== "BOTTLING") return !lastElement?.tankData?.value;
  //   else {
  //     const batch_name_selector = lastElement?.batch_name_selector;
  //     const isLastElementNameSet =
  //       batch_name_selector?.value === true
  //         ? lastElement?.new_batch_name
  //         : batch_name_selector?.label;
  //     return !(Number(lastElement?.quantity) > 0 && isLastElementNameSet);
  //   }
  // };

  const isTankAlreadyUsedInForm = (tank) => {
    return !watchedArray?.some?.(
      (field) =>
        field?.tankData?.value == tank?.id || tank?.id == tank_id_in?.value
    );
    // &&
    // !wineMakingData?.dest_tanks?.some?.(
    //   (field) => field?.tank_id == tank?.id
    // )
    // && !["BARRIQUE", "TONNEAU"].includes(tank.type)
  };

  const getDestOptions = () => {
    return (
      tanks
        ?.filter((tank) => isTankAlreadyUsedInForm(tank))
        ?.filter((tank) => isValidTankState(tank))
        ?.filter((tank) => isValidTankSubtype(tank))
        ?.sort(sortByTankName)
        ?.map((tank) =>
          mapTankToSelectOption(
            tank,
            type !== "CUT" ? "dest" : "src",
            lots,
            operation || (id ? { id: Number(id) } : null),
            getLabel
          )
        ) || []
    );
  };

  const isSwitchFixedStatus = (idx) => {
    // return true if I am using an existing FLOWER/PRESSED batch
    const currentTank = watchedArray?.[idx];
    const batch_name_selector = currentTank?.batch_name_selector;

    return (
      ["WINE", "BOTTLED"].includes(currentTank?.tankData?.state) &&
      batch_name_selector?.value === false &&
      batch_name_selector?.label &&
      [0, 1, 2].includes(batch_name_selector?.batch_type)
    );
  };

  const isSwitchDisabled = (idx) => {
    const currentTank = watchedArray?.[idx];
    const new_batch_name = currentTank?.new_batch_name;
    const batch_name_selector = currentTank?.batch_name_selector;

    if (isSwitchFixedStatus(idx)) return true;

    if (batch_name_selector?.value && new_batch_name)
      return checkSwitchDisabled(idx) || isBatchExistingAndShared(idx);

    return checkSwitchDisabled(idx) || isBatchExistingAndShared(idx);

    // return (!(checkSwitchDisabled(idx) || isBatchExistingAndShared(idx)) === false);
  };

  const getBuyerOptions = () => {
    return Array.from(
      new Map(
        closingRecipients.map((buyer) => [
          buyer.recipient,
          {
            value: buyer.id,
            label: buyer.recipient,
          },
        ])
      ).values()
    );
  };

  const getCloseReasonOptions = () => {
    const reasons = [
      "BULK_SALE", // sale of bulk wine
      "DISTILLERY", // sent to distillery
      "DISPOSAL", // discarded / waste
      "SAMPLE", // sample / testing
      "INTERNAL_USE", // internal lab or process use
      "OTHER", // other reason
    ];

    return (
      reasons?.map((o) => ({
        value: o,
        label: getLabel(`buyReason_${o}`),
      })) || []
    );
  };

  const handleCreateOption = (newCreatableOption = {}) => {
    if (newCreatableOption?.value && newCreatableOption?.label)
      setClosingRecipients((prev) => [...prev, newCreatableOption]);
  };

  const returnLotTypeSwitch = (idx) => {
    const isRacking = type === "RACKING";
    const isPressing =
      type === "DESTEMMING" && (
        (tank_id_in?.color === "WHITE" && subtype === "WITH_PRESSING") ||
        (tank_id_in?.color === "RED" && subtype === "DIRECT_PRESSING")
      );

    const optionsCount = 3; // isPressing ? 3 : 2;
    const { status, fixed, disabled } = getLotSwitchState(idx, optionsCount);

    if (isPressing || isRacking)
      return (
        <Switch3
          options={[
            { label: getLabel("lotType_FLOWER"), value: 1 },
            { label: getLabel("lotType_MIXED"), value: 2 },
            { label: getLabel("lotType_PRESSED"), value: 0 },
          ]}
          value={status} // 0 | 1 | 2
          fixed={fixed}
          disabled={disabled}
          onChange={(newValue) => {
            const tank = watchedArray?.[idx];
            const name = (
              tank?.batch_name_selector?.value
                ? tank?.new_batch_name
                : tank?.batch_name_selector?.label
            )?.trim?.();
            if (!name) return;

            setLotTypeMap((prev) => ({
              ...prev,
              [name]: newValue,
            }));

            // ALSO store in form field so it persists during submit
            update(idx, { ...tank, _batch_type: newValue });
          }}
        />
      );

    // if (type === "RACKING") return (<div className="switch_wrapper">
    //     <Switch
    //       leftOption={{
    //         label: getLabel("lotType_FLOWER"),
    //       }}
    //       rightOption={{
    //         label: getLabel("lotType_PRESSED"),
    //       }}
    //       // toggleHandler={(e) =>
    //       //   setIsPressed([
    //       //     ...isPressed.slice(0, idx),
    //       //     !isPressed[idx],
    //       //     ...isPressed.slice(idx + 1),
    //       //   ])
    //       // }
    //       toggleHandler={(e) => {
    //         const tank = watchedArray?.[idx];
    //         const name = tank?.batch_name_selector?.value
    //           ? tank?.new_batch_name
    //           : tank?.batch_name_selector?.label;

    //         const cleanedValue = name?.trim();
    //         // Skip if cleanedValue is empty or already exists in lotTypeMap
    //         if (!cleanedValue) return;

    //         setLotTypeMap((prev) => {
    //           return {
    //             ...prev,
    //             [cleanedValue]: !prev?.[cleanedValue],
    //           };
    //         });
    //       }}
    //       status={status}
    //       disabled={disabled}
    //       fixed={fixed}
    //       // status={getSwitchStatus(idx)}
    //       // disabled={isSwitchDisabled(idx)}
    //       // fixed={isSwitchFixedStatus(idx)}
    //     />
    //   </div>)
  };

  return (
    <>
      <h5>
        {getLabel(
          type === "CLOSING"
            ? "toCloseDest"
            : type === "BOTTLING"
            ? "toBottles"
            : type === "CUT"
            ? "fromTanks"
            : type === "FILTERING"
            ? "toTank"
            : "toTanks"
        )}
      </h5>
      <div className={`operation_form_wrapper_row vertical ${useCardLayout ? "full_width" : ""}`}>
        {fields?.map?.((field, idx) => {
          return (
            <div key={field.id} className={`operation_form_wrapper_row vertical ${useCardLayout ? "full_width" : ""}`}>
              {type === "CLOSING" && (
                <div className="new_batch_name_wrapper">
                  <Select
                    isDisabled={!tank_id_in?.value}
                    error={errors}
                    label={getLabel("operationDestBuyerName")}
                    placeholder={getLabel("operationDestBuyerNamePlaceholder")}
                    required={getLabel("inputRequiredError")}
                    name={`${baseName}.${idx}.close_dest`}
                    control={control}
                    isSearchable={true}
                    isCreatable={true}
                    options={getBuyerOptions()}
                    customClassName="new_batch_name_fix_margin"
                    pattern={{
                      value: NUM_ALPHA_SPACE_APEX_DOT_ALL_LEN_REGEX,
                      message: getLabel("errorAlphaSpaceApexNum"),
                    }}
                    onCreateOption={handleCreateOption}
                  />
                  <Input
                    name={`${baseName}.${idx}.quantity`}
                    register={register}
                    type="number"
                    customClassName="quantity"
                    label={isBatchMode ? getLabel("numBottles") : `${getLabel("operationDestTankQuantity")} (${inputUnit})`}
                    placeholder={getLabel(
                      "operationDestTanksQuantityPlaceholder"
                    )}
                    required={getLabel("inputRequiredError")}
                    isDisabled={!tank_id_in?.value}
                    min={{
                      value: 1,
                      message: getLabel("errorMinValue", { value: 1 }),
                    }}
                    regExpPattern={isBatchMode ? {
                      value: INT_REGEX,
                      message: getLabel("errorInt"),
                    } : {
                      value: getInputQtyRegex(inputUnit),
                      message: getLabel(inputUnit === "hL" ? "errorIntFloat" : "errorInt"),
                    }}
                    error={getError(idx, baseName, "quantity")}
                    validate={isBatchMode ? undefined : (value) => {
                      return checkTransferAvailableQuantity(
                        id,
                        idx,
                        type,
                        subtype,
                        tank_id_in,
                        watchedArray,
                        value,
                        baseName,
                        getValues,
                        getLabel,
                        clearErrors,
                        trigger,
                        false,
                        "pomaces",
                        inputUnit
                      );
                    }}
                  />
                  <Select
                    label={getLabel("operationDestBuyerReason")}
                    error={errors}
                    required={getLabel("inputRequiredError")}
                    name={`${baseName}.${idx}.close_reason`}
                    placeholder={getLabel(
                      "operationDestBuyerReasonPlaceholder"
                    )}
                    customClassName="new_batch_name_fix_margin"
                    isDisabled={!tank_id_in?.value}
                    control={control}
                    // isSearchable={true}
                    options={getCloseReasonOptions()}
                  />
                  {/* <Input
                  name={`${baseName}.${idx}.close_reason`}
                  placeholder={getLabel("operationDestBuyerReasonPlaceholder")}
                  isDisabled={!tank_id_in?.value}
                  error={getError(idx, baseName, "close_reason")}
                  register={register}
                  type="text"
                  label={getLabel("operationDestBuyerReason")}
                  minLength={{
                    value: 3,
                    message: getLabel("errorMinLength", { value: 3 }),
                  }}
                  maxLength={{
                    value: 100,
                    message: getLabel("errorMaxLength", {
                      value: 100,
                    }),
                  }}
                  regExpPattern={{
                    value: NUM_ALPHA_SPACE_APEX_DOT_ALL_LEN_REGEX,
                    message: getLabel("errorAlphaSpaceApexNum"),
                  }}
                /> */}
                  <OptionalNoteRow
                    key={field.id}
                    idx={idx}
                    register={register}
                    errors={errors}
                    baseName={baseName}
                    getLabel={getLabel}
                    isDisabled={!tank_id_in?.value}
                    setValue={setValue}
                    isUpdate={Boolean(id)}
                    notes={watchedArray?.[idx]?.close_notes}
                  />
                </div>
              )}
              <div className="operation_form_wrapper_row dest_tank_fields_row">
                {type !== "BOTTLING" && type !== "CLOSING" && (
                  <div className="dest_select">
                    <Select
                      isDisabled={(type !== "CUT" && !tank_id_in?.value) || (type === "DESTEMMING" && (!subtype || (subtype == "CARBONIC_MACERATION" && !getValues("carbonic_output_state")?.value)))}
                      label={getLabel(
                        type === "BOTTLING"
                          ? "operationDestBottleName"
                          : type === "CUT"
                          ? "operationSrcTankName"
                          : "operationDestTankName"
                      )}
                      placeholder={getLabel(
                        type === "BOTTLING"
                          ? "operationDestBottleNamePlaceholder"
                          : type === "CUT"
                          ? "operationSrcTanksPlaceholder"
                          : "operationDestTanksPlaceholder"
                      )}
                      error={errors}
                      required={getLabel("inputRequiredError")}
                      name={`${baseName}.${idx}.tankData`}
                      control={control}
                      // isSearchable={true}
                      options={getDestOptions()}
                      onTableChange={(value) => handleDestTankChange(idx, value)}
                      tooltip={
                        type === "CUT" && idx === 0
                          ? getLabel("cutTankInTooltip")
                          : ""
                      }
                    />
                  </div>
                )}
                {type !== "CLOSING" && watchedArray?.[idx]?.tankData?.value && !useCardLayout && (
                  <DestTankDetail
                    tank={getUnifiedTankData(watchedArray?.[idx], {
                      type: type,
                      subtype,
                      carbonic_output_state: getValues("carbonic_output_state")?.value,
                      isSrc: type === "CUT",
                      id,
                      operation,
                      getValues,
                      dest_tanks: type === "CUT" ? [tank_id_in] : watchedArray,
                      tank_id_in,
                      lots,
                      lotNames,
                      lotTypeMap,
                      expectedDestinationState,
                      unit: inputUnit,
                    })}
                    operation={
                      operation
                        ? operation
                        : {
                            type,
                            subtype,
                            batch_type:
                              watchedArray?.[idx]?.batch_name_selector?.value
                                ? lotTypeMap?.[
                                    watchedArray?.[idx]?.new_batch_name
                                  ]
                                : "",
                          }
                    }
                    isDrop={false}
                    isName={false}
                    isFirst={idx === 0}
                    isMobile={isMobile}
                  />
                )}
              {type !== "CLOSING" && watchedArray?.[idx]?.tankData?.value && !useCardLayout && (
                <div className="operation_form_wrapper_row">
                  {/* Quantità + switch tipo lotto impilati in colonna: fuori dal
                      wizard lo switch3 va sotto l'Input, così su schermi stretti
                      non si comprime tutto in una sola riga. */}
                  <div className="quantity_switch_col">
                  <Input
                    name={`${baseName}.${idx}.quantity`}
                    register={register}
                    type="number"
                    customClassName="quantity"
                    label={`${getLabel(
                      type === "BOTTLING"
                        ? "operationDestBottlingQuantity"
                        : "operationDestTankQuantity"
                    )} (${inputUnit})`}
                    placeholder={getLabel(
                      type === "BOTTLING"
                        ? "operationDestBottlingQuantityPlaceholder"
                        : "operationDestTanksQuantityPlaceholder"
                    )}
                    required={getLabel("inputRequiredError")}
                    min={{
                      value: getInputQtyMin(inputUnit),
                      message: getLabel("errorMinValue", { value: getInputQtyMin(inputUnit) }),
                    }}
                    regExpPattern={{
                      value: getInputQtyRegex(inputUnit),
                      message: getLabel(inputUnit === "hL" ? "errorIntFloat" : "errorInt"),
                    }}
                    error={getError(idx, baseName, "quantity")}
                    validate={(value) => {
                      if (type === "CUT") {
                        const tankData = watchedArray?.[idx]?.tankData || {};
                        return checkCutAvailableQuantity(
                          id,
                          operation,
                          tank_id_in,
                          tankData,
                          value,
                          getLabel,
                          [],
                          inputUnit
                        );
                      }
                      return checkTransferAvailableQuantity(
                        id,
                        idx,
                        type,
                        subtype,
                        tank_id_in,
                        watchedArray,
                        value,
                        baseName,
                        getValues,
                        getLabel,
                        clearErrors,
                        trigger,
                        false,
                        "pomaces",
                        inputUnit
                      );
                    }}
                  />

                  {returnLotTypeSwitch(idx)}
                  </div>

                  {type === "BOTTLING" &&
                    renderBatchNameSelector(
                      id,
                      type,
                      false,
                      watchedArray,
                      baseName,
                      idx,
                      control,
                      register,
                      errors,
                      lots,
                      lotNames,
                      expectedDestinationState,
                      setValue,
                      getValues,
                      getLabel,
                      getError,
                      setLotTypeMap,
                      null,
                      null,
                      null,
                      tank_id_in,
                      lotTypeMap
                    )}

                  {!["BOTTLING", "CUT", "CLOSING"].includes(type) &&
                    renderBatchNameSelector(
                      id,
                      type,
                      false,
                      watchedArray,
                      baseName,
                      idx,
                      control,
                      register,
                      errors,
                      lots,
                      lotNames,
                      expectedDestinationState,
                      setValue,
                      getValues,
                      getLabel,
                      getError,
                      setLotTypeMap,
                      type === "BOTTLING"
                        ? tank_id_in?.batch_name
                        : type === "DESTEMMING"
                        ? tank_id_in?.label || tank_id_in?.name
                        : null,
                      type === "DESTEMMING" ? tank_id_in?.color : null,
                      getValues("subtype")?.value,
                      null,
                      lotTypeMap
                    )}
                </div>
              )}
              {!useCardLayout && fields?.length > 1 && type !== "FILTERING" && (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    remove(idx);
                  }}
                  title={getLabel("operationRemoveDestTank")}
                >
                  -
                </button>
              )}
              </div>
              {type !== "CLOSING" && watchedArray?.[idx]?.tankData?.value && useCardLayout && (
                <div className="wizard_dest_tank_detail_card">
                  {/* Header */}
                  <div className="wizard_dest_card_header">
                    <span className="wizard_dest_card_title">
                      {watchedArray?.[idx]?.tankData?.label}
                    </span>
                    {fields?.length > 1 && type !== "FILTERING" && (
                      <button
                        className="wizard_dest_card_remove"
                        onClick={(e) => {
                          e.preventDefault();
                          remove(idx);
                        }}
                        title={getLabel("operationRemoveDestTank")}
                      >
                        ×
                      </button>
                    )}
                  </div>

                  {/* Body */}
                  <div className="wizard_dest_card_body">
                    {/* Left: tank visualization */}
                    <div className="wizard_dest_card_viz">
                      <DestTankDetail
                        tank={getUnifiedTankData(watchedArray?.[idx], {
                          type: type,
                          subtype,
                          carbonic_output_state: getValues("carbonic_output_state")?.value,
                          isSrc: type === "CUT",
                          id,
                          operation,
                          getValues,
                          dest_tanks: type === "CUT" ? [tank_id_in] : watchedArray,
                          tank_id_in,
                          lots,
                          lotNames,
                          lotTypeMap,
                          expectedDestinationState,
                          unit: inputUnit,
                        })}
                        operation={
                          operation
                            ? operation
                            : {
                                type,
                                subtype,
                                batch_type:
                                  watchedArray?.[idx]?.batch_name_selector?.value
                                    ? lotTypeMap?.[
                                        watchedArray?.[idx]?.new_batch_name
                                      ]
                                    : "",
                              }
                        }
                        isDrop={false}
                        isName={false}
                        isFirst={idx === 0}
                        isMobile={isMobile}
                      />
                    </div>

                    {/* Right: controls */}
                    <div className="wizard_dest_card_controls">
                      <Input
                        name={`${baseName}.${idx}.quantity`}
                        register={register}
                        type="number"
                        customClassName="quantity"
                        label={`${getLabel(
                          type === "BOTTLING"
                            ? "operationDestBottlingQuantity"
                            : "operationDestTankQuantity"
                        )} (${inputUnit})`}
                        placeholder={getLabel(
                          type === "BOTTLING"
                            ? "operationDestBottlingQuantityPlaceholder"
                            : "operationDestTanksQuantityPlaceholder"
                        )}
                        required={getLabel("inputRequiredError")}
                        min={{
                          value: getInputQtyMin(inputUnit),
                          message: getLabel("errorMinValue", { value: getInputQtyMin(inputUnit) }),
                        }}
                        regExpPattern={{
                          value: getInputQtyRegex(inputUnit),
                          message: getLabel(inputUnit === "hL" ? "errorIntFloat" : "errorInt"),
                        }}
                        error={getError(idx, baseName, "quantity")}
                        validate={(value) => {
                          if (type === "CUT") {
                            const tankData = watchedArray?.[idx]?.tankData || {};
                            return checkCutAvailableQuantity(
                              id,
                              operation,
                              tank_id_in,
                              tankData,
                              value,
                              getLabel,
                              [],
                              inputUnit
                            );
                          }
                          return checkTransferAvailableQuantity(
                            id,
                            idx,
                            type,
                            subtype,
                            tank_id_in,
                            watchedArray,
                            value,
                            baseName,
                            getValues,
                            getLabel,
                            clearErrors,
                            trigger,
                            false,
                            "pomaces",
                            inputUnit
                          );
                        }}
                      />

                      {returnLotTypeSwitch(idx)}

                      {type === "BOTTLING" &&
                        renderBatchNameSelector(
                          id,
                          type,
                          false,
                          watchedArray,
                          baseName,
                          idx,
                          control,
                          register,
                          errors,
                          lots,
                          lotNames,
                          expectedDestinationState,
                          setValue,
                          getValues,
                          getLabel,
                          getError,
                          setLotTypeMap,
                          null,
                          null,
                          null,
                          tank_id_in,
                          lotTypeMap
                        )}

                      {!["BOTTLING", "CUT", "CLOSING"].includes(type) &&
                        renderBatchNameSelector(
                          id,
                          type,
                          false,
                          watchedArray,
                          baseName,
                          idx,
                          control,
                          register,
                          errors,
                          lots,
                          lotNames,
                          expectedDestinationState,
                          setValue,
                          getValues,
                          getLabel,
                          getError,
                          setLotTypeMap,
                          type === "BOTTLING"
                            ? tank_id_in?.batch_name
                            : type === "DESTEMMING"
                            ? tank_id_in?.label || tank_id_in?.name
                            : null,
                          type === "DESTEMMING" ? tank_id_in?.color : null,
                          getValues("subtype")?.value,
                          ["RACKING", "FILTERING"].includes(type) ? tank_id_in : null,
                          lotTypeMap
                        )}
                    </div>
                  </div>
                </div>
              )}
              {type === "BOTTLING" && !isWizardMode &&
                renderBatchNameSelector(
                  id,
                  type,
                  false,
                  watchedArray,
                  baseName,
                  idx,
                  control,
                  register,
                  errors,
                  lots,
                  lotNames,
                  expectedDestinationState,
                  setValue,
                  getValues,
                  getLabel,
                  getError,
                  setLotTypeMap,
                  null,
                  null,
                  null,
                  tank_id_in,
                  lotTypeMap
                )}
              {type === "BOTTLING" &&
                renderBottlingCapBottleSelector(
                  subtype,
                  operation,
                  watchedArray,
                  capsData,
                  bottlesData,
                  tank_id_in,
                  baseName,
                  bottleTypes,
                  idx,
                  control,
                  register,
                  errors,
                  getValues,
                  getLabel,
                  getError,
                  clearErrors
                )}
            </div>
          );
        })}
        {type !== "FILTERING" && (
          <button
            id="tanksD"
            disabled={isPlusButtonDisabled()} // disable if previous is not set
            onClick={(e) => {
              e.preventDefault();
              append({
                tankData: {},
                quantity: 0,
              });
              // setIsPressed([...isPressed, false]);
            }}
          >
            +
          </button>
        )}
      </div>
    </>
  );
};

const OptionalNoteRow = ({
  idx,
  register,
  errors,
  baseName,
  getLabel,
  notes = "",
  setValue = () => null,
  isDetail = false,
  isUpdate = false,
  isDisabled = false,
}) => {
  const [showNotes, setShowNotes] = useState(false);

  const handleClick = () => {
    if (isDisabled) return;
    setShowNotes((prev) => !prev);

    // clear data
    if (showNotes) {
      setValue(`${baseName}.${idx}.close_notes`, null);
    }
  };

  // Build field path based on whether idx is present
  const fieldPath =
    idx !== null && idx !== undefined
      ? `${baseName}.${idx}.close_notes`
      : `${baseName}.close_notes`;

  // Match RHF error structure
  const fieldError =
    idx !== null && idx !== undefined
      ? errors?.[baseName]?.[idx]?.close_notes
      : errors?.[baseName]?.close_notes;

  return (
    <div
      className={`optional_sticky_note_row ${isDetail ? "detail_mode" : ""} ${
        isDisabled ? "disabled" : ""
      }`}
    >
      {/* --- Sticky note toggle --- */}
      <div
        // className={`sticky_note_icon ${showNotes ? '' : 'margin_top_fix'}`}
        className={`sticky_note_icon ${
          !showNotes && !isDetail ? "margin_top_fix" : ""
        }`}
        onClick={() => handleClick()}
      >
        <Icon           icon={"fa-sticky-note"}
          size="lg"
          color={showNotes ? "#ffcc00" : "gray"} // highlight when active
        />
        {!isDetail && (
          <span className="note_label">
            {" "}
            {getLabel(isUpdate && notes?.length > 0 ? "updateNote" : "addNote")}
          </span>
        )}
      </div>

      {showNotes && isDetail && <p>{notes}</p>}
      {showNotes && !isDetail && (
        <TextArea
          // name={`${baseName}.${idx}.close_notes`}
          // error={errors?.[baseName]?.[idx]?.close_notes}
          name={fieldPath}
          error={fieldError}
          register={register}
          // label={getLabel("protocolNotes")}
          isLabel={false}
          placeholder={getLabel("protocolNotesPlaceholder")}
          maxLength={{
            value: 500,
            message: getLabel("errorMaxLength", { value: 500 }),
          }}
        />
      )}
    </div>
  );
};

const actualizeDestTank = (
  operation,
  destTank,
  tanks,
  lots,
  drops,
  is_src = false,
  virtualTanks = null,
  isVirtualMode = false,
  isNextToExecute = false
) => {
  const { id, type, completion_date, subtype } = operation || {};
  // if not completed, compute tankData from current tanks
  if (completion_date !== null) {
    if (operation?.type === "STABILIZATION_RESIN") {
      const percentage = Number(operation?.treatments?.[0]?.quantity || 0);
      const tmpTank = { ...destTank };
      tmpTank.is_planned = true;
      tmpTank.percentage = percentage;
      tmpTank.planned_quantity = tmpTank.old_quantity;
      tmpTank.old_quantity = Math.floor(
        (Number(tmpTank.old_quantity) * percentage) / 100
      );

      return tmpTank;
    } else if (operation?.type === "RACKING" && is_src) {
      const tmpTank = { ...destTank };
      const pomacesQuantity = Number(operation?.pomaces?.[0]?.quantity || 0);
      tmpTank.arrow_quantity += pomacesQuantity;
      tmpTank.quantity -= pomacesQuantity;

      return tmpTank;
    } else if (operation?.type === "RACKING" && !is_src) {
      const tmpTank = { ...destTank };
      // tank.quantity already holds the post-op actual value (drop applied by SQL).
      // Fall back to old_quantity + arrow_quantity - drop only if quantity is missing.
      tmpTank.quantity = Number(tmpTank.quantity) ||
        (Number(tmpTank.old_quantity) || 0) + (Number(tmpTank.arrow_quantity) || 0) - (Number(tmpTank.drop) || 0);
      return tmpTank;
    }

    if (!is_src && subtype && destTank?.color)
      return { ...destTank, color: applySubtypeColorTransformation(destTank.color, subtype) };
    return destTank;
    // const tmp = {
    // ...destTank,
    // quantity: destTank?.quantity + (destTank?.drop || 0),
    // old_quantity: destTank?.old_quantity + (destTank?.drop || 0),
    // ...((destTank?.state === 'WINE' || destTank?.state === 'BOTTLED') && { batch_type: Number(destTank?.batch_type) }),
    // quantity: destTank?.quantity + (destTank?.old_quantity || 0),
    // };

    // return tmp;
  }

  // CRYO_MACERATION started (not completed): transfer already happened at start.
  // Use the operation's recorded pre-transfer quantities instead of the current
  // Redux tank state (which already includes the transferred amount, causing double-counting).
  if (
    !is_src &&
    type === "DESTEMMING" &&
    subtype === "CRYO_MACERATION" &&
    operation?.start_date &&
    completion_date === null
  ) {
    return {
      ...destTank,
      old_quantity: destTank?.old_quantity ?? 0,
      quantity: (destTank?.old_quantity ?? 0) + (destTank?.arrow_quantity ?? 0),
      color: applySubtypeColorTransformation(destTank?.color, subtype),
      state: destTank?.state,
      composition: destTank?.composition || [],
      drop: 0,
    };
  }

  const currentTank =
    tanks?.find((t) => t?.id === Number(destTank?.tank_id)) || null;
  if (currentTank === null) return {};

  // Protocol application mode: bypass is_planned logic entirely
  // Real state = destTank as planned by the protocol (not current Redux)
  // Virtual state = projected quantities from vTank API
  if (operation?.protocol_application_id) {
    const vTank = virtualTanks?.[destTank.tank_id] ?? virtualTanks?.[String(destTank.tank_id)] ?? null;

    if (isVirtualMode && vTank) {
      // Stato Simulato: proiezione futura da API
      if (is_src) {
        return {
          ...currentTank,
          old_quantity: vTank.quantity,
          quantity: (vTank.quantity ?? 0) - (destTank?.arrow_quantity || 0),
          arrow_quantity: destTank?.arrow_quantity || 0,
          is_planned: false,
          is_src: true,
          batch_id: vTank.batch_id ?? destTank?.batch_id,
          state: vTank.state ?? destTank?.state,
          color: destTank?.color || currentTank?.color,
          composition: destTank?.composition || [],
        };
      } else {
        // tank destinazione: planned_quantity = proiettata, old_quantity = attuale
        return {
          ...currentTank,
          old_quantity: currentTank?.quantity || 0,
          planned_quantity: vTank.quantity,
          quantity: currentTank?.quantity || 0,
          arrow_quantity: destTank?.arrow_quantity || 0,
          is_planned: (vTank.quantity ?? 0) > 0,
          is_src: false,
          state: vTank.state ?? destTank?.state ?? currentTank?.state,
          color: destTank?.color || currentTank?.color,
          composition: destTank?.composition || [],
          srcs_composition: operation?.src_tanks?.flatMap((s) => s?.composition || []) || [],
        };
      }
    } else {
      // Stato Reale: usa destTank così com'è nel contesto del protocollo
      // Per next-to-execute steps: mostra il cambio di stato causato dall'operazione
      // old_quantity = stato attuale, quantity = quello che sarà dopo l'operazione
      if (isNextToExecute) {
        return {
          ...currentTank,
          old_quantity: currentTank?.quantity || 0,
          quantity: destTank?.quantity || 0,
          planned_quantity: 0,
          arrow_quantity: destTank?.arrow_quantity || 0,
          is_planned: false,
          is_src,
          state: destTank?.state || currentTank?.state,
          color: destTank?.color || currentTank?.color,
          composition: destTank?.composition || currentTank?.composition || [],
          batch_id: destTank?.batch_id || currentTank?.batch_id,
          batch_name: destTank?.batch_name || currentTank?.batch_name,
          old_batch_name: destTank?.batch_name || currentTank?.batch_name,
          ...((!is_src) && { srcs_composition: operation?.src_tanks?.flatMap((s) => s?.composition || []) || [] }),
        };
      }
      // For future steps: show projected quantities from destTank in protocol context
      // (destTank.quantity = null/0 per step non ancora raggiunto)
      const realQty = destTank?.quantity ?? 0;
      return {
        ...currentTank,
        old_quantity: realQty,
        quantity: realQty + (is_src ? -1 : 1) * (destTank?.arrow_quantity || 0),
        arrow_quantity: destTank?.arrow_quantity || 0,
        is_planned: false,
        is_src,
        state: destTank?.state || currentTank?.state,
        color: destTank?.color || currentTank?.color,
        composition: destTank?.composition || [],
        batch_id: destTank?.batch_id || currentTank?.batch_id,
        batch_name: destTank?.batch_name || currentTank?.batch_name,
        old_batch_name: destTank?.batch_name || currentTank?.batch_name,
        ...((!is_src) && { srcs_composition: operation?.src_tanks?.flatMap((s) => s?.composition || []) || [] }),
      };
    }
  }

  // Virtual mode: use virtual tank quantity as base
  const vTank = isVirtualMode ? (virtualTanks?.[destTank.tank_id] ?? virtualTanks?.[String(destTank.tank_id)]) : null;
  const baseQuantity = vTank?.quantity != null ? vTank.quantity : currentTank?.quantity;

  let drop = 0;
  if (drops && typeof drops === "object") {
    Object.entries(drops).forEach(([t, q]) => {
      if (Number(t) === currentTank?.id && q !== undefined && q !== '') {
        // q è la quantità effettiva inserita dal cantiniere (unità input).
        // drop = pianificato − effettivo (negativo = guadagno)
        const actualLiters = inputToLiters(q, getInputTankUnit());
        const plannedLiters = Number(destTank?.arrow_quantity ?? 0);
        drop = plannedLiters - actualLiters;
        return false;
      }
    });
  }

  const isPlannedState =
    (is_src ? currentTank?.is_planned_src : currentTank?.is_planned) === true;
  const programmedOpIds = is_src
    ? currentTank?.programmed_as_src
    : currentTank?.programmed_as_dest;
  const isPlannedByOtherOps =
    isPlannedState && programmedOpIds?.some((p_id) => p_id !== Number(id));

  const isPlanned = isPlannedState && isPlannedByOtherOps;

  const lotData = isPlanned
    ? lots?.find((l) => l?.id === destTank?.planned_batch_id) || null
    : null;
  const isLotDataAvailable = lotData !== null;
  // if (is_src && currentTank?.name == 'Vasca 2') console.log('currentTank', currentTank, 'isPlannedByOtherOps', isPlannedByOtherOps)
  // if (currentTank?.id == 4) console.log('currentTank', currentTank, 'isPlanned', isPlanned, 'isPlannedByOtherOps', isPlannedByOtherOps)

  const tankData = {
    ...currentTank,
    // planned_quantity: isPlannedState && !isPlannedByOtherOps ? 0 : (isPlanned && isPlannedByOtherOps ? Number(currentTank?.planned_quantity) : Number(currentTank?.quantity)) + (is_src ? 1 : -1) * Number(destTank?.arrow_quantity),
    // planned_quantity:
    //   isPlannedState && !isPlannedByOtherOps
    //     ? 0
    //     : isPlanned && isPlannedByOtherOps
    //     ? Number(currentTank?.planned_quantity) -
    //       Number(currentTank?.quantity) +
    //       (is_src ? 1 : -1) * Number(destTank?.arrow_quantity)
    //     : Number(currentTank?.quantity),
    color: !is_src
      ? applySubtypeColorTransformation(destTank?.color || currentTank?.color, subtype)
      : (destTank?.color || currentTank?.color),
    state: destTank?.state || currentTank?.state,
    drop: operation?.completion_date === null ? drop || 0 : destTank?.drop,
    old_quantity: baseQuantity,
    old_batch_name: currentTank?.batch_name,
    old_batch_type: currentTank?.batch_type,
    arrow_quantity: destTank?.arrow_quantity || 0,
    quantity:
      baseQuantity + (is_src ? -1 : 1) * (destTank?.arrow_quantity || 0),
    is_new: destTank?.is_new === true,
    is_src: is_src,
    // batch_type: !is_src ? (destTank?.batch_type === 1 ? "FLOWER" : "PRESSED") : "",
    batch_type: destTank?.batch_type,
    is_planned: isPlanned,
    is_planned_src: currentTank?.is_planned_src === true,
    ...(isLotDataAvailable && {
      tooltip: {
        varieties: lotData?.varieties,
        years: lotData?.years,
        origins: lotData?.origins,
        percentages: lotData?.percentages,
      },
    }),
    composition: destTank?.composition || [],
  };

  if (!is_src) {
    tankData.srcs_composition =
      operation?.src_tanks?.flatMap((s) => s?.composition || []) || [];
  }

  if (tankData.is_new) {
    // check if was new only when created but now exists
    tankData.is_new =
      lots?.find(
        (l) =>
          l?.name === currentTank?.planned_batch_name &&
          l?.status !== "PLANNED" &&
          l?.state === currentTank?.planned_batch_state &&
          l?.name?.toLowerCase?.()
      ) === undefined;
  }

  if (!tankData.batch_name) tankData.batch_name = destTank?.batch_name;

  if (type === "NEW_LOT" && !is_src) {
    tankData.batch_id = currentTank?.planned_batch_id || destTank?.batch_id;
    tankData.batch_name =
      currentTank?.planned_batch_name || destTank?.batch_name;
  }

  if (is_src && type === "CUT" && isPlannedByOtherOps) {
    tankData.planned_quantity =
      (isPlanned
        ? Number(destTank?.old_quantity)
        : Number(currentTank?.quantity)) +
      (is_src ? -1 : 1) * Number(destTank?.arrow_quantity) +
      (id ? destTank?.arrow_quantity : 0);
    tankData.old_quantity =
      (isPlanned
        ? Number(currentTank?.planned_quantity)
        : Number(currentTank?.quantity)) + (id ? destTank?.arrow_quantity : 0);
  }

  if (is_src) {
    // if (type === "RACKING" && is_src) {
    if (type === "STABILIZATION_RESIN") {
      const resin_percentage =
        Number(
          operation?.treatments?.find((t) => t?.tank_id == currentTank?.id)
            ?.quantity
        ) || 0;
      if (resin_percentage > 0) {
        tankData.is_planned = true;
        const resinQty = Math.ceil(
          (resin_percentage / 100) * currentTank?.quantity
        );
        tankData.percentage = resin_percentage;
        tankData.old_quantity = resinQty;
        tankData.planned_quantity = currentTank?.quantity;
      }
    } else {
      if (isPlanned && isPlannedByOtherOps) {
        const plannedPomacesThisOperationQuantity =
          currentTank?.planned_pomaces?.find(
            (o) => Number(id) === o?.operation_id
          )?.quantity || 0;
        const plannedPomacesQuantity =
          currentTank?.planned_pomaces?.reduce((acc, curr) => {
            return acc + (Number(curr?.quantity) || 0);
          }, 0) || 0;

        tankData.planned_quantity = currentTank.quantity;
        tankData.quantity =
          currentTank?.planned_quantity -
          plannedPomacesQuantity +
          plannedPomacesThisOperationQuantity; // final quantity
        tankData.old_quantity = tankData.quantity + tankData.arrow_quantity;
        tankData.arrow_quantity += plannedPomacesThisOperationQuantity;
      } else {
        // const availability = isPlannedState ? tankData.planned_quantity : tankData.quantity;
        const pomaces_quantity = Number(operation?.pomaces?.[0]?.quantity) || 0;
        const pomaces_w_quantity =
          Number(operation?.pomaces?.[1]?.quantity) || 0;
        tankData.quantity =
          Number(tankData?.quantity) - pomaces_quantity - pomaces_w_quantity;
        tankData.arrow_quantity =
          Number(tankData?.arrow_quantity) +
          pomaces_quantity +
          pomaces_w_quantity;
      }
    }
  } else {
    if (isPlanned && isPlannedByOtherOps) {
      tankData.planned_quantity -= tankData.arrow_quantity;
      tankData.old_quantity =
        currentTank.quantity + tankData.quantity - tankData.arrow_quantity;
    } else {
      tankData.planned_quantity = 0;
      tankData.old_quantity = currentTank.quantity;
    }
  }

  // else if (["STABILIZATION_STATIC", "STABILIZATION_DYNAMIC"].includes(type) && is_src) {
  // }

  return tankData;
};

const isOperationError = (type, tanks, operationTank) => {
  // e.g., due to concurrent operation on the same dest tank
  const currentTank =
    tanks?.find((t) => t?.id === operationTank?.tank_id) || null;
  if (currentTank === null) return false;

  if (type === "AUTOMATIC") return false;

  if (currentTank?.is_planned)
    return (
      currentTank?.quantity + operationTank?.arrow_quantity >
      currentTank?.capacity
    );
  else if (currentTank?.is_planned_src)
    return currentTank?.quantity - operationTank?.arrow_quantity < 0;

  return false;
};

const CompleteWithDropInput = ({
  type,
  tank,
  register,
  errors,
  completed,
  setValue,
  getLabel,
  isDrop = true,
  watchedActual = {},
  validateActual,
}) => {
  const id = type === "CLOSING" ? tank?.close_id : tank?.tank_id;
  const inputUnit = getInputTankUnit();
  const plannedDisplay = litersToInput(tank?.arrow_quantity ?? tank?.quantity ?? 0, inputUnit);
  const currentActual = watchedActual?.[id];
  const caloValue = currentActual !== undefined && currentActual !== ''
    ? Number(plannedDisplay) - Number(currentActual)
    : 0;

  return (
    <>
      <Input
        name={`completed.${id}`}
        register={register}
        error={errors[`completed.${id}`]}
        required={getLabel("inputRequiredError")}
        isLabel={false}
        type={"checkbox"}
        checked={!!completed?.[id]}
        onClick={() => {
          setValue(`completed.${id}`, !completed?.[id]);
        }}
        customClassName={"confirm"}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            setValue(`completed.${id}`, !completed?.[id]);
          }
        }}
      />
      {!["AUTOMATIC", "TREATMENT", "ANALYSIS", "CLEANING"].includes(type) &&
        isDrop &&
        completed?.[id] && (
          <>
            <Input
              name={`actual.${id}`}
              isOk={false}
              defaultValue={plannedDisplay}
              customClassName="quantity"
              label={getLabel("operationActualQuantity", { unit: inputUnit })} 
              placeholder={getLabel("operationActualQuantityPlaceholder")} 
              tooltip={getLabel("operationActualQuantityTooltip")}
              register={register}
              error={errors[`actual`]?.[id]}
              required={getLabel("inputRequiredError")}
              type={"number"}
              min={{
                value: 0,
                message: getLabel("errorMinValue", { value: "0" }),
              }}
              regExpPattern={
                inputUnit === "hL"
                  ? { value: INT_FLOAT_REGEX, message: getLabel("errorIntFloat") }
                  : undefined
              }
              validate={validateActual}
            />
            {caloValue !== 0 && !errors[`actual`]?.[id] && (
              <div className="batch_lot_label">
                <span className={caloValue > 0 ? "loss" : "gain"}>
                  {caloValue > 0
                    ? `${getLabel("operationDropLabel")}: ${Math.abs(caloValue).toFixed(inputUnit === "hL" ? 2 : 0)} ${inputUnit}`
                    : `${getLabel("operationGainLabel")}: ${Math.abs(caloValue).toFixed(inputUnit === "hL" ? 2 : 0)} ${inputUnit}`}
                </span>
              </div>
            )}
          </>
        )}
    </>
  );
};

const TankOperationDetail = ({
  type,
  tank,
  operation,
  completed,
  drops = [],
  totalDrug = [],
  idx,
  role,
  tanks,
  lots,
  users,
  register,
  errors,
  setValue,
  getLabel,
  getValues,
  clearErrors,
  isSrc = false,
  isMobile = false,
  virtualTanks = null,
  isVirtualMode = false,
  isNextToExecute = false,
}) => {
  const bottleTypes = useSelector(selectBottleTypes);
  const inputUnit = getInputTankUnit();

  // Without pomaces, the total liters actually received can never exceed the
  // total planned withdrawal from the source(s) — a "gain" is only physically
  // possible for DESTEMMING/RACKING when pomace estimates shrink. Applies to
  // every wine-moving type where this ceiling makes sense: DESTEMMING, RACKING,
  // DECANT (1 source -> N destinations) and CUT (N sources -> 1 destination).
  // The pomace term is simply 0 when not applicable (empty reduce below).
  // Returns error message string if over, true if valid.
  const sourceQtyTotal = (operation?.src_tanks || []).reduce(
    (acc, st) => acc + (Number(st?.arrow_quantity ?? st?.old_quantity ?? st?.quantity) || 0),
    0
  );

  const hasSourceConstraint =
    getValues &&
    ["DESTEMMING", "RACKING", "DECANT", "CUT"].includes(type) &&
    sourceQtyTotal > 0;

  const validateActualQty = hasSourceConstraint
    ? (value) => {
        const sourceQty = sourceQtyTotal;
        const id = type === "CLOSING" ? tank?.close_id : tank?.tank_id;
        const destTotal = (operation.dest_tanks || []).reduce((acc, dt) => {
          if (String(dt?.tank_id) === String(id)) {
            return acc + inputToLiters(Number(value) || 0, inputUnit);
          }
          const raw = getValues(`actual.${dt?.tank_id}`);
          const plannedL = Number(dt?.arrow_quantity ?? dt?.quantity) || 0;
          return acc + (raw !== undefined && raw !== "" ? inputToLiters(Number(raw) || 0, inputUnit) : plannedL);
        }, 0);
        const pomaceTotal = (operation.pomaces || []).reduce((acc, p) => {
          const raw = getValues(`cellarman_pomaces.${p.waste_type}`);
          const plannedL = Number(p.quantity) || 0;
          return acc + (raw !== undefined && raw !== "" ? inputToLiters(Number(raw) || 0, inputUnit) : plannedL);
        }, 0);
        if (destTotal + pomaceTotal > sourceQty + 0.001) {
          return getLabel("errorMaxValue", { value: getLabel("errorMaxValueReached") });
        }
        // Valid: clear stale errors on all related fields (all cellarman_pomaces.* and all actual.*).
        if (clearErrors) {
          (operation.pomaces || []).forEach((p) => clearErrors(`cellarman_pomaces.${p.waste_type}`));
          (operation.dest_tanks || []).forEach((dt) => clearErrors(`actual.${dt?.tank_id}`));
        }
        return true;
      }
    : undefined;

  return (
    <div
      className="operation_info_container_row"
      key={`row-${isSrc ? "src" : "dest"}-${idx}`}
    >
      {type !== "BOTTLING" && (type !== "CLOSING" || isSrc) && (
        <div className={`tank_operation_wrapper${isVirtualMode ? " is_virtual" : ""}`}>
          {isVirtualMode && (
            <span className="tank_virtual_badge">{getLabel("simulated")}</span>
          )}
          <DestTankDetail
            // tank={getTankDactualizeSrcTankata(tank)}
            tank={actualizeDestTank(operation, tank, tanks, lots, drops, isSrc, virtualTanks, isVirtualMode, isNextToExecute)}
            // color={batchData?.color}
            // data={tank}
            // isDrop={operation?.completion_date !== null}
            isDrop={
              ["AUTOMATIC", "TREATMENT", "ANALYSIS", "CLEANING"].includes(type)
                ? false
                : operation?.completion_date !== null &&
                  type !== undefined &&
                  !isSrc
            } // trick for isSrc and BOTTLING to hide drop
            operation={operation}
            isCurrentStateOnly={[
              "AUTOMATIC",
              "TREATMENT",
              "ANALYSIS",
              "CLEANING",
            ].includes(type)}
            isFirst={
              idx === 0 &&
              !["AUTOMATIC", "TREATMENT", "ANALYSIS", "CLEANING"].includes(type)
            }
            isMobile={isMobile}
            isShowComposition={type !== "CLEANING"}
          ></DestTankDetail>
        </div>
      )}
      {type === "BOTTLING" && (
        <BottleIcon
          {...tank}
          volume={getLabel(`bottleVolume_${tank?.bottle_type}_Vol`)}
          isDetail={true}
          isName={true}
          composition={tank?.composition || []}
          bottleCount={getBottlesCount(
            0,
            [
              {
                quantity: tank?.quantity - (tank?.drop || 0),
                bottle_lot: { bottle_type: tank?.bottle_type },
              },
            ],
            bottleTypes
          )}
        />
      )}
      {type === "CLOSING" && !isSrc && (
        <CloseIcon data={tank} isDetail={true} />
      )}
      {operation?.completion_date === null &&
        isOperationError(type, tanks, tank) && (
          <div className="tank_error">
            <h5 className="alert_no_info">
              {getLabel("errorDestTankOperationQuantity")}
              <br></br>
              <br></br>
              {getLabel("errorModifyOperationQuantity")}
            </h5>
          </div>
        )}
      {(["DESTEMMING", "TREATMENT", "BOTTLING"].includes(type) ||
        (type === "AUTOMATIC" && operation?.type === "STABILIZATION_DYNAMIC") ||
        operation?.type === "ADD") &&
        totalDrug}
      {(role === ROLES.USER ||
        (role === ROLES.CLIENT &&
          users?.filter((u) => u?.type === "USER")?.length === 0)) &&
        !isOperationError(type, tanks, tank) &&
        operation?.completion_date === null &&
        !(type === "DESTEMMING" && operation?.subtype === "CRYO_MACERATION" && !operation?.start_date) &&
        ((type === "AUTOMATIC" && isSrc) ||
          !isSrc ||
          (type === "BOTTLING" && isSrc)) && (
          <CompleteWithDropInput
            type={type}
            tank={{
              ...tank,
              ...(type === "BOTTLING" && { tank_id: tank?.transfer_id }),
            }}
            register={register}
            errors={errors}
            completed={completed}
            isDrop={
              type === "FILTERING" && operation?.start_date === null
                ? false
                : true
            }
            setValue={setValue}
            getLabel={getLabel}
            watchedActual={drops}
            validateActual={validateActualQty}
          />
        )}
    </div>
  );
};

const TanksRow = ({
  type,
  field,
  srcBatchFieldArray,
  idx,
  src_lots,
  lots,
  state,
  tanks,
  control,
  errors,
  srcTankEnabledFieldArray,
  setSrcTankEnabledFieldArray,
  toggleSetStatusAll,
  getValues,
  setValue,
}) => {
  const [getLabel] = useLabels();
  const [key, setKey] = useState(field.id);

  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor("name", {
      header: getLabel("tankName"),
      cell: TableCell,
      meta: {
        isFilterDisabled: true,
      },
    }),
    columnHelper.accessor("batch_name", {
      header: getLabel("lotName"),
      cell: TableCell,
      meta: {
        isFilterDisabled: true,
      },
    }),
    columnHelper.accessor((row) => `${row?.quantity} L`, {
      header: getLabel("quantity"),
      cell: TableCell,
      meta: {
        isFilterDisabled: true,
      },
    }),
    columnHelper.display({
      header: getLabel("tankSelected"),
      id: "edit",
      cell: EditCell,
      meta: {
        isEditable: true,
        isOnlyManual: true,
      },
    }),
  ];

  const renderTable = (lot_id, filteredTanks) => {
    if (filteredTanks?.length > 0) {
      return (
        <div className="tank_row_wrapper">
          <div className="tanks_list_table">
            {/* <Table
              data={filteredTanks}
              prefix="analysisForm"
              customColumns={columns}
              isSearchBar={false}
            /> */}
            <Table
              defaultData={filteredTanks?.map((t) => {
                return { ...t, protocolType: "TANKS_PROTOCOL" };
              })}
              // setRows={setOperationsP}
              columns={columns}
              // errors={errors}
              // control={control}
              isEditable={true}
              isSearchBar={false}
              isLegend={false}
              getValues={getValues}
              setValue={setValue}
              type={"analysisForm"}
              // setModifyMode={setModifyMode}
              newRow={{}}
            />
          </div>
          <div className="buttons_wrapper">
            <button
              key={`select-${idx}`}
              onClick={(e) => {
                e.preventDefault();
                toggleSetStatusAll(lot_id, true);
                setKey((prevState) => {
                  return { key: prevState.key + 1 };
                });
              }}
              type="button"
              id={"selectAll-" + lot_id}
            >
              <span className="sub"></span>
              {getLabel("selectAll")}
            </button>
            <button
              key={`unselect-${idx}`}
              onClick={(e) => {
                e.preventDefault();
                toggleSetStatusAll(lot_id, false);
                setKey((prevState) => {
                  return { key: prevState.key + 1 };
                });
              }}
              type="button"
              id={"unselectAll-" + lot_id}
            >
              <span className="sub"></span>
              {getLabel("unselectAll")}
            </button>
          </div>
        </div>
      );
    }
  };

  const getLotData = (lot) => {
    // Build the lotData object
    const lotData = {};
    lotData.name = lot?.name || lot?.label || "";
    lotData.color = lot?.color;
    lotData.batch_type = lot?.batch_type;
    lotData.initial_quantity = lot?.initial_quantity; // Fixed initial capacity (e.g., 100 Kg)
    lotData.quantity = Number(lot?.quantity) || 0;
    lotData.planned_quantity = Number(lot?.planned_quantity) || 0;
    lotData.real_initial_quantity = Number(lot?.quantity) || 0;
    lotData.estimated_initial_quantity = Number(lot?.quantity) || 0;
    lotData.real_final_quantity = lot?.is_planned
      ? Number(lot?.planned_quantity) || 0
      : Number(lot?.quantity);
    lotData.estimated_final_quantity = Number(lot?.planned_quantity) || 0;
    lotData.is_planned =
      (Number(lot?.planned_quantity) || 0) < Number(lot?.quantity);
    lotData.composition = lot?.composition;

    return lotData;
  };

  return (
    <div key={field.id} className="operation_form_wrapper_row">
      {(
        lots?.filter(
          (lot) =>
            type === "ANALYSIS"
              ? ["GRAPE", "MUST", "WINE"].includes(lot?.state) &&
                lot.state === state
              : ["MUST", "WINE"].includes(lot?.state)
          // &&
          // !srcBatchFieldArray?.fields?.some?.(
          //   (field) => field.lotData?.value == lot.id
          // )
        ) || []
      )?.length === 0 && (
        <h5 className="alert_no_info">{getLabel("noValidLotsAlert")}</h5>
      )}
      {(
        lots?.filter(
          (lot) =>
            type === "ANALYSIS"
              ? ["GRAPE", "MUST", "WINE"].includes(lot?.state) &&
                lot.state === state
              : ["MUST", "WINE"].includes(lot?.state)
          // &&
          // !srcBatchFieldArray?.fields?.some?.(
          //   (field) => field.lotData?.value == lot.id
          // )
        ) || []
      )?.length > 0 && (
        <Select
          label={getLabel("operationLotName")}
          placeholder={getLabel("operationLotNamePlaceholder")}
          error={errors[`src_lots.${idx}`]}
          required={getLabel("inputRequiredError")}
          name={`src_lots.${idx}.lotData`}
          control={control}
          isSearchable={true}
          options={lots
            ?.filter(
              (lot) =>
                (type === "ANALYSIS"
                  ? ["GRAPE", "MUST", "WINE"].includes(lot?.state) &&
                    lot.state === state
                  : ["MUST", "WINE"].includes(lot?.state)) &&
                !srcBatchFieldArray?.fields?.some?.(
                  (field) => field.lotData?.value == lot.id
                )
            )
            ?.sort((a, b) => {
              // case insensitive
              return (a.name || "")?.localeCompare(b.name || "", undefined, {
                numeric: true,
                sensitivity: "base", // ignore upper/lowercase and accents
              });
            })
            ?.map?.((lot) => {
              return {
                value: lot?.id,
                initial_quantity: lot?.quantity,
                quantity: lot?.actual_quantity,
                planned_quantity: lot?.planned_quantity - (lot?.planned_pomaces
                  ?.reduce((acc, curr) => {
                  return acc + (Number(curr?.quantity) || 0);
                }, 0)) || 0,
                batch_type: lot?.batch_type,
                color: lot?.color,
                is_planned: lot?.is_planned,
                icon: lot?.is_planned 
                  ? "fa-calendar"
                  : null,
                label:
                  lot?.name +
                  (lot?.state === "GRAPE"
                    ? ` (${getLabel("lotState_GRAPE")})`
                    : ""),
                state: lot?.state,
                isTank: tanks.filter((t) => t.batch_id == lot.id)?.length > 0,
              };
            })}
        />
      )}
      {src_lots[idx]?.lotData?.value &&
        src_lots[idx]?.lotData?.state === "GRAPE" && (
          <DestLotDetail
            lot={getLotData(src_lots[idx]?.lotData)}
            isRecap={true}
            isDestemming={true}
            // isMobile={isMobile}
            isName={false}
            isAdditional={true}
          />
        )}
      {src_lots[idx]?.lotData?.value &&
        renderTable(
          src_lots[idx]?.lotData.value,
          tanks
            .filter(
              (t) =>
                ["GRAPE", "MUST", "WINE"].includes(t?.state) &&
                Number(t?.quantity > 0) &&
                t?.batch_name &&
                t.batch_id === src_lots[idx]?.lotData.value
            )
            ?.map((t) => ({
              id: t.id,
              name: t.name,
              quantity: t.quantity,
              batch_id: t.batch_id,
              batch_name: t.batch_name,
              idx: idx,
              enabled: srcTankEnabledFieldArray.includes(t.id) || false,
            }))
        )}
      {srcBatchFieldArray?.fields?.length > 1 && (
        <button
          onClick={(e) => {
            e.preventDefault();
            const tmpArray = srcTankEnabledFieldArray.filter(
              (el) =>
                !lots
                  .find(
                    (l) =>
                      l.id == srcBatchFieldArray?.fields[idx]?.lotData?.value
                  )
                  ?.tanks?.map((t) => t.tank_id)
                  .includes(el)
            );
            setSrcTankEnabledFieldArray(tmpArray);
            srcBatchFieldArray?.remove(idx);
          }}
        >
          -
        </button>
      )}
    </div>
  );
};

const LotOrTankOperationSelector = ({
  type,
  analysisType,
  control,
  register,
  errors,
  protocol_id,
  lots,
  tanks,
  src_lots,
  src_tanks,
  srcBatchFieldArray,
  srcTankFieldArray,
  srcTankEnabledFieldArray,
  setSrcTankEnabledFieldArray,
  getValues,
  setValue,
  getLabel,
  onlyTanks = false,
  setTotalTreatmentVolume,
}) => {
  const physicalPercentage = useWatch({
    name: "physical_percentage",
    control,
  });

  useEffect(() => {
    if (type === "TREATMENT") {
      const totalVolume = src_tanks?.reduce((acc, curr) => {
        return acc + (Number(curr?.tankData?.quantity) || 0);
      }, 0);
      setTotalTreatmentVolume(totalVolume);
    }
  }, [src_tanks]);

  const toggleSetStatusAll = (lot_id, enableStatus = false) => {
    const tank_ids =
      tanks
        ?.filter(
          (t) =>
            Number(t?.quantity) > 0 && t.batch_name && t.batch_id === lot_id
        )
        ?.map((t) => t.id) || [];

    for (const tank_id of tank_ids) {
      setValue(`edit.${tank_id}`, enableStatus);
    }

    // toggleTankEnabled(tank_ids, enableStatus);
  };

  const isTankAlreadyUsedInForm = (tank) => {
    return !src_tanks?.some?.((field) => field?.tankData?.value == tank?.id);
  };

  const filterTank = (tank) => {
    // return (tanks ?? []).filter((tank) => {
    if (type === "CLEANING") {
      // cleaning: only empty tanks or without a batch
      return !(tank?.is_planned && Number(tank?.planned_quantity) > 0) && (Number(tank?.quantity) === 0 || !tank?.batch_id);
    }

    if (type === "ANALYSIS") {
      // analysis: tanks with wine and matching state
      return Number(tank?.quantity) > 0 && tank?.state === protocol_id?.state;
    } else if (["WINEMAKING", "WINEMAKINGPOST"].includes(type)) {
      const state = type === "WINEMAKINGPOST" ? "WINE" : "MUST";

      return (
        Number(tank?.quantity) > 0 && tank?.state === state
        //  || Number(tank?.quantity) === 0
      );
    }

    // Operation-specific state filters based on OPERATION_VALID_STATES
    if (type === "DESTEMMING") {
      // GRAPE state tanks OR WINE state tanks with special maceration techniques
      const specialMacerationTechniques = [
        'FILM_MACERATION',
        'CRYO_MACERATION',
        'ROSE_MACERATION',
        'DIRECT_PRESSING',
        'ORANGE_WINE',
        'CARBONIC_MACERATION'
      ];
      const isWineWithSpecialMaceration =
        tank?.state === "WINE" &&
        tank?.vinification_technique &&
        specialMacerationTechniques.includes(tank.vinification_technique);

      return Number(tank?.quantity) > 0 && (
        tank?.state === "GRAPE" || isWineWithSpecialMaceration
      );
    }

    if (type === "TREATMENT") {
      // MUST or WINE state tanks with quantity > 0
      return Number(tank?.quantity) > 0 && ["MUST", "WINE"].includes(tank?.state);
    }

    if (type === "RACKING") {
      // MUST state tanks OR WINE state tanks with special maceration techniques
      const specialMacerationTechniques = [
        'FILM_MACERATION',
        'CRYO_MACERATION',
        'ROSE_MACERATION',
        'DIRECT_PRESSING',
        'ORANGE_WINE',
        'CARBONIC_MACERATION'
      ];
      const isWineWithSpecialMaceration =
        tank?.state === "WINE" &&
        tank?.vinification_technique &&
        specialMacerationTechniques.includes(tank.vinification_technique);

      return Number(tank?.quantity) > 0 && (
        tank?.state === "MUST" || isWineWithSpecialMaceration
      );
    }

    if (["CUT", "DECANT", "NEW_LOT", "ADD", "HOMOGENIZATION_MASS", "OXYGENATION"].includes(type)) {
      // MUST or WINE state tanks with quantity > 0
      return Number(tank?.quantity) > 0 && ["MUST", "WINE"].includes(tank?.state);
    }

    if (type === "BOTTLING") {
      // Only WINE state tanks with quantity > 0
      return Number(tank?.quantity) > 0 && tank?.state === "WINE";
    }

    if (type === "CLOSING") {
      // MUST, WINE, or BOTTLED state tanks with quantity > 0
      return Number(tank?.quantity) > 0 && ["MUST", "WINE", "BOTTLED"].includes(tank?.state);
    }

    if (
      [
        "STABILIZATION_STATIC",
        "STABILIZATION_DYNAMIC",
        "STABILIZATION_RESIN",
        "FILTERING",
      ].includes(type)
    ) {
      // Only WINE state tanks with quantity > 0
      return Number(tank?.quantity) > 0 && tank?.state === "WINE";
    }

    // default: tanks with >0 quantity
    return Number(tank?.quantity) > 0;
    // });
  };

  const isButtonDisabled = () => {
    // return true if there is already one empty tank form or all tanks are already selected
    const availableTanks = tanks
      ?.filter((tank) => isTankAlreadyUsedInForm(tank))
      ?.filter((tank) => filterTank(tank));
    const emptyRowsAlreadyAvailable =
      src_tanks?.filter((t) => !t?.tankData?.value)?.length > 0;

    return (
      emptyRowsAlreadyAvailable || availableTanks?.length === 0
      // || src_tanks?.length === availableTanks?.length
    );
  };

  // const isTankSelectable = (tank, idx = null) => {
  //   const alreadySelected = src_tanks
  //     ?.filter(t => t?.tankData?.value)
  //     ?.some((field, i) => {
  //     // Avoid comparing the field at the current index
  //     if (idx !== null && i === idx) return false;
  //     return field?.tankData?.value === tank?.id;
  //   });

  //   const isTankEligible = filterTank(tank);
  //     // type === "CLEANING"
  //     //   ? (Number(tank?.quantity) === 0 || !tank?.batch_id)
  //     //   : tank?.quantity > 0 &&
  //     //     (type === "ANALYSIS" ? tank.state === protocol_id?.state : true);

  //   return isTankEligible && !alreadySelected;
  // };

  const filteredTanks = useMemo(() => {
    return (
      tanks
        ?.filter((tank) => isTankAlreadyUsedInForm(tank))
        ?.filter((tank) => filterTank(tank)) ?? []
    );
  }, [tanks, protocol_id]);

  return (
    <>
      <h4>{getLabel("operationTanksConfiguration")}</h4>
      {!onlyTanks && (
        <div className="operation_form_wrapper_row vertical">
          <Select
            label={getLabel("operationAnalysisTypeName")}
            placeholder={getLabel("operationAnalysisTypeNamePlaceholder")}
            error={errors}
            name="analysisType"
            control={control}
            required={getLabel("inputRequiredError")}
            options={[
              {
                label: getLabel("lot"),
                value: "lot",
              },
              {
                label: getLabel("tank"),
                value: "tank",
              },
            ]?.filter((o) =>
              protocol_id?.state === "GRAPE" ? o.value === "lot" : true
            )}
            tooltip={getLabel(
              type === "CLEANING"
                ? "analysisSourceTankTooltip"
                : "analysisSourceTypeTooltip"
            )}
          />
          {analysisType?.value === "lot" && (
            <>
              {srcBatchFieldArray?.fields?.map?.((field, idx) => {
                return (
                  <TanksRow
                    type={type}
                    field={field}
                    idx={idx}
                    src_lots={src_lots}
                    srcTankEnabledFieldArray={srcTankEnabledFieldArray}
                    setSrcTankEnabledFieldArray={setSrcTankEnabledFieldArray}
                    srcBatchFieldArray={srcBatchFieldArray}
                    tanks={tanks}
                    lots={lots}
                    state={protocol_id?.state}
                    errors={errors}
                    control={control}
                    toggleSetStatusAll={toggleSetStatusAll}
                    getValues={getValues}
                    setValue={setValue}
                  />
                );
              })}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  srcBatchFieldArray?.append({
                    lotData: {
                      value: null,
                      label: null,
                    },
                  });
                }}
              >
                +
              </button>
            </>
          )}
        </div>
      )}
      {(onlyTanks || analysisType?.value === "tank") && (
        <>
          <div className="operation_form_wrapper_row vertical">
            {(filteredTanks?.length === 0 && !src_tanks?.some?.((f) => f?.tankData?.value)) &&
              <h6 className="protocols_alert_title">
                {getLabel("noValidTanksAlert")}
              </h6>}
            {srcTankFieldArray?.fields?.map?.((field, idx) => {
              return (
                <div key={field.id} className="operation_form_wrapper_row">
                  {(filteredTanks?.length > 0) && <Select
                    label={getLabel("operationSrcTankName")}
                    placeholder={getLabel("operationSrcTanksPlaceholder")}
                    error={errors}
                    required={getLabel("inputRequiredError")}
                    name={`src_tanks.${idx}.tankData`}
                    isSearchable={true}
                    isDisabled={type !== "PHYSICAL" && !protocol_id?.value}
                    control={control}
                    options={tanks
                      ?.filter((tank) => isTankAlreadyUsedInForm(tank))
                      ?.filter((tank) => filterTank(tank))
                      ?.map((tank) => ({
                        ...tank,
                        ...(type === "CLEANING" && {
                          is_disabled: tank?.is_sanitized,
                        }),
                      }))
                      // ?.filter((tank) => isTankSelectable(tank, idx))
                      ?.sort((a, b) => {
                        // case insensitive
                        return (a.name || "")?.localeCompare(
                          b.name || "",
                          undefined,
                          {
                            numeric: true,
                            sensitivity: "base", // ignore upper/lowercase and accents
                          }
                        );
                      })
                      ?.map((tank) => {
                        return {
                          ...tank,
                          value: tank?.id,
                          label: tank.name,
                          name:
                            tank?.name +
                            ` (${
                              lots?.find((lot) => lot?.id === tank?.batch_id)
                                ?.name || getLabel("tankState_EMPTY")
                            })`,
                          quantity: tank.quantity,
                          capacity: tank.capacity,
                          batch_type:
                            tank?.batch_type || tank?.planned_batch_type,
                          color: tank.color,
                          lot: tank.batch_name,
                          lot_id: tank?.batch_id || "",
                        };
                      })}
                    tooltip={
                      idx === 0 ? getLabel("analysisSourceTankTooltip") : ""
                    }
                  />}
                  {src_tanks?.[idx]?.tankData?.value && (
                    <div className="tank_quantity_info">
                      <TankIcon
                        tank={{
                          ...src_tanks?.[idx]?.tankData,
                          name: src_tanks?.[idx]?.tankData?.label,
                        }}
                        isArrowQuantity={false}
                      />
                      {protocol_id?.protocol_subtype ===
                        "STABILIZATION_RESIN" && (
                        <Input
                          customClassName="quantity"
                          // name="physical_percentage"
                          name={`physical_percentage.${idx}`}
                          register={register}
                          type="number"
                          label={getLabel("operationPhysicalTreatmentPerc")}
                          placeholder={getLabel(
                            "operationPhysicalTreatmentPercPlaceholder"
                          )}
                          min={{
                            value: 1,
                            message: getLabel("errorMinValue", { value: 1 }),
                          }}
                          max={{
                            value: 100,
                            message: getLabel("errorMaxValue", { value: 100 }),
                          }}
                          regExpPattern={{
                            value: INT_REGEX,
                            message: getLabel("errorInt"),
                          }}
                          error={errors?.physical_percentage?.[idx]}
                          tooltip={getLabel(
                            "operationPhysicalTreatmentPercTooltip"
                          )}
                        />
                      )}
                      {protocol_id?.protocol_subtype ===
                        "STABILIZATION_RESIN" && (
                        <p className="total_liters">
                          {(() => {
                            const perc = Number(physicalPercentage?.[idx]) || 0;
                            const valid = perc > 0 && perc <= 100;
                            return valid
                              ? `${(
                                  (Number(
                                    src_tanks?.[idx]?.tankData?.quantity
                                  ) *
                                    perc) /
                                  100
                                )?.toFixed(0)} L`
                              : "";
                          })()}
                        </p>
                      )}
                    </div>
                  )}
                  {srcTankFieldArray?.fields?.length > 1 && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        srcTankFieldArray?.remove(idx);

                        // if it's a STABILIZATION_RESIN protocol, remove the corresponding percentage
                        if (
                          protocol_id?.protocol_subtype ===
                          "STABILIZATION_RESIN"
                        ) {
                          const current =
                            getValues("physical_percentage") || [];
                          const updated = current.filter((_, i) => i !== idx);
                          setValue("physical_percentage", updated);
                        }
                      }}
                    >
                      -
                    </button>
                  )}
                </div>
              );
            })}
            {filteredTanks?.length > 0 && <button
              onClick={(e) => {
                e.preventDefault();
                srcTankFieldArray?.append({
                  tankData: {},
                });
              }}
              disabled={isButtonDisabled()}
              // disabled={tanks?.some((tank) => isTankSelectable(tank))}
            >
              +
            </button>}
          </div>
        </>
      )}
    </>
  );
};

const ContextMenu = ({ pos, items, onClose, onOpen }) => {
  const navigate = useNavigate();
  const didOpenRef = useRef(false);

  // Call onOpen only once when menu opens
  useEffect(() => {
    if (pos && !didOpenRef.current) {
      if (onOpen) onOpen();
      didOpenRef.current = true;
    }
    if (!pos) {
      didOpenRef.current = false; // reset when menu closes
    }
  }, [pos, onOpen]);

  if (!pos) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: pos.y,
        left: pos.x,
        background: "white",
        borderRadius: "8px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        minWidth: "160px",
        zIndex: 9999,
        overflow: "hidden",
      }}
    >
      {items.map((item, index) => (
        <div
          key={index}
          onClick={() => {
            navigate(item.path);
            onClose();
          }}
          style={{
            padding: "10px 14px",
            cursor: "pointer",
            fontSize: "14px",
            borderBottom: index !== items.length - 1 ? "1px solid #eee" : "",
            background: "white",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "rgb(243, 239, 245)";
            e.currentTarget.style.background = "rgb(100, 36, 46)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "#060b0f";
            e.currentTarget.style.background = "rgb(243, 239, 245)";
          }}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

const PomacesDestination = ({
  id,
  type,
  operation,
  watch,
  trigger,
  dest_tanks,
  tank_id_in,
  register,
  control,
  errors,
  clearErrors,
  getLabel,
  getValues,
  setValue,
  pomacesRecipients,
  setPomacesRecipients,
  isWhite = false,
  baseName = "dest_tanks",
}) => {
  const pomacesName = `pomaces${isWhite ? "W" : ""}`;
  const inputUnit = getInputTankUnit();
  const { auth } = useAuth();
  const currencySymbol = getCurrencySymbol(getCurrencyCode(auth?.user));
  const isQuantityDisabled =
    !Array.isArray(dest_tanks) ||
    dest_tanks?.length === 0 ||
    !dest_tanks?.[0]?.quantity;

  // computePomacesStatus ragiona in litri: normalizziamo i valori dal form.
  const pomacesStatus = computePomacesStatus({
    type,
    tank_id_in,
    dest_tanks: dest_tanks?.map?.((d) => ({
      ...d,
      quantity: inputToLiters(d?.quantity, inputUnit),
    })),
    pomaces: inputToLiters(getValues("pomaces.quantity") || 0, inputUnit),
    pomacesW: inputToLiters(getValues("pomacesW.quantity") || 0, inputUnit),
    value: inputToLiters(watch(`${pomacesName}.quantity`) || 0, inputUnit),
    isWhite: isWhite,
    isPomaces: true,
  });

  const isPomacesWarning = pomacesStatus?.isWarning;

  const pomacesWarningMessage = isPomacesWarning
    ? getLabel(
        pomacesStatus.reason === "UNDER_MIN"
          ? "errorMinValueWarning"
          : "errorMaxValueWarning",
        {
          // min/max sono in litri: mostriamoli nell'unità dell'input
          value: litersToInput(
            pomacesStatus.reason === "UNDER_MIN"
              ? pomacesStatus.min
              : pomacesStatus.max,
            inputUnit
          ),
        }
      )
    : "";

  // useEffect(() => {
  //   if (!tank_id_in?.value) return;
  //   const pomaces = Number(getValues("pomaces.quantity") || 0);
  //   const pomacesW = Number(getValues("pomacesW.quantity") || 0);
  //   const input_tank = { ...tank_id_in };

  //   if (type === "DESTEMMING" || type === "RACKING") {
  //    const { lotAvailability } = computePlannedLotAvailability({
  //       tank: tank_id_in,
  //       operationId: id,
  //     });

  //     input_tank.quantity = lotAvailability;
  //   }

  //   const value = Number(getValues(`${pomacesName}.quantity`) || 0);
  //   const status = computePomacesStatus({
  //     type,
  //     tank_id_in: input_tank,
  //     dest_tanks,
  //     pomaces: pomaces,
  //     pomacesW: pomacesW,
  //     value,
  //     isWhite,
  //     isPomaces: true,
  //   });

  //   setIsWarning(status.isWarning && !status.isError);
  // }, [dest_tanks, getValues, isWhite]);

  const handleCreateOption = (newCreatableOption = {}) => {
    if (newCreatableOption?.value && newCreatableOption?.label)
      setPomacesRecipients((prev) => [...prev, newCreatableOption]);
  };

  const getPomacesReasonOptions = () => {
    const reasons = [
      "SKIN", // bucce
      "STEM", // raspi
      "POMACE", // vinacce
      "LIQUID", // discarded / waste
    ];

    return (
      reasons?.map((o) => ({
        value: o,
        label: getLabel(`pomaceReason_${o}`),
      })) || []
    );
  };

  const getPomacesOptions = () => {
    const noFieldPomaces =
      pomacesRecipients?.filter((p) => p?.is_field === false) || [];
    const newPomacesRecipients =
      noFieldPomaces?.filter((p) => p?.is_new === true) || [];
    const existingPomacesRecipients =
      noFieldPomaces?.filter((p) => p?.is_new !== true) || [];

    return [
      {
        value: -1,
        label: getLabel("pomaceOption_FIELD"),
        is_field: true,
      },

      ...(newPomacesRecipients?.length > 0 ? newPomacesRecipients : []), // when DESTEMMING, both SKIN and STEM can create new options

      ...Array.from(
        new Map(
          existingPomacesRecipients.map((pomace) => [
            pomace.recipient,
            {
              value: pomace.id,
              label: pomace.recipient,
            },
          ])
        ).values()
      ),
    ];
  };

  const pomacesReasonValue = watch(`${pomacesName}.reason`)?.value || "POMACE";
  const destNameLabel = getLabel(`operationPomaceDestination_${pomacesReasonValue}`) || getLabel("operationDestPomacesName");

  return (
    <>
      <h5>
        {getLabel(
          isWhite
            ? type === "DESTEMMING"
              ? "operationSkins"
              : "operationStems"
            : type === "DESTEMMING"
              ? "operationStems"
              : "operationPomaces"
        )}
      </h5>
      <div className="operation_form_wrapper_row">
        <div className="new_batch_name_wrapper">
          <Select
            isDisabled={!tank_id_in?.value}
            error={errors}
            label={destNameLabel}
            placeholder={getLabel("operationDestPomacesNamePlaceholder")}
            required={getLabel("inputRequiredError")}
            name={`${pomacesName}.dest`}
            control={control}
            isSearchable={true}
            isCreatable={true}
            options={getPomacesOptions()}
            customClassName="new_batch_name_fix_margin"
            pattern={{
              value: NUM_ALPHA_SPACE_APEX_DOT_ALL_LEN_REGEX,
              message: getLabel("errorAlphaSpaceApexNum"),
            }}
            onCreateOption={handleCreateOption}
          />
          <Input
            name={`${pomacesName}.quantity`}
            isOk={false}
            forceWarningChange={true}
            register={register}
            type="number"
            customClassName="quantity"
            label={getLabel(`operationPomacesQuantity`)}
            placeholder={getLabel(
              type === "DESTEMMING"
                ? "operationStemsQuantityPlaceholder"
                : "operationPomacesQuantityPlaceholder"
            )}
            error={errors?.[pomacesName]?.quantity}
            isDisabled={!tank_id_in?.value || isQuantityDisabled}
            // isWarning={isPomacesWarning}
            // warningMessage={pomacesWarningMessage}
            required={getLabel("inputRequiredError")}
            // min={{
            //   value: 1,
            //   message: getLabel("errorMinValue", { value: 1 }),
            // }}
            regExpPattern={{
              value: getInputQtyRegex(inputUnit),
              message: getLabel(inputUnit === "hL" ? "errorIntFloat" : "errorInt"),
            }}
            validate={(value) => {
              return checkTransferAvailableQuantity(
                id,
                -1,
                type,
                null,   // subtype,
                tank_id_in,
                dest_tanks,
                value,
                baseName,
                getValues,
                getLabel,
                clearErrors,
                trigger,
                true, // isPomaces
                isWhite ? "pomacesW" : "pomaces"
              );
            }}
            tooltip={getLabel(
              type === "DESTEMMING"
                ? "operationStemsQuantityTooltip"
                : "operationPomacesQuantityTooltip"
            )}
          />
          <Input
            name={`${pomacesName}.cost`}
            customClassName="quantity"
            isOk={false}
            error={errors?.[pomacesName]?.cost}
            register={register}
            type="number"
            isDisabled={!tank_id_in?.value}
            label={getLabel("operationDestPomacesCost")}
            placeholder={getLabel("drugBatchUnitCostPlaceholder", {
              currency: currencySymbol,
              unit: getValues("unit")?.label,
            })}
            // required={getLabel("inputRequiredError")}
            min={{
              value: 0,
              message: getLabel("errorMinValue", { value: 0 }),
            }}
            regExpPattern={{
              value: INT_FLOAT_REGEX,
              message: getLabel("errorIntFloat"),
            }}
          />
          <OptionalNoteRow
            idx={null}
            register={register}
            errors={errors}
            baseName={pomacesName}
            getLabel={getLabel}
            isDisabled={!tank_id_in?.value}
            setValue={setValue}
            isUpdate={Boolean(id)}
            notes={getValues(pomacesName)?.close_notes || ""}
          />
          {/* <Input
          name={"pomaces_dest"}
          register={register}
          isDisabled={!tank_id_in?.quantity}
          type="text"
          label={getLabel("operationPomacesDestination")}
          placeholder={getLabel(
            "operationPomacesDestinationPlaceholder"
          )}
          errors={errors["pomaces_dest"]}
          minLength={{
            value: 3,
            message: getLabel("errorMinLength", { value: 3 }),
          }}
          maxLength={{
            value: 24,
            message: getLabel("errorMaxLength", { value: 24 }),
          }}
          regExpPattern={{
            value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
            message: getLabel("errorAlphaNumSpace_-"),
          }}
          tooltip={getLabel("destemmingPomacesTooltip")}
        /> */}
        </div>
      </div>
    </>
  );
};

const DrugsBatchSelectorTable = ({
  id,
  type,
  title = "",
  operation,
  isSelectDisabled,
  protocol_id,
  configs,
  protocols = [],
  drugs = [],
  units = [],
  reset,
  errors,
  control,
  register,
  setValue,
  setError,
  getValues,
  totalTreatmentVolume = 0,
  isBatchSelectorModal,
  drugBatchFieldArray,
  protocol,
  setProtocol,
  setIsBatchSelectorModal,
  validateSteps,
  setParentOperationsP,
  getLabel,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModifyMode, setIsModifyMode] = useState(-1);
  const [operationsP, setOperationsP] = useState([]);
  const [isAutomaticAssignment, setIsAutomaticAssignment] = useState(false);
  const [isEnoughStock, setIsEnoughStock] = useState(false);
  // const [checkbox, setCheckbox] = useState(false);
  
  const { column } = useWatch({ control });
  const protocol_subtype = useWatch({ control, name: "protocol_subtype" });
  
  const isWineMakingApplication = !["DESTEMMING", "BOTTLING"].includes(type);

  const winemakingPType =
    type === "CLEANING"
      ? "CIP"
      : type === "PHYSICAL"
      ? type
      : type === "WINEMAKINGPOST"
      ? "POST"
      : "PRE";

  const {
    register: modalRegister,
    reset: modalReset,
    handleSubmit: modalHandleSubmit,
    formState: { errors: modalErrors },
    setValue: modalSetValue,
    getValues: modalGetValues,
    setError: modalSetError,
    clearErrors: modalClearErrors,
    control: modalControl,
  } = useForm({
    defaultValues: {
      drug_batches_tmp: [{ value: null, label: null }],
      // day: protocol?.ay || "",
      // phase: protocol?.phase || "",
      // operation: protocol?.operation || "",
    },
    mode: "onTouched",
  });

  const drugBatchesFieldArrayTmp = useFieldArray({
    control: modalControl,
    name: "drug_batches_tmp",
  });

  // refs
  const debounceRef = useRef(null);
  const lastVolumeRef = useRef(null);
  const prevProtocolIdRef = useRef(null);
  const isInitializedRef = useRef(false);

  const getProtocolName = (p) => {
    const protocolSubtype =
      p?.protocol_subtype === "STABILIZATION_RESIN"
        ? getLabel("physicalProtocol_STAB") +
          " " +
          getLabel("physicalProtocolSTABILIZATION_RESIN")
        : p?.stabilization_type === "STABILIZATION_COLD"
        ? getLabel(`protocolOperation_${p?.protocol_subtype}`)?.toLowerCase() +
          " " +
          // getLabel(`physicalProtocol${p?.protocol_subtype}`) +
          // " - " +
          getLabel(`physicalProtocol${p?.stabilization_type}String`)
        : getLabel("physicalProtocol_FILTRATION");

    return p?.name + ` (${protocolSubtype?.toLowerCase?.()})`;
  };

  /**
   * 🔹 Update assigned drug batches when quantity changes
   */
  // Merge user-edited column quantities into ops. Used by handleAutoAssignment
  // and the volume useEffect so they always use the confirmed-or-typed quantity,
  // not just the original protocol default stored in operationsP.
  const applyColumnOverrides = (ops) =>
    ops.map((op) => {
      const substanceId = op.substance_id;
      const direct = column?.[substanceId];
      let rawVal = direct?.new ?? direct?.value;
      if (rawVal == null) {
        const suffixedKey = Object.keys(column || {}).find(
          (k) => String(k).split("_")[0] === String(substanceId)
        );
        if (suffixedKey) rawVal = column[suffixedKey]?.new ?? column[suffixedKey]?.value;
      }
      const editedQty = Number(rawVal);
      return editedQty > 0 ? { ...op, quantity: editedQty } : op;
    });

  const updateAssignedDrugBatches = (substance_id, newQty = null, latestOps = null) => {
    if (!substance_id) return;
    const opsToUse = latestOps ?? operationsP;
    if (!opsToUse?.length) return;

    // Use 'new' if exists, otherwise fallback to 'value'. The quantity input registers
    // under `column.<substance_id>_<rowKey>.value`, so also look for a suffixed key.
    const direct = column?.[substance_id];
    let rawColVal = direct?.new ?? direct?.value;
    if (rawColVal == null) {
      const suffixedKey = Object.keys(column || {}).find(
        (k) => String(k).split("_")[0] === String(substance_id),
      );
      if (suffixedKey) rawColVal = column[suffixedKey]?.new ?? column[suffixedKey]?.value;
    }
    const newQuantity = newQty ? Number(newQty) : Number(rawColVal) || 0;

    if (!newQuantity || Number(newQuantity) <= 0) {
      return;
    }

    // 1️⃣ genera stato temporaneo. Assicura che la sostanza abbia i batches del
    // magazzino a livello top (assignDrugBatches filtra su o.batches), così il
    // ricalcolo funziona anche quando ops li espone solo sotto product.batches.
    const tmpOperationsP = opsToUse.map((o) => {
      if (o.substance_id !== Number(substance_id)) return o;
      const topBatches =
        o?.batches?.length > 0
          ? o.batches
          : drugs?.find((d) => d?.id === o?.substance_id)?.batches || [];
      return {
        ...o,
        batches: topBatches,
        quantity: newQuantity,
        product: {
          ...o?.product,
          quantity: newQuantity,
        },
      };
    });

    // 2️⃣ aggiorna operationsP quando chiamato standalone (non da updateWinemakingTableData)
    // Questo mantiene operationsP sincronizzato con le quantità editate dall'utente,
    // così handleAutoAssignment e il volume useEffect usano sempre i valori corretti.
    if (!latestOps) {
      setOperationsP(tmpOperationsP);
      if (isWineMakingApplication) {
        setParentOperationsP(tmpOperationsP);
      }
    }

    // Re-assign when: explicitly triggered (winemaking ops update), automatic
    // assignment is on, OR this substance already has drug_batches selected
    // (changing its quantity must recompute those batch quantities).
    const existingBatches = getValues("drug_batches")?.[substance_id];
    const hasExistingBatches =
      Array.isArray(existingBatches) && existingBatches.length > 0;
    if (latestOps !== null || isAutomaticAssignment || hasExistingBatches) {
      assignDrugBatches(
        tmpOperationsP,
        totalTreatmentVolume,
        drugBatchFieldArray,
        getLabel,
        null,
        true,
        setValue
      );
    }
  };

  /**
   * 🔹 Ricalcolo automatico drug batches al cambio volume
   */
  useEffect(() => {
    if (isSelectDisabled) return;
    if (!isAutomaticAssignment) return;
    if (Number(totalTreatmentVolume) <= 0) return;
    if (!operationsP?.length) return;
    if (!isInitializedRef.current) return;

    // evita doppio trigger
    if (lastVolumeRef.current === totalTreatmentVolume) return;
    lastVolumeRef.current = totalTreatmentVolume;

    // clear debounce precedente
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    // skip primo render (es. quando aggiungi un tank)
    if (
      drugBatchFieldArray.fields?.length === 0 ||
      (drugBatchFieldArray.fields?.length === 1 &&
        drugBatchFieldArray.fields?.[0]?.value === null)
    ) {
      return;
    }

    debounceRef.current = setTimeout(() => {
      // Apply column overrides so volume-triggered re-assignment uses the
      // user-edited quantities, not the original protocol defaults.
      const opsWithOverrides = isWineMakingApplication
        ? operationsP
        : applyColumnOverrides(operationsP);
      assignDrugBatches(
        opsWithOverrides,
        totalTreatmentVolume,
        drugBatchFieldArray,
        getLabel,
        null,
        true,
        setValue
      );
    }, 400); // UX-friendly

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [totalTreatmentVolume, isAutomaticAssignment, operationsP, isSelectDisabled]);

  /**
   * 🔹 Gestione protocol change / init operations
   */
  useEffect(() => {
    if (!protocol_id?.value) return;

    const prevProtocolId = prevProtocolIdRef.current;
    const currentProtocolId = protocol_id.value;
    const protocolChanged =
      prevProtocolId !== null && prevProtocolId !== currentProtocolId;

    prevProtocolIdRef.current = currentProtocolId;
    
    // ===========================
    // 🔸 NON WINE MAKING
    // ===========================
    if (!isWineMakingApplication) {
      // 🔹 EDIT + protocol invariato → usa trattamenti esistenti
     const hasSavedTreatments =
      Array.isArray(operation?.treatments) &&
      operation.treatments.length > 0;

    if (id && !protocolChanged && hasSavedTreatments) {
      // 🔹 USA I TREATMENTS DAL DB
      const tmpOps = [];
      const seenSubstanceId = new Set();

      for (const s of operation.treatments) {
        const substance_id = s?.substance_id;
        if (!substance_id || seenSubstanceId.has(substance_id)) continue;

        seenSubstanceId.add(substance_id);

        const drug = drugs?.find((d) => d?.id === substance_id);

        tmpOps.push({
          ...s,
          product: substance_id,
          product_name: s?.substance_name,
          opType: "PROTOCOL",
          operation: s?.operation || s?.type,
          min_range: drug?.min_range,
          max_range: drug?.max_range,
          batches: s?.drug_batches || [],
        });
      }

      setOperationsP(tmpOps);
      isInitializedRef.current = true;
      return;
    }

      // 🔹 protocol cambiato → OVERRIDE
      const ops =
        [...(protocol_id?.drugs || [])].map((op) => {
          const drug = drugs?.find((d) => d?.id === op?.substance_id);

          const product =
            drug && {
              ...drug,
              batches: drug?.drug_batches || [],
              value: drug.id,
              label: `${drug.substance_name}${
                drug.unit ? ` (${drug.unit})` : ""
              }`,
            };

          return {
            ...op,
            value: op?.substance_id || op?.product,
            product,
            unit_id: drug?.unit_id,
            opType: "PROTOCOL",
          };
        }) || [];

      setOperationsP(ops);

      isInitializedRef.current = true;
      return;
    }

    // ===========================
    // 🔸 WINE MAKING
    // ===========================
    if (
      [
        "CLEANING",
        "PHYSICAL",
        "STABILIZATION_STATIC",
        "STABILIZATION_DYNAMIC",
        "STABILIZATION_RESIN",
      ].includes(type) &&
      id
    ) {
      const ops =
        [...(operation?.treatments || [])]
          ?.sort((a, b) => Number(a?.day) - Number(b?.day))
          ?.map((s) => ({
            ...s,
            product: s?.substance_id,
            product_name: s?.substance_name,
            opType: "WINEMAKINGPROTOCOL",
            operation: s?.operation || s?.type,
          })) || [];

      setOperationsP(ops);
      isInitializedRef.current = true;
      return;
    }

    const selectedProtocol = protocols?.find(
      (p) => p.id === protocol_id?.value
    );
    if (selectedProtocol) setProtocol(selectedProtocol);

    const ops =
      [...(selectedProtocol?.operations || [])]
        ?.sort((a, b) => Number(a?.day) - Number(b?.day))
        ?.map((op) => {
          const drug = drugs?.find(
            (d) => d?.id === (op?.substance_id || op?.product)
          );

          const product =
            drug && {
              ...drug,
              value: drug.id,
              label: `${drug.name}${drug.unit ? ` (${drug.unit})` : ""}`,
              quantity: op?.quantity,
            };

          return {
            ...op,
            value: op?.substance_id || op?.product,
            product,
            quantity: op?.quantity,
            batches: drug?.batches || [],
            opType: "WINEMAKINGPROTOCOL",
          };
        }) || [];

    setOperationsP(ops);
    setParentOperationsP(ops);
    isInitializedRef.current = true;
  }, [protocol_id?.value, id]);

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor((row) => row?.substance_name || "", {
      header: getLabel("drugName"),
      cell: TableCell,
      meta: {
        type: "text",
        isFilterDisabled: true,
      },
    }),
    columnHelper.accessor(
      (row) =>
        row?.type ? getLabel(`drugType_${row.type?.toUpperCase()}`) : "",
      {
        header: getLabel("drugType"),
        cell: TableCell,
        meta: {
          type: "text",
          isFilterDisabled: true,
        },
      }
    ),
    columnHelper.accessor(
      (row) =>
        row?.recommended_quantity
          ? `${row?.recommended_quantity} ${row?.unit || ""}`
          : "",
      {
        header: getLabel("drugIdealQuantity"),
        cell: TableCell,
        meta: {
          isFilterDisabled: true,
        },
      }
    ),
    columnHelper.accessor(
      (row) =>
        `${(row?.min_range == null || isNaN(row?.min_range)) ? "n/a" : row?.min_range} - ${
          (row?.max_range == null || isNaN(row?.max_range)) ? "n/a" : row?.max_range
        } ${row?.unit || ""}`,
      {
        header: getLabel("substanceRange"),
        cell: TableCell,
        meta: {
          type: "number",
          isFilterDisabled: true,
        },
      }
    ),
    columnHelper.accessor("quantity", {
      //(row) => `${row?.quantity || ""}`, {
      header: getLabel("drugQuantity"),
      cell: TableCell,
      meta: {
        type: "number",
        editable: true,
        isFilterDisabled: true,
        customClassName: "highlight",
        regExpPattern: INT_FLOAT_REGEX,
        register: register,
        additional: "unit",
      },
    }),
    columnHelper.accessor("batch_row", {
      header: getLabel("drugBatchNumber"),
      cell: TableCell,
      meta: {
        type: "select",
        control: control,
        editable: true,
        isFilterDisabled: true,
        dateFormat: configs?.shortDateFormat,
        options: drugs,
        options2: getValues("drug_batches") || [],
      },
    }),
    columnHelper.display({
      id: "edit",
      cell: EditCell,
      meta: {
        isEditable: true,
        function_type: "CONFIRM",
        onConfirm: updateAssignedDrugBatches,
      },
    }),
  ];

  const computeAddOpTypeString = (row) => {
    if (row?.treatments?.length > 1) {
      return getLabel(`operationType${row.type}`);
    }
    const protocol_type = row?.functional || null;
    const subtype = protocol_type
      ? getLabel(`drugLabelGroup_${protocol_type}`)
      : null;
    return `${getLabel(`protocolType_${row.operation}`)} ${
      subtype ? "(" + subtype?.toLowerCase?.() + ")" : ""
    }`;
  };

  const winemakingColumns = [
    columnHelper.accessor(
      (row) => row?.day + (row?.day_to ? ` - ${row?.day_to}` : ""),
      {
        header: getLabel(type === "CIP" ? "protocolStep" : "protocolDay"),
        cell: TableCell,
        meta: {
          type: "number",
          register: modalRegister,
          isFilterDisabled: true,
        },
      }
    ),
    ...(type !== "CIP" && type !== "CLEANING"
      ? [
          columnHelper.accessor(
            (row) => (row?.phase ? getLabel(`protocolPhase_${row.phase}`) : ""),
            {
              header: getLabel("protocolPhase"),
              cell: TableCell,
              // meta: {
              //   type: "text",
              // },
              meta: {
                // type: "select",
                isFilterDisabled: true,
                options: [
                  // { value: "Computer Science", label: "Computer Science" },
                  // { value: "Communications", label: "Communications" },
                  // { value: "Business", label: "Business" },
                  // { value: "Psychology", label: "Psychology" },
                ],
              },
            }
          ),
        ]
      : []),
    columnHelper.accessor(
      (row) =>
        row?.operation
          ? row.operation === "ADD"
            ? computeAddOpTypeString(row)
            : getLabel(`protocolOperation_${row.operation}`)
          : "",
      {
        header: getLabel("protocolOperation"),
        cell: TableCell,
        meta: {
          type: "text",
          register: modalRegister,
          isFilterDisabled: true,
        },
      }
    ),
    columnHelper.accessor(
      (row) =>
        row?.operation === "SO2"
          ? ""
          : row.operation === "RINSE" || row.operation === "VAPORIZATION"
          ? getLabel("protocolProduct_H2O")
          : row?.product?.name || row?.product_name || "",
      {
        header: getLabel("protocolProduct"),
        cell: TableCell,
        meta: {
          type: "text",
          register: modalRegister,
          isFilterDisabled: true,
        },
      }
    ),

    columnHelper.accessor(
      (row) =>
        row?.quantity
          ? row.operation === "RINSE" || row.operation === "VAPORIZATION"
            ? ""
            : row?.operation === "CLEANING"
            ? `${row?.quantity} %`
            : row?.protocol_type === "HOMOGENIZATION_TEMP"
            ? `${row?.quantity} \u00b0C`
            : (row?.quantity || 0) +
              " " +
              (row?.operation === "OXYGENATION"
                ? getLabel("protocolOxygenationNoDose")
                : row?.product?.unit || row?.product_unit || "")
          : "",
      {
        header: getLabel(
          type !== "CLEANING" ? "protocolQuantity" : "protocolConcentration"
        ),
        cell: TableCell,
        meta: {
          type: "number",
          // editable: true,
          isFilterDisabled: true,
          // customClassName: "highlight",
          // regExpPattern: INT_FLOAT_REGEX,
          // register: register,
          // additional: "unit",
        },
      }
    ),
    ...(type !== "CLEANING"
      ? [
          columnHelper.accessor(
            (row) =>
              row?.protocol_type
                ? row?.operation === "ADD"
                  ? ""
                  : getLabel(`protocolType_${row?.protocol_type}`) +
                    (row?.protocol_type === "HOMOGENIZATION_REASSEMBLY" &&
                    row?.homogenization_type
                      ? ` (${getLabel(
                          `protocolHomogenizationMass_${row?.homogenization_type}`
                        )})`
                      : "") +
                    (row?.protocol_type === "CUSTOM"
                      ? ` (${row?.oxygenation_dose_hours}h:${row?.oxygenation_dose_minutes}m)`
                      : "")
                : "",
            {
              header: getLabel("protocolType"),
              cell: TableCell,
              meta: {
                type: "text",
                isFilterDisabled: true,
              },
            }
          ),
        ]
      : []),

    // columnHelper.accessor(
    //   (row) =>
    //     row?.quantity
    //       ? row.operation === "CLEANING"
    //         ? `${row?.quantity} %`
    //         : row?.operation === "SO2"
    //         ? `${row?.quantity} ${row?.product_unit}`
    //         : row?.protocol_type === "HOMOGENIZATION_TEMP"
    //         ? `${row?.quantity} \u00b0C`
    //         : `${row.quantity || 0} ${row?.operation === "OXYGENATION" ? "" :
    //             (row?.product?.unit || row?.product_unit || "")
    //           } ${
    //             row?.operation === "OXYGENATION"
    //               ? row?.protocol_type === "MICRO"
    //                 ? getLabel("protocolOxygenationNoDose_MICRO")
    //                 : row?.protocol_type === "MACRO"
    //                 ? getLabel("protocolOxygenationNoDose_MACRO")
    //                 : row?.protocol_type === "CUSTOM"
    //                 ? `${getLabel("protocolOxygenationNoDose_CUSTOM")}${
    //                     row?.oxygenation_dose_hours || ""
    //                   }h:${
    //                     row?.oxygenation_dose_minutes ||
    //                     ""
    //                   }m`
    //                 : ""
    //               : ""
    //           }`
    //       : "",
    // (row) =>
    //   row?.quantity
    //     ? row?.operation === "RINSE"
    //     ? ""
    //     : row?.operation === "CLEANING"
    //     ? `${row?.quantity} %` :
    //     row?.protocol_type === "HOMOGENIZATION_TEMP"
    //       ? `${row?.quantity} \u00b0C`
    //       : (row?.quantity || 0) +
    //         " " +
    //         (row?.product?.unit || row?.product_unit || "")
    //     : "",
    //   {
    //     header: getLabel(
    //       type === "CIP" ? "protocolConcentration" : "protocolQuantity"
    //     ),
    //     cell: TableCell,
    //     meta: {
    //       type: "number",
    //       register: modalRegister,
    //     },
    //   }
    // ),
    // columnHelper.accessor("oxygenationType", {
    //   header: getLabel("protocolOxygenationType"),
    //   cell: TableCell,
    //   meta: {
    //     type: "text",
    //     register: register,
    //   },
    // }),
  ];

  if (
    operationsP?.find((o) => o?.protocol_type === "HOMOGENIZATION_REASSEMBLY")
  ) {
    // columns.splice(
    //   6,
    //   0,
    winemakingColumns.push(
      ...[
        // columnHelper.accessor(
        //   (row) =>
        //     row?.protocol_type && row?.protocol_type !== "ADD"
        //       ? row?.operation === "OXYGENATION"
        //         ? getLabel(`protocolOXYGENATION_${row?.protocol_type}`)
        //         : getLabel(`protocolType_${row?.protocol_type}`) +
        //           (row?.protocol_type === "HOMOGENIZATION_REASSEMBLY" &&
        //           row?.homogenization_type
        //             ? ` (${getLabel(
        //                 `protocolHomogenizationMass_${row?.homogenization_type}`
        //               )})`
        //             : "") +
        //           (row?.protocol_type === "CUSTOM"
        //             ? ` (${row?.oxygenation_dose_hours}h:${row?.oxygenation_dose_minutes}m)`
        //             : "")
        //       : "",
        //   {
        //     header: getLabel("protocolType"),
        //     cell: TableCell,
        //     meta: {
        //       type: "text",
        //       register: modalRegister,
        //       // placeholder: getLabel("lotColorPlaceholder"),
        //     },
        //   }
        // ),
        columnHelper.accessor(
          (row) =>
            row?.work_time &&
            (row?.pause_time || row?.homogenization_pause_time)
              ? `${row?.work_time} min/${
                  row?.pause_time || row?.homogenization_pause_time
                }h ${
                  (type === "CIP" || row.operation === "HOMOGENIZATION_MASS") &&
                  row?.iter_per_day
                    ? `x ${row?.iter_per_day}`
                    : ""
                }`
              : "",
          {
            header: getLabel("protocolWorkPauseTime"),
            cell: TableCell,
            meta: {
              type: "number",
              register: modalRegister,
              isFilterDisabled: true,
            },
          }
        ),
        columnHelper.accessor(
          (row) => (row?.motor_speed ? row?.motor_speed + " %" : ""),
          {
            header: getLabel("protocolMotorSpeed"),
            cell: TableCell,
            meta: {
              type: "number",
              register: modalRegister,
              isFilterDisabled: true,
            },
          }
        ),
      ]
    );
  }

  if (operationsP?.some((o) => o?.operation === "ADD" || o?.protocol_type === "ADD")) {
    winemakingColumns.splice(
      5,
      0,
      columnHelper.accessor("batch_row", {
        header: getLabel("drugBatchNumber"),
        cell: TableCell,
        meta: {
          type: "select",
          is_winemaking: isWineMakingApplication,
          control: control,
          editable: true,
          isFilterDisabled: true,
          dateFormat: configs?.shortDateFormat,
          options: drugs,
          options2: getValues("drug_batches") || [],
        },
      })
    );
  }
  if (type === "CLEANING") {
    winemakingColumns.push(
      columnHelper.accessor(
        (row) => (row?.work_time ? `${row?.work_time} min` : ""),
        {
          header: getLabel("protocolHomogenizationContactTime"),
          cell: TableCell,
          meta: {
            type: "text",
            isFilterDisabled: true,
          },
        }
      )
    );
  }

  winemakingColumns.push(
    columnHelper.display({
      id: "edit",
      cell: EditCell,
      meta: {
        isEditable: true,
        function_type: "CONFIRM",
        onConfirm: updateAssignedDrugBatches,
      },
    })
  );

  const getWinemakingOperation = () => {
    const operation = operationsP?.[isModifyMode];
    return operation;
  };

  const getDrug = () => {
    const tmp = drugs?.find((d) => d?.id === Number(isModifyMode)) || {};
    const quantityOverride =
      operationsP?.find((o) =>
        isBatchSelectorModal === "BATCH_SELECTOR"
          ? o?.product?.value === isModifyMode
          : tmp
      )?.quantity ||
      (id
        ? operation?.treatments?.find((t) => t?.substance_id === isModifyMode)
            ?.quantity
        : tmp?.quantity) ||
      0;

    const drug = {
      ...tmp,
      substance_name: tmp?.name,
      quantity: quantityOverride,
    };

    return drug;
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    if (setIsBatchSelectorModal) setIsBatchSelectorModal("");
    modalReset({
      drug_batches_tmp: [],
    });
    if (isWineMakingApplication && errors?.day) modalClearErrors("day");
  };

  const handleConfirmModal = () => {
    if (isBatchSelectorModal === "BATCH_SELECTOR") {
      const drug = getDrug();
      if (!drug) return;

      // const drug = {
      //   ...tmp,
      //   substance_name: tmp?.name,
      //   // quantity: quantityOverride,
      // };

      if (drugBatchesFieldArrayTmp.fields?.length > 0) {
        const batches =
          drugBatchesFieldArrayTmp.fields?.map((b) => {
            return { ...b, substance_id: drug?.id };
          }) || [];

        const usedTotal =
          batches.reduce((sum, b) => sum + (Number(b.quantity) || 0), 0) || 0;

        const warehouseUnit = getWarehouseUnit(drug, getLabel);
        const requiredNumericQty = computeRequiredNumericQty(
          drug,
          totalTreatmentVolume
        );
        const requiredWarehouseQty = computeRequiredWarehouseQty(
          warehouseUnit,
          requiredNumericQty
        );
        const remainingQty = Math.max(requiredWarehouseQty - usedTotal, 0);
        const isEnoughStock = usedTotal >= requiredWarehouseQty;
        batches[0].is_enough_stock = isEnoughStock && remainingQty <= 0;

        setIsEnoughStock(isEnoughStock && remainingQty <= 0);
        // Keep drug_batches as an object { [substance_id]: batches } so
        // buildTreatmentsDataArray can look up by substance_id. Using
        // setValue(`drug_batches.${id}`, ...) makes RHF treat it as a sparse
        // array (index = substance_id), which the !Array.isArray guard rejects.
        const existing = getValues("drug_batches");
        setValue("drug_batches", {
          ...(!Array.isArray(existing) ? (existing || {}) : {}),
          [isModifyMode]: batches,
        });
      }

      // modalReset({
      //   drug_batches_tmp: [],
      // });
    } else {
      const values = modalGetValues();
      const requiredError = { type: "manual", message: getLabel("inputRequiredError") };
      let hasError = false;
      if (!values?.day) { modalSetError("day", requiredError); hasError = true; }
      if (!values?.operation?.value) { modalSetError("operation", requiredError); hasError = true; }
      if (!values?.phase?.value && type !== "CLEANING") { modalSetError("phase", requiredError); hasError = true; }
      if (hasError) return;

      updateWinemakingTableData();
    }

    modalReset();
    setIsModalOpen(false);
    if (setIsBatchSelectorModal) setIsBatchSelectorModal("");
  };

  const updateWinemakingTableData = () => {
    // console.log("errors", errors, "modalErrors", modalErrors, 'modalGetValues', modalGetValues());
    // return
    const {
      id,
      day,
      work_time,
      pause_time,
      motor_speed,
      iter_per_day,
      homogenization_type,
      oxygenation_dose_hours,
      oxygenation_dose_minutes,
      protocol_type,
      functional,
      quantity,
      operation,
      phase,
      product,
      goal,
      note,
    } = modalGetValues();
    // console.log('op2', modalGetValues())
    const opValue = operation?.value;

    const index = operationsP?.findIndex((o) => o?.id === Number(id));
    const prevItem = index > -1 ? operationsP[index] : {};

    const newItem = {
      ...prevItem,
      phase: phase?.value,
      operation: operation?.value,
      id: Number(id) || Date.now(),
      opType: "WINEMAKINGPROTOCOL",
      functional: functional?.value,
      day: Number(day),
      goal,
      note,
    };

    let drugForBatches = null;
    if (opValue === "ADD" && (functional?.value || type === "CLEANING")) {
      const drug = drugs?.find((d) => d?.id === Number(product?.value));
      if (!drug) {
        setIsModalOpen(false);
        return;
      }
      const assignedDrugBatches = getValues("drug_batches")?.[drug?.id] || [];

      newItem.product = {
        ...drug,
        batches: assignedDrugBatches || [],
        value: drug?.id,
        label: drug?.name + (drug?.unit ? " (" + drug?.unit + ")" : ""),
        unit_id: drug?.unit_id,
        quantity: Number(quantity),
      };
      // product: drug?.id,
      // product_name: drug?.name,
      // product_type: drug?.type,
      // product_unit: drug?.unit,
      // product_unit_id: drug?.unit_id,
      newItem.quantity = Number(quantity);
      newItem.work_time = work_time;
      // warehouse batches needed by assignDrugBatches for auto-assignment
      newItem.batches = drug?.batches || [];
      drugForBatches = drug;
    } else if (["RINSE", "CLEANING", "VAPORIZATION"].includes(opValue)) {
      const drug = drugs?.find((d) => d?.id === Number(product?.value || product?.id));
      if (drug) {
        newItem.product = {
          ...drug,
          value: drug?.id,
          label: drug?.name + (drug?.unit ? " (" + drug?.unit + ")" : ""),
        };
        newItem.substance_id = drug?.id;
        newItem.product_name = drug?.name;
      }
      newItem.work_time = work_time;
      newItem.protocol_type = "ADD";
      if (!["RINSE", "VAPORIZATION"].includes(opValue) && product?.id !== 45) {
        newItem.quantity = Number(quantity);
      }
    } else if (opValue === "OXYGENATION") {
      newItem.protocol_type = protocol_type?.value;
      newItem.quantity = Number(quantity);
      newItem.oxygenation_dose_hours = Number(oxygenation_dose_hours) || null;
      newItem.oxygenation_dose_minutes =
        Number(oxygenation_dose_minutes) || null;
    } else if (opValue === "HOMOGENIZATION_MASS") {
      newItem.protocol_type = protocol_type?.value;
      newItem.quantity = Number(quantity);

      if (protocol_type?.value === "HOMOGENIZATION_REASSEMBLY") {
        newItem.homogenization_type = homogenization_type?.value;
        newItem.work_time = work_time;
        newItem.motor_speed = motor_speed;
        newItem.pause_time = pause_time;
        newItem.iter_per_day = iter_per_day;
      }
    }

    if (newItem.product) {
      newItem.product_name = newItem.product.name;
      newItem.product_unit = newItem.product.unit;
      newItem.unit_id = newItem.product.unit_id;
      newItem.substance_id = newItem.product.id;
      newItem.product_type = newItem.product.type;
      newItem.product_min_range = newItem.product.min_range;
      newItem.product_max_range = newItem.product.max_range;
    }

    // Crea una copia modificata localmente di operationsP
    const updated = [...(operationsP || [])];

    if (index > -1) {
      // Modify existing
      updated.splice(index, 1, newItem);
    } else {
      // Add new
      updated.push(newItem);
    }

    // Ordina per day
    updated.sort((a, b) => (a.day ?? 0) - (b.day ?? 0));

    // Validazione
    if (!validateSteps(updated, false)) {
      setError("day", {
        type: "manual",
        message: getLabel("errorStepNotIncremental"),
      });
      // Il toast viene gestito internamente da validateSteps
      return;
    }

    // Se valido, aggiorna stato e chiudi modal
    setOperationsP(updated);
    if (isWineMakingApplication) setParentOperationsP(updated);

    // Ricalcola batch assignment con lo stato aggiornato (inclusa eventuale nuova riga)
    if (opValue === "ADD" && drugForBatches) {
      updateAssignedDrugBatches(drugForBatches.id, Number(quantity), updated);
    }

    // console.log("updated", updated);
    setIsModalOpen(false);
  };

  const setModifyMode = (row_id) => {
    setIsModifyMode(row_id);
  };

  const handleOpenModal = (isModifyId = -1, modalType) => {
    modalClearErrors();
    setIsModalOpen(true);
    setModifyMode(isModifyId);

    if (isWineMakingApplication && modalType === "WINEMAKING_OPERATIONS") {
      setIsBatchSelectorModal(modalType);
      if (isModifyId === -1) modalReset();
      return;
    }
    setIsBatchSelectorModal("BATCH_SELECTOR");

    if (isModifyId === -1) {
      reset({
        drug_batches_tmp: [],
      });
    } else if (isModifyId > 0) {
      const drugBatches = getValues("drug_batches") || [];

      const drug = getDrug();
      const unit = units?.find((u) => u.id === drug?.unit_id)?.unit || "";

      const substance = {
        ...drug,
        unit: unit,
        substance_id: drug?.id,
        drug_batches: drugBatches?.[isModifyId] || [],
        // quantity: drug?.quantity,
      };

      const groupedTreatmentsBySubstanceId = groupBySubstanceId([substance]); // trick to use operation?.treatments
      const d = groupedTreatmentsBySubstanceId?.[0] || null;

      const drugBatchesArray = d?.drug_batches || [];
      if (d) {
        modalSetValue("drug_batches_tmp", drugBatchesArray);
      }
    }
  };

  const filterWinemakingProtocolsByType = () => {
    const isStabilization = [
      "STABILIZATION_STATIC",
      "STABILIZATION_DYNAMIC",
      "STABILIZATION_RESIN",
    ].includes(type);
    const isFiltration = type === "FILTRATION";
    const isPhysical = type === "PHYSICAL" || isStabilization || isFiltration;

    if (isPhysical)
      return (
        protocols
          ?.filter(
            (p) =>
              p?.protocol_type === "PHYSICAL" &&
              isPhysical &&
              (protocol_subtype?.value === "physicalProtocol_STABILIZATION" ||
                (isFiltration &&
                  protocol_subtype?.value === "physicalProtocol_FILTRATION"))
          )
          ?.map((p) => {
            const name = getProtocolName(p);
            return { ...p, value: p?.id, label: name, name: name };
          }) || []
      );

    return protocols
      ?.filter(
        (p) =>
          p?.protocol_type === winemakingPType &&
          (winemakingPType !== "POST" ||
            p?.operations?.[0]?.phase !== "BOTTLING")
      )
      ?.map?.((p) => {
        return {
          value: p?.id,
          label: p?.name,
          subtype: p?.protocol_subtype,
          name: `${p?.name} ${
            p?.protocol_subtype
              ? `(${getLabel(
                  `protocolSubtype_${p?.protocol_subtype}`
                )?.toLowerCase()})`
              : ""
          }`,
        };
      });
  };

  const handleAutoAssignment = () => {
    if (!isAutomaticAssignment) setIsAutomaticAssignment(true);
    // For non-winemaking: override operationsP quantities with any user-edited
    // column values so the batch calculation uses the correct product quantity,
    // not the original protocol default.
    const filteredOps =
      (isWineMakingApplication
        ? operationsP
            ?.filter((o) => o?.operation === "ADD" || o?.protocol_type === "ADD")
            ?.map((o) => {
              return {
                ...o,
                ...o?.product,
                quantity: o?.quantity,
                product: { ...o?.product, quantity: o?.quantity },
              };
            })
        : applyColumnOverrides(operationsP)) || [];
    if (!isWineMakingApplication) {
      filteredOps?.forEach(element => {
        if (element?.batches?.length === 0) {
          const batches = drugs?.find(dd => dd?.id === element?.substance_id)?.batches || [];
          if (batches) element.batches = batches;
        }
      });
    }
    
    assignDrugBatches(
      filteredOps,
      totalTreatmentVolume,
      drugBatchFieldArray,
      getLabel,
      null,
      true,
      setValue
    );
  };

  return (
    <div>
      <h6>{getLabel(title)}</h6>
      {!isWineMakingApplication && (
        <div className="operation_form_wrapper_row align_bottom">
          <Select
            label={getLabel("protocolName")}
            placeholder={getLabel("protocolNamePlaceholder")}
            errors={errors[`protocol_id`]}
            required={getLabel("protocolNameRequiredError")}
            name={`protocol_id`}
            control={control}
            options={protocols}
            isDisabled={isSelectDisabled}
          />
          <div className="automatic_lot_assignment">
            <Tooltip
              variant={"info"}
              html={getLabel("treatmentAssignDrugBatchesTooltip")}
              place="right"
              events={["hover"]}
            >
              <CTA
                // customClassName={"dialog confirm"}
                disabled={!protocol_id?.value || totalTreatmentVolume <= 0}
                isRed={false}
                onClick={handleAutoAssignment}
              >
                {getLabel("treatmentAssignDrugBatches")}
              </CTA>
            </Tooltip>
          </div>
        </div>
      )}
      {(type !== "CLEANING" && isWineMakingApplication) && (
        <div className="operation_form_wrapper_row align_bottom">
          {!id && type === "PHYSICAL" && (
            <Select
              label={getLabel("protocolSubtype")}
              placeholder={getLabel("protocolSubtypePlaceholder")}
              errors={errors[`protocol_subtype`]}
              // required={getLabel("protocolNameRequiredError")}
              name={`protocol_subtype`}
              control={control}
              options={[
                {
                  value: "physicalProtocol_STABILIZATION",
                  label: getLabel("physicalProtocol_STABILIZATION"),
                },
                // {
                //   value: "physicalProtocol_FILTRATION",
                //   label: getLabel("physicalProtocol_FILTRATION"),
                // },
              ]}
            />
          )}
          <Select
            label={getLabel("protocolName")}
            placeholder={getLabel("protocolNamePlaceholder")}
            errors={errors[`protocol_id`]}
            required={getLabel("protocolNameRequiredError")}
            name={`protocol_id`}
            control={control}
            isDisabled={
              !protocol_subtype &&
              [
                "PHYSICAL",
                "STABILIZATION_STATIC",
                "STABILIZATION_DYNAMIC",
                "STABILIZATION_RESIN",
              ].includes(type)
            }
            options={filterWinemakingProtocolsByType()}
          />
          {operationsP?.some((o) => o?.operation === "ADD" || o?.protocol_type === "ADD") && (
            <div className="automatic_lot_assignment">
              <Tooltip
                variant={"info"}
                html={getLabel("treatmentAssignDrugBatchesTooltip")}
                place="right"
                events={["hover"]}
              >
                {/* <CTA
                  // customClassName={"dialog confirm"}
                  isRed={false}
                  onClick={() => assignDrugBatches([operationsP?.filter((o) => o?.operation === "ADD" || o?.protocol_type === "ADD")], totalTreatmentVolume, drugBatchesFieldArrayTmp, getLabel, null)}
                >
                  {getLabel("treatmentAssignDrugBatches")}
                </CTA> */}
                <CTA
                  // customClassName={"dialog confirm"}
                  disabled={!protocol_id?.value || totalTreatmentVolume <= 0}
                  isRed={false}
                  onClick={handleAutoAssignment}
                >
                  {getLabel("treatmentAssignDrugBatches")}
                </CTA>
              </Tooltip>
            </div>
          )}
          {type === "CLEANING" && protocol?.protocol_subtype && (
            <Label label={getLabel("protocolSubtype_CLEANING")}>
              {getLabel(`protocolSubtype_${protocol?.protocol_subtype}`)}
            </Label>
          )}
        </div>
      )}
      {protocol_id?.value && (
        <div className="operation_form_wrapper_row vertical">
          <Table
            defaultData={operationsP}
            columns={!isWineMakingApplication ? columns : winemakingColumns}
            // Non-winemaking inline quantity edits register/validate on the PARENT
            // form (column.<id>_<rowKey>.value). The Table must read errors/values
            // from that same form so the blocking range error disables EditCell's
            // "done". Winemaking edits go through the modal form instead.
            errors={isWineMakingApplication ? modalErrors : errors}
            control={isWineMakingApplication ? modalControl : control}
            isEditable={true}
            isLegend={false}
            isSearchBar={false}
            setValue={isWineMakingApplication ? modalSetValue : setValue}
            getValues={isWineMakingApplication ? modalGetValues : getValues}
            type={"treatment"}
            isWineMakingOperations={isWineMakingApplication}
            modalHandler={handleOpenModal}
            setModifyMode={setModifyMode}
            setRows={(newRows) => {
              const rows = type === "CLEANING"
                ? newRows.map((row, idx) => ({ ...row, day: idx + 1 }))
                : newRows;
              setOperationsP(rows);
              if (setParentOperationsP) setParentOperationsP(rows);
            }}
            totalVolume={totalTreatmentVolume}
          />
          <ConfirmationModal
            isOpen={isModalOpen}
            onConfirm={handleConfirmModal}
            onClose={handleCloseModal}
            description={getLabel("modalConfigureDrugBatchDescription")}
            isOperationRecap={true}
            totalStep={0}
            errors={modalErrors}
            getValues={modalGetValues}
            // configs={configs}
          >
            <OperationRecap
              id={id || null}
              type={
                isBatchSelectorModal === "BATCH_SELECTOR"
                  ? "NEW_DRUG_BATCH"
                  : "WINEMAKING_OPERATIONS"
              }
              operationType={type}
              configs={configs}
              control={modalControl}
              register={modalRegister}
              getValues={modalGetValues}
              setValue={modalSetValue}
              errors={modalErrors}
              drugs={drugs}
              // units={units}
              arrayFields={drugBatchesFieldArrayTmp}
              additionalData={
                isBatchSelectorModal === "BATCH_SELECTOR"
                  ? getDrug()
                  : getWinemakingOperation()
              }
              additionalSubtype={totalTreatmentVolume}
              isAutomaticCTA={true}
            />
          </ConfirmationModal>

          {/* {false && isWineMakingApplication && isBatchSelectorModal !== "BATCH_SELECTOR" && (
            <WineMakingProtocolRowModal
              isOpen={isModalOpen}
              // onConfirm={updateWinemakingTableData}
              onConfirm={modalHandleSubmit(updateWinemakingTableData)}
              handleSubmit={modalHandleSubmit}
              onClose={handleCloseModal}
              description={getLabel("modalLogout")}
            >
              <WineMakingProtocolModalChildren
                type={type === "CLEANING" ? "CIP" : type}
                operation={operationsP?.[isModifyMode]}
                // operation={!id ? modalOperation : watchedOperation}
                register={register}
                errors={errors}
                control={control}
                drugs={drugs}
                getLabel={getLabel}
                getValues={getValues}
                setValue={setValue}
                setCheckboxState={setCheckbox(!checkbox)}
              />
            </WineMakingProtocolRowModal>
          )} */}
        </div>
      )}
    </div>
  );
};

export const groupByIngredientField = (items, groupingParam, getLabel) => {
  const groups = {};

  items.forEach((item) => {
    if (!Array.isArray(item.ingredients)) return;

    item.ingredients.forEach((ingredient) => {
      const key = getLabel(`drugLabelGroup_${ingredient?.[groupingParam]}`);
      if (!key) return;

      if (!groups[key]) {
        groups[key] = new Map(); // Use Map to ensure uniqueness by `value`
      }

      if (!groups[key].has(item.value)) {
        groups[key].set(item.value, item);
      }
    });
  });

  // Convert maps into final structure
  return Object.entries(groups).map(([label, map]) => ({
    label,
    options: Array.from(map.values()),
    is_grouped: true,
  }));
};

const ProtocolConflictModal = ({ isOpen, protocols = [], onConfirm, onCancel }) => {
  const [getLabel] = useLabels();
  const modalRef = useRef(null);

  useEffect(() => {
    const el = modalRef.current;
    if (!el) return;
    if (isOpen) { el.close(); el.showModal(); } else { el.close(); }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <Modal forwardRef={modalRef} closeHandle={onCancel} isOpen={isOpen} customClassName="confirmation winemaking">
      <div className="confirmation-modal-container">
        <h2 className="title">{getLabel("protocolConflictTitle") || "Operazione impatta un Protocollo attivo"}</h2>
        <p className="description" style={{ marginTop: "0.75rem" }}>
          {getLabel("protocolConflictBody") || "I tank selezionati fanno parte dei seguenti protocolli. Gli step indicati potrebbero essere invalidati:"}
        </p>
        {protocols.map((proto) => (
          <div key={proto.id} style={{ marginTop: "1rem" }}>
            <strong>{proto.protocol_name}</strong>
            <ul style={{ marginTop: "0.5rem", paddingLeft: "1.25rem" }}>
              {(proto.pending_steps || []).map((s) => (
                <li key={s.step_order}>
                  {getLabel("protocolConflictStep") || "Step"} {s.step_order} – {s.operation}
                  {s.day != null ? ` (${getLabel("protocolConflictDay") || "giorno"} ${s.day})` : ""}
                </li>
              ))}
            </ul>
          </div>
        ))}
        <p style={{ marginTop: "1rem", fontSize: "0.875rem", opacity: 0.7 }}>
          {getLabel("protocolConflictNotice") || "Il responsabile del protocollo verrà notificato automaticamente."}
        </p>
        <div className="confirmation-modal-btns" style={{ marginTop: "1.5rem", display: "flex", gap: "1rem", justifyContent: "flex-end" }}>
          <button type="button" className="submit-btn secondary-btn" onClick={onCancel}>
            {getLabel("protocolConflictCancel") || "Annulla"}
          </button>
          <button type="button" className="submit-btn" onClick={onConfirm}>
            {getLabel("protocolConflictConfirm") || "Confermo, procedi"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export {
  Button,
  CTA,
  Tooltip,
  Card,
  Modal,
  TankColumn,
  CellarmanColumn,
  Dropdown,
  BatchColumn,
  CloseColumn,
  BottlingColumn,
  Toast,
  ConfirmationModal,
  OperationRecap,
  TankIcon,
  CloseIcon,
  PomacesIcon,
  RecapTankIcon,
  FilterIcon,
  BatchIcon,
  BottleIcon,
  InfoTooltip,
  InfoCard,
  WineMakingProtocolModalChildren,
  WineMakingProtocolRowModal,
  NotificationWithLink,
  Carousel,
  StickyNotesModal,
  DrugForm,
  DrugStock,
  SourceSelector,
  DestinationSelector,
  buildPomace,
  mapTankToSelectOption,
  // SourceDetail,
  // DestinationDetail,
  TankOperationDetail,
  LotOrTankOperationSelector,
  OptionalNoteRow,
  ContextMenu,
  PomacesDestination,
  DrugsBatchSelectorTable,
  ProtocolConflictModal,
};
